/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		31: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/10.24.1/tableonline." + {"0":"72832","1":"05edc","2":"6025a","3":"bbcb2","4":"b83d3","5":"bdc08","6":"e8965","7":"1a11b","8":"a9786","9":"69c9e","10":"57e8d","11":"59acc","12":"1558f","13":"ead81","14":"152b6","15":"9ecb8","16":"d7835","17":"83151","18":"6aa9f","19":"dd9d0","20":"62975","21":"2d74b","22":"4300c","23":"4b1b5","24":"d850e","25":"3744b","26":"62f20","27":"2891c","28":"24cc5","29":"200d6","30":"e2895"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+SFM":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, ".searchField__svWp4{width:100%;border-radius:5px;z-index:1;-webkit-box-shadow:0 2px 6px rgba(0,0,0,.1);box-shadow:0 2px 6px rgba(0,0,0,.1);outline:1px solid hsla(0,0%,100%,.5);background:#fff;position:relative;max-width:405px;margin:.25rem 1rem .25rem auto}.searchField__svWp4>svg{padding-left:.5rem}.searchField__svWp4,.searchInput__YkWjq,a.citySelection__7F2gK{color:#fff;font-weight:500;cursor:pointer;background:rgba(0,0,0,.1);-webkit-transition:background .3s ease;transition:background .3s ease;font-size:16px;line-height:22px}a.citySelection__7F2gK{background:transparent}.searchField__svWp4 svg{fill:#fff}.searchField__svWp4.focus__9tmRp,.searchField__svWp4.focus__9tmRp .searchInput__YkWjq,.searchField__svWp4.focus__9tmRp a.citySelection__7F2gK,.searchField__svWp4:hover,.searchField__svWp4:hover .searchInput__YkWjq,.searchField__svWp4:hover a.citySelection__7F2gK{color:#000;background:#fff}.searchField__svWp4.focus__9tmRp .searchInput__YkWjq,.searchField__svWp4.focus__9tmRp a.citySelection__7F2gK,.searchField__svWp4:hover .searchInput__YkWjq,.searchField__svWp4:hover a.citySelection__7F2gK{background:transparent}.searchField__svWp4.focus__9tmRp svg,.searchField__svWp4:hover svg{fill:#555}.searchField__svWp4.focus__9tmRp a.citySelection__7F2gK,.searchField__svWp4:hover a.citySelection__7F2gK{border-right:1px solid rgba(0,0,0,.1)}.searchForm__1PCQf{display:-webkit-box;display:-ms-flexbox;display:flex;padding:.5rem;margin-top:0;border-radius:5px;background:transparent;width:100%}.searchInput__YkWjq{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;width:100px;border:0;font-size:16px;font-weight:500;background:transparent;color:inherit;outline:0}.searchInput__YkWjq::-webkit-input-placeholder{color:inherit;opacity:.64}.searchInput__YkWjq::-moz-placeholder{color:inherit;opacity:.64}.searchInput__YkWjq::-ms-input-placeholder{color:inherit;opacity:.64}.searchInput__YkWjq::placeholder{color:inherit;opacity:.64}a.citySelection__7F2gK{position:relative;padding:0 .5rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-item-align:stretch;align-self:stretch}.searchIcon__dH_zB{height:16px}a.citySelection__7F2gK svg{pointer-events:none;position:absolute;right:.65rem;opacity:.4}a.citySelection__7F2gK select{font-weight:500;font-size:16px;outline:0;border-left:1px solid rgba(0,0,0,.08);-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;color:inherit;border:0;padding:0 .25rem}button.searchButton__2LLhx{font-weight:500;display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;background:none;-webkit-box-shadow:none;box-shadow:none;margin:0;min-height:0;height:auto;line-height:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.autocomplete__dlxu5{background:rgba(0,0,0,.01);color:#111}.autocompleteSuggestion__26-hh{padding:1rem;display:block}.autocompleteSuggestionSmall__SB2Az{border-top:1px solid rgba(0,0,0,.04)}.autocompleteSuggestion__26-hh:hover,.autocompleteSuggestionSmall__SB2Az:hover{background:rgba(0,0,0,.01);cursor:pointer}.autocompleteSuggestionSmall__SB2Az{padding:.5rem 1rem;display:block}.autocompleteSuggestionSmall__SB2Az:last-child{padding-bottom:1rem}.autocompleteSuggestionSmall__SB2Az h5{font-size:16px}.autocompleteSuggestion__26-hh h5 span,.autocompleteSuggestionSmall__SB2Az h5 span{font-weight:400}@media (max-width:768px){.searchField__svWp4{margin-right:.5rem}}.noCityFilter__3b3p9 .searchForm__1PCQf{padding:.5rem .75rem;width:100%}.noCityFilter__3b3p9 .searchInput__YkWjq{padding-left:.25rem}.cityFilterContainer__1HQPp{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
exports.locals = {
	"searchField": "searchField__svWp4",
	"searchInput": "searchInput__YkWjq",
	"citySelection": "citySelection__7F2gK",
	"focus": "focus__9tmRp",
	"searchForm": "searchForm__1PCQf",
	"searchIcon": "searchIcon__dH_zB",
	"searchButton": "searchButton__2LLhx",
	"autocomplete": "autocomplete__dlxu5",
	"autocompleteSuggestion": "autocompleteSuggestion__26-hh",
	"autocompleteSuggestionSmall": "autocompleteSuggestionSmall__SB2Az",
	"noCityFilter": "noCityFilter__3b3p9",
	"cityFilterContainer": "cityFilterContainer__1HQPp"
};

/***/ }),

/***/ "+eY/":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("D6Eh");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false,"singleton":true,"attrs":{"data-tableonline-build":"10.24.1"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "/OGg":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, "[data-a11y-dialog-native] .overlay__cfaVv{display:none}.dialogContainer__3lqGv{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.dialogContainer__3lqGv,.overlay__cfaVv{position:fixed;top:0;left:0;height:100%;width:100%;z-index:2}.overlay__cfaVv{background:rgba(0,0,0,.18);-webkit-animation:backgroundIn__3Ugnv .35s ease;animation:backgroundIn__3Ugnv .35s ease}.title__C4G9r{font-size:1.5rem;display:block;text-align:center;line-height:2.75rem;margin:0 auto}.dialog__2b6Jv{max-width:100%;width:100%;max-width:calc(100% - 2rem);margin:1rem;border-radius:5px;display:block;background:#fff;overflow:hidden;position:relative;-webkit-box-shadow:0 18px 35px rgba(0,0,0,.17);box-shadow:0 18px 35px rgba(0,0,0,.17);border:0;z-index:3;padding:4.75rem 2rem;-webkit-animation:dialogAnimation__2xOEf .65s cubic-bezier(.78,-1.22,.17,1.89);animation:dialogAnimation__2xOEf .65s cubic-bezier(.78,-1.22,.17,1.89)}.dialog__2b6Jv.scroll__gjEIy{overflow:scroll;max-height:100vh}.dialogContainer__3lqGv[aria-hidden=true]{display:none}.closeButton__3ztxL{border:0;display:inline-block;padding:0;text-align:center;line-height:2.75rem;height:2.75rem;width:2.75rem;border-radius:5px;font-weight:500;font-size:inherit;line-height:inherit;-webkit-transition:opacity .2s;transition:opacity .2s;text-decoration:none;-webkit-appearance:none;-webkit-box-shadow:rgba(0,0,0,.1) 0 2px 6px;box-shadow:0 2px 6px rgba(0,0,0,.1);position:absolute;top:1rem;right:2rem;z-index:2}body[modal-visible]{overflow:hidden}@-webkit-keyframes dialogAnimation__2xOEf{0%{-webkit-transform:scale3d(.8,.8,1);transform:scale3d(.8,.8,1);opacity:0}}@keyframes dialogAnimation__2xOEf{0%{-webkit-transform:scale3d(.8,.8,1);transform:scale3d(.8,.8,1);opacity:0}}@-webkit-keyframes backgroundIn__3Ugnv{0%{opacity:0}to{opacity:1}}@keyframes backgroundIn__3Ugnv{0%{opacity:0}to{opacity:1}}", ""]);

// exports
exports.locals = {
	"overlay": "overlay__cfaVv",
	"dialogContainer": "dialogContainer__3lqGv",
	"backgroundIn": "backgroundIn__3Ugnv",
	"title": "title__C4G9r",
	"dialog": "dialog__2b6Jv",
	"dialogAnimation": "dialogAnimation__2xOEf",
	"scroll": "scroll__gjEIy",
	"closeButton": "closeButton__3ztxL"
};

/***/ }),

/***/ "/QC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribers", function() { return subscribers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentUrl", function() { return getCurrentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "route", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.attributes;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.attributes.default ? 0 : rank(vnode.attributes.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.attributes.path, vnode.attributes);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Link = function Link(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;

/* harmony default export */ __webpack_exports__["default"] = (Router);
//# sourceMappingURL=preact-router.es.js.map

/***/ }),

/***/ "/g0k":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3Ql4");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false,"singleton":true,"attrs":{"data-tableonline-build":"10.24.1"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "0/XQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// CONCATENATED MODULE: ../node_modules/mitt/dist/mitt.es.js
//      
// An event handler can take an optional event argument
// and should not return a value


// An array of all currently registered event handlers for a type


// A map of event types and their corresponding event handlers.


/** Mitt: Tiny (~200b) functional event emitter / pubsub.
 *  @name mitt
 *  @returns {Mitt}
 */
function mitt(all) {
	all = all || Object.create(null);

	return {
		/**
   * Register an event handler for the given type.
   *
   * @param  {String} type	Type of event to listen for, or `"*"` for all events
   * @param  {Function} handler Function to call in response to given event
   * @memberOf mitt
   */
		on: function on(type, handler) {
			(all[type] || (all[type] = [])).push(handler);
		},

		/**
   * Remove an event handler for the given type.
   *
   * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
   * @param  {Function} handler Handler function to remove
   * @memberOf mitt
   */
		off: function off(type, handler) {
			if (all[type]) {
				all[type].splice(all[type].indexOf(handler) >>> 0, 1);
			}
		},

		/**
   * Invoke all handlers for the given type.
   * If present, `"*"` handlers are invoked after type-matched handlers.
   *
   * @param {String} type  The event type to invoke
   * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
   * @memberOf mitt
   */
		emit: function emit(type, evt) {
			(all[type] || []).slice().map(function (handler) {
				handler(evt);
			});
			(all['*'] || []).slice().map(function (handler) {
				handler(type, evt);
			});
		}
	};
}

/* harmony default export */ var mitt_es = (mitt);
//# sourceMappingURL=mitt.es.js.map
// EXTERNAL MODULE: ./components/root/index.js
var root = __webpack_require__("VjJS");

// CONCATENATED MODULE: ./components/pubsub/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pubsub_PubSub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Emit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Stateful; });
/* unused harmony export Observe */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

 /** @jsx h */



var localStorageSupport = 'localStorage' in root["a" /* default */];

var ignoreSave = ['hasTranslationRoute'];

/** Instantiates a pubsub and exposes it via context */
var pubsub_PubSub = function () {
  function PubSub() {
    _classCallCheck(this, PubSub);

    this.events = mitt_es();

    this.get = function (key) {
      if (localStorageSupport) {
        var val = localStorage.getItem('TableOnline--' + key);
        return !val ? null : val.indexOf('{') === 0 || val.indexOf('[') === 0 ? JSON.parse(val) : val;
      }
      return null;
    };
  }

  PubSub.prototype.getChildContext = function getChildContext() {
    var _this = this;

    return {
      events: _extends({}, this.events, {
        get: this.get,
        emit: function emit(type, data) {
          return updateData(_this.events.emit, type, data);
        }
      })
    };
  };

  PubSub.prototype.render = function render(_ref) {
    var children = _ref.children;

    return children[0];
  };

  return PubSub;
}();

/** Passes pubsub's emit() function as a prop (avoids direct context access) */
var pubsub_connect = function connect(Component) {
  return function (props, context) {
    return Object(preact_min["h"])(Component, _extends({
      emit: function emit(type, data) {
        return updateData(context.events.emit, type, data);
      }
    }, props));
  };
};

var pubsub_updateLocalStorage = function updateLocalStorage(type, data) {
  if (localStorageSupport && !ignoreSave.includes(type)) data === null || data === void 0 ? root["a" /* default */].localStorage.removeItem('TableOnline--' + type) : root["a" /* default */].localStorage.setItem('TableOnline--' + type, typeof data === 'string' ? data : JSON.stringify(data));
};

var updateData = function updateData(emit, type, data) {
  lastState[type] = data;
  emit(type, data);
  pubsub_updateLocalStorage(type, data);
};

/** Emits a pubsub event when rendered */

var Emit = pubsub_connect(function (_ref2) {
  var emit = _ref2.emit,
      props = _objectWithoutProperties(_ref2, ['emit']);

  return Object.keys(props).forEach(function (type) {
    if (type === 'children') return;
    updateData(emit, type, props[type]);
  });
});


var lastState = localStorageSupport ? Object.keys(localStorage).reduce(function (obj, str) {
  if (str.indexOf('TableOnline--') === 0) {
    var item = localStorage.getItem(str);
    obj[str.slice(13)] = item.indexOf('{') === 0 || item.indexOf('[') === 0 ? JSON.parse(item) : item;
  }
  return obj;
}, {}) : {};

/** Binds listener props to pubsub */
var Stateful = function (_Component) {
  _inherits(Stateful, _Component);

  function Stateful(props) {
    _classCallCheck(this, Stateful);

    var _this2 = _possibleConstructorReturn(this, _Component.call(this, props));

    _this2.onUpdate = function (key) {
      return function (data) {
        if (_this2.state[key] !== data) {
          var _this2$setState;

          _this2.setState((_this2$setState = {}, _this2$setState[key] = data, _this2$setState));
          lastState[key] = data;
          pubsub_updateLocalStorage(key, data);
        }
      };
    };

    _this2.state = {};
    _this2.props.events.forEach(function (key) {
      _this2.state[key] = lastState[key];
    });
    return _this2;
  }

  Stateful.prototype.componentDidMount = function componentDidMount() {
    this.bind('on', this.props.events);
  };

  Stateful.prototype.componentDidUpdate = function componentDidUpdate(oldProps) {
    this.bind('off', oldProps.events);
    this.bind('on', this.props.events);
  };

  Stateful.prototype.componentWillUnmount = function componentWillUnmount() {
    this.bind('off', this.props.events);
  };

  Stateful.prototype.bind = function bind(method) {
    var _this3 = this;

    var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    events.forEach(function (key) {
      return _this3.context.events[method](key, _this3.onUpdate(key));
    });
  };

  Stateful.prototype.render = function render(_ref3, state) {
    var children = _ref3.children;

    return typeof children[0] === 'function' ? children[0](state) : null;
  };

  return Stateful;
}(preact_min["Component"]);

/** Binds listener props to pubsub */
var Observe = function (_Component2) {
  _inherits(Observe, _Component2);

  function Observe() {
    _classCallCheck(this, Observe);

    return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
  }

  Observe.prototype.componentDidMount = function componentDidMount() {
    this.bind('on', this.props);
  };

  Observe.prototype.componentDidUpdate = function componentDidUpdate(oldProps) {
    this.bind('off', oldProps);
    this.bind('on', this.props);
  };

  Observe.prototype.componentWillUnmount = function componentWillUnmount() {
    this.bind('off', this.props);
  };

  Observe.prototype.bind = function bind(method, events) {
    for (var i in events) {
      if (typeof events[i] === 'function') {
        this.context.events[method](i.replace(/^on/, '').toLowerCase(), events[i]);
      }
    }
  };

  return Observe;
}(preact_min["Component"]);

/***/ }),

/***/ "0U3q":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("fGnf");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false,"singleton":true,"attrs":{"data-tableonline-build":"10.24.1"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "1Hmk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var setFunctionName = __webpack_require__("zPSE");
var $TypeError = __webpack_require__("uVNY");

var $Object = Object;

module.exports = setFunctionName(function flags() {
	if (this == null || this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.hasIndices) {
		result += 'd';
	}
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.unicodeSets) {
		result += 'v';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
}, 'get flags', true);

/***/ }),

/***/ "1PyO":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("m2kL");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false,"singleton":true,"attrs":{"data-tableonline-build":"10.24.1"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "2S6C":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ZE63");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false,"singleton":true,"attrs":{"data-tableonline-build":"10.24.1"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "2V1b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("58Ti");
var $TypeError = __webpack_require__("uVNY");

var $call = __webpack_require__("oG9A");
var $actualApply = __webpack_require__("rXTS");

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};

/***/ }),

/***/ "2gTp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),

/***/ "2i3q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./eval')} */

module.exports = EvalError;

/***/ }),

/***/ "2pTr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__("VxKF");
var callBind = __webpack_require__("y9YS");

var implementation = __webpack_require__("4md/");
var getPolyfill = __webpack_require__("TyWm");
var shim = __webpack_require__("Fi9R");

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;

/***/ }),

/***/ "34Ju":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */

var $gOPD = __webpack_require__("XU8W");

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;

/***/ }),

/***/ "3JcB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */

var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;

/***/ }),

/***/ "3Ql4":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, ".bookingFlow__afA8a{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;padding:0}.bookingForm__3LWzx{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;display:block;width:100%}.titleWrapper__1UQ7c{max-width:50%;padding-bottom:1rem;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.restaurantInfo__1xFjI,.titleWrapper__1UQ7c{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.restaurantInfo__1xFjI{display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:1rem;margin-bottom:1rem}.restaurantNameLink__37a25{text-shadow:1px 0 0 currentColor}.restaurantIconDetails__15koV{opacity:.54;padding:0 1rem 0 0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.restaurantIconDetails__15koV span{padding-left:.25rem}.fieldset__1H2L8{border:0;padding:1rem;margin:0}.legend__2T-9z,.legend__2T-9z h3{font-weight:400}.legend__2T-9z h3{opacity:.54;padding-right:.5rem}.legend__2T-9z h3.fullOpacity__zGqQd{opacity:1}.requiredLegend__3Fyll{color:#d12c1a;display:inline;font-size:1rem;font-weight:500;vertical-align:text-top;margin-left:.5rem}.fulfilledLegend__T963c{color:#000f0f;opacity:.54}.fieldsetContent__12WxN{margin-bottom:2rem}.fieldsetContent__12WxN,.fieldsetContentWithoutMargin__3ffKL{-webkit-box-shadow:0 2px 6px rgba(0,0,0,.1);box-shadow:0 2px 6px rgba(0,0,0,.1);border-radius:5px;margin-top:0;background:#fff;-webkit-transition:-webkit-box-shadow .5s ease;transition:-webkit-box-shadow .5s ease;transition:box-shadow .5s ease;transition:box-shadow .5s ease,-webkit-box-shadow .5s ease}.widget__3z_Ld{margin-top:0;margin-bottom:0}.fieldsetContent__12WxN>section+section{border-top:1px solid rgba(0,0,0,.1)}.checkboxContainer__3LjP_{padding:1rem 1rem 1rem 2rem}.disabledOption__1aza3>label{opacity:.1;pointer-events:none}.checkboxContent__140SS{padding:1rem}.checkboxContent__140SS h3{opacity:1}.checkboxContent__140SS h5{white-space:pre-line}.checkboxContent__140SS sub{font-weight:500;text-transform:uppercase;padding-top:1.5rem;display:inline-block;opacity:.75;-webkit-transition:opacity .5s ease;transition:opacity .5s ease}.inputContainer__3c3g4{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;position:relative}.inputLabel__19PVu{padding:1rem;width:16rem;max-width:100%;line-height:30px;font-size:1rem;opacity:.54;font-weight:500}.inputLabel__19PVu.affiliateInput__6yen2,.inputLabel__19PVu.imageLabel__jh9Dg{opacity:1}.inputContainer__3c3g4[error]{color:#d12c1a;background:rgba(231,76,60,.06)}.affiliateInput__6yen2,.inputContainer__3c3g4[error] .inputLabel__19PVu{opacity:1}.adultAmountSelector__1rG8q svg,.childrenAmountSelector__3a3YJ svg,.inputContainer__3c3g4>svg,.resetBookingPeriod__2pgXk svg{position:absolute;right:1rem;top:50%;margin-top:-6px;pointer-events:none}.periodWrapper__2leKA{margin:.5rem 0}.inputArea__1BzRc{width:100%;max-width:calc(100% - 16rem);-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:1rem}.inputArea__1BzRc.noPadding__15LoP{padding:0}.inputArea__1BzRc.noPadding__15LoP p{font-weight:500}.inputArea__1BzRc>div{width:100%}.inputArea__1BzRc select{height:100%}.error__2xexw{font-size:16px;padding:1rem;border:1px solid rgba(230,33,23,.15);background:rgba(230,33,23,.05);border-radius:3px;-webkit-box-shadow:rgba(0,0,0,.1) 0 2px 6px;box-shadow:0 2px 6px rgba(0,0,0,.1)}.textInputArea__1KPBB{max-width:48rem}.error__2xexw:empty{display:none}.termsOfService__yot54{font-weight:500;text-decoration:underline;opacity:1;font-size:14px}.affiliateLogo__2r5Jv{max-width:10rem;margin-top:.5rem}.paymentLogo__2zQmn{margin-top:.5rem;padding:8px;vertical-align:middle}.norwegianLogo__uYlAp{margin-top:.15rem}.cardInput__uAvLV{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.cardInput__uAvLV>div{background:rgba(0,0,0,.02);padding:12px;border-radius:4px;border:2px solid rgba(0,0,0,.08);width:6rem}.cardInput__uAvLV>div:first-child{width:100%;margin-bottom:.5rem}.cardInput__uAvLV>div:last-child{margin-left:.5rem}.cardInput__uAvLV>div[class=StripeElement--focus]{border:2px solid #124142}.cardError__1gg_W{display:none;margin-top:1rem;margin-bottom:1rem}.giftCardInput__fbmcp{width:100%}.giftCardInput__fbmcp>div:nth-child(2){display:inline-block;width:auto}.giftCardInput__fbmcp:focus-within .giftCardSoftError__1koCe{display:none}.giftCardSoftError__1koCe{margin-top:1rem;display:block}.giftCardAmountContainer__2ADfJ{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.giftCardTitleContainer__d2-PK{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto}.profileSelector__2UYFv{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.profileSelector__2UYFv .restaurantIconDetails__15koV{font-weight:400}.promotionSplitter__Ry5bY{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;margin-top:-4rem;padding:1rem 0 0}.mainPromotion__GDbl6{border-radius:.25rem;-webkit-box-shadow:0 18px 35px rgba(0,0,0,.17);box-shadow:0 18px 35px rgba(0,0,0,.17);margin-top:1rem;aspect-ratio:16/9;width:50%;width:calc(50% - 1rem);margin-right:1rem}.selectorLink__1258k{display:inline-block;max-width:100%;width:240px;padding:0 .5rem .5rem 0;font-weight:500}.secondaryPromotion__2E17e{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;width:50%;padding:0 1rem 0 0;margin:0;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.secondaryPromotion__2E17e,.secondaryTitle__1yLgr{display:-webkit-box;display:-ms-flexbox;display:flex}.secondaryTitle__1yLgr{color:#fff;padding:0 1rem;height:9rem;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.secondaryTitle__1yLgr h3{padding-bottom:1rem}.secondaryList__33DQS,.secondaryTitle__1yLgr{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto}.secondaryList__33DQS{list-style:none;margin:0;padding:1rem}.secondaryPromotion__2E17e>h3{color:#fff;padding:2rem 0}.partySizeSelector__3546D{-webkit-appearance:none;border:none;background:none;font-weight:500;border-bottom:0 solid #aaa;border-radius:0;padding-bottom:.125rem;width:100%}.partySizeSelectorCaption__3CKlg{padding:.5rem 0;display:block;width:100%}.ageLimitCaption__2vNBz{display:block;width:100%;font-weight:400;line-height:1}.adultAmountSelector__1rG8q,.childrenAmountSelector__3a3YJ{height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex:1 0 50%;flex:1 0 50%;position:relative}.childrenAmountSelector__3a3YJ{border-left:1px solid rgba(0,0,0,.1)}.childrenAmountSelector__3a3YJ select{padding-left:1rem}.bookingDateSelector__1TXqW{padding:0;font-weight:500}.bookingDateToggle__1CybK{width:100%}.calendarBackground__2INXj{background:#fff}.selectedBookingTime__3OzLD{font-weight:500}.periodWrapperTitle__3Nx7H{padding:.25rem}.periodContainer__1_-zA{padding:0;-ms-flex-wrap:wrap;flex-wrap:wrap}.periodContainer__1_-zA,.singlePeriod__1Gijs{display:-webkit-box;display:-ms-flexbox;display:flex}.singlePeriod__1Gijs{background:#eee;padding:0 .5rem;height:2rem;margin:.25rem;font-weight:500;border-radius:5px!important;border:2px solid transparent;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.singlePeriod__1Gijs.selected__2rLAr{font-weight:500;border:2px solid #dcf183;background:#f9faf5}.singlePeriod__1Gijs.waiting__3DdJQ{border-color:rgba(0,0,0,.2);border-style:dashed;background:#fff}.periodLegendWrapper__1hMBK{margin-top:1rem;padding-top:1rem;padding-bottom:1rem;border-top:1px solid #f5f6f4;font-size:12px;color:#666;-ms-flex-wrap:wrap;flex-wrap:wrap}.periodLegend__3ugPC,.periodLegendWrapper__1hMBK{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.periodLegend__3ugPC{margin:.25rem .75rem}.bookingTagSvg__ch4u_{margin-left:.5rem}.nextAvailableDate__23FtS{text-decoration:underline;font-weight:500;cursor:pointer;display:inline-block}.muted__2sWQJ{opacity:.54}.inputAreaWrapper__1Chu7{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:.5rem}.countryCodeSelectorDisplay__1wSuA{width:100%;background:#fff}.smallPadding__II40J{padding:.5rem}.countryCodeSelectorWrapper__zIlG4{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;background:#fff}.countryCodeList__D5ISg{list-style:none;margin:0;padding:0;max-height:80vh;height:20rem;overflow:scroll;width:100%}.countryCodeListItem__14zju{display:-webkit-box;display:-ms-flexbox;display:flex;border-bottom:1px solid rgba(0,0,0,.08)}.countryCodeFlag__23Dk9{width:4rem}.countryCodeName__Vso_v{padding:0;font-weight:500;width:100%}.countryCodeFlagWrapper__18AsG{display:block;text-align:center;width:100%}.countryCodeSelectorFlag__4qPCG{font-weight:500;height:100%;color:#373737;background-color:transparent;border:2px solid rgba(0,0,0,.08);border-radius:4px;-webkit-box-shadow:0 1px 1px 0 rgba(0,0,0,.08);box-shadow:0 1px 1px 0 rgba(0,0,0,.08);background:rgba(0,0,0,.02);max-width:100%;margin-right:.5rem}.showAll__sD2Qm{padding:.5rem;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;display:-webkit-box;display:-ms-flexbox;display:flex;width:100%}.showAll__sD2Qm>.countryCodeName__Vso_v{width:auto}.countryCodeFlagImage__f_LeE{height:.75rem}.countryCodeToggleText__3aXgP{margin-left:.5rem}.inputSpacer__V7QpP{-webkit-box-flex:0;-ms-flex:0 0 0.5rem;flex:0 0 0.5rem;height:.5rem}.registrationTeaser__1RR7q{font-weight:500;-webkit-box-shadow:rgba(0,0,0,.1) 0 2px 6px;box-shadow:0 2px 6px rgba(0,0,0,.1);width:100%;padding:2rem;height:auto;text-align:left;margin-top:2rem;border:1px solid #124142;background:rgba(18,65,66,.02)}.loginButton__27097{-webkit-box-shadow:rgba(0,0,0,.1) 0 2px 6px;box-shadow:0 2px 6px rgba(0,0,0,.1);background:#fff}.loginButton__27097,.registerButton__3uuvV{font-weight:500;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100%;padding:1rem;text-align:center}.registerButton__3uuvV{-webkit-box-shadow:none;box-shadow:none;background:transparent;margin-top:1rem}.registrationPerks__1SBjI{font-weight:400;font-size:16px}.affiliateCaption__3mZBV,.giftCardNotEnabledCaption__3lgmC{font-size:16px;opacity:.54}.giftCardNotEnabledLink__Ld2ws{font-weight:500;text-decoration:underline;font-size:16px;display:block;width:100%;margin-top:.5rem;opacity:.54;color:#000}.norwegianFetch__3ZaHv{white-space:nowrap;margin:0 1rem}.norwegianInput__3ha54{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:.5rem;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.resetBookingPeriod__2pgXk{position:absolute;right:0;top:0;bottom:0;height:auto;padding:0;width:3rem}.cardImage__1q7Bc{display:block;-o-object-fit:cover;object-fit:cover;height:100%;width:100%}.errorModal__1Y7m1{max-width:48rem}.errorModalContent__1P-u7{max-width:26rem;margin:0 auto}.errorMessage__29kav{text-align:center;opacity:.56;margin-bottom:2rem}.centerFlex__35ft9{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.bookingDetail__1IH7J{border-radius:5px;margin-top:1rem;margin-bottom:2rem;padding:2rem;white-space:pre-line}.confirmFooter__340fG{height:5.75rem}.confirmFooterWrapper__2z5b5{-webkit-box-shadow:0 -2px 6px rgba(0,0,0,.1);box-shadow:0 -2px 6px rgba(0,0,0,.1);position:fixed;bottom:0;left:0;right:0;justify-items:flex-end;display:-webkit-box;display:-ms-flexbox;display:flex;background:#fff;z-index:1;border-top:1px solid rgba(0,0,0,.08)}.confirmFooterControls__1LmPN{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-wrap:wrap;flex-wrap:wrap}.confirmFooterControls__1LmPN a{margin:1rem auto}.bookingButton__2D3q2{font-size:21px;border-radius:21px}.expandFlex__1WCaB{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1}.waitlistMessageWrapper__3mTqd{margin-top:-2.5rem;padding:1rem}.waitlistMessage__27ORM{border:2px solid rgba(255,153,0,.5);background:rgba(255,153,0,.1);padding:1rem;border-radius:4px}.pendingBanner__1lyu1{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1;background:#fef3f2;-webkit-box-shadow:0 18px 35px rgba(0,0,0,.17);box-shadow:0 18px 35px rgba(0,0,0,.17);position:fixed;top:0;left:0;right:0;z-index:1;border-bottom:1px solid rgba(0,0,0,.1);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.pendingBanner__1lyu1:before{content:\"\";background:#fda29b;-webkit-animation:fadeIn__2Sx0i 420s linear;animation:fadeIn__2Sx0i 420s linear;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;position:absolute;top:0;left:0;right:0;bottom:0}.pendingBanner__1lyu1,.pendingBanner__1lyu1 p{font-size:14px;line-height:1.5}.pendingBannerActions__3BU2G{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.pendingBannerClose__2yplV{border-radius:50%;opacity:.5;border:0;-webkit-appearance:none;background:transparent;color:inherit;width:2rem;height:2rem;line-height:2rem;text-align:center;-webkit-box-shadow:none;box-shadow:none;-webkit-transition:opacity .3s ease;transition:opacity .3s ease;font-size:2rem;margin:1rem}.pendingBannerClose__2yplV:hover{opacity:1}.pendingBannerClose__2yplV:after{content:\"\\D7\"}.promotionArea__3K_L9{padding:0;margin:0;border-top:0}.promotionDescription__PduGS{font-weight:400;white-space:pre-line;padding:0 0 1rem;margin-top:0}.promotionDate__1Xsv2{font-weight:500;padding:1rem 1rem 0;margin-top:0;opacity:.54}.promotionMenu__3YZUI{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:0 0 1rem;width:100%}@-webkit-keyframes fadeIn__2Sx0i{0%{opacity:0}to{opacity:1}}@keyframes fadeIn__2Sx0i{0%{opacity:0}to{opacity:1}}@media only screen and (max-width:64rem){.inputArea__1BzRc{padding:1rem;max-width:100%}.inputArea__1BzRc.noPadding__15LoP{padding:0 1rem .5rem}.inputLabel__19PVu{padding-bottom:0;max-width:100%}.periodContainer__1_-zA,.periodWrapperTitle__3Nx7H{padding:0}}@media only screen and (max-width:50rem){.titleWrapper__1UQ7c{max-width:100%}.secondaryTitle__1yLgr{color:#001414;height:auto;padding:2rem 0 0}.mainPromotion__GDbl6{height:auto;display:none}.restaurantInfo__1xFjI{margin-top:0}.mainPromotion__GDbl6,.secondaryList__33DQS,.secondaryPromotion__2E17e{padding:0;width:100%}.secondaryPromotion__2E17e{display:block}.checkboxContainer__3LjP_{padding:0 .5rem 0 .25rem}.inputArea__1BzRc.noPadding__15LoP{padding-bottom:0;padding:0 .5rem .5rem}.inputArea__1BzRc.noPadding__15LoP button,.inputArea__1BzRc.noPadding__15LoP p,.inputArea__1BzRc.noPadding__15LoP select{font-weight:500;line-height:16px;height:auto}.inputLabel__19PVu{padding:0;font-size:12px;font-weight:500;line-height:1.5rem}.inputLabel__19PVu.mobilePadding__pWRCk{padding:.5rem}.inputArea__1BzRc{padding:0}.periodWrapper__2leKA{margin-top:0}.inputArea__1BzRc.noPadding__15LoP .periodContainer__1_-zA button{padding:0 .5rem;line-height:2rem;height:2rem}.inputArea__1BzRc.noPadding__15LoP button{min-height:1rem}.countryCodeSelectorFlag__4qPCG{padding:.5rem}.error__2xexw{padding:.25rem;line-height:2}.fieldset__1H2L8{padding:.5rem}.fieldsetContent__12WxN{-webkit-box-shadow:0;box-shadow:0;margin-top:0;margin-bottom:0}.checkboxContent__140SS{padding:.25rem}.legend__2T-9z{display:table;padding:1rem 0 .5rem}.inputLabel__19PVu[for=card-element]{display:none}.bookingDetail__1IH7J{padding:.5rem;font-size:12px;margin-top:1rem;margin-bottom:1rem;position:relative}.affiliateCaption__3mZBV,.bookingDetail__1IH7J p{margin-top:0;line-height:16px}.affiliateCaption__3mZBV,.periodWrapperTitle__3Nx7H,.restaurantIconDetails__15koV{font-size:12px}.periodWrapper__2leKA{margin:0 0 .25rem}.noCheckboxContainerMobilePadding__scfwY{padding:0}.waitlistMessageWrapper__3mTqd{margin-top:0;padding:.5rem}.pendingBanner__1lyu1,.pendingBanner__1lyu1 p{font-size:12px;line-height:1.5}}@media only screen and (max-height:64rem){.promotionSplitter__Ry5bY{margin-top:-4rem}}", ""]);

// exports
exports.locals = {
	"bookingFlow": "bookingFlow__afA8a",
	"bookingForm": "bookingForm__3LWzx",
	"titleWrapper": "titleWrapper__1UQ7c",
	"restaurantInfo": "restaurantInfo__1xFjI",
	"restaurantNameLink": "restaurantNameLink__37a25",
	"restaurantIconDetails": "restaurantIconDetails__15koV",
	"fieldset": "fieldset__1H2L8",
	"legend": "legend__2T-9z",
	"fullOpacity": "fullOpacity__zGqQd",
	"requiredLegend": "requiredLegend__3Fyll",
	"fulfilledLegend": "fulfilledLegend__T963c",
	"fieldsetContent": "fieldsetContent__12WxN",
	"fieldsetContentWithoutMargin": "fieldsetContentWithoutMargin__3ffKL",
	"widget": "widget__3z_Ld",
	"checkboxContainer": "checkboxContainer__3LjP_",
	"disabledOption": "disabledOption__1aza3",
	"checkboxContent": "checkboxContent__140SS",
	"inputContainer": "inputContainer__3c3g4",
	"inputLabel": "inputLabel__19PVu",
	"imageLabel": "imageLabel__jh9Dg",
	"affiliateInput": "affiliateInput__6yen2",
	"resetBookingPeriod": "resetBookingPeriod__2pgXk",
	"adultAmountSelector": "adultAmountSelector__1rG8q",
	"childrenAmountSelector": "childrenAmountSelector__3a3YJ",
	"periodWrapper": "periodWrapper__2leKA",
	"inputArea": "inputArea__1BzRc",
	"noPadding": "noPadding__15LoP",
	"error": "error__2xexw",
	"textInputArea": "textInputArea__1KPBB",
	"termsOfService": "termsOfService__yot54",
	"affiliateLogo": "affiliateLogo__2r5Jv",
	"paymentLogo": "paymentLogo__2zQmn",
	"norwegianLogo": "norwegianLogo__uYlAp",
	"cardInput": "cardInput__uAvLV",
	"cardError": "cardError__1gg_W",
	"giftCardInput": "giftCardInput__fbmcp",
	"giftCardSoftError": "giftCardSoftError__1koCe",
	"giftCardAmountContainer": "giftCardAmountContainer__2ADfJ",
	"giftCardTitleContainer": "giftCardTitleContainer__d2-PK",
	"profileSelector": "profileSelector__2UYFv",
	"promotionSplitter": "promotionSplitter__Ry5bY",
	"mainPromotion": "mainPromotion__GDbl6",
	"selectorLink": "selectorLink__1258k",
	"secondaryPromotion": "secondaryPromotion__2E17e",
	"secondaryTitle": "secondaryTitle__1yLgr",
	"secondaryList": "secondaryList__33DQS",
	"partySizeSelector": "partySizeSelector__3546D",
	"partySizeSelectorCaption": "partySizeSelectorCaption__3CKlg",
	"ageLimitCaption": "ageLimitCaption__2vNBz",
	"bookingDateSelector": "bookingDateSelector__1TXqW",
	"bookingDateToggle": "bookingDateToggle__1CybK",
	"calendarBackground": "calendarBackground__2INXj",
	"selectedBookingTime": "selectedBookingTime__3OzLD",
	"periodWrapperTitle": "periodWrapperTitle__3Nx7H",
	"periodContainer": "periodContainer__1_-zA",
	"singlePeriod": "singlePeriod__1Gijs",
	"selected": "selected__2rLAr",
	"waiting": "waiting__3DdJQ",
	"periodLegendWrapper": "periodLegendWrapper__1hMBK",
	"periodLegend": "periodLegend__3ugPC",
	"bookingTagSvg": "bookingTagSvg__ch4u_",
	"nextAvailableDate": "nextAvailableDate__23FtS",
	"muted": "muted__2sWQJ",
	"inputAreaWrapper": "inputAreaWrapper__1Chu7",
	"countryCodeSelectorDisplay": "countryCodeSelectorDisplay__1wSuA",
	"smallPadding": "smallPadding__II40J",
	"countryCodeSelectorWrapper": "countryCodeSelectorWrapper__zIlG4",
	"countryCodeList": "countryCodeList__D5ISg",
	"countryCodeListItem": "countryCodeListItem__14zju",
	"countryCodeFlag": "countryCodeFlag__23Dk9",
	"countryCodeName": "countryCodeName__Vso_v",
	"countryCodeFlagWrapper": "countryCodeFlagWrapper__18AsG",
	"countryCodeSelectorFlag": "countryCodeSelectorFlag__4qPCG",
	"showAll": "showAll__sD2Qm",
	"countryCodeFlagImage": "countryCodeFlagImage__f_LeE",
	"countryCodeToggleText": "countryCodeToggleText__3aXgP",
	"inputSpacer": "inputSpacer__V7QpP",
	"registrationTeaser": "registrationTeaser__1RR7q",
	"loginButton": "loginButton__27097",
	"registerButton": "registerButton__3uuvV",
	"registrationPerks": "registrationPerks__1SBjI",
	"affiliateCaption": "affiliateCaption__3mZBV",
	"giftCardNotEnabledCaption": "giftCardNotEnabledCaption__3lgmC",
	"giftCardNotEnabledLink": "giftCardNotEnabledLink__Ld2ws",
	"norwegianFetch": "norwegianFetch__3ZaHv",
	"norwegianInput": "norwegianInput__3ha54",
	"cardImage": "cardImage__1q7Bc",
	"errorModal": "errorModal__1Y7m1",
	"errorModalContent": "errorModalContent__1P-u7",
	"errorMessage": "errorMessage__29kav",
	"centerFlex": "centerFlex__35ft9",
	"bookingDetail": "bookingDetail__1IH7J",
	"confirmFooter": "confirmFooter__340fG",
	"confirmFooterWrapper": "confirmFooterWrapper__2z5b5",
	"confirmFooterControls": "confirmFooterControls__1LmPN",
	"bookingButton": "bookingButton__2D3q2",
	"noCheckboxContainerMobilePadding": "noCheckboxContainerMobilePadding__scfwY",
	"expandFlex": "expandFlex__1WCaB",
	"waitlistMessageWrapper": "waitlistMessageWrapper__3mTqd",
	"waitlistMessage": "waitlistMessage__27ORM",
	"pendingBanner": "pendingBanner__1lyu1",
	"fadeIn": "fadeIn__2Sx0i",
	"pendingBannerActions": "pendingBannerActions__3BU2G",
	"pendingBannerClose": "pendingBannerClose__2yplV",
	"promotionArea": "promotionArea__3K_L9",
	"promotionDescription": "promotionDescription__PduGS",
	"promotionDate": "promotionDate__1Xsv2",
	"promotionMenu": "promotionMenu__3YZUI",
	"mobilePadding": "mobilePadding__pWRCk"
};

/***/ }),

/***/ "3YCK":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("IPWD");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false,"singleton":true,"attrs":{"data-tableonline-build":"10.24.1"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "4YSV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("etZl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);



var Checkbox = function Checkbox(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'label',
    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.checkbox },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
      type: props.type ? props.type : 'checkbox',
      checked: props.checked,
      disabled: props.disabled,
      onChange: props.onChange,
      id: props.id,
      name: props.name
    }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.indicator }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'main',
      { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.content },
      props.children
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Checkbox);

/***/ }),

/***/ "4md/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var numberIsNaN = function numberIsNaN(value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};

/***/ }),

/***/ "55IF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./globals.js
var globals = __webpack_require__("zQXs");

// EXTERNAL MODULE: ../node_modules/preact-helmet/lib/Helmet.js
var Helmet = __webpack_require__("FJnM");
var Helmet_default = /*#__PURE__*/__webpack_require__.n(Helmet);

// EXTERNAL MODULE: ./components/hero/style.css
var style = __webpack_require__("0U3q");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./components/slots/index.js
var slots = __webpack_require__("Jof1");

// EXTERNAL MODULE: ./components/header/index.js + 3 modules
var header = __webpack_require__("sIAo");

// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// EXTERNAL MODULE: ./components/breadcrumbs/style.css
var breadcrumbs_style = __webpack_require__("r/Ku");
var breadcrumbs_style_default = /*#__PURE__*/__webpack_require__.n(breadcrumbs_style);

// CONCATENATED MODULE: ./components/breadcrumbs/index.js





var breadcrumbs_Breadcrumbs = function Breadcrumbs(_ref) {
  var _ref$breadcrumbs = _ref.breadcrumbs,
      breadcrumbs = _ref$breadcrumbs === undefined ? [] : _ref$breadcrumbs;

  if (!breadcrumbs.length) return null;

  return Object(preact_min["h"])(
    'div',
    { 'class': breadcrumbs_style_default.a.breadcrumbWrapper },
    Object(preact_min["h"])(
      'ul',
      { 'class': breadcrumbs_style_default.a.breadcrumbs },
      breadcrumbs.map(function (item) {
        return Object(preact_min["h"])(
          'li',
          null,
          Object(preact_min["h"])(
            match["Link"],
            {
              activeClassName: breadcrumbs_style_default.a.active,
              'class': breadcrumbs_style_default.a.link,
              href: item.link
            },
            item.title
          )
        );
      })
    )
  );
};

/* harmony default export */ var components_breadcrumbs = (breadcrumbs_Breadcrumbs);
// CONCATENATED MODULE: ./components/hero/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hero_HeroWrapper; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var hero_buildMetaTags = function buildMetaTags(title, description, image, link) {
  image = !image ? '' : image.includes('?') ? image + '&auto=format' : image.includes('auto=format') ? image : image + '?auto=format';
  var titleTags = [{ name: 'name' }, { name: 'twitter:name' }, { itemprop: 'name' }, { property: 'og:title' }],
      descriptionTags = [{ name: 'description' }, { name: 'twitter:description' }, { itemprop: 'description' }, { property: 'og:description' }],
      imageTags = [{ name: 'image' }, { name: 'twitter:image' }, { itemprop: 'image' }, { property: 'og:image' }],
      appTags = [{
    name: 'apple-itunes-app',
    content: 'app-id=1596078295, appArgument=' + encodeURIComponent(window.location.href)
  }];

  return {
    title: title,
    meta: [{ property: 'og:site_name', content: 'TableOnline.fi' }, { property: 'og:see_also', content: globals["b" /* DOMAIN */] + '/en' }, { property: 'og:type', content: 'article' }, { property: 'twitter:card', content: 'summary' }].concat(titleTags.map(function (property) {
      return _extends({}, property, { content: title });
    }), descriptionTags.map(function (property) {
      return _extends({}, property, {
        content: description
      });
    }), imageTags.map(function (property) {
      return _extends({}, property, { content: image });
    }), appTags).filter(function (item) {
      return item.content;
    }),
    link: link ? link.map(function (item) {
      item.href = item.href.indexOf('/') === 0 ? '' + globals["b" /* DOMAIN */] + item.href : item.href;
      return item;
    }).map(function (item) {
      return item.hreflang && item.hreflang === 'ee' ? _extends({}, item, { hreflang: 'et' }) : item;
    }) : []
  };
};

var _ref3 = Object(preact_min["h"])(header["a" /* default */], { dark: true });

var _ref4 = Object(preact_min["h"])('h1', { placeholder: true, key: 'heroTitleH1Placeholder' });

var _ref5 = Object(preact_min["h"])('h2', { placeholder: true, key: 'heroTitleH2Placeholder' });

var hero_HeroWrapper = function (_Component) {
  _inherits(HeroWrapper, _Component);

  function HeroWrapper() {
    _classCallCheck(this, HeroWrapper);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  HeroWrapper.prototype.render = function render(_ref, state, _ref2) {
    var propBreadcrumbs = _ref.breadcrumbs;
    var _ref2$breadcrumbs = _ref2.breadcrumbs,
        contextBreadcrumbs = _ref2$breadcrumbs === undefined ? [] : _ref2$breadcrumbs;

    // Use breadcrumbs from props if available, otherwise from context
    var breadcrumbs = propBreadcrumbs || contextBreadcrumbs;

    return Object(preact_min["h"])(
      'header',
      null,
      _ref3,
      Object(preact_min["h"])(
        'div',
        { 'class': style_default.a.hero, 'hero-bg': true },
        Object(preact_min["h"])(
          'div',
          { 'class': style_default.a.heroTitle + ' contain' },
          Object(preact_min["h"])(components_breadcrumbs, { breadcrumbs: breadcrumbs }),
          Object(preact_min["h"])(
            slots["a" /* Slot */],
            { name: 'hero' },
            Object(preact_min["h"])(
              'div',
              { 'class': style_default.a.heroTitleContent },
              _ref4,
              _ref5
            )
          )
        )
      )
    );
  };

  return HeroWrapper;
}(preact_min["Component"]);

var hero_Hero = function (_Component2) {
  _inherits(Hero, _Component2);

  function Hero() {
    _classCallCheck(this, Hero);

    return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
  }

  Hero.prototype.render = function render(_ref6) {
    var title = _ref6.title,
        description = _ref6.description,
        children = _ref6.children,
        _ref6$image = _ref6.image,
        image = _ref6$image === undefined ? 'https://img.tableonline.fi/restaurant/309/images/tableonline-309-alasti-I018418f53294.jpg?auto=format&fit=crop&w=' + window.innerWidth + '&q=80' : _ref6$image,
        _ref6$onlyChildren = _ref6.onlyChildren,
        onlyChildren = _ref6$onlyChildren === undefined ? false : _ref6$onlyChildren,
        link = _ref6.link;

    return Object(preact_min["h"])(
      slots["b" /* SlotContent */],
      { slot: 'hero' },
      Object(preact_min["h"])(
        'div',
        { 'class': style_default.a.heroTitleContent },
        title && onlyChildren === false ? Object(preact_min["h"])(
          'h1',
          null,
          title
        ) : null,
        description && onlyChildren === false ? Object(preact_min["h"])(
          'h2',
          null,
          description
        ) : null,
        children || null,
        Object(preact_min["h"])(Helmet_default.a, _extends({}, hero_buildMetaTags(title, description, image, link), {
          onChangeClientState: function onChangeClientState() {
            return [].concat(document.head.querySelectorAll('[data-preact-helmet="true"]').forEach(function (el) {
              return document.head.querySelector('title').insertAdjacentElement('afterEnd', el);
            }));
          }
        })),
        image ? Object(preact_min["h"])('style', {
          dangerouslySetInnerHTML: {
            __html: '[hero-bg] {background:url(' + image + ') 50% 50% / cover}'
          }
        }) : null
      )
    );
  };

  return Hero;
}(preact_min["Component"]);

/* harmony default export */ var hero = __webpack_exports__["b"] = (hero_Hero);

/***/ }),

/***/ "55Q6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./reflectApply')} */

module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

/***/ }),

/***/ "58Ti":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__("B6/o");

module.exports = Function.prototype.bind || implementation;

/***/ }),

/***/ "5NKs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__("LiLl");

var callBindBasic = __webpack_require__("2V1b");

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	/* eslint no-extra-parens: 0 */

	var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic( /** @type {const} */[intrinsic]);
	}
	return intrinsic;
};

/***/ }),

/***/ "5ttS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(I18n) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Footer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("ZMjw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_image__ = __webpack_require__("tJjN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pubsub__ = __webpack_require__("0/XQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_translate__ = __webpack_require__("Mcf2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_button__ = __webpack_require__("rAoZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_popover__ = __webpack_require__("exxx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__analytics__ = __webpack_require__("qV3Q");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var trackContentClick = function trackContentClick(content_type, content_id) {
  Object(__WEBPACK_IMPORTED_MODULE_7__analytics__["b" /* default */])({
    event: 'select_content',
    content_type: content_type,
    content_id: content_id
  });
};

var LanguageSelectorList = function LanguageSelectorList(_ref, _ref2) {
  var languages = _ref.languages;
  var closePopOver = _ref2.closePopOver;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languageSelectorWrapper, onClick: closePopOver },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_3__components_pubsub__["c" /* Stateful */],
      { events: ['hasTranslationRoute'] },
      function (_ref3) {
        var _ref3$hasTranslationR = _ref3.hasTranslationRoute,
            hasTranslationRoute = _ref3$hasTranslationR === undefined ? false : _ref3$hasTranslationR;
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'ul',
          null,
          languages.map(function (language) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'li',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                __WEBPACK_IMPORTED_MODULE_5__components_button__["c" /* default */],
                {
                  'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languageSelectorButton,
                  href: hasTranslationRoute ? window.location.pathname.split('/').map(function (item, index) {
                    return index === 1 ? language.code : item;
                  }).join('/') : '/' + language.code,
                  onClick: function onClick() {
                    return window.setTimeout(function () {
                      return window.location.reload();
                    }, 16);
                  }
                },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'span',
                  { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languageSelectorFlag },
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__components_image__["a" /* default */], {
                    src: 'https://cdn.rawgit.com/hjnilsson/country-flags/master/svg/' + language.flag + '.svg',
                    alt: language.name,
                    'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languageSelectorFlagImage
                  })
                ),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'span',
                  { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languageSelectorDisplayname },
                  language.name
                )
              )
            );
          })
        );
      }
    )
  );
};

var LanguageSelector = function (_Component) {
  _inherits(LanguageSelector, _Component);

  function LanguageSelector() {
    var _temp, _this, _ret;

    _classCallCheck(this, LanguageSelector);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      languages: [{ code: 'en', name: 'English', flag: 'gb' }, { code: 'fi', name: 'Suomi', flag: 'fi' }, { code: 'ee', name: 'Eesti', flag: 'ee' }]
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  LanguageSelector.prototype.render = function render(props, _ref4, _ref5) {
    var languages = _ref4.languages;
    var lang = _ref5.lang;

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languageSelectorContainer },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_6__components_popover__["a" /* default */],
        {
          toggle: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            __WEBPACK_IMPORTED_MODULE_5__components_button__["c" /* default */],
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languageToggle },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'span',
              { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languageSelectorFlag },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__components_image__["a" /* default */], {
                src: 'https://cdn.rawgit.com/hjnilsson/country-flags/master/svg/' + languages.filter(function (_ref6) {
                  var code = _ref6.code;
                  return code === lang;
                })[0].flag + '.svg',
                alt: languages.filter(function (_ref7) {
                  var code = _ref7.code;
                  return code === lang;
                })[0].name,
                'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languageSelectorFlagImage
              })
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'span',
              { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languageSelectorDisplayname },
              languages.filter(function (_ref8) {
                var code = _ref8.code;
                return code === lang;
              })[0].name
            )
          ),
          'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languageSelector
        },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(LanguageSelectorList, {
          languages: languages,
          hasTranslationRoute: props.hasTranslationRoute
        })
      )
    );
  };

  return LanguageSelector;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var _ref10 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('hr', null);

var _ref11 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'li',
  null,
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'a',
    { href: '/fi' },
    'Suomi'
  )
);

var _ref12 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'li',
  null,
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'a',
    { href: '/en' },
    'English'
  )
);

var _ref13 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'li',
  null,
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'a',
    { href: '/ee' },
    'Eesti'
  )
);

var _ref14 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', {
  width: '22',
  heigth: '16',
  src: 'https://static.citycdn.fi/graphics/city-logo-160.png',
  alt: 'TableOnlinen ruoka ja ravintola-aiheinen blogi'
});

var _ref15 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'svg',
  {
    viewBox: '0 0 16 16',
    xmlns: 'http://www.w3.org/2000/svg',
    'fill-rule': 'evenodd',
    fill: '#ffffff',
    'clip-rule': 'evenodd',
    'stroke-linejoin': 'round',
    'stroke-miterlimit': '1.414'
  },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', {
    d: 'M15.117 0H.883C.395 0 0 .395 0 .883v14.234c0 .488.395.883.883.883h7.663V9.804H6.46V7.39h2.086V5.607c0-2.066 1.262-3.19 3.106-3.19.883 0 1.642.064 1.863.094v2.16h-1.28c-1 0-1.195.476-1.195 1.176v1.54h2.39l-.31 2.416h-2.08V16h4.077c.488 0 .883-.395.883-.883V.883C16 .395 15.605 0 15.117 0',
    'fill-rule': 'nonzero'
  })
);

var _ref16 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'svg',
  {
    fill: '#ffffff',
    viewBox: '0 0 16 16',
    xmlns: 'http://www.w3.org/2000/svg',
    'fill-rule': 'evenodd',
    'clip-rule': 'evenodd',
    'stroke-linejoin': 'round',
    'stroke-miterlimit': '1.414'
  },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', {
    d: 'M16 3.038c-.59.26-1.22.437-1.885.517.677-.407 1.198-1.05 1.443-1.816-.634.375-1.337.648-2.085.795-.598-.638-1.45-1.036-2.396-1.036-1.812 0-3.282 1.468-3.282 3.28 0 .258.03.51.085.75C5.152 5.39 2.733 4.084 1.114 2.1.83 2.583.67 3.147.67 3.75c0 1.14.58 2.143 1.46 2.732-.538-.017-1.045-.165-1.487-.41v.04c0 1.59 1.13 2.918 2.633 3.22-.276.074-.566.114-.865.114-.21 0-.416-.02-.617-.058.418 1.304 1.63 2.253 3.067 2.28-1.124.88-2.54 1.404-4.077 1.404-.265 0-.526-.015-.783-.045 1.453.93 3.178 1.474 5.032 1.474 6.038 0 9.34-5 9.34-9.338 0-.143-.004-.284-.01-.425.64-.463 1.198-1.04 1.638-1.7z',
    'fill-rule': 'nonzero'
  })
);

var _ref17 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'svg',
  {
    fill: '#ffffff',
    viewBox: '0 0 16 16',
    xmlns: 'http://www.w3.org/2000/svg',
    'fill-rule': 'evenodd',
    'clip-rule': 'evenodd',
    'stroke-linejoin': 'round',
    'stroke-miterlimit': '1.414'
  },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M14.154 16H1.846C.826 16 0 15.173 0 14.153V1.846C0 .826.826 0 1.846 0h12.308C15.174 0 16 .826 16 1.846v12.307c0 1.02-.826 1.847-1.846 1.847M8 4.923C6.3 4.923 4.923 6.3 4.923 8S6.3 11.077 8 11.077 11.077 9.7 11.077 8C11.077 6.3 9.7 4.923 8 4.923m6.154-2.462c0-.34-.275-.614-.616-.614h-1.846c-.34 0-.615.275-.615.615V4.31c0 .34.276.615.615.615h1.846c.34 0 .616-.276.616-.615V2.46zm0 4.31H12.76c.103.392.163.804.163 1.23 0 2.72-2.204 4.923-4.923 4.923-2.72 0-4.923-2.204-4.923-4.923 0-.426.06-.838.162-1.23H1.845v6.768c0 .34.275.615.616.615h11.076c.34 0 .616-.275.616-.615v-6.77z' })
);

var _ref18 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'svg',
  {
    fill: '#ffffff',
    viewBox: '0 0 16 16',
    xmlns: 'http://www.w3.org/2000/svg',
    'fill-rule': 'evenodd',
    'clip-rule': 'evenodd',
    'stroke-linejoin': 'round',
    'stroke-miterlimit': '1.414'
  },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M0 7.345c0-1.294.16-2.59.16-2.59s.156-1.1.636-1.587c.608-.637 1.408-.617 1.764-.684C3.84 2.36 8 2.324 8 2.324s3.362.004 5.6.166c.314.038.996.04 1.604.678.48.486.636 1.588.636 1.588S16 6.05 16 7.346v1.258c0 1.296-.16 2.59-.16 2.59s-.156 1.102-.636 1.588c-.608.638-1.29.64-1.604.678-2.238.162-5.6.166-5.6.166s-4.16-.037-5.44-.16c-.356-.067-1.156-.047-1.764-.684-.48-.487-.636-1.587-.636-1.587S0 9.9 0 8.605v-1.26zm6.348 2.73V5.58l4.323 2.255-4.32 2.24h-.002z' })
);

var _ref19 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'svg',
  {
    viewBox: '0 0 16 16',
    xmlns: 'http://www.w3.org/2000/svg',
    'fill-rule': 'evenodd',
    fill: '#ffffff',
    'clip-rule': 'evenodd',
    'stroke-linejoin': 'round',
    'stroke-miterlimit': '1.414'
  },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', {
    d: 'M15.117 0H.883C.395 0 0 .395 0 .883v14.234c0 .488.395.883.883.883h7.663V9.804H6.46V7.39h2.086V5.607c0-2.066 1.262-3.19 3.106-3.19.883 0 1.642.064 1.863.094v2.16h-1.28c-1 0-1.195.476-1.195 1.176v1.54h2.39l-.31 2.416h-2.08V16h4.077c.488 0 .883-.395.883-.883V.883C16 .395 15.605 0 15.117 0',
    'fill-rule': 'nonzero'
  })
);

var _ref20 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'svg',
  {
    fill: '#ffffff',
    viewBox: '0 0 16 16',
    xmlns: 'http://www.w3.org/2000/svg',
    'fill-rule': 'evenodd',
    'clip-rule': 'evenodd',
    'stroke-linejoin': 'round',
    'stroke-miterlimit': '1.414'
  },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M14.154 16H1.846C.826 16 0 15.173 0 14.153V1.846C0 .826.826 0 1.846 0h12.308C15.174 0 16 .826 16 1.846v12.307c0 1.02-.826 1.847-1.846 1.847M8 4.923C6.3 4.923 4.923 6.3 4.923 8S6.3 11.077 8 11.077 11.077 9.7 11.077 8C11.077 6.3 9.7 4.923 8 4.923m6.154-2.462c0-.34-.275-.614-.616-.614h-1.846c-.34 0-.615.275-.615.615V4.31c0 .34.276.615.615.615h1.846c.34 0 .616-.276.616-.615V2.46zm0 4.31H12.76c.103.392.163.804.163 1.23 0 2.72-2.204 4.923-4.923 4.923-2.72 0-4.923-2.204-4.923-4.923 0-.426.06-.838.162-1.23H1.845v6.768c0 .34.275.615.616.615h11.076c.34 0 .616-.275.616-.615v-6.77z' })
);

var Footer = function (_Component2) {
  _inherits(Footer, _Component2);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
  }

  Footer.prototype.render = function render(props, state, _ref9) {
    var lang = _ref9.lang;

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'footer',
      { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footer, style: props.style },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': 'contain' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'span',
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.logoIntro },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', {
            src: '/assets/images/logo-text-white-large.png',
            alt: 'TableOnline Logo',
            'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerLogo
          }),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            __WEBPACK_IMPORTED_MODULE_4__components_translate__["a" /* default */],
            { p: true, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerIntroText },
            I18n.t("Make reservations, read reviews, find offers and discover the top restaurants in Finland and Tallinn. Search hundreds of restaurants and find the best!")
          )
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(LanguageSelector, { hasTranslationRoute: props.hasTranslationRoute })
      ),
      _ref10,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': 'contain' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerLinks },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerLinkContainer },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'h6',
              { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerLinkTitle },
              'TableOnline.fi'
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'ul',
              { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerLinkList },
              _ref11,
              _ref12,
              _ref13
            )
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerLinkContainer },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              __WEBPACK_IMPORTED_MODULE_4__components_translate__["a" /* default */],
              { h6: true, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerLinkTitle },
              I18n.t("About TableOnline")
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'ul',
              { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerLinkList },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'li',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'a',
                  {
                    onClick: function onClick() {
                      return trackContentClick('Footer link', 'Contact us');
                    },
                    href: lang === 'fi' ? '/fi/ota-yhteytta' : lang === 'en' ? '/en/contact-us' : lang === 'ee' ? '/ee/vota-meiega-uhendust' : null
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_4__components_translate__["a" /* default */],
                    null,
                    I18n.t("Contact us")
                  )
                )
              ),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'li',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'a',
                  {
                    href: 'https://www.tableonline.fi/' + lang + '/profile',
                    onClick: function onClick() {
                      return trackContentClick('Footer link', 'Restaurant backoffice');
                    }
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_4__components_translate__["a" /* default */],
                    null,
                    I18n.t("Restaurant backoffice")
                  )
                )
              )
            )
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerLinkContainer },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              __WEBPACK_IMPORTED_MODULE_4__components_translate__["a" /* default */],
              { h6: true, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerLinkTitle },
              I18n.t("More information")
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'ul',
              { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerLinkList },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'li',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'a',
                  {
                    href: '/' + lang + '/terms',
                    onClick: function onClick() {
                      return trackContentClick('Footer link', 'Terms and conditions');
                    }
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_4__components_translate__["a" /* default */],
                    null,
                    I18n.t("Terms and Conditions")
                  )
                )
              ),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'li',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'a',
                  {
                    href: '/' + lang + '/giftcard-terms',
                    onClick: function onClick() {
                      return trackContentClick('Footer link', 'Gift card terms of use');
                    }
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_4__components_translate__["a" /* default */],
                    null,
                    I18n.t("Gift card terms of use")
                  )
                )
              ),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'li',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'a',
                  {
                    href: '/' + lang + '/privacy',
                    onClick: function onClick() {
                      return trackContentClick('Footer link', 'Privacy policy');
                    }
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_4__components_translate__["a" /* default */],
                    null,
                    I18n.t("Privacy policy")
                  )
                )
              ),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'li',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'a',
                  {
                    href: '/' + lang + '/cookies',
                    onClick: function onClick() {
                      return trackContentClick('Footer link', 'Cookie settings');
                    }
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_4__components_translate__["a" /* default */],
                    null,
                    I18n.t("Cookie settings")
                  )
                )
              )
            )
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerLinkContainer },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              __WEBPACK_IMPORTED_MODULE_4__components_translate__["a" /* default */],
              { h6: true, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerLinkTitle },
              I18n.t("Partner with TableOnline")
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'ul',
              { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerLinkList },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'li',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'a',
                  {
                    onClick: function onClick() {
                      return trackContentClick('Footer link', 'Join TableOnline');
                    },
                    target: '_blank',
                    href: lang === 'fi' ? '/fi/liity-tableonlineen' : lang === 'en' ? '/en/join' : lang === 'ee' ? '/ee/vota-meiega-uhendust' : null
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_4__components_translate__["a" /* default */],
                    null,
                    I18n.t("For restaurants")
                  )
                )
              ),
              lang === 'fi' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'li',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'a',
                  {
                    href: '/fi/affiliate-yhteistyo',
                    onClick: function onClick() {
                      return trackContentClick('Footer link', 'Affiliate partnership');
                    }
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_4__components_translate__["a" /* default */],
                    null,
                    I18n.t("For affiliate partners")
                  )
                )
              ) : lang === 'en' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'li',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'a',
                  {
                    href: '/en/affiliate',
                    onClick: function onClick() {
                      return trackContentClick('Footer link', 'Affiliate partnership');
                    }
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_4__components_translate__["a" /* default */],
                    null,
                    I18n.t("For affiliate partners")
                  )
                )
              ) : null
            )
          ),
          lang !== 'ee' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerLinkContainer },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              __WEBPACK_IMPORTED_MODULE_4__components_translate__["a" /* default */],
              { h6: true, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerLinkTitle },
              I18n.t("Follow us")
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'ul',
              { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerSocialMediaList },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'li',
                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerSocialMediaItem },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'a',
                  {
                    href: 'https://www.city.fi/blogit/tableonline',
                    onClick: function onClick() {
                      return trackContentClick('Footer link', 'TableOnline Blog');
                    }
                  },
                  _ref14
                )
              ),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'li',
                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerSocialMediaItem },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'a',
                  {
                    href: 'https://www.facebook.com/tableonlinefi',
                    onClick: function onClick() {
                      return trackContentClick('Footer link', 'Facebook');
                    }
                  },
                  _ref15
                )
              ),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'li',
                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerSocialMediaItem },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'a',
                  {
                    href: 'https://twitter.com/tableonlinefi',
                    onClick: function onClick() {
                      return trackContentClick('Footer link', 'Twitter');
                    }
                  },
                  _ref16
                )
              ),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'li',
                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerSocialMediaItem },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'a',
                  {
                    href: 'https://instagram.com/tableonlinefi',
                    onClick: function onClick() {
                      return trackContentClick('Footer link', 'Instagram');
                    }
                  },
                  _ref17
                )
              ),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'li',
                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerSocialMediaItem },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'a',
                  {
                    href: 'https://www.youtube.com/channel/UCTj2L1ZmVQSymMEH2wXwfeA',
                    onClick: function onClick() {
                      return trackContentClick('Footer link', 'Youtube');
                    }
                  },
                  _ref18
                )
              )
            )
          ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerLinkContainer },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              __WEBPACK_IMPORTED_MODULE_4__components_translate__["a" /* default */],
              { h6: true, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerLinkTitle },
              I18n.t("Follow us")
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'ul',
              { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerSocialMediaList },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'li',
                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerSocialMediaItem },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'a',
                  {
                    href: 'https://www.facebook.com/tableonline.ee/',
                    onClick: function onClick() {
                      return trackContentClick('Footer link', 'Facebook');
                    }
                  },
                  _ref19
                )
              ),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'li',
                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.footerSocialMediaItem },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'a',
                  {
                    href: 'https://www.instagram.com/tableonlineeesti/',
                    onClick: function onClick() {
                      return trackContentClick('Footer link', 'Instagram');
                    }
                  },
                  _ref20
                )
              )
            )
          )
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.copyright + ' contain' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'a',
            { href: 'https://alasti.fi?ref=tableonline' },
            'Copyright \xA9 ',
            new Date().getFullYear(),
            '. All rights reserved. Site by Alasti.'
          )
        )
      )
    );
  };

  return Footer;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("iY+1")))

/***/ }),

/***/ "6FVH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__("CjFg");

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};

/***/ }),

/***/ "6JNq":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// I18n.js
// =======
//
// This small library provides the Rails I18n API on the Javascript.
// You don't actually have to use Rails (or even Ruby) to use I18n.js.
// Just make sure you export all translations in an object like this:
//
//     I18n.translations.en = {
//       hello: "Hello World"
//     };
//
// See tests for specific formatting like numbers and dates.
//

// Using UMD pattern from
// https://github.com/umdjs/umd#regular-module
// `returnExports.js` version
;(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return factory(root);
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(root);
  } else {
    // Browser globals (root is window)
    root.I18n = factory(root);
  }
})(this, function (global) {
  "use strict";

  // Use previously defined object if exists in current scope

  var I18n = global && global.I18n || {};

  // Just cache the Array#slice function.
  var slice = Array.prototype.slice;

  // Apply number padding.
  var padding = function padding(number) {
    return ("0" + number.toString()).substr(-2);
  };

  // Improved toFixed number rounding function with support for unprecise floating points
  // JavaScript's standard toFixed function does not round certain numbers correctly (for example 0.105 with precision 2).
  var toFixed = function toFixed(number, precision) {
    return decimalAdjust('round', number, -precision).toFixed(precision);
  };

  // Is a given variable an object?
  // Borrowed from Underscore.js
  var isObject = function isObject(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object';
  };

  var isFunction = function isFunction(func) {
    var type = typeof func;
    return type === 'function';
  };

  // Check if value is different than undefined and null;
  var isSet = function isSet(value) {
    return typeof value !== 'undefined' && value !== null;
  };

  // Is a given value an array?
  // Borrowed from Underscore.js
  var isArray = function isArray(val) {
    if (Array.isArray) {
      return Array.isArray(val);
    }
    return Object.prototype.toString.call(val) === '[object Array]';
  };

  var isString = function isString(val) {
    return typeof val === 'string' || Object.prototype.toString.call(val) === '[object String]';
  };

  var isNumber = function isNumber(val) {
    return typeof val === 'number' || Object.prototype.toString.call(val) === '[object Number]';
  };

  var isBoolean = function isBoolean(val) {
    return val === true || val === false;
  };

  var isNull = function isNull(val) {
    return val === null;
  };

  var decimalAdjust = function decimalAdjust(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp));
  };

  var lazyEvaluate = function lazyEvaluate(message, scope) {
    if (isFunction(message)) {
      return message(scope);
    } else {
      return message;
    }
  };

  var merge = function merge(dest, obj) {
    var key, value;
    for (key in obj) {
      if (obj.hasOwnProperty(key)) {
        value = obj[key];
        if (isString(value) || isNumber(value) || isBoolean(value) || isArray(value) || isNull(value)) {
          dest[key] = value;
        } else {
          if (dest[key] == null) dest[key] = {};
          merge(dest[key], value);
        }
      }
    }return dest;
  };

  // Set default days/months translations.
  var DATE = {
    day_names: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    abbr_day_names: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    month_names: [null, "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    abbr_month_names: [null, "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    meridian: ["AM", "PM"]
  };

  // Set default number format.
  var NUMBER_FORMAT = {
    precision: 3,
    separator: ".",
    delimiter: ",",
    strip_insignificant_zeros: false
  };

  // Set default currency format.
  var CURRENCY_FORMAT = {
    unit: "$",
    precision: 2,
    format: "%u%n",
    sign_first: true,
    delimiter: ",",
    separator: "."
  };

  // Set default percentage format.
  var PERCENTAGE_FORMAT = {
    unit: "%",
    precision: 3,
    format: "%n%u",
    separator: ".",
    delimiter: ""
  };

  // Set default size units.
  var SIZE_UNITS = [null, "kb", "mb", "gb", "tb"];

  // Other default options
  var DEFAULT_OPTIONS = {
    // Set default locale. This locale will be used when fallback is enabled and
    // the translation doesn't exist in a particular locale.
    defaultLocale: "en"
    // Set the current locale to `en`.
    , locale: "en"
    // Set the translation key separator.
    , defaultSeparator: "."
    // Set the placeholder format. Accepts `{{placeholder}}` and `%{placeholder}`.
    , placeholder: /(?:\{\{|%\{)(.*?)(?:\}\}?)/gm
    // Set if engine should fallback to the default locale when a translation
    // is missing.
    , fallbacks: false
    // Set the default translation object.
    , translations: {}
    // Set missing translation behavior. 'message' will display a message
    // that the translation is missing, 'guess' will try to guess the string
    , missingBehaviour: 'message'
    // if you use missingBehaviour with 'message', but want to know that the
    // string is actually missing for testing purposes, you can prefix the
    // guessed string by setting the value here. By default, no prefix!
    , missingTranslationPrefix: ''
  };

  // Set default locale. This locale will be used when fallback is enabled and
  // the translation doesn't exist in a particular locale.
  I18n.reset = function () {
    var key;
    for (key in DEFAULT_OPTIONS) {
      this[key] = DEFAULT_OPTIONS[key];
    }
  };

  // Much like `reset`, but only assign options if not already assigned
  I18n.initializeOptions = function () {
    var key;
    for (key in DEFAULT_OPTIONS) {
      if (!isSet(this[key])) {
        this[key] = DEFAULT_OPTIONS[key];
      }
    }
  };
  I18n.initializeOptions();

  // Return a list of all locales that must be tried before returning the
  // missing translation message. By default, this will consider the inline option,
  // current locale and fallback locale.
  //
  //     I18n.locales.get("de-DE");
  //     // ["de-DE", "de", "en"]
  //
  // You can define custom rules for any locale. Just make sure you return a array
  // containing all locales.
  //
  //     // Default the Wookie locale to English.
  //     I18n.locales["wk"] = function(locale) {
  //       return ["en"];
  //     };
  //
  I18n.locales = {};

  // Retrieve locales based on inline locale, current locale or default to
  // I18n's detection.
  I18n.locales.get = function (locale) {
    var result = this[locale] || this[I18n.locale] || this["default"];

    if (isFunction(result)) {
      result = result(locale);
    }

    if (isArray(result) === false) {
      result = [result];
    }

    return result;
  };

  // The default locale list.
  I18n.locales["default"] = function (locale) {
    var locales = [],
        list = [];

    // Handle the inline locale option that can be provided to
    // the `I18n.t` options.
    if (locale) {
      locales.push(locale);
    }

    // Add the current locale to the list.
    if (!locale && I18n.locale) {
      locales.push(I18n.locale);
    }

    // Add the default locale if fallback strategy is enabled.
    if (I18n.fallbacks && I18n.defaultLocale) {
      locales.push(I18n.defaultLocale);
    }

    // Locale code format 1:
    // According to RFC4646 (https://www.ietf.org/rfc/rfc4646.txt)
    // language codes for Traditional Chinese should be `zh-Hant`
    //
    // But due to backward compatibility
    // We use older version of IETF language tag
    // @see https://www.w3.org/TR/html401/struct/dirlang.html
    // @see https://en.wikipedia.org/wiki/IETF_language_tag
    //
    // Format: `language-code = primary-code ( "-" subcode )*`
    //
    // primary-code uses ISO639-1
    // @see https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
    // @see https://www.iso.org/iso/home/standards/language_codes.htm
    //
    // subcode uses ISO 3166-1 alpha-2
    // @see https://en.wikipedia.org/wiki/ISO_3166
    // @see https://www.iso.org/iso/country_codes.htm
    //
    // @note
    //   subcode can be in upper case or lower case
    //   defining it in upper case is a convention only


    // Locale code format 2:
    // Format: `code = primary-code ( "-" region-code )*`
    // primary-code uses ISO 639-1
    // script-code uses ISO 15924
    // region-code uses ISO 3166-1 alpha-2
    // Example: zh-Hant-TW, en-HK, zh-Hant-CN
    //
    // It is similar to RFC4646 (or actually the same),
    // but seems to be limited to language, script, region

    // Compute each locale with its country code.
    // So this will return an array containing
    // `de-DE` and `de`
    // or
    // `zh-hans-tw`, `zh-hans`, `zh`
    // locales.
    locales.forEach(function (locale) {
      var localeParts = locale.split("-");
      var firstFallback = null;
      var secondFallback = null;
      if (localeParts.length === 3) {
        firstFallback = [localeParts[0], localeParts[1]].join("-");
        secondFallback = localeParts[0];
      } else if (localeParts.length === 2) {
        firstFallback = localeParts[0];
      }

      if (list.indexOf(locale) === -1) {
        list.push(locale);
      }

      if (!I18n.fallbacks) {
        return;
      }

      [firstFallback, secondFallback].forEach(function (nullableFallbackLocale) {
        // We don't want null values
        if (typeof nullableFallbackLocale === "undefined") {
          return;
        }
        if (nullableFallbackLocale === null) {
          return;
        }
        // We don't want duplicate values
        //
        // Comparing with `locale` first is faster than
        // checking whether value's presence in the list
        if (nullableFallbackLocale === locale) {
          return;
        }
        if (list.indexOf(nullableFallbackLocale) !== -1) {
          return;
        }

        list.push(nullableFallbackLocale);
      });
    });

    // No locales set? English it is.
    if (!locales.length) {
      locales.push("en");
    }

    return list;
  };

  // Hold pluralization rules.
  I18n.pluralization = {};

  // Return the pluralizer for a specific locale.
  // If no specify locale is found, then I18n's default will be used.
  I18n.pluralization.get = function (locale) {
    return this[locale] || this[I18n.locale] || this["default"];
  };

  // The default pluralizer rule.
  // It detects the `zero`, `one`, and `other` scopes.
  I18n.pluralization["default"] = function (count) {
    switch (count) {
      case 0:
        return ["zero", "other"];
      case 1:
        return ["one"];
      default:
        return ["other"];
    }
  };

  // Return current locale. If no locale has been set, then
  // the current locale will be the default locale.
  I18n.currentLocale = function () {
    return this.locale || this.defaultLocale;
  };

  // Check if value is different than undefined and null;
  I18n.isSet = isSet;

  // Find and process the translation using the provided scope and options.
  // This is used internally by some functions and should not be used as an
  // public API.
  I18n.lookup = function (scope, options) {
    options = options || {};

    var locales = this.locales.get(options.locale).slice(),
        locale,
        scopes,
        fullScope,
        translations;

    fullScope = this.getFullScope(scope, options);

    while (locales.length) {
      locale = locales.shift();
      scopes = fullScope.split(options.separator || this.defaultSeparator);
      translations = this.translations[locale];

      if (!translations) {
        continue;
      }
      while (scopes.length) {
        translations = translations[scopes.shift()];

        if (translations === undefined || translations === null) {
          break;
        }
      }

      if (translations !== undefined && translations !== null) {
        return translations;
      }
    }

    if (isSet(options.defaultValue)) {
      return lazyEvaluate(options.defaultValue, scope);
    }
  };

  // lookup pluralization rule key into translations
  I18n.pluralizationLookupWithoutFallback = function (count, locale, translations) {
    var pluralizer = this.pluralization.get(locale),
        pluralizerKeys = pluralizer(count),
        pluralizerKey,
        message;

    if (translations && isObject(translations)) {
      while (pluralizerKeys.length) {
        pluralizerKey = pluralizerKeys.shift();
        if (isSet(translations[pluralizerKey])) {
          message = translations[pluralizerKey];
          break;
        }
      }
    }

    return message;
  };

  // Lookup dedicated to pluralization
  I18n.pluralizationLookup = function (count, scope, options) {
    options = options || {};
    var locales = this.locales.get(options.locale).slice(),
        locale,
        scopes,
        translations,
        message;
    scope = this.getFullScope(scope, options);

    while (locales.length) {
      locale = locales.shift();
      scopes = scope.split(options.separator || this.defaultSeparator);
      translations = this.translations[locale];

      if (!translations) {
        continue;
      }

      while (scopes.length) {
        translations = translations[scopes.shift()];
        if (!isObject(translations)) {
          break;
        }
        if (scopes.length === 0) {
          message = this.pluralizationLookupWithoutFallback(count, locale, translations);
        }
      }
      if (typeof message !== "undefined" && message !== null) {
        break;
      }
    }

    if (typeof message === "undefined" || message === null) {
      if (isSet(options.defaultValue)) {
        if (isObject(options.defaultValue)) {
          message = this.pluralizationLookupWithoutFallback(count, options.locale, options.defaultValue);
        } else {
          message = options.defaultValue;
        }
        translations = options.defaultValue;
      }
    }

    return { message: message, translations: translations };
  };

  // Rails changed the way the meridian is stored.
  // It started with `date.meridian` returning an array,
  // then it switched to `time.am` and `time.pm`.
  // This function abstracts this difference and returns
  // the correct meridian or the default value when none is provided.
  I18n.meridian = function () {
    var time = this.lookup("time");
    var date = this.lookup("date");

    if (time && time.am && time.pm) {
      return [time.am, time.pm];
    } else if (date && date.meridian) {
      return date.meridian;
    } else {
      return DATE.meridian;
    }
  };

  // Merge serveral hash options, checking if value is set before
  // overwriting any value. The precedence is from left to right.
  //
  //     I18n.prepareOptions({name: "John Doe"}, {name: "Mary Doe", role: "user"});
  //     #=> {name: "John Doe", role: "user"}
  //
  I18n.prepareOptions = function () {
    var args = slice.call(arguments),
        options = {},
        subject;

    while (args.length) {
      subject = args.shift();

      if (typeof subject != "object") {
        continue;
      }

      for (var attr in subject) {
        if (!subject.hasOwnProperty(attr)) {
          continue;
        }

        if (isSet(options[attr])) {
          continue;
        }

        options[attr] = subject[attr];
      }
    }

    return options;
  };

  // Generate a list of translation options for default fallbacks.
  // `defaultValue` is also deleted from options as it is returned as part of
  // the translationOptions array.
  I18n.createTranslationOptions = function (scope, options) {
    var translationOptions = [{ scope: scope }];

    // Defaults should be an array of hashes containing either
    // fallback scopes or messages
    if (isSet(options.defaults)) {
      translationOptions = translationOptions.concat(options.defaults);
    }

    // Maintain support for defaultValue. Since it is always a message
    // insert it in to the translation options as such.
    if (isSet(options.defaultValue)) {
      translationOptions.push({ message: options.defaultValue });
    }

    return translationOptions;
  };

  // Translate the given scope with the provided options.
  I18n.translate = function (scope, options) {
    options = options || {};

    var translationOptions = this.createTranslationOptions(scope, options);

    var translation;
    var usedScope = scope;

    var optionsWithoutDefault = this.prepareOptions(options);
    delete optionsWithoutDefault.defaultValue;

    // Iterate through the translation options until a translation
    // or message is found.
    var translationFound = translationOptions.some(function (translationOption) {
      if (isSet(translationOption.scope)) {
        usedScope = translationOption.scope;
        translation = this.lookup(usedScope, optionsWithoutDefault);
      } else if (isSet(translationOption.message)) {
        translation = lazyEvaluate(translationOption.message, scope);
      }

      if (translation !== undefined && translation !== null) {
        return true;
      }
    }, this);

    if (!translationFound) {
      return this.missingTranslation(scope, options);
    }

    if (typeof translation === "string") {
      translation = this.interpolate(translation, options);
    } else if (isArray(translation)) {
      translation = translation.map(function (t) {
        return typeof t === "string" ? this.interpolate(t, options) : t;
      }, this);
    } else if (isObject(translation) && isSet(options.count)) {
      translation = this.pluralize(options.count, usedScope, options);
    }

    return translation;
  };

  // This function interpolates the all variables in the given message.
  I18n.interpolate = function (message, options) {
    if (message == null) {
      return message;
    }

    options = options || {};
    var matches = message.match(this.placeholder),
        placeholder,
        value,
        name,
        regex;

    if (!matches) {
      return message;
    }

    while (matches.length) {
      placeholder = matches.shift();
      name = placeholder.replace(this.placeholder, "$1");

      if (isSet(options[name])) {
        value = options[name].toString().replace(/\$/gm, "_#$#_");
      } else if (name in options) {
        value = this.nullPlaceholder(placeholder, message, options);
      } else {
        value = this.missingPlaceholder(placeholder, message, options);
      }

      regex = new RegExp(placeholder.replace(/{/gm, "\\{").replace(/}/gm, "\\}"));
      message = message.replace(regex, value);
    }

    return message.replace(/_#\$#_/g, "$");
  };

  // Pluralize the given scope using the `count` value.
  // The pluralized translation may have other placeholders,
  // which will be retrieved from `options`.
  I18n.pluralize = function (count, scope, options) {
    options = this.prepareOptions({ count: String(count) }, options);
    var pluralizer, result;

    result = this.pluralizationLookup(count, scope, options);
    if (typeof result.translations === "undefined" || result.translations == null) {
      return this.missingTranslation(scope, options);
    }

    if (typeof result.message !== "undefined" && result.message != null) {
      return this.interpolate(result.message, options);
    } else {
      pluralizer = this.pluralization.get(options.locale);
      return this.missingTranslation(scope + '.' + pluralizer(count)[0], options);
    }
  };

  // Return a missing translation message for the given parameters.
  I18n.missingTranslation = function (scope, options) {
    //guess intended string
    if (this.missingBehaviour === 'guess') {
      //get only the last portion of the scope
      var s = scope.split('.').slice(-1)[0];
      //replace underscore with space && camelcase with space and lowercase letter
      return (this.missingTranslationPrefix.length > 0 ? this.missingTranslationPrefix : '') + s.replace(/_/g, ' ').replace(/([a-z])([A-Z])/g, function (match, p1, p2) {
        return p1 + ' ' + p2.toLowerCase();
      });
    }

    var localeForTranslation = options != null && options.locale != null ? options.locale : this.currentLocale();
    var fullScope = this.getFullScope(scope, options);
    var fullScopeWithLocale = [localeForTranslation, fullScope].join(options.separator || this.defaultSeparator);

    return '[missing "' + fullScopeWithLocale + '" translation]';
  };

  // Return a missing placeholder message for given parameters
  I18n.missingPlaceholder = function (placeholder, message, options) {
    return "[missing " + placeholder + " value]";
  };

  I18n.nullPlaceholder = function () {
    return I18n.missingPlaceholder.apply(I18n, arguments);
  };

  // Format number using localization rules.
  // The options will be retrieved from the `number.format` scope.
  // If this isn't present, then the following options will be used:
  //
  // - `precision`: `3`
  // - `separator`: `"."`
  // - `delimiter`: `","`
  // - `strip_insignificant_zeros`: `false`
  //
  // You can also override these options by providing the `options` argument.
  //
  I18n.toNumber = function (number, options) {
    options = this.prepareOptions(options, this.lookup("number.format"), NUMBER_FORMAT);

    var negative = number < 0,
        string = toFixed(Math.abs(number), options.precision).toString(),
        parts = string.split("."),
        precision,
        buffer = [],
        formattedNumber,
        format = options.format || "%n",
        sign = negative ? "-" : "";

    number = parts[0];
    precision = parts[1];

    while (number.length > 0) {
      buffer.unshift(number.substr(Math.max(0, number.length - 3), 3));
      number = number.substr(0, number.length - 3);
    }

    formattedNumber = buffer.join(options.delimiter);

    if (options.strip_insignificant_zeros && precision) {
      precision = precision.replace(/0+$/, "");
    }

    if (options.precision > 0 && precision) {
      formattedNumber += options.separator + precision;
    }

    if (options.sign_first) {
      format = "%s" + format;
    } else {
      format = format.replace("%n", "%s%n");
    }

    formattedNumber = format.replace("%u", options.unit).replace("%n", formattedNumber).replace("%s", sign);

    return formattedNumber;
  };

  // Format currency with localization rules.
  // The options will be retrieved from the `number.currency.format` and
  // `number.format` scopes, in that order.
  //
  // Any missing option will be retrieved from the `I18n.toNumber` defaults and
  // the following options:
  //
  // - `unit`: `"$"`
  // - `precision`: `2`
  // - `format`: `"%u%n"`
  // - `delimiter`: `","`
  // - `separator`: `"."`
  //
  // You can also override these options by providing the `options` argument.
  //
  I18n.toCurrency = function (number, options) {
    options = this.prepareOptions(options, this.lookup("number.currency.format", options), this.lookup("number.format", options), CURRENCY_FORMAT);

    return this.toNumber(number, options);
  };

  // Localize several values.
  // You can provide the following scopes: `currency`, `number`, or `percentage`.
  // If you provide a scope that matches the `/^(date|time)/` regular expression
  // then the `value` will be converted by using the `I18n.toTime` function.
  //
  // It will default to the value's `toString` function.
  //
  I18n.localize = function (scope, value, options) {
    options || (options = {});

    switch (scope) {
      case "currency":
        return this.toCurrency(value, options);
      case "number":
        scope = this.lookup("number.format", options);
        return this.toNumber(value, scope);
      case "percentage":
        return this.toPercentage(value, options);
      default:
        var localizedValue;

        if (scope.match(/^(date|time)/)) {
          localizedValue = this.toTime(scope, value, options);
        } else {
          localizedValue = value.toString();
        }

        return this.interpolate(localizedValue, options);
    }
  };

  // Parse a given `date` string into a JavaScript Date object.
  // This function is time zone aware.
  //
  // The following string formats are recognized:
  //
  //    yyyy-mm-dd
  //    yyyy-mm-dd[ T]hh:mm::ss
  //    yyyy-mm-dd[ T]hh:mm::ss
  //    yyyy-mm-dd[ T]hh:mm::ssZ
  //    yyyy-mm-dd[ T]hh:mm::ss+0000
  //    yyyy-mm-dd[ T]hh:mm::ss+00:00
  //    yyyy-mm-dd[ T]hh:mm::ss.123Z
  //
  I18n.parseDate = function (date) {
    var matches, convertedDate, fraction;
    // A date input of `null` or `undefined` will be returned as-is
    if (date == null) {
      return date;
    }
    // we have a date, so just return it.
    if (typeof date === "object") {
      return date;
    }

    matches = date.toString().match(/(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}):(\d{2})([\.,]\d{1,3})?)?(Z|\+00:?00)?/);

    if (matches) {
      for (var i = 1; i <= 6; i++) {
        matches[i] = parseInt(matches[i], 10) || 0;
      }

      // month starts on 0
      matches[2] -= 1;

      fraction = matches[7] ? 1000 * ("0" + matches[7]) : null;

      if (matches[8]) {
        convertedDate = new Date(Date.UTC(matches[1], matches[2], matches[3], matches[4], matches[5], matches[6], fraction));
      } else {
        convertedDate = new Date(matches[1], matches[2], matches[3], matches[4], matches[5], matches[6], fraction);
      }
    } else if (typeof date == "number") {
      // UNIX timestamp
      convertedDate = new Date();
      convertedDate.setTime(date);
    } else if (date.match(/([A-Z][a-z]{2}) ([A-Z][a-z]{2}) (\d+) (\d+:\d+:\d+) ([+-]\d+) (\d+)/)) {
      // This format `Wed Jul 20 13:03:39 +0000 2011` is parsed by
      // webkit/firefox, but not by IE, so we must parse it manually.
      convertedDate = new Date();
      convertedDate.setTime(Date.parse([RegExp.$1, RegExp.$2, RegExp.$3, RegExp.$6, RegExp.$4, RegExp.$5].join(" ")));
    } else if (date.match(/\d+ \d+:\d+:\d+ [+-]\d+ \d+/)) {
      // a valid javascript format with timezone info
      convertedDate = new Date();
      convertedDate.setTime(Date.parse(date));
    } else {
      // an arbitrary javascript string
      convertedDate = new Date();
      convertedDate.setTime(Date.parse(date));
    }

    return convertedDate;
  };

  // Formats time according to the directives in the given format string.
  // The directives begins with a percent (%) character. Any text not listed as a
  // directive will be passed through to the output string.
  //
  // The accepted formats are:
  //
  //     %a     - The abbreviated weekday name (Sun)
  //     %A     - The full weekday name (Sunday)
  //     %b     - The abbreviated month name (Jan)
  //     %B     - The full month name (January)
  //     %c     - The preferred local date and time representation
  //     %d     - Day of the month (01..31)
  //     %-d    - Day of the month (1..31)
  //     %H     - Hour of the day, 24-hour clock (00..23)
  //     %-H/%k - Hour of the day, 24-hour clock (0..23)
  //     %I     - Hour of the day, 12-hour clock (01..12)
  //     %-I/%l - Hour of the day, 12-hour clock (1..12)
  //     %m     - Month of the year (01..12)
  //     %-m    - Month of the year (1..12)
  //     %M     - Minute of the hour (00..59)
  //     %-M    - Minute of the hour (0..59)
  //     %p     - Meridian indicator (AM  or  PM)
  //     %P     - Meridian indicator (am  or  pm)
  //     %S     - Second of the minute (00..60)
  //     %-S    - Second of the minute (0..60)
  //     %w     - Day of the week (Sunday is 0, 0..6)
  //     %y     - Year without a century (00..99)
  //     %-y    - Year without a century (0..99)
  //     %Y     - Year with century
  //     %z/%Z  - Timezone offset (+0545)
  //
  I18n.strftime = function (date, format, options) {
    var options = this.lookup("date", options),
        meridianOptions = I18n.meridian();

    if (!options) {
      options = {};
    }

    options = this.prepareOptions(options, DATE);

    if (isNaN(date.getTime())) {
      throw new Error('I18n.strftime() requires a valid date object, but received an invalid date.');
    }

    var weekDay = date.getDay(),
        day = date.getDate(),
        year = date.getFullYear(),
        month = date.getMonth() + 1,
        hour = date.getHours(),
        hour12 = hour,
        meridian = hour > 11 ? 1 : 0,
        secs = date.getSeconds(),
        mins = date.getMinutes(),
        offset = date.getTimezoneOffset(),
        absOffsetHours = Math.floor(Math.abs(offset / 60)),
        absOffsetMinutes = Math.abs(offset) - absOffsetHours * 60,
        timezoneoffset = (offset > 0 ? "-" : "+") + (absOffsetHours.toString().length < 2 ? "0" + absOffsetHours : absOffsetHours) + (absOffsetMinutes.toString().length < 2 ? "0" + absOffsetMinutes : absOffsetMinutes);

    if (hour12 > 12) {
      hour12 = hour12 - 12;
    } else if (hour12 === 0) {
      hour12 = 12;
    }

    format = format.replace("%a", options.abbr_day_names[weekDay]);
    format = format.replace("%A", options.day_names[weekDay]);
    format = format.replace("%b", options.abbr_month_names[month]);
    format = format.replace("%B", options.month_names[month]);
    format = format.replace("%d", padding(day));
    format = format.replace("%e", day);
    format = format.replace("%-d", day);
    format = format.replace("%H", padding(hour));
    format = format.replace("%-H", hour);
    format = format.replace("%k", hour);
    format = format.replace("%I", padding(hour12));
    format = format.replace("%-I", hour12);
    format = format.replace("%l", hour12);
    format = format.replace("%m", padding(month));
    format = format.replace("%-m", month);
    format = format.replace("%M", padding(mins));
    format = format.replace("%-M", mins);
    format = format.replace("%p", meridianOptions[meridian]);
    format = format.replace("%P", meridianOptions[meridian].toLowerCase());
    format = format.replace("%S", padding(secs));
    format = format.replace("%-S", secs);
    format = format.replace("%w", weekDay);
    format = format.replace("%y", padding(year));
    format = format.replace("%-y", padding(year).replace(/^0+/, ""));
    format = format.replace("%Y", year);
    format = format.replace("%z", timezoneoffset);
    format = format.replace("%Z", timezoneoffset);

    return format;
  };

  // Convert the given dateString into a formatted date.
  I18n.toTime = function (scope, dateString, options) {
    var date = this.parseDate(dateString),
        format = this.lookup(scope, options);

    // A date input of `null` or `undefined` will be returned as-is
    if (date == null) {
      return date;
    }

    var date_string = date.toString();
    if (date_string.match(/invalid/i)) {
      return date_string;
    }

    if (!format) {
      return date_string;
    }

    return this.strftime(date, format, options);
  };

  // Convert a number into a formatted percentage value.
  I18n.toPercentage = function (number, options) {
    options = this.prepareOptions(options, this.lookup("number.percentage.format", options), this.lookup("number.format", options), PERCENTAGE_FORMAT);

    return this.toNumber(number, options);
  };

  // Convert a number into a readable size representation.
  I18n.toHumanSize = function (number, options) {
    var kb = 1024,
        size = number,
        iterations = 0,
        unit,
        precision,
        fullScope;

    while (size >= kb && iterations < 4) {
      size = size / kb;
      iterations += 1;
    }

    if (iterations === 0) {
      fullScope = this.getFullScope("number.human.storage_units.units.byte", options);
      unit = this.t(fullScope, { count: size });
      precision = 0;
    } else {
      fullScope = this.getFullScope("number.human.storage_units.units." + SIZE_UNITS[iterations], options);
      unit = this.t(fullScope);
      precision = size - Math.floor(size) === 0 ? 0 : 1;
    }

    options = this.prepareOptions(options, { unit: unit, precision: precision, format: "%n%u", delimiter: "" });

    return this.toNumber(size, options);
  };

  I18n.getFullScope = function (scope, options) {
    options = options || {};

    // Deal with the scope as an array.
    if (isArray(scope)) {
      scope = scope.join(options.separator || this.defaultSeparator);
    }

    // Deal with the scope option provided through the second argument.
    //
    //    I18n.t('hello', {scope: 'greetings'});
    //
    if (options.scope) {
      scope = [options.scope, scope].join(options.separator || this.defaultSeparator);
    }

    return scope;
  };
  /**
   * Merge obj1 with obj2 (shallow merge), without modifying inputs
   * @param {Object} obj1
   * @param {Object} obj2
   * @returns {Object} Merged values of obj1 and obj2
   *
   * In order to support ES3, `Object.prototype.hasOwnProperty.call` is used
   * Idea is from:
   * https://stackoverflow.com/questions/8157700/object-has-no-hasownproperty-method-i-e-its-undefined-ie8
   */
  I18n.extend = function (obj1, obj2) {
    if (typeof obj1 === "undefined" && typeof obj2 === "undefined") {
      return {};
    }
    return merge(obj1, obj2);
  };

  // Set aliases, so we can save some typing.
  I18n.t = I18n.translate.bind(I18n);
  I18n.l = I18n.localize.bind(I18n);
  I18n.p = I18n.pluralize.bind(I18n);

  return I18n;
});

/***/ }),

/***/ "6ord":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasToStringTag = __webpack_require__("KpHW")();
var callBound = __webpack_require__("5NKs");

var $toString = callBound('Object.prototype.toString');

/** @type {import('.')} */
var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

/** @type {import('.')} */
var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $toString(value) !== '[object Array]' && 'callee' in value && $toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = function () {
	return isStandardArguments(arguments);
}();

// @ts-expect-error TODO make this not error
isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

/** @type {import('.')} */
module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

/***/ }),

/***/ "79bw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */

module.exports = Error;

/***/ }),

/***/ "7N8r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (req) {
	function Async() {
		var _this = this;

		_preact.Component.call(this);

		var b = void 0,
		    old = void 0;
		this.componentWillMount = function () {
			b = _this.base = _this.nextBase || _this.__b;
			req(function (m) {
				_this.setState({ child: m.default || m });
			});
		};

		this.shouldComponentUpdate = function (_, nxt) {
			nxt = nxt.child === void 0;
			if (nxt && old === void 0 && !!b) {
				old = (0, _preact.h)(b.nodeName, { dangerouslySetInnerHTML: { __html: b.innerHTML } });
			} else {
				old = '';
			}
			return !nxt;
		};

		this.render = function (p, s) {
			return s.child ? (0, _preact.h)(s.child, p) : old;
		};
	}
	(Async.prototype = new _preact.Component()).constructor = Async;
	return Async;
};

var _preact = __webpack_require__("KM04");

/***/ }),

/***/ "7oIN":
/***/ (function(module, exports, __webpack_require__) {

var log = __webpack_require__("CTmE")('i18nline');
var Utils = __webpack_require__("P91y");

var I18nline = {
  set: function set(key, value, fn) {
    var prevValue = this.config[key];
    this.config[key] = value;
    if (fn) {
      try {
        fn();
      } finally {
        this.config[key] = prevValue;
      }
    }
  },

  configure: function configure(config) {
    var arrOpts = ['patterns', 'ignorePatterns', 'directories', 'ignoreDirectories'];
    Object.keys(config).filter(function (key) {
      return key !== 'plugins';
    }).forEach(function (key) {
      if (typeof config[key] == 'string' && arrOpts.indexOf(key) !== -1) {
        this.set(key, config[key].split(','));
      } else {
        this.set(key, config[key]);
      }
    }.bind(this));
    if (config.plugins) this.configurePlugins(config.plugins);
    return this;
  },

  configurePlugins: function configurePlugins(plugins) {
    this.processors = this.Commands.Check.processors;
    plugins.forEach(function (p) {
      p(this);
    }.bind(this));
  },

  config: {
    basePath: '.',
    ignoreDirectories: ['node_modules', 'bower_components', '.git', 'dist', 'build'],
    patterns: ['**/*.js', '**/*.jsx'],
    ignorePatterns: [],
    out: 'src/i18n',
    inferredKeyFormat: 'underscored_crc32',
    underscoredKeyLength: 50,
    defaultLocale: 'en'
  }
};

module.exports = I18nline;

log.debug('Initialized ' + log.name);

/***/ }),

/***/ "7vsa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./floor')} */

module.exports = Math.floor;

/***/ }),

/***/ "AyWa":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, ".mobileNavContainer__33a76{display:none}.citySelectorWrapper__1Vq0q{position:relative}.citySelectorWrapper__1Vq0q[showGradient]:after{content:\"\";position:absolute;bottom:0;left:0;width:100%;height:50px;background:-webkit-gradient(linear,left bottom,left top,from(#e9e9e2),to(transparent));background:linear-gradient(0deg,#e9e9e2,transparent);pointer-events:none}.scrollIndicator__2FI8U{position:absolute;right:2px;width:8px;height:24px;background:#fff;border-radius:4px;opacity:.5;-webkit-transition:height .1s;transition:height .1s;pointer-events:none}@media (max-width:768px){.mobileNavContainer__33a76{display:block;position:fixed;top:0;right:0;z-index:1000}.hamburgerButton__1lvM7{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:32px;height:24px;background:transparent;border:none;cursor:pointer;padding:0;margin:1rem;position:relative;z-index:1001}.hamburgerButton__1lvM7 span{display:block;width:100%;height:2px;background-color:#fff;border-radius:2px;-webkit-transition:all .3s ease;transition:all .3s ease}.hamburgerButton__1lvM7.open__1bp1A span:first-child{-webkit-transform:translateY(11px) rotate(45deg);-ms-transform:translateY(11px) rotate(45deg);transform:translateY(11px) rotate(45deg)}.hamburgerButton__1lvM7.open__1bp1A span:nth-child(2){opacity:0}.hamburgerButton__1lvM7.open__1bp1A span:nth-child(3){-webkit-transform:translateY(-11px) rotate(-45deg);-ms-transform:translateY(-11px) rotate(-45deg);transform:translateY(-11px) rotate(-45deg)}.backsplash__1fAmn{position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:999}.mobileMenu__3TzYB{position:fixed;top:0;left:-100%;width:85%;max-width:360px;height:100vh;background-color:#e9e9e2;color:#3f463e;-webkit-transition:left .3s ease;transition:left .3s ease;z-index:1000;-webkit-box-shadow:5px 0 15px rgba(0,0,0,.08);box-shadow:5px 0 15px rgba(0,0,0,.08);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;overflow-y:auto}.mobileMenu__3TzYB.open__1bp1A{left:0}.mobileMenuHeader__3EeBf{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:1rem;border-bottom:1px solid hsla(0,0%,100%,.1)}.tableOnlineIcon__1-QvY{height:32px}.closeButton__2tf8Z{background:transparent;border:none;color:#3f463e;cursor:pointer;padding:.5rem;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.closeButton__2tf8Z,.mobileMenuContent__3wIT6{display:-webkit-box;display:-ms-flexbox;display:flex}.mobileMenuContent__3wIT6{padding:0 0 1rem;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.profileSection__3FYkl{padding:0 1rem;border-bottom:1px solid hsla(0,0%,100%,.1)}.userInfo__3B2ul{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:.75rem;padding:.5rem 0}.userName__r8FIy{font-weight:500;font-size:16px}.authButtons__2JpoK{gap:1rem;margin:.5rem 0}.authButtons__2JpoK,.authButtons__2JpoK a{display:-webkit-box;display:-ms-flexbox;display:flex}.authButtons__2JpoK a{margin-right:0;-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}a.loginButton__vhRs1{background:transparent;border:1px solid rgba(0,0,0,.1)}.navSection__2Ekb9{padding:0}.navItem__kpZfF{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:1rem;cursor:pointer;-webkit-transition:background-color .2s ease;transition:background-color .2s ease;color:#3f463e;text-decoration:none}.navItem__kpZfF:active,.navItem__kpZfF:hover{background-color:hsla(0,0%,100%,.05)}.navItemContent__3blpS{gap:1rem}.navIconWrapper__2zAHO,.navItemContent__3blpS{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.navIconWrapper__2zAHO{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:24px;height:24px}.languageSelectorFlag__1Mv1o{width:16px;height:16px;overflow:hidden;border-radius:2px;display:block}.languageSelectorFlagImage__1sxxM{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.chevron__xZ7Z4{-webkit-transition:-webkit-transform .2s ease;transition:-webkit-transform .2s ease;transition:transform .2s ease;transition:transform .2s ease,-webkit-transform .2s ease}.chevron__xZ7Z4.up__3d5II{-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.dropdownContent__3K71m{background-color:rgba(0,0,0,.08);max-height:250px;overflow:scroll}.dropdownItem__3OYxe{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:1rem;padding:.75rem 1rem .75rem 3.5rem;cursor:pointer;-webkit-transition:background-color .2s ease;transition:background-color .2s ease}.dropdownItem__3OYxe:active,.dropdownItem__3OYxe:hover{background-color:hsla(0,0%,100%,.05)}.loadingContainer__3UWKX{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:1rem 0}.loading__3srfO{width:24px;height:24px;border:2px solid hsla(0,0%,100%,.2);border-left-color:#3f463e;border-radius:50%;-webkit-animation:spin__1bxBl 1s linear infinite;animation:spin__1bxBl 1s linear infinite}@-webkit-keyframes spin__1bxBl{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spin__1bxBl{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.fullWidthLink__2DVlC{display:block;width:100%;color:#3f463e;text-decoration:none}.appDownloadSection__2NTmY{margin-top:1rem;padding:0 1rem;border-top:1px solid hsla(0,0%,100%,.1)}.appDownloadTitle__1mMxo{font-size:16px;font-weight:500;margin:0 0 .75rem;color:#3f463e}.appDownloadLinks__1aWQT{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;gap:1rem;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.storeLink__1jxrJ{display:block;text-decoration:none;-webkit-transition:opacity .2s ease;transition:opacity .2s ease}.storeLink__1jxrJ:active,.storeLink__1jxrJ:hover{opacity:.9}.storeBadge__3PhLG{width:auto;max-width:100%;height:45px}.appIconWrapper__1jb-u{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:24px;height:24px}}", ""]);

// exports
exports.locals = {
	"mobileNavContainer": "mobileNavContainer__33a76",
	"citySelectorWrapper": "citySelectorWrapper__1Vq0q",
	"scrollIndicator": "scrollIndicator__2FI8U",
	"hamburgerButton": "hamburgerButton__1lvM7",
	"open": "open__1bp1A",
	"backsplash": "backsplash__1fAmn",
	"mobileMenu": "mobileMenu__3TzYB",
	"mobileMenuHeader": "mobileMenuHeader__3EeBf",
	"tableOnlineIcon": "tableOnlineIcon__1-QvY",
	"closeButton": "closeButton__2tf8Z",
	"mobileMenuContent": "mobileMenuContent__3wIT6",
	"profileSection": "profileSection__3FYkl",
	"userInfo": "userInfo__3B2ul",
	"userName": "userName__r8FIy",
	"authButtons": "authButtons__2JpoK",
	"loginButton": "loginButton__vhRs1",
	"navSection": "navSection__2Ekb9",
	"navItem": "navItem__kpZfF",
	"navItemContent": "navItemContent__3blpS",
	"navIconWrapper": "navIconWrapper__2zAHO",
	"languageSelectorFlag": "languageSelectorFlag__1Mv1o",
	"languageSelectorFlagImage": "languageSelectorFlagImage__1sxxM",
	"chevron": "chevron__xZ7Z4",
	"up": "up__3d5II",
	"dropdownContent": "dropdownContent__3K71m",
	"dropdownItem": "dropdownItem__3OYxe",
	"loadingContainer": "loadingContainer__3UWKX",
	"loading": "loading__3srfO",
	"spin": "spin__1bxBl",
	"fullWidthLink": "fullWidthLink__2DVlC",
	"appDownloadSection": "appDownloadSection__2NTmY",
	"appDownloadTitle": "appDownloadTitle__1mMxo",
	"appDownloadLinks": "appDownloadLinks__1aWQT",
	"storeLink": "storeLink__1jxrJ",
	"storeBadge": "storeBadge__3PhLG",
	"appIconWrapper": "appIconWrapper__1jb-u"
};

/***/ }),

/***/ "B6/o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function joiny(arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function binder() {
        if (this instanceof bound) {
            var result = target.apply(this, concatty(args, arguments));
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(that, concatty(args, arguments));
    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

/***/ }),

/***/ "BMrJ":
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var memoize = function memoize(fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = function (fn) {
	var memo = {};

	return function (selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector];
	};
}(function (target) {
	return document.querySelector(target);
});

var singleton = null;
var singletonCounter = 0;
var stylesInsertedAtTop = [];

var fixUrls = __webpack_require__("DRTY");

module.exports = function (list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if (newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if (domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j]();
				}delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if (domStyle) {
			domStyle.refs++;

			for (var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for (; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for (var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts };
		}
	}
}

function listToStyles(list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = { css: css, media: media, sourceMap: sourceMap };

		if (!newStyles[id]) styles.push(newStyles[id] = { id: id, parts: [part] });else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement(options, style) {
	var target = getElement(options.insertInto);

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if (idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement(options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs(el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
		result = options.transform(obj.css);

		if (result) {
			// If transform returns a value, use that instead of the original css.
			// This allows running runtime transformations on the css.
			obj.css = result;
		} else {
			// If the transform function returns a falsy value, don't add this css.
			// This allows conditional loading of css
			return function () {
				// noop
			};
		}
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);
	} else if (obj.sourceMap && typeof URL === "function" && typeof URL.createObjectURL === "function" && typeof URL.revokeObjectURL === "function" && typeof Blob === "function" && typeof btoa === "function") {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function remove() {
			removeStyleElement(style);

			if (style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function remove() {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if (newObj) {
			if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
}();

function applyToSingletonTag(style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag(style, obj) {
	var css = obj.css;
	var media = obj.media;

	if (media) {
		style.setAttribute("media", media);
	}

	if (style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while (style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink(link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
 	If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
 	and there is no publicPath defined then lets turn convertToAbsoluteUrls
 	on by default.  Otherwise default to the convertToAbsoluteUrls option
 	directly
 */
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if (oldSrc) URL.revokeObjectURL(oldSrc);
}

/***/ }),

/***/ "BMvp":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("HzbK");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false,"singleton":true,"attrs":{"data-tableonline-build":"10.24.1"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "CTmE":
/***/ (function(module, exports, __webpack_require__) {

var ulog = __webpack_require__("qke+");

module.exports = function (name, silent) {
	if (silent) ulog.level = ulog.NONE;
	return ulog(name);
};

/***/ }),

/***/ "CYb7":
/***/ (function(module, exports, __webpack_require__) {

!function (t, n) {
   true ? module.exports = function (t, n, e, i, o) {
    for (n = n.split ? n.split(".") : n, i = 0; i < n.length; i++) {
      t = t ? t[n[i]] : o;
    }return t === o ? e : t;
  } : "function" == typeof define && define.amd ? define(function () {
    return function (t, n, e, i, o) {
      for (n = n.split ? n.split(".") : n, i = 0; i < n.length; i++) {
        t = t ? t[n[i]] : o;
      }return t === o ? e : t;
    };
  }) : t.dlv = function (t, n, e, i, o) {
    for (n = n.split ? n.split(".") : n, i = 0; i < n.length; i++) {
      t = t ? t[n[i]] : o;
    }return t === o ? e : t;
  };
}(this);
//# sourceMappingURL=dlv.umd.js.map

/***/ }),

/***/ "CjFg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./isNaN')} */

module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};

/***/ }),

/***/ "D3C6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);

var JSONLD = function JSONLD(_ref) {
  var children = _ref.children;
  return children && children[0] ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: typeof children[0] === 'string' ? children[0] : JSON.stringify(children[0])
    }
  }) : null;
};
/* harmony default export */ __webpack_exports__["a"] = (JSONLD);

/***/ }),

/***/ "D6Eh":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, ".button__jQNF7{border:0;display:inline-block;padding:.625rem 1.25rem;line-height:1.5;min-height:2.75rem;border-radius:5px;font-size:inherit;line-height:inherit;-webkit-transition:opacity .2s;transition:opacity .2s;text-decoration:none;-webkit-appearance:none;position:relative;background:#fff;cursor:pointer}a.button__jQNF7{line-height:1.5}.children__3fqUw{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}fieldset .button__jQNF7{border-top-left-radius:0;border-bottom-left-radius:0}.disabled__olASs,.loading__1P89d{pointer-events:none}.button__jQNF7.loading__1P89d .children__3fqUw{opacity:0}.loading__1P89d:after{content:\"\";position:absolute;top:50%;left:50%;height:14px;width:14px;border-radius:14px;border:2px solid transparent;border-left-color:#124142;border-top-color:#124142;-webkit-animation:rotating__1ROFj .6s infinite linear;animation:rotating__1ROFj .6s infinite linear}.loading__1P89d .children__3fqUw{opacity:0}@-webkit-keyframes rotating__1ROFj{0%{-webkit-transform:translate3d(-7px,-7px,0) rotate(0deg);transform:translate3d(-7px,-7px,0) rotate(0deg)}to{-webkit-transform:translate3d(-7px,-7px,0) rotate(1turn);transform:translate3d(-7px,-7px,0) rotate(1turn)}}@keyframes rotating__1ROFj{0%{-webkit-transform:translate3d(-7px,-7px,0) rotate(0deg);transform:translate3d(-7px,-7px,0) rotate(0deg)}to{-webkit-transform:translate3d(-7px,-7px,0) rotate(1turn);transform:translate3d(-7px,-7px,0) rotate(1turn)}}.bookButton__2I2GM{background:#fff;font-weight:500;-webkit-box-shadow:0 2px 6px rgba(0,0,0,.2);box-shadow:0 2px 6px rgba(0,0,0,.2);font-size:16px;min-height:auto;padding:.5rem .85rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-left:auto;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;color:#000f0f;opacity:1;position:relative;overflow:hidden;cursor:pointer;border:0;border-radius:5rem}.bookButton__2I2GM svg{margin-right:.5rem;fill:currentColor}.bookButton__2I2GM.pride__3PPj4{background:linear-gradient(-45deg,#005c53,#124142,#ffa63d,#ff3d77,#124142,#005c53);color:#fff}.glow__L9TUR.bookButton__2I2GM,.hoverGlow__1ik4V:hover{color:#fff;text-shadow:0 0 4px rgba(0,0,0,.2);-webkit-box-shadow:0 15px 30px -10px #124142;box-shadow:0 15px 30px -10px #124142;background:linear-gradient(-45deg,#005c53,#124142)}.glow__L9TUR.bookButton__2I2GM:hover,.glow__L9TUR.bookButton__2I2GM:hover:before{opacity:1;-webkit-animation:none;animation:none}.glow__L9TUR.bookButton__2I2GM svg,.hoverGlow__1ik4V:hover svg{fill:currentColor}.disabled__olASs{opacity:.54;pointer-events:none}.disabled__olASs.loading__1P89d{opacity:1}@-webkit-keyframes animeShadow__1RNnW{0%,50%,to{opacity:0}25%,75%{opacity:1}}@keyframes animeShadow__1RNnW{0%,50%,to{opacity:0}25%,75%{opacity:1}}@-webkit-keyframes animeShadow2__4Ssmx{0%,50%,to{opacity:1}25%,75%{opacity:0}}@keyframes animeShadow2__4Ssmx{0%,50%,to{opacity:1}25%,75%{opacity:0}}@-webkit-keyframes anime__2TY-H{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}50%{-webkit-transform:translate3d(-80%,0,0);transform:translate3d(-80%,0,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes anime__2TY-H{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}50%{-webkit-transform:translate3d(-80%,0,0);transform:translate3d(-80%,0,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}", ""]);

// exports
exports.locals = {
	"button": "button__jQNF7",
	"children": "children__3fqUw",
	"loading": "loading__1P89d",
	"disabled": "disabled__olASs",
	"rotating": "rotating__1ROFj",
	"bookButton": "bookButton__2I2GM",
	"pride": "pride__3PPj4",
	"hoverGlow": "hoverGlow__1ik4V",
	"glow": "glow__L9TUR",
	"animeShadow": "animeShadow__1RNnW",
	"animeShadow2": "animeShadow2__4Ssmx",
	"anime": "anime__2TY-H"
};

/***/ }),

/***/ "DRTY":
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
	// get current location
	var location = typeof window !== "undefined" && window.location;

	if (!location) {
		throw new Error("fixUrls requires window.location");
	}

	// blank or null?
	if (!css || typeof css !== "string") {
		return css;
	}

	var baseUrl = location.protocol + "//" + location.host;
	var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
 This regular expression is just a way to recursively match brackets within
 a string.
 	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
    (  = Start a capturing group
      (?:  = Start a non-capturing group
          [^)(]  = Match anything that isn't a parentheses
          |  = OR
          \(  = Match a start parentheses
              (?:  = Start another non-capturing groups
                  [^)(]+  = Match anything that isn't a parentheses
                  |  = OR
                  \(  = Match a start parentheses
                      [^)(]*  = Match anything that isn't a parentheses
                  \)  = Match a end parentheses
              )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
  \)  = Match a close parens
 	 /gi  = Get all matches, not the first.  Be case insensitive.
  */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
			return $1;
		}).replace(/^'(.*)'$/, function (o, $1) {
			return $1;
		});

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
			//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};

/***/ }),

/***/ "DZEA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./ref')} */

module.exports = ReferenceError;

/***/ }),

/***/ "DbQ/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__("VxKF");
var callBind = __webpack_require__("y9YS");

var implementation = __webpack_require__("1Hmk");
var getPolyfill = __webpack_require__("YWiL");
var shim = __webpack_require__("Kszl");

var flagsBound = callBind(getPolyfill());

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;

/***/ }),

/***/ "DhUb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__("5NKs");
var hasToStringTag = __webpack_require__("KpHW")();
var hasOwn = __webpack_require__("pijy");
var gOPD = __webpack_require__("34Ju");

/** @type {import('.')} */
var fn;

if (hasToStringTag) {
	/** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */
	var $exec = callBound('RegExp.prototype.exec');
	/** @type {object} */
	var isRegexMarker = {};

	var throwRegexMarker = function throwRegexMarker() {
		throw isRegexMarker;
	};
	/** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */
	var badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}

	/** @type {import('.')} */
	// @ts-expect-error TS can't figure out that the $exec call always throws
	// eslint-disable-next-line consistent-return
	fn = function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {NonNullable<typeof gOPD>} */gOPD( /** @type {{ lastIndex?: unknown }} */value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && hasOwn(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			// eslint-disable-next-line no-extra-parens
			$exec(value, /** @type {string} */ /** @type {unknown} */badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	};
} else {
	/** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */
	var $toString = callBound('Object.prototype.toString');
	/** @const @type {'[object RegExp]'} */
	var regexClass = '[object RegExp]';

	/** @type {import('.')} */
	fn = function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || typeof value !== 'object' && typeof value !== 'function') {
			return false;
		}

		return $toString(value) === regexClass;
	};
}

module.exports = fn;

/***/ }),

/***/ "Dpjs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_portal__ = __webpack_require__("q6qL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_portal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact_portal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__("OGHo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_root__ = __webpack_require__("VjJS");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    height: '16',
    viewBox: '0 0 24 24'
  },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z' })
);

var Dialog = function (_Component) {
  _inherits(Dialog, _Component);

  function Dialog() {
    var _temp, _this, _ret;

    _classCallCheck(this, Dialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.open = function () {
      if (!_this.element) {
        return __WEBPACK_IMPORTED_MODULE_3__components_root__["a" /* default */].setTimeout(_this.open, 32);
      }
      _this.checkElements();

      // Disable scroll on body
      if (document !== void 0) document.body.setAttribute('modal-visible', true);
    }, _this.checkElements = function () {
      var contains = _this.element.contains(document.activeElement);
      // Save all elements that we can focus on
      _this.focusableElements = _this.element.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');

      // When the dialog is closed, focus should be returned to the element that opened it
      if (document && document.activeElement && !contains) _this.lastFocusedElement = document.activeElement;
      // When first opened, focus should be set to the first focusable element within the dialog
      _this.firstFocusableElement = _this.focusableElements.length ? _this.focusableElements[0] : null;
      _this.lastFocusableElement = _this.focusableElements.length ? _this.focusableElements[_this.focusableElements.length - 1] : null;

      if (_this.firstFocusableElement !== null && !contains) __WEBPACK_IMPORTED_MODULE_3__components_root__["a" /* default */].setTimeout(function () {
        return _this.firstFocusableElement.focus();
      }, 0);
    }, _this.close = function () {
      // When the dialog is closed, focus should be returned to the element that opened it
      if (_this.lastFocusedElement) _this.lastFocusedElement.focus();

      // Enable scroll on body
      if (document !== void 0) document.body.removeAttribute('modal-visible');
    }, _this.onKeyDown = function (e) {
      var KEY_TAB = 9,
          KEY_ESC = 27;
      switch (e.keyCode) {
        case KEY_TAB:
          if (_this.focusableElements.length === 1) {
            e.preventDefault();
            break;
          }
          if (e.shiftKey) {
            _this._handleBackwardTab(e);
          } else {
            _this._handleForwardTab(e);
          }
          break;
        case KEY_ESC:
          _this.props.close ? _this.props.close() : null;
          break;
        default:
          break;
      }
    }, _this._handleBackwardTab = function (e) {
      if (document && document.activeElement === _this.firstFocusableElement) {
        e.preventDefault();
        _this.lastFocusableElement.focus();
      }
    }, _this._handleForwardTab = function (e) {
      if (document && document.activeElement === _this.lastFocusableElement) {
        e.preventDefault();
        _this.firstFocusableElement.focus();
      }
    }, _this.checkHeight = function () {
      var shouldScroll = _this.dialog && _this.dialog.scrollHeight > window.innerHeight;

      if (!_this.state.scroll && shouldScroll) {
        _this.setState({ scroll: true });
      } else if (_this.state.scroll && !shouldScroll) {
        _this.setState({ scroll: false });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Dialog.prototype.componentDidMount = function componentDidMount() {
    if (this.props.show) this.open();
    window.setTimeout(this.checkHeight, 32);
  };

  Dialog.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var show = _ref.show;

    if (show && show !== this.props.show) this.open();else if (!show && show !== this.props.show) this.close();
    window.setTimeout(this.checkHeight, 32);
    window.setTimeout(this.checkHeight, 100);
  };

  Dialog.prototype.componentWillUnmount = function componentWillUnmount() {
    this.close();
  };

  Dialog.prototype.render = function render(props, state) {
    var _this2 = this;

    return props.show ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_1_preact_portal___default.a,
      { into: 'body' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        {
          'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.dialogContainer,
          'aria-hidden': props.show ? false : true,
          ref: function ref(el) {
            return _this2.element = el;
          }
        },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'dialog',
          {
            ref: function ref(el) {
              return _this2.dialog = el;
            },
            'class': (__WEBPACK_IMPORTED_MODULE_2__style___default.a.dialog + ' ' + props.class + ' ' + (state.scroll ? __WEBPACK_IMPORTED_MODULE_2__style___default.a.scroll : '')).trim(),
            'aria-labelledby': props.title ? 'dialog-title' : null,
            onKeyDown: this.onKeyDown,
            style: props.style
          },
          props.title ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'h1',
            { id: 'dialog-title', 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.title },
            props.title
          ) : null,
          props.children,
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'button',
            {
              'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.closeButton,
              type: 'button',
              'data-a11y-dialog-hide': true,
              'aria-label': 'Close this dialog window',
              onClick: props.close
            },
            _ref2
          )
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', {
          'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.overlay,
          tabindex: '-1',
          'data-a11y-dialog-hide': true,
          onClick: this.props.close
        })
      )
    ) : null;
  };

  return Dialog;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Dialog);

/***/ }),

/***/ "Dv02":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("AyWa");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false,"singleton":true,"attrs":{"data-tableonline-build":"10.24.1"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "EHrm":
/***/ (function(module, exports) {

module.exports = {"private":true,"name":"tox-frontend","type":"module","version":"10.24.1","license":"Trade secret","scripts":{"start":"if-env NODE_ENV=production && npm run -s serve || npm run -s dev","deploy":"sh scripts/deploy.sh","build":"NODE_ENV=production bash scripts/build.sh --template src/template.html --service-worker false --clean --no-prerender","netlify":"NODE_ENV=preproduction bash scripts/build.sh --template src/template.html --service-worker false --clean --no-prerender","serve":"npm run build && preact serve --port 54800","dev":"preact watch --template src/template.html --port 54800","lint":"eslint src","pretty":"prettier --write \"./**/*.{js,jsx,json,css,scss,json}\"","test":"jest ./tests","i18n":"i18nline synch && node scripts/exportI18nToCsv.js","importcsv":"node scripts/importI18nToJson.js","changelog":"git log --pretty=%s --first-parent"},"eslintConfig":{"extends":"eslint-config-synacor"},"eslintIgnore":["build/*"],"devDependencies":{"@sentry/webpack-plugin":"^1.6.2","babel-plugin-dynamic-import-webpack":"^1.1.0","create-file-webpack":"^1.0.2","eslint":"^4.9.0","eslint-config-prettier":"^7.2.0","eslint-config-synacor":"^2.0.2","eslint-plugin-babel":"^5.3.1","eslint-plugin-prettier":"^3.3.1","identity-obj-proxy":"^3.0.0","if-env":"^1.0.0","jest":"^21.2.1","preact-cli":"^2.2.1","preact-cli-plugin-fast-async":"^1.0.1","preact-render-spy":"^1.2.1","prettier":"^2.2.1","uglifyjs-webpack-plugin":"^2.2.0"},"dependencies":{"dlv":"^1.1.2","dset":"^2.0.1","file-saver":"^2.0.5","i18nline":"^2.0.1","jszip":"^3.10.1","linkstate":"^1.1.1","mitt":"^1.1.3","preact":"^8.2.6","preact-compat":"^3.17.0","preact-helmet":"^4.0.0-alpha-3","preact-i18nline":"^2.0.0","preact-portal":"^1.1.3","preact-router":"^2.5.7"},"i18n":{"ignoreDirectories":["node_modules","bower_components",".git","dist","build","scripts"],"autoTranslateTags":["Text"]},"jest":{"verbose":true,"setupFiles":["<rootDir>/src/tests/__mocks__/browserMocks.js"],"testURL":"http://localhost:54800","moduleFileExtensions":["js","jsx"],"moduleDirectories":["node_modules"],"moduleNameMapper":{"\\.(jpg|jpeg|png|gif|eot|otf|webp|svg|ttf|woff|woff2|mp4|webm|wav|mp3|m4a|aac|oga)$":"<rootDir>/src/tests/__mocks__/fileMock.js","\\.(css|less|scss)$":"identity-obj-proxy","^./style$":"identity-obj-proxy","^preact$":"<rootDir>/node_modules/preact/dist/preact.min.js","^react$":"preact-compat","^react-dom$":"preact-compat","^create-react-class$":"preact-compat/lib/create-react-class","^react-addons-css-transition-group$":"preact-css-transition-group"}}}

/***/ }),

/***/ "FJnM":
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _preact = __webpack_require__("KM04");

var _preactSideEffect = __webpack_require__("xToX");

var _preactSideEffect2 = _interopRequireDefault(_preactSideEffect);

var _deepEqual = __webpack_require__("koiw");

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _objectAssign = __webpack_require__("J4Nk");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__("Qxat");

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

var HELMET_ATTRIBUTE = "data-preact-helmet";

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props[property]) {
            return props[property];
        }
    }
    return null;
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, "title");
    var innermostTemplate = getInnermostProperty(propsList, "titleTemplate");

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, "defaultTitle");

    return innermostTitle || innermostDefaultTitle || "";
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, "onChangeClientState") || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        return typeof props[tagName] !== "undefined";
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var updateTitle = function updateTitle(title, attributes) {
    document.title = title || document.title;
    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var htmlTag = document.getElementsByTagName(tagName)[0];
    var helmetAttributeString = htmlTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        htmlTag.setAttribute(attribute, value);

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        htmlTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        htmlTag.removeAttribute(HELMET_ATTRIBUTE);
    } else {
        htmlTag.setAttribute(HELMET_ATTRIBUTE, helmetAttributes.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector("head");
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === "innerHTML") {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === "cssText") {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateHtmlAttributesAsString = function generateHtmlAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes) {
    var attributeString = generateHtmlAttributesAsString(attributes);
    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + " " + attributeString + ">" + encodeSpecialCharacters(title) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + ">" + encodeSpecialCharacters(title) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === "innerHTML" || attribute === "cssText");
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute]) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = [_HelmetConstants.TAG_NAMES.NOSCRIPT, _HelmetConstants.TAG_NAMES.SCRIPT, _HelmetConstants.TAG_NAMES.STYLE].indexOf(type) === -1;

        return str + "<" + type + " " + HELMET_ATTRIBUTE + " " + attributeHtml + (isSelfClosing ? ">" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var generateTitleAsPreactComponent = function generateTitleAsPreactComponent(type, title, attributes) {
    // assigning into an array to define toString function on it
    var initProps = _defineProperty({
        key: title
    }, HELMET_ATTRIBUTE, true);
    var props = Object.keys(attributes).reduce(function (obj, key) {
        obj[key] = attributes[key];
        return obj;
    }, initProps);

    return [(0, _preact.h)(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsPreactComponent = function generateTagsAsPreactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var mappedTag = _defineProperty({
            key: i
        }, HELMET_ATTRIBUTE, true);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = attribute;

            if (mappedAttribute === "innerHTML" || mappedAttribute === "cssText") {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return (0, _preact.h)(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsPreactComponent(type, tags.title, tags.titleAttributes);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes);
                }
            };
        case _HelmetConstants.TAG_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return tags;
                },
                toString: function toString() {
                    return generateHtmlAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsPreactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var htmlAttributes = _ref.htmlAttributes,
        title = _ref.title,
        titleAttributes = _ref.titleAttributes,
        baseTag = _ref.baseTag,
        metaTags = _ref.metaTags,
        linkTags = _ref.linkTags,
        scriptTags = _ref.scriptTags,
        noscriptTags = _ref.noscriptTags,
        styleTags = _ref.styleTags;
    return {
        htmlAttributes: getMethodsForTag(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }),
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };
};

/**
 * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
 * @param {String} title: "Title"
 * @param {String} defaultTitle: "Default Title"
 * @param {String} titleTemplate: "MySite.com - %s"
 * @param {Object} titleAttributes: {"itemprop": "name"}
 * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
 * @param {Array} meta: [{"name": "description", "content": "Test description"}]
 * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
 * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
 * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
 * @param {Array} style: [{"type": "text/css", "cssText": "div{ display: block; color: blue; }"}]
 * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
 */
var Helmet = function Helmet(WrappedComponent) {
    var _class, _temp;

    return _temp = _class = function (_Component) {
        _inherits(HelmetWrapper, _Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, (HelmetWrapper.__proto__ || Object.getPrototypeOf(HelmetWrapper)).apply(this, arguments));
        }

        _createClass(HelmetWrapper, [{
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var props = _extends({}, nextProps);
                if (!props.children || !props.children.length) {
                    delete props.children;
                }
                return !(0, _deepEqual2.default)(this.props, props);
            }
        }, {
            key: "render",
            value: function render() {
                return (0, _preact.h)(WrappedComponent, this.props);
            }
        }], [{
            key: "canUseDOM",

            // WrappedComponent.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.
            set: function set(canUseDOM) {
                WrappedComponent.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_preact.Component), _class.peek = WrappedComponent.peek, _class.rewind = function () {
        var mappedState = WrappedComponent.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = mapStateOnServer({
                htmlAttributes: {},
                title: "",
                titleAttributes: {},
                baseTag: [],
                metaTags: [],
                linkTags: [],
                scriptTags: [],
                noscriptTags: [],
                styleTags: []
            });
        }

        return mappedState;
    }, _temp;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.TAG_NAMES.HTML, propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList("titleAttributes", propsList),
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        onChangeClientState: getOnChangeClientState(propsList)
    };
};

var handleClientStateChange = function handleClientStateChange(newState) {
    var htmlAttributes = newState.htmlAttributes,
        title = newState.title,
        titleAttributes = newState.titleAttributes,
        baseTag = newState.baseTag,
        metaTags = newState.metaTags,
        linkTags = newState.linkTags,
        scriptTags = newState.scriptTags,
        noscriptTags = newState.noscriptTags,
        styleTags = newState.styleTags,
        onChangeClientState = newState.onChangeClientState;

    updateAttributes("html", htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;

        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    onChangeClientState(newState, addedTags, removedTags);
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _preactSideEffect2.default)(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);

exports.default = Helmet(HelmetSideEffects);
module.exports = exports["default"];

/***/ }),

/***/ "Fi9R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__("TyWm");
var define = __webpack_require__("VxKF");

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};

/***/ }),

/***/ "GBKF":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, ".checkbox__2sRHP{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.indicator__3LEWo{display:inline-block;position:relative;background-color:transparent;width:25px;height:25px;-webkit-transform-origin:center;-ms-transform-origin:center;transform-origin:center;border:2px solid #aaa;border-radius:50%;vertical-align:-6px;margin-right:10px;-webkit-transition:background-color .15s .2s,-webkit-transform .35s cubic-bezier(.78,-1.22,.17,1.89);transition:background-color .15s .2s,-webkit-transform .35s cubic-bezier(.78,-1.22,.17,1.89);transition:background-color .15s .2s,transform .35s cubic-bezier(.78,-1.22,.17,1.89);transition:background-color .15s .2s,transform .35s cubic-bezier(.78,-1.22,.17,1.89),-webkit-transform .35s cubic-bezier(.78,-1.22,.17,1.89)}.checkbox__2sRHP input[type=checkbox]+.indicator__3LEWo{border-radius:4px}.checkbox__2sRHP:hover .indicator__3LEWo{border:2px solid #124142}.indicator__3LEWo:before{-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);top:11px;left:7px;-webkit-transition:width 50ms ease 50ms;transition:width 50ms ease 50ms;-webkit-transform-origin:0 0;-ms-transform-origin:0 0;transform-origin:0 0}.indicator__3LEWo:after,.indicator__3LEWo:before{content:\"\";width:0;height:2px;border-radius:2px;background:#124142;position:absolute}.indicator__3LEWo:after{-webkit-transform:rotate(305deg);-ms-transform:rotate(305deg);transform:rotate(305deg);top:14px;left:8px;-webkit-transition:width 50ms ease;transition:width 50ms ease;-webkit-transform-origin:0 0;-ms-transform-origin:0 0;transform-origin:0 0}.checkbox__2sRHP input[type=checkbox]{display:none}.checkbox__2sRHP input[type=checkbox]:checked~.indicator__3LEWo{background-color:#124142;border:2px solid #124142;-webkit-transform:scale(1.25);-ms-transform:scale(1.25);transform:scale(1.25)}.checkbox__2sRHP:hover input[type=checkbox][disabled]:checked~.indicator__3LEWo,.checkbox__2sRHP input[type=checkbox][disabled]:checked~.indicator__3LEWo{background-color:#aaa;border:2px solid #aaa;-webkit-transition:none;transition:none}.checkbox__2sRHP input[type=checkbox]:checked~.indicator__3LEWo:after{width:10px;background:#fff;-webkit-transition:width .15s ease .1s;transition:width .15s ease .1s}.checkbox__2sRHP input[type=checkbox]:checked~.indicator__3LEWo:before{width:5px;background:#fff;-webkit-transition:width .15s ease .1s;transition:width .15s ease .1s}.checkbox__2sRHP:hover input[type=checkbox]:checked~.indicator__3LEWo{background-color:#124142;-webkit-transform:scale(1.25);-ms-transform:scale(1.25);transform:scale(1.25)}.checkbox__2sRHP:hover input[type=checkbox]:checked~.indicator__3LEWo:after{width:10px;background:#fff;-webkit-transition:width .15s ease .1s;transition:width .15s ease .1s}.checkbox__2sRHP:hover input[type=checkbox]:checked~.indicator__3LEWo:before{width:5px;background:#fff;-webkit-transition:width .15s ease .1s;transition:width .15s ease .1s}.content__1ry7a{max-width:calc(100% - 35px);opacity:.54;-webkit-transition:opacity .4s ease;transition:opacity .4s ease}.checkbox__2sRHP input[type=checkbox]:checked~.content__1ry7a{opacity:1}.content__1ry7a h5+h6{font-size:12px}@media only screen and (max-width:50rem){.checkboxContent__fJXxh{padding:.5rem;max-width:100%}.indicator__3LEWo{width:16px;height:16px}.indicator__3LEWo:before{top:6px;left:3px}.indicator__3LEWo:after{top:9px;left:4px}.checkbox__2sRHP:hover input[type=checkbox]:checked~.indicator__3LEWo:after{width:8px}.checkbox__2sRHP:hover input[type=checkbox]:checked~.indicator__3LEWo:before{width:3px}}", ""]);

// exports
exports.locals = {
	"checkbox": "checkbox__2sRHP",
	"indicator": "indicator__3LEWo",
	"content": "content__1ry7a",
	"checkboxContent": "checkboxContent__fJXxh"
};

/***/ }),

/***/ "GfHm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./range')} */

module.exports = RangeError;

/***/ }),

/***/ "HzbK":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, ".image__3Ts8X{-webkit-animation:imageFadeIn__3wUm1 4s ease;animation:imageFadeIn__3wUm1 4s ease;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.image__3Ts8X:before{top:0;height:100%;background-color:#fff}.image__3Ts8X:after,.image__3Ts8X:before{content:\" \";display:block;position:absolute;left:0;width:100%}.image__3Ts8X:after{font-size:16px;font-style:normal;top:5px;text-align:center}.loading__3W6_K{opacity:0}.image__3Ts8X[cached]{-webkit-animation:none;animation:none;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}@-webkit-keyframes imageFadeIn__3wUm1{0%{opacity:0}to{opacity:1}}@keyframes imageFadeIn__3wUm1{0%{opacity:0}to{opacity:1}}", ""]);

// exports
exports.locals = {
	"image": "image__3Ts8X",
	"imageFadeIn": "imageFadeIn__3wUm1",
	"loading": "loading__3W6_K"
};

/***/ }),

/***/ "I23h":
/***/ (function(module, exports) {

// Copyright 2016 by Stijn de witt. Some rights reserved. License: CC-BY-4.0.
// Based on Node's `events` module. License: MIT
function EventEmitter(obj, options) {
	// for backwards compat with `event`
	if (!obj) {
		obj = this instanceof EventEmitter ? this : {};
	}
	return function (_events, _) {

		// public API
		return Object.defineProperties(obj, {
			setMaxListeners: { value: setMaxListeners },
			maxListeners: { get: function get() {
					return typeof _.maxListeners == 'undefined' ? EventEmitter.defaultMaxListeners : _.maxListeners;
				} },
			setLogger: { value: setLogger },
			logger: { get: function get() {
					return typeof _.logger == 'undefined' ? EventEmitter.logger : _.logger;
				} },
			emit: { value: emit },
			on: { value: on },
			once: { value: once },
			off: { value: off },
			addListener: { value: on },
			removeListener: { value: off },
			removeAllListeners: { value: off },
			listeners: { value: listeners },
			listenerTypes: { value: listenerTypes },
			listenerCount: { value: listenerCount }
		});

		// ===== IMPLEMENTATION =====

		// Obviously not all Emitters should be limited to 10. This function allows
		// that to be increased. Set to zero for unlimited.
		function setMaxListeners(n) {
			_.maxListeners = n;
			return obj;
		}

		function setLogger(log) {
			_.logger = log;
			return obj;
		}

		function emit(type) {
			var args, er, listeners;
			// If there is no 'error' event listener then throw.
			if (type === 'error' && (!_events.error || !_events.error.length)) {
				if (arguments[1] instanceof Error) {
					er = arguments[1];
				} else {
					er = new Error('Unhandled error event: ' + arguments[1]);er.context = arguments[1];
				}
				throw er;
			}
			if (!_events[type]) return false;
			args = Array.prototype.slice.call(arguments, 1);
			_events[type].slice().forEach(function (fn) {
				if (!fn._once || fn._once === 1) {
					fn._once++;fn.apply(obj, args);
				}
				if (fn._once) {
					off(type, fn);
				}
			});
			return obj;
		}

		function on(type, fn) {
			if (_events.newListener) {
				obj.emit('newListener', type, fn);
			}
			_events[type] = _events[type] || [];
			_events[type].push(fn);
			// Check for listener leak
			if (!_events[type].warned) {
				var m = obj.maxListeners;
				if (m && m > 0 && _events[type].length > m) {
					_events[type].warned = true;
					obj.logger.warn('Possible EventEmitter memory leak detected for \'%s\' event. %d listeners added. Use emitter.setMaxListeners() to increase limit.', type, _events[type].length);
					obj.logger.trace && obj.logger.trace();
				}
			}
			return obj;
		}

		function once(type, fn) {
			fn._once = 1;
			return obj.on(type, fn);
		}

		function off(type, fn) {
			// bulk and not listening for removeListener -> no need to emit
			if (!fn && !_events.removeListener) {
				if (!type) {
					_events = {};
				} else if (_events[type]) {
					delete _events[type];
				}
				return obj;
			}

			// emit removeListener for all listeners on all events
			if (!type) {
				for (var key in _events) {
					if (key != 'removeListener') {
						off(key);
					}
				}
				off('removeListener');
				_events = {};
				return obj;
			}

			if (!_events[type]) {
				return obj;
			}

			if (!fn) {
				// LIFO order
				while (_events[type].length) {
					off(type, _events[type][_events[type].length - 1]);
				}
				delete _events[type];
				return obj;
			}

			var pos = _events[type].indexOf(fn);
			if (pos < 0) {
				return obj;
			}
			_events[type].splice(pos, 1);
			if (_events.removeListener) {
				emit('removeListener', type, fn);
			}
			return obj;
		}

		function listeners(type) {
			return _events[type] ? _events[type].slice() : [];
		}

		function listenerTypes() {
			return Object.keys(_events);
		}

		function listenerCount(type) {
			if (!type) {
				var result = 0;
				listenerTypes().forEach(function (x) {
					result += listenerCount(x);
				});
				return result;
			}
			if (typeof type == 'object' && type.length) {
				return listenerTypes().map(function (x) {
					return listenerCount(x);
				});
			}
			return _events[type] && _events[type].length || 0;
		}
	}({}, { logger: options && options.logger, maxListeners: options && options.maxListeners });
}

EventEmitter.EventEmitter = EventEmitter;
EventEmitter.defaultMaxListeners = 10;
EventEmitter.logger = typeof console == 'object' && console || { warn: function warn() {} };
EventEmitter.setLogger = function setLogger(logger) {
	EventEmitter.logger = logger;
};

module.exports = EventEmitter;

/***/ }),

/***/ "IPWD":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, ".mainCitySelector__3rKJx{display:-webkit-box;display:-ms-flexbox;display:flex}.citySelectorTabs__3YIzZ{width:100%}.cityPromo__X7d7z{-webkit-box-flex:1;-ms-flex:1 0 19rem;flex:1 0 19rem;display:inline-block;margin-right:.5rem;margin-top:0;margin-bottom:0}.cityPromoImage__SUqr2{display:block;-o-object-fit:cover;object-fit:cover;height:100%;width:100%}.cityPromoLink__1dZ2q{position:absolute;bottom:0;left:0;right:0;color:#fff;padding:1.25rem;background-image:-webkit-gradient(linear,left top,left bottom,from(transparent),to(rgba(0,0,0,.85)));background-image:linear-gradient(transparent,rgba(0,0,0,.85))}.cityPromoList__3V8Pz{list-style:none}.singleCity__3tXnU{display:inline-block;width:100%;max-width:140px;padding:0 .5rem .5rem 0}@media (max-width:768px){.cityPromo__X7d7z{display:none}}", ""]);

// exports
exports.locals = {
	"mainCitySelector": "mainCitySelector__3rKJx",
	"citySelectorTabs": "citySelectorTabs__3YIzZ",
	"cityPromo": "cityPromo__X7d7z",
	"cityPromoImage": "cityPromoImage__SUqr2",
	"cityPromoLink": "cityPromoLink__1dZ2q",
	"cityPromoList": "cityPromoList__3V8Pz",
	"singleCity": "singleCity__3tXnU"
};

/***/ }),

/***/ "Il1g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("58Ti");
var $apply = __webpack_require__("THdF");
var actualApply = __webpack_require__("rXTS");

/** @type {import('./applyBind')} */
module.exports = function applyBind() {
	return actualApply(bind, $apply, arguments);
};

/***/ }),

/***/ "J4Nk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(_extends({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./style/index.css
var style = __webpack_require__("rq4c");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../package.json
var package_0 = __webpack_require__("EHrm");
var package_default = /*#__PURE__*/__webpack_require__.n(package_0);

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// EXTERNAL MODULE: ../node_modules/preact-helmet/lib/Helmet.js
var Helmet = __webpack_require__("FJnM");
var Helmet_default = /*#__PURE__*/__webpack_require__.n(Helmet);

// EXTERNAL MODULE: ../node_modules/dlv/dist/dlv.umd.js
var dlv_umd = __webpack_require__("CYb7");
var dlv_umd_default = /*#__PURE__*/__webpack_require__.n(dlv_umd);

// EXTERNAL MODULE: ./helpers.js
var helpers = __webpack_require__("UiAd");

// EXTERNAL MODULE: ./analytics.js
var analytics = __webpack_require__("qV3Q");

// EXTERNAL MODULE: ./globals.js
var globals = __webpack_require__("zQXs");

// EXTERNAL MODULE: ./components/slots/index.js
var slots = __webpack_require__("Jof1");

// EXTERNAL MODULE: ./components/header/index.js + 3 modules
var header = __webpack_require__("sIAo");

// EXTERNAL MODULE: ./components/hero/index.js + 1 modules
var hero = __webpack_require__("55IF");

// EXTERNAL MODULE: ./components/footer/index.js
var footer = __webpack_require__("5ttS");

// EXTERNAL MODULE: ./components/pubsub/index.js + 1 modules
var pubsub = __webpack_require__("0/XQ");

// EXTERNAL MODULE: ./components/root/index.js
var root = __webpack_require__("VjJS");

// CONCATENATED MODULE: ./utils/auth.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var namespace = 'TableOnline--auth';
var defaultRequestOptions = { method: 'GET' };
var statusCodes = {
  200: 'OK',
  201: 'Created',
  202: 'Accepted',
  204: 'No Content',
  301: 'Moved Permanently',
  302: 'Found',
  303: 'See Other',
  304: 'Not Modified',
  307: 'Temporary Redirect',
  400: 'Bad Request',
  401: 'Unauthorized',
  403: 'Forbidden',
  404: 'Not Found',
  405: 'Method Not Allowed',
  406: 'Not Acceptable',
  412: 'Precondition Failed',
  415: 'Unsupported Media Type',
  500: 'Internal Server Error',
  501: 'Not Implemented'
};

// BUNDLE FETCH REQUESTS (only GET)
var MEMFETCH = {};

// MEMOIZE RESPONSES (only GET)
var MEMRESPONSE = {};

var b64DecodeUnicode = function b64DecodeUnicode(str) {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(atob(str).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
};
var saveData = function () {
  var a = document.createElement('a');
  document.body.appendChild(a);
  a.style = 'display: none';
  return function (data, fileName) {
    var blob = new Blob([data], { type: 'octet/stream' }),
        url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  };
}();

var auth_AuthProvider = function (_Component) {
  _inherits(AuthProvider, _Component);

  function AuthProvider() {
    var _temp, _this, _ret;

    _classCallCheck(this, AuthProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._decodeJWTData = function (jwt) {
      return jwt ? JSON.parse(b64DecodeUnicode(jwt.split('.')[1])) : {};
    }, _this.isValidToken = function (token, sub) {
      var data = _this._decodeJWTData(token);
      return data && data.sub === sub && new Date().valueOf() < data.exp * 1000;
    }, _this.shouldFetchRefreshToken = function (token) {
      var data = _this._decodeJWTData(token);
      // Decide if token should be refreshed ( set to 7 days from now )
      return new Date().valueOf() + 1000 * 60 * 60 * 24 * 7 > data.exp * 1000;
    }, _this.getCurrentAccessToken = function () {
      return new Promise(function (resolve, reject) {
        var user = _this.getUser();
        if (!user) {
          resolve();
          return;
        }
        var token = user.accessToken;
        var refreshToken = user.refreshToken;

        if (!_this.isValidToken(token, 'access')) {
          _this.getAccessToken(refreshToken).then(function () {
            token = _this.getUser().accessToken;
            resolve(token);
          }).catch(function (err) {
            reject(err);
          });
        } else {
          resolve(token);
        }
      });
    }, _this.getToken = function (token, returnSecureToken) {
      return new Promise(function (resolve, reject) {
        if (_this._tokenFetch) {
          _this._tokenFetch.push({ resolve: resolve, reject: reject });
        } else {
          _this._tokenFetch = [];
          _this._fetch('/auth/token', {
            method: 'POST',
            body: JSON.stringify({
              token: token,
              returnSecureToken: returnSecureToken
            })
          }).then(function (res) {
            resolve(res);
            _this._tokenFetch.forEach(function (callbacks) {
              return callbacks.resolve(res);
            });
            _this._tokenFetch = null;
          }).catch(function (err) {
            reject(err);
            _this._tokenFetch.forEach(function (callbacks) {
              return callbacks.reject(err);
            });
            _this._tokenFetch = null;
          });
        }
      });
    }, _this.getRefreshToken = function (token) {
      return new Promise(function (resolve, reject) {
        if (!_this.isValidToken(token, 'refresh')) {
          _this.logout();
          return reject('Unauthorized');
        }

        _this.getToken(token, true).then(function (response) {
          // Save latest refresh token to user data
          _this.setUser(_extends({}, _this.getUser(), { refreshToken: response.token }));
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }, _this.loginWithCustomToken = function (refreshToken) {
      return new Promise(function (resolve, reject) {
        _this.getAccessToken(refreshToken).then(function () {
          _this.setUser({ refreshToken: refreshToken });
          _this.getUserFromServer().then(function (res) {
            _this.context.events.emit('loggedIn', true);
            resolve(res);
          });
        }).catch(function (err) {
          reject(err);
        });
      });
    }, _this.getAccessToken = function (refreshtoken) {
      return new Promise(function (resolve, reject) {
        if (!_this.isValidToken(refreshtoken, 'refresh')) {
          _this.logout();
          return reject('Unauthorized');
        }

        _this.getToken(refreshtoken).then(function (response) {
          // Save latest token to user data
          var user = response.user || _this._decodeJWTData(response.token) || _this.getUser() || {};

          user.accessToken = response.token;
          if (response.rt) user.refreshToken = response.rt;else if (refreshtoken) user.refreshToken = refreshtoken;

          _this.setUser(user);
          resolve(response);
        }).catch(function (error) {
          _this.logout();
          reject(error);
        });
      });
    }, _this.resetPassword = function (auth) {
      return new Promise(function (resolve, reject) {
        _this._fetch('/auth/resetpass', {
          method: 'POST',
          body: JSON.stringify(_extends({}, auth, {
            lang: window.location.pathname.split('/').reduce(function (r, item) {
              return r || item;
            }, '')
          }))
        }).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
    }, _this.getUser = function () {
      var str = localStorage.getItem(namespace);
      return str ? JSON.parse(str) : null;
    }, _this.getUserFromServer = function () {
      return new Promise(function (resolve, reject) {
        var user = _this.getUser();
        if (user) {
          _this.getCurrentAccessToken().then(function (accessToken) {
            if (user.accessToken) {
              _this._fetch('/user', {
                method: 'GET'
              }, accessToken).then(function (res) {
                if (typeof res === 'string') {
                  throw res;
                }
                _this.setUser(res.restaurants ? _extends({}, res.user, { restaurants: res.restaurants }) : res.user);
                resolve(res.user);
              }).catch(function (err) {
                reject(err);
              });
            }
          }).catch(function (err) {
            _this.logout();
            reject(err);
          });
        } else {
          reject('User is not logged in');
        }
      });
    }, _this.setUser = function (changes) {
      var user = _this.getUser() || {};
      if (user.accessToken) {
        user = _extends({}, user, _this._decodeJWTData(user.accessToken));
      }
      Object.keys(changes).forEach(function (key) {
        user[key] = changes[key];
      });

      localStorage.setItem(namespace, JSON.stringify(user));

      _this.context.events.emit('auth', user);

      if (user.email && root["a" /* default */].Raven) {
        window.Raven.this.setUserContext({
          email: user.email
        });
      }

      return user;
    }, _this.createAccount = function (auth) {
      return new Promise(function (resolve, reject) {
        _this._fetch('/auth/signup', {
          method: 'POST',
          body: JSON.stringify(auth)
        }).then(function (res) {
          return resolve(res);
        }).catch(function (error) {
          reject(error);
        });
      });
    }, _this.deleteAccount = function () {
      return _this.request('/auth/delete', {
        method: 'DELETE'
      });
    }, _this.login = function (auth) {
      return new Promise(function (resolve, reject) {
        _this._fetch('/auth/login', {
          method: 'POST',
          body: JSON.stringify(auth)
        }).then(function (res) {
          _this.loginWithCustomToken(res.token).then(resolve).catch(reject);
        }).catch(function (error) {
          reject(error);
        });
      });
    }, _this.logout = function () {
      localStorage.removeItem(namespace);
      _this.context.events.emit('auth', null);
      _this.context.events.emit('loggedIn', false);
    }, _this.update = function (user) {
      return new Promise(function (resolve, reject) {
        if (user) {
          _this.getCurrentAccessToken().then(function (accessToken) {
            _this._fetch('/user', {
              method: 'POST',
              body: JSON.stringify(user)
            }, accessToken).then(function (res) {
              _this.getAccessToken(res.token).then(resolve);
            }).catch(function (error) {
              reject(error);
            });
          }).catch(function (err) {
            _this.logout();
            reject(err);
          });
        } else {
          reject('User is not logged in');
        }
      });
    }, _this.request = function (url, opts) {
      return new Promise(function (resolve, reject) {
        _this.getCurrentAccessToken().then(function (token) {
          _this._fetch(url, opts, token).then(function (res) {
            resolve(res);
          }).catch(function (err) {
            reject(err);
          });
        }).catch(function (err) {
          reject(err);
        });
      });
    }, _this.init = function () {
      return new Promise(function ($return, $error) {
        var user;

        user = _this.getUser();
        if (user && user.refreshToken && _this.isValidToken(user.refreshToken, 'refresh')) {
          if (_this.shouldFetchRefreshToken(user.refreshToken)) {
            var $Try_1_Post = function () {
              try {
                return $If_3.call(this);
              } catch ($boundEx) {
                return $error($boundEx);
              }
            }.bind(this);var $Try_1_Catch = function (error) {
              try {
                _this.logout();
                return $return();
              } catch ($boundEx) {
                return $error($boundEx);
              }
            };
            try {
              return Promise.resolve(_this.getRefreshToken(user.refreshToken)).then(function ($await_6) {
                try {
                  return $Try_1_Post();
                } catch ($boundEx) {
                  return $Try_1_Catch($boundEx);
                }
              }, $Try_1_Catch);
            } catch (error) {
              $Try_1_Catch(error)
            }
          }

          function $If_3() {
            if (user.accessToken && _this.isValidToken(user.accessToken, 'access')) {
              _this.context.events.emit('auth', user);
              _this.context.events.emit('loggedIn', true);
              _this.getUserFromServer();
            } else {
              _this.getAccessToken(user.refreshToken).then(_this.init).catch(function () {
                _this.logout();
              });
            }
            return $If_2.call(this);
          }

          return $If_3.call(this);
        } else {
          _this.context.events.emit('loggedIn', false);
          return $If_2.call(this);
        }

        function $If_2() {
          return $return(_this);
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  AuthProvider.prototype._fetch = function _fetch(url, opts, token) {
    return new Promise(function (resolve, reject) {
      var options = _extends({}, defaultRequestOptions, opts);
      var INTERNALREQUEST = url.indexOf('https://') !== 0 && url.indexOf('http://') !== 0;
      var path = (INTERNALREQUEST ? globals["e" /* LAMBDA */] : '') + url;

      if (INTERNALREQUEST) {
        if (typeof options.body === 'string') options.headers = {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        };
        if (token) {
          options.headers = _extends({}, options.headers, { Authorization: token });
        }
        options.headers = _extends({}, options.headers, {
          Platform: 'web'
        });
      }
      if (opts && opts.headers) options.headers = _extends({}, options.headers, opts.headers);

      if (options.body && typeof options.body === 'string') {
        // CLEAN ILLEGAL CHARACTERS, EVEN IF IM NOT THE POLICE
        options.body = options.body.replace(/[\u200B-\u200D\uFEFF]/g, '');
      }

      if (options.method === 'GET' && MEMRESPONSE[path]) {
        resolve(MEMRESPONSE[path]);
      } else if (options.method === 'GET' && MEMFETCH[path]) {
        MEMFETCH[path].push({ resolve: resolve, reject: reject });
      } else {
        if (options.method === 'GET') MEMFETCH[path] = [];
        fetch(path, options).then(function (response) {
          return new Promise(function ($return, $error) {
            if (response.ok) {
              if (dlv_umd_default()(options, 'headers.Accept', '').includes('text/')) {
                return Promise.resolve(response.text()).then(function ($await_7) {
                  try {
                    saveData($await_7, url.split('/').pop() + '.csv');
                    return $If_5.call(this);
                  } catch ($boundEx) {
                    return $error($boundEx);
                  }
                }.bind(this), $error);
              } else return $return(response.json());

              function $If_5() {
                return $If_4.call(this);
              }

              return $If_5.call(this);
            } else {
              return $return(new Promise(function (resolve, reject) {
                response.json().then(function (json) {
                  reject(json);
                }).catch(function () {
                  reject(statusCodes[response.status]);
                });
              }));
            }

            function $If_4() {
              return $return();
            }

            return $If_4.call(this);
          });
        }).then(function (response) {
          if (typeof response === 'string') {
            throw response;
          }

          if (response.errorMessage) {
            if (response.errorMessage.includes('Task timed out')) {
              //toast('Server is not responding, please try again', {type: 'error'} );
            } else {
                //toast(response.errorMessage, {type: 'error'} );
              }
            reject(response.errorMessage);
            if (options.method === 'GET') MEMFETCH[path].forEach(function (callback) {
              return callback.reject(response.errorMessage);
            });
          } else if (response.error) {
            reject(response.error);
            if (options.method === 'GET') MEMFETCH[path].forEach(function (callback) {
              return callback.reject(response.errorMessage);
            });
          } else {
            resolve(response);
            if (options.method === 'GET') MEMRESPONSE[path] = response;
            if (options.method === 'GET') MEMFETCH[path].forEach(function (callback) {
              return callback.resolve(response);
            });
          }
          if (options.method === 'GET') delete MEMFETCH[path];
        }).catch(function (err) {
          if (err.indexOf && err.includes('Task timed out')) {
            //toast('Server is not responding, please try again', {type: 'error'} );
          } else if (typeof err === 'string') {
            //toast(err, {type: 'error'} );
          } else {
              //toast('An error occured while fetching assets', {type: 'error'} );
            }
          reject(err);
          if (options.method === 'GET') MEMFETCH[path].forEach(function (callback) {
            return callback.reject(err);
          });
          if (options.method === 'GET') delete MEMFETCH[path];
        });
      }
    });
  };

  AuthProvider.prototype.componentDidMount = function componentDidMount() {
    this.init();
  };

  AuthProvider.prototype.getChildContext = function getChildContext() {
    var logout = this.logout,
        getUser = this.getUser,
        setUser = this.setUser,
        request = this.request,
        createAccount = this.createAccount,
        deleteAccount = this.deleteAccount,
        login = this.login,
        resetPassword = this.resetPassword,
        update = this.update,
        getRefreshToken = this.getRefreshToken;

    var auth = {
      logout: logout,
      getUser: getUser,
      setUser: setUser,
      request: request,
      createAccount: createAccount,
      deleteAccount: deleteAccount,
      login: login,
      resetPassword: resetPassword,
      update: update,
      getRefreshToken: getRefreshToken
    };
    return { auth: auth };
  };

  AuthProvider.prototype.render = function render(_ref) {
    var children = _ref.children;

    return children[0];
  };

  return AuthProvider;
}(preact_min["Component"]);

/* harmony default export */ var auth = (auth_AuthProvider);
// EXTERNAL MODULE: ./utils/i18n.js
var i18n = __webpack_require__("LnyB");

// EXTERNAL MODULE: ./i18n/index.js
var i18n_0 = __webpack_require__("ktCQ");

// EXTERNAL MODULE: ../node_modules/preact-cli/lib/components/async.js
var components_async = __webpack_require__("7N8r");
var async_default = /*#__PURE__*/__webpack_require__.n(components_async);

// CONCATENATED MODULE: ../node_modules/preact-cli/lib/lib/webpack/async-component-loader.js!./routes/landing/index.js

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(4).then((function (require) {
				cb( __webpack_require__("gUMf") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var landing = (async_default()(load));
	
// CONCATENATED MODULE: ../node_modules/preact-cli/lib/lib/webpack/async-component-loader.js!./routes/search/index.js

		

		function search_load(cb) {
			__webpack_require__.e/* require.ensure */(2).then((function (require) {
				cb( __webpack_require__("3h6+") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var search = (async_default()(search_load));
	
// CONCATENATED MODULE: ../node_modules/preact-cli/lib/lib/webpack/async-component-loader.js!./routes/confirmation/index.js

		

		function confirmation_load(cb) {
			__webpack_require__.e/* require.ensure */(6).then((function (require) {
				cb( __webpack_require__("xG59") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var confirmation = (async_default()(confirmation_load));
	
// CONCATENATED MODULE: ../node_modules/preact-cli/lib/lib/webpack/async-component-loader.js!./routes/profile/index.js

		

		function profile_load(cb) {
			__webpack_require__.e/* require.ensure */(3).then((function (require) {
				cb( __webpack_require__("i+m+") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var profile = (async_default()(profile_load));
	
// CONCATENATED MODULE: ../node_modules/preact-cli/lib/lib/webpack/async-component-loader.js!./routes/dynamic/index.js

		

		function dynamic_load(cb) {
			__webpack_require__.e/* require.ensure */(5).then((function (require) {
				cb( __webpack_require__("YlBZ") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var dynamic = (async_default()(dynamic_load));
	
// CONCATENATED MODULE: ../node_modules/preact-cli/lib/lib/webpack/async-component-loader.js!./routes/admin/index.js

		

		function admin_load(cb) {
			__webpack_require__.e/* require.ensure */(7).then((function (require) {
				cb( __webpack_require__("9Jja") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var admin = (async_default()(admin_load));
	
// CONCATENATED MODULE: ../node_modules/preact-cli/lib/lib/webpack/async-component-loader.js!./routes/admin/changes/index.js

		

		function changes_load(cb) {
			__webpack_require__.e/* require.ensure */(0).then((function (require) {
				cb( __webpack_require__("+PhO") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var admin_changes = (async_default()(changes_load));
	
// CONCATENATED MODULE: ../node_modules/preact-cli/lib/lib/webpack/async-component-loader.js!./components/ads/index.js

		

		function ads_load(cb) {
			__webpack_require__.e/* require.ensure */(1).then((function (require) {
				cb( __webpack_require__("MjVw") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var ads = (async_default()(ads_load));
	
// EXTERNAL MODULE: ./components/topbar/index.js
var topbar = __webpack_require__("SeHH");

// CONCATENATED MODULE: ../node_modules/preact-cli/lib/lib/webpack/async-component-loader.js!./components/hybrid-page/index.js

		

		function hybrid_page_load(cb) {
			__webpack_require__.e/* require.ensure */(12).then((function (require) {
				cb( __webpack_require__("EOUp") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var hybrid_page = (async_default()(hybrid_page_load));
	
// CONCATENATED MODULE: ./index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return index_App; });


function index__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function index__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function index__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























// Code-splitting is automated for routes











var clicks = 0;

// Static list of hybrid routes
var HYBRID_ROUTES = {
  '/fi/liity-tableonlineen': true,
  '/en/join': true
  // Add more hybrid routes as needed
};

var _ref2 = Object(preact_min["h"])(topbar["a" /* default */], null);

var _ref3 = Object(preact_min["h"])(landing, { path: '/:lang/' });

var _ref4 = Object(preact_min["h"])(search, { path: '/:lang/search' });

var _ref5 = Object(preact_min["h"])(admin, { path: '/:lang/admin' });

var _ref6 = Object(preact_min["h"])(admin_changes, { path: '/:lang/admin/changes' });

var _ref7 = Object(preact_min["h"])(profile, { path: '/:lang/profile/:view?' });

var _ref8 = Object(preact_min["h"])(confirmation, { path: '/:lang/booking/:bookingId/:hash' });

var _ref9 = Object(preact_min["h"])(dynamic, {
  path: '/:lang/:city/:slug?/:restaurantId?/:action?',
  'default': true
});

var _ref10 = Object(preact_min["h"])('span', { 'class': 'verticalSpacer' });

var _ref11 = Object(preact_min["h"])(ads, null);

var _ref12 = Object(preact_min["h"])(footer["a" /* default */], null);

var index_App = function (_Component) {
  index__inherits(App, _Component);

  function App(props) {
    index__classCallCheck(this, App);

    // Sets router reference to the window for the route function to work outside of the component
    var _this = index__possibleConstructorReturn(this, _Component.call(this, props));

    _this.kkeys = [];

    _this.handleRoute = function (e) {
      if (e.url === _this.currentUrl) {
        return;
      }
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      if (dlv_umd_default()(e, 'current.attributes')) {
        _this.handleAffiliateLinking(dlv_umd_default()(e, 'current.attributes'));
        _this.handleInternalTagging(dlv_umd_default()(e, 'current.attributes'));
      }
      if (_this.currentUrl) {
        Object(analytics["c" /* facebookTracking */])();
      }

      _this.currentUrl = e.url;

      var newLocale = root["a" /* default */].location.pathname.split('/').filter(function (b) {
        return b;
      })[0] || _this.state.defaultLanguage;

      if (i18n_0["a" /* default */].supportedLocales.includes(newLocale)) {
        i18n_0["a" /* default */].changeLocale(newLocale);
        if (typeof document !== 'undefined') document.cookie = 'lang=' + newLocale + '; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/';
        Object(preact_min["render"])(Object(preact_min["h"])(Helmet_default.a, {
          htmlAttributes: { lang: newLocale === 'ee' ? 'et' : newLocale }
        }), document.body);
      }
    };

    _this.isHybridRoute = function (path) {
      return HYBRID_ROUTES[path] || false;
    };

    _this.konami = function () {
      clicks++;
      if (clicks >= 4) {
        _this.setState({ accessGranted: true }, function () {
          if (typeof document !== 'undefined') document.cookie = 'password=*zM?Y%AvvK7+-jNw5^Tq5g8^c$mn#F$J; expires=Fri, 31 Dec 9999 23:59:59 GMT';
        });
        root["a" /* default */].removeEventListener('click', _this.konami);
        root["a" /* default */].removeEventListener('touchend', _this.konami);
      }
    };

    _this.handleAffiliateLinking = function (params) {
      if (params.tlink) {
        Object(helpers["p" /* setAffiliate */])('tlink', params.tlink);
      } else if (params.rewardno) {
        Object(helpers["p" /* setAffiliate */])('norwegian', params.rewardno);
      } else if (params.finnair) {
        Object(helpers["p" /* setAffiliate */])('finnair', params.finnair);
      }
      return;
    };

    _this.handleInternalTagging = function (params) {
      if (params.tags) {
        Object(helpers["r" /* setInternalTrackingTag */])('tags', (params.tags || '').split(','));
      }
      return;
    };

    window.route = preact_router_es["route"];
    // eslint-disable-next-line no-console
    console.log('%cTableOnline version ' + package_0["version"], 'color:#005c53');

    var lang = root["a" /* default */].location.pathname.split('/').filter(function (b) {
      return b;
    })[0];
    if (lang && i18n_0["a" /* default */].supportedLocales.includes(lang)) {
      i18n_0["a" /* default */].changeLocale(lang);
    } else {
      if (lang) {
        Object(preact_router_es["route"])('/' + _this.state.defaultLanguage + window.location.pathname);
      }
    }

    // Test hidden affiliates
    var cookies = Object(helpers["j" /* getCookies */])();
    var queryPreferences = Object(helpers["l" /* getParams */])();

    Object(helpers["s" /* setPreferences */])(queryPreferences);

    if (cookies['TT2']) {
      Object(helpers["c" /* deleteCookie */])('TableOnline--affiliate', '/');
    }

    if (typeof navigator !== 'undefined' || typeof document !== 'undefined') {
      _this.state = {
        latest: package_0["version"],
        accessGranted: document.querySelector('main').innerHTML || globals["f" /* PRODUCTION */] || cookies.password === '*zM?Y%AvvK7+-jNw5^Tq5g8^c$mn#F$J',
        defaultLanguage: (cookies.lang && i18n_0["a" /* default */].supportedLocales.includes(cookies.lang) ? cookies.lang : [].concat(dlv_umd_default()(navigator, 'languages'), [dlv_umd_default()(navigator, 'language')]).filter(function (language) {
          return i18n_0["a" /* default */].supportedLocales.includes(language);
        })[0]) || 'fi',
        breadcrumbs: []
      };
    } else {
      _this.state = {
        latest: package_0["version"],
        accessGranted: true,
        defaultLanguage: 'fi',
        breadcrumbs: []
      };
    }

    // Start trackers
    Object(analytics["b" /* default */])({ ecommerce: null });
    Object(analytics["c" /* facebookTracking */])();
    return _this;
  }
  /** Gets fired when the route changes.
   *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
   *	@param {string} event.url	The newly routed URL
   */


  App.prototype.componentDidMount = function componentDidMount() {
    if (this.state.accessGranted === false) {
      root["a" /* default */].addEventListener('click', this.konami);
      root["a" /* default */].addEventListener('touchend', this.konami);
    }
  };

  // Check if current path is a hybrid route


  App.prototype.getChildContext = function getChildContext() {
    var _this2 = this;

    return {
      supportedLocales: ['fi', 'en', 'ee'], // I18n.supportedLocales,
      setBreadcrumbs: function setBreadcrumbs(breadcrumbs) {
        if (!breadcrumbs || !_this2.state.breadcrumbs || JSON.stringify(breadcrumbs) !== JSON.stringify(_this2.state.breadcrumbs)) {
          _this2.setState({ breadcrumbs: breadcrumbs });
        }
      }
    };
  };

  App.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    return JSON.stringify(nextState) !== JSON.stringify(this.state);
  };

  App.prototype.render = function render(props, _ref) {
    var _ref$accessGranted = _ref.accessGranted,
        accessGranted = _ref$accessGranted === undefined ? false : _ref$accessGranted,
        breadcrumbs = _ref.breadcrumbs,
        defaultLanguage = _ref.defaultLanguage,
        latest = _ref.latest;

    return accessGranted && defaultLanguage && latest ? Object(preact_min["h"])(
      i18n["a" /* default */],
      null,
      Object(preact_min["h"])(
        pubsub["b" /* PubSub */],
        null,
        Object(preact_min["h"])(
          auth,
          null,
          Object(preact_min["h"])(
            slots["c" /* SlotProvider */],
            null,
            this.isHybridRoute(root["a" /* default */].location.pathname) ? Object(preact_min["h"])(hybrid_page, {
              path: root["a" /* default */].location.pathname,
              lang: defaultLanguage
            }) : Object(preact_min["h"])(
              'main',
              { id: 'app' },
              Object(preact_min["h"])(Helmet_default.a, {
                htmlAttributes: {
                  lang: defaultLanguage === 'ee' ? 'et' : defaultLanguage
                },
                titleTemplate: '%s | TableOnline.fi',
                titleAttributes: {
                  itemprop: 'name',
                  lang: defaultLanguage === 'ee' ? 'et' : defaultLanguage
                },
                meta: [{
                  name: 'description',
                  content: i18n_0["a" /* default */].t('Make reservations, read reviews, find offers and discover the top restaurants in Finland and Tallinn. Search hundreds of restaurants and find the best!')
                }, { property: 'og:type', content: 'article' }],
                onChangeClientState: function onChangeClientState() {
                  return [].concat(document.head.querySelectorAll('[data-preact-helmet="true"]').forEach(function (el) {
                    return document.head.querySelector('title').insertAdjacentElement('afterEnd', el);
                  }));
                }
              }),
              _ref2,
              Object(preact_min["h"])(hero["a" /* HeroWrapper */], { breadcrumbs: breadcrumbs }),
              Object(preact_min["h"])(
                preact_router_es["Router"],
                { onChange: this.handleRoute },
                Object(preact_min["h"])(
                  match_default.a,
                  { path: '/' },
                  function () {
                    Object(preact_router_es["route"])('/' + defaultLanguage, true);
                  }
                ),
                _ref3,
                _ref4,
                _ref5,
                _ref6,
                _ref7,
                _ref8,
                _ref9
              ),
              _ref10,
              Object(preact_min["h"])(
                match_default.a,
                { path: '/:lang/:city/:slug/:restaurantId/book' },
                function (e) {
                  var split = e.path.split('/');
                  return split.length === 6 && split.slice(-1)[0] === 'book' || split.slice(-1)[0] === 'giftcard' ? null : _ref11;
                }
              ),
              _ref12
            )
          )
        )
      )
    ) : false;
  };

  return App;
}(preact_min["Component"]);



/***/ }),

/***/ "Jof1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Slot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SlotProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SlotContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var cache = {};

var Slot = function (_Component) {
  _inherits(Slot, _Component);

  function Slot(props, context) {
    _classCallCheck(this, Slot);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.update = function (content) {
      _this.setState({ content: content });
    };

    _this.context.slots.register(_this.props.name, _this.update);
    return _this;
  }

  Slot.prototype.render = function render(props, _ref) {
    var _ref$content = _ref.content,
        content = _ref$content === undefined ? cache[this.props.name] && cache[this.props.name][window.location.pathname] ? cache[this.props.name][window.location.pathname] : props.children : _ref$content;

    return content[0];
  };

  return Slot;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var SlotProvider = function () {
  function SlotProvider() {
    _classCallCheck(this, SlotProvider);

    this.onChange = {};
  }

  SlotProvider.prototype.getChildContext = function getChildContext() {
    var onChange = this.onChange;

    return {
      slots: {
        onChange: onChange,
        register: function register(name, cb) {
          onChange[name] = cb;
        }
      }
    };
  };

  SlotProvider.prototype.render = function render(props) {
    return props.children[0];
  };

  return SlotProvider;
}();
var SlotContent = function (_Component2) {
  _inherits(SlotContent, _Component2);

  function SlotContent(props, context) {
    _classCallCheck(this, SlotContent);

    var _this2 = _possibleConstructorReturn(this, _Component2.call(this, props, context));

    cache[_this2.props.slot] = cache[_this2.props.slot] || {};
    cache[_this2.props.slot][window.location.pathname] = _this2.props.children;

    _this2.props.children;
    _this2.context.slots.onChange[_this2.props.slot](_this2.props.children);
    return _this2;
  }

  SlotContent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.context.slots.onChange[this.props.slot](void 0);
  };

  SlotContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref2) {
    var children = _ref2.children,
        slot = _ref2.slot;

    var slots = this.context.slots;
    if (slots.onChange[slot]) {
      slots.onChange[slot](children);
    }
  };

  SlotContent.prototype.render = function render() {
    return null;
  };

  return SlotContent;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "KpHW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__("jYt2");

/** @type {import('.')} */
module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};

/***/ }),

/***/ "Kszl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var supportsDescriptors = __webpack_require__("VxKF").supportsDescriptors;
var getPolyfill = __webpack_require__("YWiL");
var gOPD = __webpack_require__("34Ju");
var defineProperty = Object.defineProperty;
var $TypeError = __webpack_require__("79bw");
var getProto = __webpack_require__("v2Hg");
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};

/***/ }),

/***/ "LiLl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $Object = __webpack_require__("bwdo");

var $Error = __webpack_require__("79bw");
var $EvalError = __webpack_require__("2i3q");
var $RangeError = __webpack_require__("GfHm");
var $ReferenceError = __webpack_require__("DZEA");
var $SyntaxError = __webpack_require__("srJF");
var $TypeError = __webpack_require__("uVNY");
var $URIError = __webpack_require__("u6G0");

var abs = __webpack_require__("fPNz");
var floor = __webpack_require__("7vsa");
var max = __webpack_require__("ujtv");
var min = __webpack_require__("sV6m");
var pow = __webpack_require__("hGbk");
var round = __webpack_require__("lg1n");
var sign = __webpack_require__("6FVH");

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function getEvalledConstructor(expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__("34Ju");
var $defineProperty = __webpack_require__("3JcB");

var throwTypeError = function throwTypeError() {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function () {
	try {
		// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
		arguments.callee; // IE 8 does not throw here
		return throwTypeError;
	} catch (calleeThrows) {
		try {
			// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
			return $gOPD(arguments, 'callee').get;
		} catch (gOPDthrows) {
			return throwTypeError;
		}
	}
}() : throwTypeError;

var hasSymbols = __webpack_require__("NS5K")();

var getProto = __webpack_require__("v2Hg");
var $ObjectGPO = __webpack_require__("lJDY");
var $ReflectGPO = __webpack_require__("bx7G");

var $apply = __webpack_require__("THdF");
var $call = __webpack_require__("oG9A");

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__("58Ti");
var hasOwn = __webpack_require__("pijy");
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && i + 1 >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

/***/ }),

/***/ "LnyB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n__ = __webpack_require__("ktCQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var I18N = function (_Component) {
  _inherits(I18N, _Component);

  function I18N() {
    var _temp, _this, _ret;

    _classCallCheck(this, I18N);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      lang: 'en'
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  I18N.prototype.getChildContext = function getChildContext() {
    return {
      changeLocale: function changeLocale(lang) {
        __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].changeLocale(lang);
      },
      lang: this.state.lang
    };
  };

  I18N.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].on('change', function (lang) {
      _this2.setState({ lang: lang });
    });
  };

  I18N.prototype.render = function render(_ref) {
    var children = _ref.children;

    return children[0];
  };

  return I18N;
}(__WEBPACK_IMPORTED_MODULE_1_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (I18N);

/***/ }),

/***/ "MM91":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, ".navigation__18LFJ{width:100%;position:absolute;top:0;left:0;right:0;z-index:1}.header__3QGkI{border-bottom:1px solid hsla(0,0%,100%,.1);-webkit-transition:-webkit-box-shadow 1s ease;transition:-webkit-box-shadow 1s ease;transition:box-shadow 1s ease;transition:box-shadow 1s ease,-webkit-box-shadow 1s ease}.header__3QGkI:hover{-webkit-box-shadow:0 3.5rem 100px 0 rgba(0,0,0,.06);box-shadow:0 3.5rem 100px 0 rgba(0,0,0,.06)}.header__3QGkI,.header__3QGkI div,.header__3QGkI nav,.logo__35n-0{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.logoContainer__3K8mS{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;padding-top:.5rem;padding-bottom:.5rem}.logoWrapper__m8IYV{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto}.searchContainer__2axn9{-webkit-box-flex:2;-ms-flex:2 0 auto;flex:2 0 auto;max-width:50%;padding:0 1rem}.authContainer__3erl4{display:-webkit-box;display:-ms-flexbox;display:flex;gap:.5rem}.authContainer__3erl4,a.authButton__UXg8u{-webkit-box-align:center;-ms-flex-align:center;align-items:center}a.authButton__UXg8u{padding:.5rem 1rem!important;border-radius:4px;font-weight:500;white-space:nowrap;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;background:transparent;color:#fff}a.signupButton__2Pbjg{background:#fff;color:#000}.header__3QGkI.light__Y4e54{color:#000f0f}.header__3QGkI.dark__XD_Dc{color:#fff}.logo__35n-0 img:first-child{margin-right:1rem}.header__3QGkI a{padding:0 .5rem 0 0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}a.active__3gItZ{opacity:1}.link__koygZ{font-weight:500}.link__koygZ svg{margin-right:.5rem}.tableOnlineLogo__1Zv0g{height:2rem;width:auto}.navigationIcons__1ZOyw{list-style:none;margin:0;padding:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.navigationIcons__1ZOyw li{padding:0;margin:0 .25rem 0 0}.navigationIcons__1ZOyw a{font-weight:500;font-size:16px}.hideOnMobile__cQmrZ{display:none}@media (max-width:768px){.header__3QGkI{border-bottom:0 solid hsla(0,0%,100%,.1);display:none}.authContainer__3erl4,.navigationIcons__1ZOyw{display:none}}", ""]);

// exports
exports.locals = {
	"navigation": "navigation__18LFJ",
	"header": "header__3QGkI",
	"logo": "logo__35n-0",
	"logoContainer": "logoContainer__3K8mS",
	"logoWrapper": "logoWrapper__m8IYV",
	"searchContainer": "searchContainer__2axn9",
	"authContainer": "authContainer__3erl4",
	"authButton": "authButton__UXg8u",
	"signupButton": "signupButton__2Pbjg",
	"light": "light__Y4e54",
	"dark": "dark__XD_Dc",
	"active": "active__3gItZ",
	"link": "link__koygZ",
	"tableOnlineLogo": "tableOnlineLogo__1Zv0g",
	"navigationIcons": "navigationIcons__1ZOyw",
	"hideOnMobile": "hideOnMobile__cQmrZ"
};

/***/ }),

/***/ "Mcf2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);

var nativeElements = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span', 'blockquote', 'small', 'strong'];
var Text = function Text(props) {
  var Tag = Object.keys(props).filter(function (item) {
    return nativeElements.indexOf(item) !== -1;
  })[0] || 'span';
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Tag, props);
};
/* harmony default export */ __webpack_exports__["a"] = (Text);

/***/ }),

/***/ "NS5K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__("jYt2");

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') {
		return false;
	}
	if (typeof Symbol !== 'function') {
		return false;
	}
	if (typeof origSymbol('foo') !== 'symbol') {
		return false;
	}
	if (typeof Symbol('bar') !== 'symbol') {
		return false;
	}

	return hasSymbolSham();
};

/***/ }),

/***/ "NyUK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__("5NKs");

var getDay = callBound('Date.prototype.getDay');
/** @type {import('.')} */
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay(value);
		return true;
	} catch (e) {
		return false;
	}
};

/** @type {(value: unknown) => string} */
var toStr = callBound('Object.prototype.toString');
var dateClass = '[object Date]';
var hasToStringTag = __webpack_require__("KpHW")();

/** @type {import('.')} */
module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr(value) === dateClass;
};

/***/ }),

/***/ "OGHo":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("/OGg");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false,"singleton":true,"attrs":{"data-tableonline-build":"10.24.1"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "P91y":
/***/ (function(module, exports, __webpack_require__) {

var log = __webpack_require__("CTmE")('i18nline:utils');

var htmlEntities = {
  "'": "&#39;",
  "&": "&amp;",
  '"': "&quot;",
  ">": "&gt;",
  "<": "&lt;"
};

function HtmlSafeString(string) {
  this.string = typeof string === 'string' ? string : "" + string;
}
HtmlSafeString.prototype.toString = function () {
  return this.string;
};

var Utils = {
  HtmlSafeString: HtmlSafeString,

  difference: function difference(a1, a2) {
    var result = [];
    for (var i = 0, len = a1.length; i < len; i++) {
      if (a2.indexOf(a1[i]) === -1) result.push(a1[i]);
    }
    return result;
  },

  keys: function keys(object) {
    var keys = [];
    for (var key in object) {
      if (object.hasOwnProperty(key)) keys.push(key);
    }
    return keys;
  },

  htmlEscape: function htmlEscape(string) {
    if (typeof string === 'undefined' || string === null) return '';
    if (string instanceof Utils.HtmlSafeString) return string.toString();
    return String(string).replace(/[&<>"']/g, function (m) {
      return htmlEntities[m];
    });
  },

  regexpEscape: function regexpEscape(string) {
    if (typeof string === 'undefined' || string === null) return '';
    return String(string).replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
  },

  extend: function extend() {
    var args = [].slice.call(arguments);
    var target = args.shift();
    for (var i = 0, len = args.length; i < len; i++) {
      var source = args[i];
      for (var key in source) {
        if (source.hasOwnProperty(key)) target[key] = source[key];
      }
    }
    return target;
  }
};

module.exports = Utils;

log.debug('Initialized ' + log.name);

/***/ }),

/***/ "PUD9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmailForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ForgotPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ResetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PersonalDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EnterPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AuthModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("fF25");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dlv__ = __webpack_require__("CYb7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_dlv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pubsub__ = __webpack_require__("0/XQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modal__ = __webpack_require__("Dpjs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_input__ = __webpack_require__("q40z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_button__ = __webpack_require__("rAoZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_checkbox__ = __webpack_require__("4YSV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__routes_book_CountryCodeSelector__ = __webpack_require__("fnmv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_translate__ = __webpack_require__("Mcf2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_i18nline__ = __webpack_require__("iY+1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_i18nline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_i18nline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers__ = __webpack_require__("UiAd");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var EmailForm = function EmailForm(_ref) {
  var error = _ref.error,
      auth = _ref.auth,
      noTitles = _ref.noTitles,
      loading = _ref.loading,
      _onChange = _ref.onChange,
      onSubmit = _ref.onSubmit,
      onCreate = _ref.onCreate,
      onForgot = _ref.onForgot;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.detailForm },
    noTitles ? null : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_9__components_translate__["a" /* default */],
      { p: true, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.formIntro },
      __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t("You're just few steps away from using the most convenient restaurant booking service there is. Just enter your email to get started.")
    ),
    error ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.error },
      error
    ) : null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'form',
      { onSubmit: onSubmit, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.singleForm },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__components_input__["c" /* default */], {
        size: 'full',
        placeholder: __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Email address'),
        type: 'email',
        name: 'email',
        id: 'email',
        pattern: "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-.]{2,})$",
        value: auth.email,
        onInput: function onInput(e) {
          return _onChange({ email: e.target.value });
        },
        onChange: function onChange(e) {
          return _onChange({ email: e.target.value });
        },
        onBlur: function onBlur(e) {
          return _onChange({ email: Object(__WEBPACK_IMPORTED_MODULE_11__helpers__["f" /* fixEmail */])(e.target.value).trim() });
        }
      }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
        style: 'height:1px;width:1px;overflow:hidden;opacity:0;border:0;',
        placeholder: __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Password'),
        minlength: '8',
        maxlength: '50',
        type: 'password',
        name: 'password',
        id: 'password',
        autocomplete: 'current-password',
        value: auth.password,
        onInput: function onInput(e) {
          return _onChange({ password: e.target.value });
        },
        onChange: function onChange(e) {
          return _onChange({ password: e.target.value });
        }
      }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_6__components_button__["c" /* default */],
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.darkButton + ' defaultButton', loading: loading },
        __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t("Next")
      )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.secondaryActions },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'p',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          __WEBPACK_IMPORTED_MODULE_6__components_button__["c" /* default */],
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.forgotPassword, onClick: onForgot },
          __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Forgot your password?')
        )
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'p',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          __WEBPACK_IMPORTED_MODULE_6__components_button__["c" /* default */],
          { 'class': 'defaultLink', onClick: onCreate },
          __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Create account')
        )
      )
    )
  );
};

var ForgotPassword = function (_Component) {
  _inherits(ForgotPassword, _Component);

  function ForgotPassword() {
    _classCallCheck(this, ForgotPassword);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ForgotPassword.prototype.render = function render(_ref2) {
    var error = _ref2.error,
        auth = _ref2.auth,
        loading = _ref2.loading,
        noTitles = _ref2.noTitles,
        onChange = _ref2.onChange,
        onSubmit = _ref2.onSubmit,
        onBack = _ref2.onBack;

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.detailForm },
      noTitles ? null : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_9__components_translate__["a" /* default */],
        { p: true, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.formIntro },
        __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t("If you have an account with us, enter your email below and check your inbox.")
      ),
      error ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.error },
        error
      ) : null,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'form',
        { onSubmit: onSubmit },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.emailField },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__components_input__["c" /* default */], {
            size: 'full',
            placeholder: __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Email address'),
            type: 'email',
            autocomplete: 'email',
            pattern: "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-.]{2,})$",
            value: auth.email,
            onInput: function onInput(e) {
              return onChange(_extends({}, auth, { email: e.target.value }));
            },
            onBlur: function onBlur(e) {
              return onChange(_extends({}, auth, { email: Object(__WEBPACK_IMPORTED_MODULE_11__helpers__["f" /* fixEmail */])(e.target.value).trim() }));
            }
          })
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.rightSideButton },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            __WEBPACK_IMPORTED_MODULE_6__components_button__["c" /* default */],
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.darkButton + ' defaultButton', loading: loading },
            __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t("Next")
          )
        )
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.secondaryActions },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'p',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            __WEBPACK_IMPORTED_MODULE_6__components_button__["c" /* default */],
            { 'class': 'defaultLink', onClick: onBack },
            __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Go back')
          )
        )
      )
    );
  };

  return ForgotPassword;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var ResetPassword = function ResetPassword(_ref3) {
  var error = _ref3.error,
      auth = _ref3.auth,
      loading = _ref3.loading,
      noTitles = _ref3.noTitles,
      onChange = _ref3.onChange,
      onSubmit = _ref3.onSubmit,
      onBack = _ref3.onBack,
      onForgot = _ref3.onForgot;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.detailForm },
    noTitles ? null : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_9__components_translate__["a" /* default */],
      { p: true, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.formIntro },
      __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t("Enter a new password and confirmation code below and you're on your way to logging in!")
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'form',
      { onSubmit: onSubmit },
      error ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.error },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'p',
          { 'class': 'hug' },
          error
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.secondaryActions },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'p',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              __WEBPACK_IMPORTED_MODULE_6__components_button__["c" /* default */],
              {
                'class': 'defaultButton',
                style: 'opacity:1',
                type: 'button',
                onClick: function onClick(e) {
                  e.preventDefault();
                  e.stopImmediatePropagation();
                  onForgot();
                }
              },
              __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Order a new verification code')
            )
          )
        )
      ) : null,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.emailField },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__components_input__["c" /* default */], {
          size: 'full',
          placeholder: __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Email address'),
          type: 'email',
          autocomplete: 'email',
          pattern: "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-.]{2,})$",
          value: auth.email,
          onInput: function onInput(e) {
            return onChange(_extends({}, auth, { email: e.target.value }));
          },
          onBlur: function onBlur(e) {
            return onChange(_extends({}, auth, { email: Object(__WEBPACK_IMPORTED_MODULE_11__helpers__["f" /* fixEmail */])(e.target.value).trim() }));
          }
        })
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.emailField },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__components_input__["c" /* default */], {
          size: 'full',
          placeholder: __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Confirmation code'),
          type: 'text',
          value: auth.resetkey,
          onInput: function onInput(e) {
            return onChange(_extends({}, auth, { resetkey: e.target.value }));
          }
        })
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.sideBySide },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.leftInput },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__components_input__["c" /* default */], {
            size: 'full',
            placeholder: __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Password'),
            minlength: '8',
            maxlength: '50',
            type: 'password',
            autocomplete: 'new-password',
            value: auth.password,
            onInput: function onInput(e) {
              return onChange(_extends({}, auth, { password: e.target.value }));
            }
          })
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.rightInput },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__components_input__["c" /* default */], {
            size: 'full',
            placeholder: __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Password again'),
            minlength: '8',
            maxlength: '50',
            type: 'password',
            autocomplete: 'new-password',
            value: auth.repassword,
            onInput: function onInput(e) {
              return onChange(_extends({}, auth, { repassword: e.target.value }));
            }
          })
        )
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.rightSideButton },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          __WEBPACK_IMPORTED_MODULE_6__components_button__["c" /* default */],
          {
            'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.darkButton + ' defaultButton',
            disabled: !(auth.email && auth.resetkey && auth.repassword && auth.repassword === auth.password),
            loading: loading },
          __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t("Save")
        )
      )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.secondaryActions },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'p',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          __WEBPACK_IMPORTED_MODULE_6__components_button__["c" /* default */],
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.forgotPassword, onClick: onBack },
          __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t("Go back")
        )
      )
    )
  );
};

var PersonalDetails = function PersonalDetails(_ref4, _ref5) {
  var error = _ref4.error,
      auth = _ref4.auth,
      loading = _ref4.loading,
      noTitles = _ref4.noTitles,
      _onChange2 = _ref4.onChange,
      onSubmit = _ref4.onSubmit,
      acceptedTerms = _ref4.acceptedTerms,
      onAccept = _ref4.onAccept,
      onEmail = _ref4.onEmail;
  var lang = _ref5.lang;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.detailForm },
    noTitles ? null : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_9__components_translate__["a" /* default */],
      { p: true, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.formIntro },
      __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t("Cool to have you with us! We need a few additional details before we can officially get started.")
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'form',
      { onSubmit: onSubmit },
      error ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.error },
        error
      ) : null,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.emailField },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__components_input__["c" /* default */], {
          size: 'full',
          placeholder: __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Email address'),
          type: 'email',
          autocomplete: 'email',
          pattern: "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-.]{2,})$",
          value: auth.email,
          onInput: function onInput(e) {
            return _onChange2(_extends({}, auth, { email: e.target.value }));
          },
          onBlur: function onBlur(e) {
            return _onChange2(_extends({}, auth, { email: Object(__WEBPACK_IMPORTED_MODULE_11__helpers__["f" /* fixEmail */])(e.target.value.trim()) }));
          }
        })
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.sideBySide },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.leftInput },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__components_input__["c" /* default */], {
            size: 'full',
            placeholder: __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('First name'),
            autocomplete: 'given-name',
            value: auth.firstname,
            onInput: function onInput(e) {
              return _onChange2(_extends({}, auth, { firstname: e.target.value }));
            }
          })
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.rightInput },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__components_input__["c" /* default */], {
            size: 'full',
            placeholder: __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Last name'),
            autocomplete: 'family-name',
            value: auth.lastname,
            onInput: function onInput(e) {
              return _onChange2(_extends({}, auth, { lastname: e.target.value }));
            }
          })
        )
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.sideBySide },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.leftShortInput },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__routes_book_CountryCodeSelector__["a" /* CountryCodeSelector */], {
            contact_info: auth,
            onChange: function onChange(country_code) {
              return _onChange2(_extends({}, auth, country_code));
            }
          })
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.rightLongInput },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__components_input__["c" /* default */], {
            required: true,
            size: 'small',
            type: 'tel',
            autocomplete: 'tel-national',
            error: __WEBPACK_IMPORTED_MODULE_2_dlv___default()(error, 'auth.mobile_phone'),
            title: __WEBPACK_IMPORTED_MODULE_2_dlv___default()(error, 'auth.mobile_phone'),
            placeholder: __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Mobile phone'),
            value: auth.mobile_phone,
            onInput: function onInput(e) {
              return _onChange2(_extends({}, auth, { mobile_phone: e.target.value.trim() }));
            }
          })
        )
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.acceptTerms },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          __WEBPACK_IMPORTED_MODULE_7__components_checkbox__["a" /* default */],
          { checked: acceptedTerms, onChange: onAccept },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'a',
            { href: '/' + lang + '/terms', target: '_blank' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              __WEBPACK_IMPORTED_MODULE_9__components_translate__["a" /* default */],
              { p: true, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.termsText + ' hug' },
              __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t("I agree to the TableOnline terms and conditions")
            )
          )
        )
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.rightSideButton },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          __WEBPACK_IMPORTED_MODULE_6__components_button__["c" /* default */],
          {
            'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.darkButton + ' defaultButton',
            disabled: !acceptedTerms,
            loading: loading
          },
          __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Create an account')
        )
      )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.secondaryActions },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'p',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          __WEBPACK_IMPORTED_MODULE_6__components_button__["c" /* default */],
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.forgotPassword, onClick: onEmail },
          __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t("Go back")
        )
      )
    )
  );
};

var EnterPassword = function EnterPassword(_ref6) {
  var error = _ref6.error,
      auth = _ref6.auth,
      loading = _ref6.loading,
      noTitles = _ref6.noTitles,
      onChange = _ref6.onChange,
      onSubmit = _ref6.onSubmit,
      onEmail = _ref6.onEmail,
      onForgot = _ref6.onForgot;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.detailForm },
    noTitles ? null : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_9__components_translate__["a" /* default */],
      { p: true, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.formIntro },
      __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t("One more step to get you on your way, promise!")
    ),
    error ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.error },
      error
    ) : null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'form',
      { onSubmit: onSubmit, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.singleForm },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
        'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.hidden,
        autocomplete: 'email',
        type: 'email',
        name: 'email',
        pattern: "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-.]{2,})$",
        value: auth.email,
        hidden: true
      }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__components_input__["c" /* default */], {
        size: 'full',
        placeholder: __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Password'),
        minlength: '8',
        maxlength: '50',
        type: 'password',
        name: 'password',
        value: auth.password,
        autocomplete: 'current-password',
        onInput: function onInput(e) {
          return onChange(_extends({}, auth, { password: e.target.value }));
        }
      }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_6__components_button__["c" /* default */],
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.darkButton + ' defaultButton', loading: loading },
        __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t("Login")
      )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.secondaryActions },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'p',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          __WEBPACK_IMPORTED_MODULE_6__components_button__["c" /* default */],
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.forgotPassword, onClick: onForgot },
          __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Forgot your password?')
        )
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'p',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          __WEBPACK_IMPORTED_MODULE_6__components_button__["c" /* default */],
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.forgotPassword, onClick: onEmail },
          __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t("Go back")
        )
      )
    )
  );
};

var LoggedIn = function LoggedIn(_ref7, context) {
  var auth = _ref7.auth,
      loading = _ref7.loading;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.loggedInView },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'table',
      { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.detailsTable },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'tbody',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'tr',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'td',
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.tableColumn },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              __WEBPACK_IMPORTED_MODULE_9__components_translate__["a" /* default */],
              { p: true, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.mutedTitle + ' hug' },
              __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t("Full name")
            )
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'td',
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.tableColumn },
            auth.firstname,
            ' ',
            auth.lastname
          )
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'tr',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'td',
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.tableColumn },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              __WEBPACK_IMPORTED_MODULE_9__components_translate__["a" /* default */],
              { p: true, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.mutedTitle + ' hug' },
              __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t("Phone number")
            )
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'td',
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.tableColumn },
            auth.mobile_phone
          )
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'tr',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'td',
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.tableColumn },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              __WEBPACK_IMPORTED_MODULE_9__components_translate__["a" /* default */],
              { p: true, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.mutedTitle + ' hug' },
              __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t("Email")
            )
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'td',
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.tableColumn },
            auth.email
          )
        )
      )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.logoutWrapper },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_6__components_button__["c" /* default */],
        { 'class': 'defaultButton', onClick: context.auth.logout, loading: loading },
        __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t("Logout")
      )
    )
  );
};

var AuthModal = function (_Component2) {
  _inherits(AuthModal, _Component2);

  function AuthModal() {
    var _temp, _this2, _ret;

    _classCallCheck(this, AuthModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
      auth: { country_code: _this2.context.lang === 'ee' ? 'EE' : 'FI' },
      view: 'email',
      acceptedTerms: false
    }, _this2.titles = {
      email: __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Welcome to TableOnline'),
      create: __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Create an account'),
      password: __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Enter your password'),
      loggedIn: __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Welcome back!')
    }, _this2.next = function (e) {
      if (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
      _this2.setState({ error: null, loading: true });

      if (_this2.state.view === 'email' || !_this2.state.auth.password) {
        _this2.setState({ loading: false, view: 'password' });
      } else if (_this2.state.view === 'create') {
        if (_this2.state.auth.password !== _this2.state.auth.repassword) {
          _this2.setState({
            error: __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Passwords do not match'),
            loading: false
          });
          return;
        } else if (_this2.state.auth.password && _this2.state.auth.password.length < 8) {
          _this2.setState({
            error: __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Password should be at least 8 characters long'),
            loading: false
          });
          return;
        } else if (_this2.state.auth.mobile_phone && _this2.state.auth.mobile_phone.indexOf('+') !== -1) {
          _this2.setState({
            error: __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t('Phone number should not contain country code'),
            loading: false
          });
          return;
        }
        _this2.context.auth.createAccount(_this2.state.auth).then(function (res) {
          if (res && res.user) {
            _this2.context.auth.login(_this2.state.auth).catch(function (error) {
              return _this2.setState({ error: error.toString(), loading: false });
            });
          }
        }).catch(function (error) {
          _this2.setState({ error: error.toString(), loading: false });
        });
      } else if (_this2.state.view === 'password') {
        _this2.context.auth.login(_this2.state.auth).catch(function (error) {
          return _this2.setState({ error: error.toString(), loading: false });
        });
      }
      //this.setState({ view: 'create' })
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  AuthModal.prototype.componentDidMount = function componentDidMount() {
    if (this.props.view) this.state.view = this.props.view;
  };

  AuthModal.prototype.render = function render(props, state) {
    var _this3 = this;

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_3__components_pubsub__["c" /* Stateful */],
      { events: ['auth'] },
      function (_ref8) {
        var auth = _ref8.auth;
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          __WEBPACK_IMPORTED_MODULE_6__components_button__["c" /* default */],
          {
            'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.authTrigger,
            style: props.style ? props.style : null,
            onClick: function onClick(e) {
              e.preventDefault();
              e.stopImmediatePropagation();
              _this3.setState({ showModal: true });
            }
          },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'span',
            null,
            props.label ? props.label : auth ? auth.firstname : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              __WEBPACK_IMPORTED_MODULE_9__components_translate__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_10_i18nline___default.a.t("Login / Sign up")
            )
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            __WEBPACK_IMPORTED_MODULE_4__components_modal__["a" /* default */],
            {
              title: _this3.titles[auth ? 'loggedIn' : state.view],
              show: state.showModal,
              close: function close() {
                return _this3.setState({ showModal: false });
              },
              'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.authModal
            },
            auth ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(LoggedIn, {
              auth: auth,
              onChange: function onChange(auth) {
                return _this3.setState({ auth: auth });
              },
              onSubmit: _this3.next
            }) : state.view === 'email' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(EmailForm, {
              error: state.error,
              loading: state.loading,
              auth: state.auth,
              onChange: function onChange(auth) {
                _this3.setState(function (state) {
                  return {
                    auth: _extends({}, state.auth, auth)
                  };
                });
              },
              onSubmit: _this3.next,
              onCreate: function onCreate() {
                return _this3.setState({ view: 'create', error: null });
              },
              onForgot: function onForgot() {
                return _this3.setState({ error: 'Enter valid email address' });
              }
            }) : state.view === 'create' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(PersonalDetails, {
              error: state.error,
              loading: state.loading,
              auth: state.auth,
              onChange: function onChange(auth) {
                return _this3.setState({ auth: auth });
              },
              onSubmit: _this3.next,
              onEmail: function onEmail() {
                return _this3.setState({ view: 'email', error: null });
              },
              acceptedTerms: state.acceptedTerms,
              onAccept: function onAccept(e) {
                _this3.setState({ acceptedTerms: e.target.checked });
              }
            }) : state.view === 'password' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(EnterPassword, {
              error: state.error,
              loading: state.loading,
              auth: state.auth,
              onChange: function onChange(auth) {
                return _this3.setState({ auth: auth });
              },
              onSubmit: _this3.next,
              onEmail: function onEmail() {
                return _this3.setState({ view: 'email', error: null });
              }
            }) : null
          )
        );
      }
    );
  };

  return AuthModal;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "QKJL":
/***/ (function(module, exports, __webpack_require__) {

var log = __webpack_require__("CTmE")('i18nline:call-helpers');

var pluralize = __webpack_require__("xCEH");
var Utils = __webpack_require__("P91y");
var I18nline = __webpack_require__("7oIN");
var getSlug = __webpack_require__("WDG1");
var crc32 = __webpack_require__("vnt6");

var CallHelpers = {
  ALLOWED_PLURALIZATION_KEYS: ["zero", "one", "few", "many", "other"],
  REQUIRED_PLURALIZATION_KEYS: ["one", "other"],
  UNSUPPORTED_EXPRESSION: [],

  normalizeKey: function normalizeKey(key) {
    return key;
  },

  normalizeDefault: function normalizeDefault(defaultValue, translateOptions) {
    defaultValue = CallHelpers.inferPluralizationHash(defaultValue, translateOptions);
    return defaultValue;
  },

  inferPluralizationHash: function inferPluralizationHash(defaultValue, translateOptions) {
    if (typeof defaultValue === 'string' && defaultValue.match(/^[\w-]+$/) && translateOptions && "count" in translateOptions) {
      return { one: "1 " + defaultValue, other: "%{count} " + pluralize(defaultValue) };
    } else {
      return defaultValue;
    }
  },

  isObject: function isObject(object) {
    return typeof object === 'object' && object !== this.UNSUPPORTED_EXPRESSION;
  },

  validDefault: function validDefault(allowBlank) {
    var defaultValue = this.defaultValue;
    return allowBlank && (typeof defaultValue === 'undefined' || defaultValue === null) || typeof defaultValue === 'string' || this.isObject(defaultValue);
  },

  inferKey: function inferKey(defaultValue, translateOptions) {
    if (this.validDefault(defaultValue)) {
      defaultValue = this.normalizeDefault(defaultValue, translateOptions);
      if (typeof defaultValue === 'object') defaultValue = "" + defaultValue.other;
      return this.keyify(defaultValue);
    }
  },

  keyifyUnderscored: function keyifyUnderscored(string) {
    var key = getSlug(string, { separator: '_', lang: false }).replace(/[-_]+/g, '_');
    return key.substring(0, I18nline.config.underscoredKeyLength);
  },

  keyifyUnderscoredCrc32: function keyifyUnderscoredCrc32(string) {
    var checksum = crc32(string.length + ":" + string).toString(16);
    return this.keyifyUnderscored(string) + "_" + checksum;
  },

  keyify: function keyify(string) {
    switch (I18nline.config.inferredKeyFormat) {
      case 'underscored':
        return this.keyifyUnderscored(string);
      case 'underscored_crc32':
        return this.keyifyUnderscoredCrc32(string);
      default:
        return string;
    }
  },

  keyPattern: /^(\w+\.)+\w+$/,

  /**
   * Possible translate signatures:
   *
   * key [, options]
   * key, default_string [, options]
   * key, default_object, options
   * default_string [, options]
   * default_object, options
   **/
  isKeyProvided: function isKeyProvided(keyOrDefault, defaultOrOptions, maybeOptions) {
    if (typeof keyOrDefault === 'object') return false;
    if (typeof defaultOrOptions === 'string') return true;
    if (maybeOptions) return true;
    if (typeof keyOrDefault === 'string' && keyOrDefault.match(CallHelpers.keyPattern)) return true;
    return false;
  },

  isPluralizationHash: function isPluralizationHash(object) {
    var pKeys;
    return this.isObject(object) && (pKeys = Utils.keys(object)) && pKeys.length > 0 && Utils.difference(pKeys, this.ALLOWED_PLURALIZATION_KEYS).length === 0;
  },

  inferArguments: function inferArguments(args, meta) {
    if (args.length === 2 && typeof args[1] === 'object' && args[1].defaultValue) return args;

    var hasKey = this.isKeyProvided.apply(this, args);
    if (meta) meta.inferredKey = !hasKey;
    if (!hasKey) args.unshift(null);

    var defaultValue = null;
    var defaultOrOptions = args[1];
    if (args[2] || typeof defaultOrOptions === 'string' || this.isPluralizationHash(defaultOrOptions)) defaultValue = args.splice(1, 1)[0];
    if (args.length === 1) args.push({});
    var options = args[1];
    if (defaultValue) options.defaultValue = defaultValue;
    if (!hasKey) args[0] = this.inferKey(defaultValue, options);
    return args;
  },

  applyWrappers: function applyWrappers(string, wrappers) {
    var i;
    var len;
    var keys;
    if (typeof wrappers === 'string') wrappers = [wrappers];
    if (wrappers instanceof Array) {
      for (i = wrappers.length; i; i--) {
        string = this.applyWrapper(string, new Array(i + 1).join("*"), wrappers[i - 1]);
      }
    } else {
      keys = Utils.keys(wrappers);
      keys.sort(function (a, b) {
        return b.length - a.length;
      }); // longest first
      for (i = 0, len = keys.length; i < len; i++) {
        string = this.applyWrapper(string, keys[i], wrappers[keys[i]]);
      }
    }
    return string;
  },

  applyWrapper: function applyWrapper(string, delimiter, wrapper) {
    var escapedDelimiter = Utils.regexpEscape(delimiter);
    var pattern = new RegExp(escapedDelimiter + "(.*?)" + escapedDelimiter, "g");
    return string.replace(pattern, wrapper);
  }
};

module.exports = CallHelpers;

log.debug('Initialized ' + log.name);

/***/ }),

/***/ "Qxat":
/***/ (function(module, exports) {

exports.__esModule = true;
var TAG_NAMES = exports.TAG_NAMES = {
    HTML: "htmlAttributes",
    TITLE: "title",
    BASE: "base",
    META: "meta",
    LINK: "link",
    SCRIPT: "script",
    NOSCRIPT: "noscript",
    STYLE: "style"
};

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    NAME: "name",
    CHARSET: "charset",
    HTTPEQUIV: "http-equiv",
    REL: "rel",
    HREF: "href",
    PROPERTY: "property",
    SRC: "src",
    INNER_HTML: "innerHTML",
    CSS_TEXT: "cssText",
    ITEM_PROP: "itemprop"
};

var PREACT_TAG_MAP = exports.PREACT_TAG_MAP = {
    "charset": "charSet",
    "http-equiv": "httpEquiv",
    "itemprop": "itemProp",
    "class": "className"
};

/***/ }),

/***/ "SDfs":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("xcHB");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false,"singleton":true,"attrs":{"data-tableonline-build":"10.24.1"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "SeHH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("YTNT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_router_match__ = __webpack_require__("sw5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_router_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_preact_router_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_image__ = __webpack_require__("tJjN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_popover__ = __webpack_require__("exxx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_button__ = __webpack_require__("rAoZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_cityselector__ = __webpack_require__("qubP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_auth__ = __webpack_require__("PUD9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n__ = __webpack_require__("ktCQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pubsub__ = __webpack_require__("0/XQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers__ = __webpack_require__("UiAd");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var LanguageSelectorList = function (_Component) {
  _inherits(LanguageSelectorList, _Component);

  function LanguageSelectorList() {
    _classCallCheck(this, LanguageSelectorList);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  LanguageSelectorList.prototype.render = function render(props, state, _ref) {
    var closePopOver = _ref.closePopOver,
        lang = _ref.lang;

    var languages = [{ code: 'en', name: 'English', flag: 'gb' }, { code: 'fi', name: 'Suomi', flag: 'fi' }, { code: 'ee', name: 'Eesti', flag: 'ee' }];

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languageSelectorWrapper, onClick: closePopOver },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_9__components_pubsub__["c" /* Stateful */],
        { events: ['hasTranslationRoute'] },
        function (_ref2) {
          var _ref2$hasTranslationR = _ref2.hasTranslationRoute,
              hasTranslationRoute = _ref2$hasTranslationR === undefined ? false : _ref2$hasTranslationR;
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'ul',
            null,
            languages.map(function (language) {
              return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'li',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  __WEBPACK_IMPORTED_MODULE_5__components_button__["c" /* default */],
                  {
                    'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languageSelectorButton,
                    href: hasTranslationRoute ? window.location.pathname.split('/').map(function (item, index) {
                      return index === 1 ? language.code : item;
                    }).join('/') : '/' + language.code,
                    onClick: function onClick() {
                      return window.setTimeout(function () {
                        return window.location.reload();
                      }, 16);
                    }
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'span',
                    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languageSelectorFlag },
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__components_image__["a" /* default */], {
                      src: 'https://cdn.rawgit.com/hjnilsson/country-flags/master/svg/' + language.flag + '.svg',
                      alt: language.name,
                      'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languageSelectorFlagImage
                    })
                  ),
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'span',
                    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languageSelectorDisplayname },
                    language.name
                  )
                )
              );
            })
          );
        }
      )
    );
  };

  return LanguageSelectorList;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '12',
    height: '12',
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    'stroke-width': '2',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    style: 'margin-left: 4px'
  },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('polyline', { points: '6 9 12 15 18 9' })
);

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(LanguageSelectorList, null);

var LanguageSelector = function (_Component2) {
  _inherits(LanguageSelector, _Component2);

  function LanguageSelector() {
    var _temp, _this2, _ret;

    _classCallCheck(this, LanguageSelector);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
      showPopover: false
    }, _this2.togglePopover = function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this2.setState({ showPopover: !_this2.state.showPopover });
    }, _this2.closePopover = function () {
      _this2.setState({ showPopover: false });
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  LanguageSelector.prototype.render = function render(props, _ref3, _ref4) {
    var _this3 = this;

    var showPopover = _ref3.showPopover;
    var lang = _ref4.lang;

    var languages = [{ code: 'en', name: 'English', flag: 'gb' }, { code: 'fi', name: 'Suomi', flag: 'fi' }, { code: 'ee', name: 'Eesti', flag: 'ee' }];

    var currentLanguage = languages.find(function (l) {
      return l.code === lang;
    }) || languages[0];

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languageSelectorContainer },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'button',
        {
          'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languageToggle,
          onClick: this.togglePopover,
          ref: function ref(el) {
            return _this3.languageToggleRef = el;
          }
        },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'span',
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languageSelectorFlag },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__components_image__["a" /* default */], {
            src: 'https://cdn.rawgit.com/hjnilsson/country-flags/master/svg/' + currentLanguage.flag + '.svg',
            alt: currentLanguage.name,
            'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languageSelectorFlagImage
          })
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'span',
          null,
          currentLanguage.name
        ),
        _ref5
      ),
      showPopover && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.languagePopover },
        _ref6
      )
    );
  };

  return LanguageSelector;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var _ref9 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(LanguageSelector, null);

var _ref11 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    height: '16',
    viewBox: '0 0 24 24',
    fill: 'currentColor'
  },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z' })
);

var _ref12 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '12',
    height: '12',
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    'stroke-width': '2',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    style: 'margin-left: 4px'
  },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('polyline', { points: '6 9 12 15 18 9' })
);

var TopBar = function (_Component3) {
  _inherits(TopBar, _Component3);

  function TopBar() {
    var _temp2, _this4, _ret2;

    _classCallCheck(this, TopBar);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this4 = _possibleConstructorReturn(this, _Component3.call.apply(_Component3, [this].concat(args))), _this4), _this4.state = {
      showCitySelector: false
    }, _this4.toggleCitySelector = function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this4.setState({ showCitySelector: !_this4.state.showCitySelector });
    }, _this4.closeCitySelector = function (cityName) {
      if (cityName) {
        Object(__WEBPACK_IMPORTED_MODULE_10__helpers__["q" /* setCity */])(cityName);

        if (_this4.context.events) {
          _this4.context.events.emit('city', cityName);
        }
      }
      _this4.setState({ showCitySelector: false });
    }, _temp2), _possibleConstructorReturn(_this4, _ret2);
  }

  TopBar.prototype.render = function render(props, _ref7, _ref8) {
    var _this5 = this;

    var showCitySelector = _ref7.showCitySelector;
    var lang = _ref8.lang;

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.topBar },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.topBarContainer },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.topBarLeft },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.topBarItem },
            _ref9
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.topBarItem },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              __WEBPACK_IMPORTED_MODULE_9__components_pubsub__["c" /* Stateful */],
              { events: ['city'] },
              function (_ref10) {
                var _ref10$city = _ref10.city,
                    city = _ref10$city === undefined ? Object(__WEBPACK_IMPORTED_MODULE_10__helpers__["i" /* getCity */])() : _ref10$city;
                return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'button',
                  {
                    onClick: _this5.toggleCitySelector,
                    'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.topBarLink,
                    ref: function ref(el) {
                      return _this5.citySelectorRef = el;
                    }
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'span',
                    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.topBarIcon },
                    _ref11
                  ),
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'span',
                    null,
                    city
                  ),
                  _ref12
                );
              }
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6__components_cityselector__["b" /* default */], {
              show: showCitySelector,
              onClose: this.closeCitySelector,
              anchor: this.citySelectorRef
            })
          )
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.topBarRight },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            __WEBPACK_IMPORTED_MODULE_2_preact_router_match__["Link"],
            {
              href: lang === 'fi' ? '/fi/liity-tableonlineen' : lang === 'en' ? '/en/join' : lang === 'ee' ? '/ee/vota-meiega-uhendust' : null,
              'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.topBarLink
            },
            __WEBPACK_IMPORTED_MODULE_8__i18n__["a" /* default */].t('For restaurants')
          )
        )
      )
    );
  };

  return TopBar;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (TopBar);

/***/ }),

/***/ "SkL2":
/***/ (function(module, exports, __webpack_require__) {

var log = __webpack_require__("CTmE")('i18nline:extensions:i18n');
var EventEmitter = __webpack_require__("I23h");
var CallHelpers = __webpack_require__("QKJL");
var Utils = __webpack_require__("P91y");

var extend = function extend(I18n) {
  function changed(locale) {
    return function () {
      I18n.emit('change', locale || I18n.locale);
    };
  }

  if (!I18n.on) EventEmitter(I18n);

  /**
   * Changes the current locale, loading the translations if needed.
   * If I18n has an emit method, emits a 'change' event with the given locale.
   * Returns a Promise that resolves with the locale when the change is completed.
   *
   * @param {string} locale
   * @return {PromiseLike<object>}
   */
  I18n.changeLocale = function (locale) {
    return Promise.all(I18n.locales.get(I18n.locale = locale).map(function (locale) {
      return I18n.load(locale);
    })).then(changed());
  };

  /**
   * Loads the translations for locale, from cache (unless bypassCache == true)
   * or by calling I18n.import with the given locale. Returns a Promise.
   *
   * @param {string} locale
   * @param {boolean} bypassCache
   * @return {PromiseLike<object>}
   */
  I18n.load = function (locale, bypassCache) {
    return new Promise(function (resolve) {
      return I18n.translations[locale] && !bypassCache ? resolve(I18n.translations[locale]) : I18n.import(locale).then(function (x) {
        resolve(I18n.translations[locale] = x[locale]);
      });
    });
  };

  /**
   * Returns a function that reloads the translations for the given locale.
   * The reload function bypasses the cache, making it ideal for HMR.
   *
   * @param {string} locale
   * @return {function}
   */
  I18n.reload = function (locale) {
    return function () {
      I18n.load(locale, true).then(changed(locale));
    };
  };

  I18n.import = function (locale) {
    return Promise.reject('Implement I18n.import');
  };

  var htmlEscape = Utils.htmlEscape;

  if (!I18n.interpolateWithoutHtmlSafety) I18n.interpolateWithoutHtmlSafety = I18n.interpolate;
  I18n.interpolate = function (message, options) {
    var needsEscaping = false;
    var matches = message.match(this.PLACEHOLDER) || [];
    var len = matches.length;
    var match;
    var keys = [];
    var key;
    var i;
    var wrappers = options.wrappers || options.wrapper;

    if (wrappers) {
      needsEscaping = true;
      message = htmlEscape(message);
      message = CallHelpers.applyWrappers(message, wrappers);
    }

    for (i = 0; i < len; i++) {
      match = matches[i];
      key = match.replace(this.PLACEHOLDER, "$1");
      keys.push(key);
      if (!(key in options)) continue;
      if (match[1] === 'h') options[key] = new Utils.HtmlSafeString(options[key]);
      if (options[key] instanceof Utils.HtmlSafeString) needsEscaping = true;
    }

    if (needsEscaping) {
      if (!wrappers) message = htmlEscape(message);
      for (i = 0; i < len; i++) {
        key = keys[i];
        if (!(key in options)) continue;
        options[key] = htmlEscape(options[key]);
      }
    }
    message = this.interpolateWithoutHtmlSafety(message, options);
    return needsEscaping ? new Utils.HtmlSafeString(message) : message;
  };

  // add html-safety hint, i.e. "%h{...}"
  I18n.PLACEHOLDER = /(?:\{\{|%h?\{)(.*?)(?:\}\}?)/gm;

  I18n.CallHelpers = CallHelpers;
  I18n.Utils = Utils;

  if (!I18n.translateWithoutI18nline) I18n.translateWithoutI18nline = I18n.translate;
  I18n.translate = function () {
    var args = CallHelpers.inferArguments([].slice.call(arguments));
    var key = args[0];
    var options = args[1];
    key = CallHelpers.normalizeKey(key, options);
    var defaultValue = options.defaultValue;

    if (defaultValue) {
      options.defaultValue = CallHelpers.normalizeDefault(defaultValue, options);
    }

    return this.translateWithoutI18nline(key, options);
  };

  I18n.t = I18n.translate;
  return I18n;
};

module.exports = extend;

log.debug('Initialized ' + log.name);

/***/ }),

/***/ "THdF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./functionApply')} */

module.exports = Function.prototype.apply;

/***/ }),

/***/ "TyWm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__("4md/");

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};

/***/ }),

/***/ "UiAd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["t"] = slugify;
/* harmony export (immutable) */ __webpack_exports__["g"] = generateUUID;
/* harmony export (immutable) */ __webpack_exports__["b"] = debounce;
/* harmony export (immutable) */ __webpack_exports__["l"] = getParams;
/* harmony export (immutable) */ __webpack_exports__["j"] = getCookies;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteCookie;
/* harmony export (immutable) */ __webpack_exports__["s"] = setPreferences;
/* harmony export (immutable) */ __webpack_exports__["m"] = getPreferences;
/* harmony export (immutable) */ __webpack_exports__["q"] = setCity;
/* harmony export (immutable) */ __webpack_exports__["i"] = getCity;
/* harmony export (immutable) */ __webpack_exports__["p"] = setAffiliate;
/* harmony export (immutable) */ __webpack_exports__["h"] = getAffiliate;
/* harmony export (immutable) */ __webpack_exports__["r"] = setInternalTrackingTag;
/* harmony export (immutable) */ __webpack_exports__["k"] = getInternalTrackingTag;
/* harmony export (immutable) */ __webpack_exports__["f"] = fixEmail;
/* harmony export (immutable) */ __webpack_exports__["v"] = validEmail;
/* harmony export (immutable) */ __webpack_exports__["e"] = findClosestDay;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildRestaurantUrl;
/* harmony export (immutable) */ __webpack_exports__["o"] = parseImageUrl;
/* unused harmony export untilResponds */
/* unused harmony export publishedDateFromObjectId */
/* harmony export (immutable) */ __webpack_exports__["d"] = distanceFromDate;
/* unused harmony export parseDateToReadable */
/* harmony export (immutable) */ __webpack_exports__["n"] = parseCommercialDateRange;
/* harmony export (immutable) */ __webpack_exports__["u"] = sortCommercialsByDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globals__ = __webpack_require__("zQXs");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function slugify(text) {
  if (!text) return '';
  var a = 'àáäâèéëêìíïîòóöôõȭȱȯōøūùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;';
  var b = 'aaaaeeeeiiiioooooooooouuuuuncsyoarsnpwgnmuxzh------';
  var p = new RegExp(a.split('').join('|'), 'g');

  return text.toString().toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
  .replace(p, function (c) {
    return b.charAt(a.indexOf(c));
  }) // Replace special chars
  .replace(/&/g, '-and-') // Replace & with 'and'
  .replace(/[^\w-]+/g, '') // Remove all non-word chars
  .replace(/--+/g, '-') // Replace multiple - with single -
  .replace(/^-+/, '') // Trim - from start of text
  .replace(/-+$/, ''); // Trim - from end of text
}

function generateUUID() {
  // Public Domain/MIT
  var d = new Date().getTime();
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); //use high-precision timer if available
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function getParams() {
  return window.location.search.substring(1) ? window.location.search.substring(1).split('&').reduce(function (params, str) {
    params[decodeURIComponent(str.split('=')[0])] = decodeURIComponent(str.split('=')[1]);
    return params;
  }, {}) : {};
}

function getCookies() {
  return document.cookie.split(';').reduce(function (cookies, str) {
    cookies[str.split('=')[0].trim()] = str.split('=')[1];
    return cookies;
  }, {});
}
function deleteCookie(key, path, domain) {
  document.cookie = encodeURIComponent(key) + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' + (domain ? '; domain=' + domain : '') + (path ? '; path=' + path : '');
  if (getCookies()[key] && !path) {
    deleteCookie(key, '/');
  }
  if (getCookies()[key] && !path) {
    var possiblePaths = window.location.pathname.split('/').map(function (item, index, array) {
      return array.slice(0, index).join('/');
    }).filter(function (item) {
      return item;
    });
    possiblePaths.forEach(function (path) {
      return deleteCookie(key, path);
    });
  }

  return getCookies()[key];
}
var defaultPreferences = {
  date: new Date().toJSON().substring(0, 10),
  time: '19:00',
  persons: 2,
  period: 'dinner'
};

function setPreferences(_ref) {
  var date = _ref.date,
      time = _ref.time,
      persons = _ref.persons,
      period = _ref.period;

  if (date) localStorage.setItem('TableOnline--date', date);
  if (time) localStorage.setItem('TableOnline--time', time);
  if (persons) localStorage.setItem('TableOnline--persons', persons);
  if (period) localStorage.setItem('TableOnline--period', period);
  return getPreferences();
}

function getPreferences() {
  var queryPreferences = getParams();

  var date = queryPreferences.date || localStorage.getItem('TableOnline--date');
  var time = queryPreferences.time || localStorage.getItem('TableOnline--time');
  var persons = queryPreferences.persons || localStorage.getItem('TableOnline--persons');
  var period = queryPreferences.period || localStorage.getItem('TableOnline--period');

  var preferences = _extends({}, defaultPreferences);
  if (date && new Date(date).valueOf() >= new Date(defaultPreferences.date).valueOf()) preferences.date = date;
  if (time) preferences.time = time;
  if (persons) preferences.persons = parseInt(persons);
  if (period) preferences.period = period;

  return preferences;
}

var languages = [navigator.language].concat(navigator.languages);

var defaultCity = languages.includes('et') || languages.includes('et-EE') || window.location.pathname.split('/')[1] === 'ee' ? 'Tallinn' : 'Helsinki';

function setCity(city) {
  var capitalizedCity = city ? city[0].toUpperCase() + city.substring(1) : null;
  if (capitalizedCity) localStorage.setItem('TableOnline--city', capitalizedCity);
  return getCity();
}
function getCity() {
  var city = localStorage && localStorage.getItem('TableOnline--city') ? localStorage.getItem('TableOnline--city') : defaultCity;
  var capitalizedCity = city[0].toUpperCase() + city.substring(1);
  return capitalizedCity;
}
function setAffiliate(key, value) {
  var date = new Date();
  try {
    if (key === 'norwegian') {
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
      if (window.name === 'norwegianfetch') {
        window.close();
      }
    } else if (key === 'finnair') {
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
    } else if (key === 'tlink') {
      date.setTime(date.getTime() + 12 * 60 * 60 * 1000);
    }
    // Set cookie
    document.cookie = 'TableOnline--affiliate=' + key + ':' + value + '; expires=' + date.toUTCString() + '; path=/';
  } catch (err) {}

  return getAffiliate();
}
function getAffiliate() {
  var affiliate = getCookies()['TableOnline--affiliate'];
  if (affiliate) {
    var _ref2;

    return _ref2 = {}, _ref2[affiliate.split(':')[0]] = affiliate.split(':')[1], _ref2;
  }
  return;
}
function setInternalTrackingTag(key, value) {
  var valueToString = Array.isArray(value) ? value.join(',') : value;
  var date = new Date();
  if (!valueToString) return getInternalTrackingTag();
  try {
    if (key === 'tags') {
      date.setTime(date.getTime() + 12 * 60 * 60 * 1000);
    }
    var _valueToString = Array.isArray(value) ? value.join(',') : value;
    // Set cookie
    document.cookie = 'TableOnline--tags=' + encodeURIComponent(_valueToString) + '; expires=' + date.toUTCString() + '; path=/';
  } catch (err) {}

  return getInternalTrackingTag();
}
function getInternalTrackingTag() {
  var internalTags = getCookies()['TableOnline--tags'];
  if (internalTags) {
    return decodeURIComponent(internalTags).split(',');
  }
  return [];
}
function fixEmail(e) {
  var email = e.target ? e.target.value : e;

  var emailEndingFixDictionary = {
    '@gmail.co': '@gmail.com',
    '@gmail.fi': '@gmail.com',
    '@hotmail.co': '@hotmail.com',
    '.f': '.fi',
    '.fo': '.fi',
    '.cmo': '.com',
    '.ccom': '.com',
    '.comm': '.com',
    '.coom': '.com',
    '.col': '.com',
    '.con': '.com',
    '.gom': '.com',
    '.vom': '.com',
    '.xom': '.com'
  },
      emailInternalFixDictionary = {
    '@gmai.': '@gmail.',
    '@gmil.': '@gmail.',
    '@gamil.': '@gmail.',
    '@gnail.': '@gmail.',
    '@hotmai.': '@hotmail.'
  };

  Object.keys(emailEndingFixDictionary).forEach(function (mistake) {
    var fix = emailEndingFixDictionary[mistake];
    if (email.lastIndexOf(mistake) === email.length - mistake.length) {
      email = email.replace(mistake, fix);
    }
  });
  Object.keys(emailInternalFixDictionary).forEach(function (mistake) {
    var fix = emailInternalFixDictionary[mistake];
    if (email.indexOf(mistake)) {
      email = email.replace(mistake, fix);
    }
  });

  return email;
}

function validEmail(email) {
  if (!email || typeof email !== 'string') return false;
  // Created because the clients sometimes forget TLD's and supporting
  // e.g. 'localhost' email domain is not necessary
  var supportedEmailExpression = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]{2,})$/g;
  return supportedEmailExpression.test(email);
}

function findClosestDay(recurrencies, startDay) {
  if (!startDay || new Date(startDay.substring(0, 10)).valueOf() < new Date(new Date().toJSON().substring(0, 10)).valueOf()) {
    startDay = new Date();
  } else {
    startDay = new Date(startDay);
  }

  var todayWeekday = startDay.getDay(),
      distanceComparison = 7 - todayWeekday;

  var distanceToOfferWeekDay = recurrencies.reduce(function (closest, current) {
    return closest === 0 || !current.week_day ? closest : closest ? Math.min(distanceComparison - (7 - current.week_day) % 7, distanceComparison - (7 - closest) % 7) : distanceComparison - (7 - current.week_day) % 7;
  }, null);

  var closestDay = startDay;

  if (distanceToOfferWeekDay) {
    closestDay.setDate(closestDay.getDate() + distanceToOfferWeekDay + 1);
  }
  return closestDay.toJSON().substring(0, 10);
}
function buildRestaurantUrl(restaurant, lang) {
  if (!restaurant || !lang) {
    return '';
  }
  return '/' + lang + '/' + slugify(restaurant.city) + '/' + restaurant.slug + '/' + restaurant.restaurantId;
}
function parseImageUrl(url) {
  if (!url) {
    return '';
  }

  url = url.replace('https://tox.imgix.net/', '');
  url = url.replace('https://images.weserv.nl/?url=https://tableonline.static.cm/', '');

  //console.log(url);
  var imageBase = __WEBPACK_IMPORTED_MODULE_0__globals__["f" /* PRODUCTION */] ? 'https://img.tableonline.fi' : 'https://preprod-img.tableonline.fi';
  return url.indexOf('http') === 0 ? url : imageBase + '/' + url;
}
function untilResponds(url) {
  return new Promise(function (resolve) {
    var poll = setInterval(function () {
      return new Promise(function ($return, $error) {
        var test;
        var $Try_3_Post = function () {
          try {
            return $return();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        };var $Try_3_Catch = function (err) {
          try {
            return $Try_3_Post();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        };
        try {
          return Promise.resolve(fetch(url + '?noCachePoll=' + new Date().valueOf())).then(function ($await_4) {
            try {
              test = $await_4;
              if (test.ok) {
                clearInterval(poll);
                resolve(true);
              }
              return $Try_3_Post();
            } catch ($boundEx) {
              return $Try_3_Catch($boundEx);
            }
          }, $Try_3_Catch);
        } catch (err) {
          $Try_3_Catch(err)
        }
      });
    }, 2000);
  });
}
function publishedDateFromObjectId(objectId) {
  return new Date(parseInt(objectId.substring(0, 8), 16) * 1000).toISOString();
}
function distanceFromDate(date) {
  var compare = typeof date === 'string' ? new Date(date) : date;
  var isValid = typeof compare.getTime === 'function' && compare.getTime() === compare.getTime();

  if (isValid) {
    var today = new Date();
    var distance = today - compare;
    var days = ~~(distance / 86400000);
    var months = ~~(days / 30);
    var years = ~~(months / 12);

    return {
      days: days,
      months: months,
      years: years
    };
  }
  return null;
}
function parseDateToReadable(date) {
  if (date === null) return '';
  var dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.toJSON().substring(0, 10).split('-').reverse().map(function (item) {
    return parseInt(item);
  }).join('.');
}

function parseCommercialDateRange(start_date, end_date) {
  if (!start_date && !end_date) return null;

  var startDate = parseDateToReadable(start_date);
  var endDate = parseDateToReadable(end_date);
  var now = parseDateToReadable(new Date());

  if (startDate === endDate) {
    return startDate;
  } else if (endDate === null) {
    return now + ' - ' + endDate;
  } else {
    return startDate + ' - ' + endDate;
  }
}

function sortCommercialsByDate() {
  var commercials = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return [].concat(commercials).sort(function (a, b) {
    var aPermanent = a.permanent || !a.end_date;
    var bPermanent = b.permanent || !b.end_date;
    if (aPermanent && bPermanent) return 0;
    if (aPermanent) return 1;
    if (bPermanent) return -1;

    var endDiff = new Date(a.end_date).valueOf() - new Date(b.end_date).valueOf();
    if (endDiff !== 0) return endDiff;

    var startA = a.start_date ? new Date(a.start_date).valueOf() : Infinity;
    var startB = b.start_date ? new Date(b.start_date).valueOf() : Infinity;
    return startA - startB;
  });
}

/***/ }),

/***/ "VCQ6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var functionsHaveNames = function functionsHaveNames() {
	return typeof function f() {}.name === 'string';
};

var gOPD = Object.getOwnPropertyDescriptor;
if (gOPD) {
	try {
		gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		gOPD = null;
	}
}

functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
	if (!functionsHaveNames() || !gOPD) {
		return false;
	}
	var desc = gOPD(function () {}, 'name');
	return !!desc && !!desc.configurable;
};

var $bind = Function.prototype.bind;

functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
	return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
};

module.exports = functionsHaveNames;

/***/ }),

/***/ "VGEP":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, ".footer__14P9B{background:#001414;background:-webkit-gradient(linear,left top,left bottom,from(#001414),to(#073535));background:linear-gradient(180deg,#001414,#073535);color:#fff;margin-top:2rem}.logoIntro__2VCUQ{text-align:center;margin:4rem auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.footerLogo__1TxVE{height:1.5rem}.footerIntroText__2G2cs{display:block;max-width:32rem;margin:2rem auto;font-size:16px}.footer__14P9B hr{opacity:.1}.footerLinks__3QB54{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:100%}.footerLinkContainer__m0XG6{padding:.5rem;width:12rem;max-width:100%}.footerLinkTitle__3Dw-m{font-size:16px}.footerLinkList__1LgEV,.footerSocialMediaList__2Zokc{list-style:none;padding:0;margin:1rem 0;font-size:16px}.footerSocialMediaList__2Zokc{display:-webkit-box;display:-ms-flexbox;display:flex}.footerSocialMediaItem__3Sl48{margin-right:1rem}.footerSocialMediaItem__3Sl48 svg{width:1rem}.languageSelectorContainer__2db9R{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.languageToggle__2vjRK{justify-self:center}.languageSelectorFlag__2ip3P{display:-webkit-box;display:-ms-flexbox;display:flex;width:1.5rem;margin-right:1rem;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.languageSelectorFlagImage__3D1gi{height:.75rem}.languageSelectorDisplayname__25dZM{font-weight:500;color:#141d1e}.languageSelectorWrapper__oGcRx{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;background:#fff}.languageSelectorWrapper__oGcRx ul{padding:0;margin:0;list-style:none;width:100%;display:block}.languageSelectorWrapper__oGcRx li{border-bottom:1px solid rgba(0,0,0,.08);width:100%;border-radius:none;display:block}.languageSelectorWrapper__oGcRx li>*{display:block}.copyright__1Frfi{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}", ""]);

// exports
exports.locals = {
	"footer": "footer__14P9B",
	"logoIntro": "logoIntro__2VCUQ",
	"footerLogo": "footerLogo__1TxVE",
	"footerIntroText": "footerIntroText__2G2cs",
	"footerLinks": "footerLinks__3QB54",
	"footerLinkContainer": "footerLinkContainer__m0XG6",
	"footerLinkTitle": "footerLinkTitle__3Dw-m",
	"footerLinkList": "footerLinkList__1LgEV",
	"footerSocialMediaList": "footerSocialMediaList__2Zokc",
	"footerSocialMediaItem": "footerSocialMediaItem__3Sl48",
	"languageSelectorContainer": "languageSelectorContainer__2db9R",
	"languageToggle": "languageToggle__2vjRK",
	"languageSelectorFlag": "languageSelectorFlag__2ip3P",
	"languageSelectorFlagImage": "languageSelectorFlagImage__3D1gi",
	"languageSelectorDisplayname": "languageSelectorDisplayname__25dZM",
	"languageSelectorWrapper": "languageSelectorWrapper__oGcRx",
	"copyright": "copyright__1Frfi"
};

/***/ }),

/***/ "VjJS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var root = typeof self === 'object' && self.self === self && self || typeof global === 'object' && global.global === global && global || this;

/* harmony default export */ __webpack_exports__["a"] = (root);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("h6ac")))

/***/ }),

/***/ "VxKF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__("ywQn");
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty = __webpack_require__("jPvt");

var isFunction = function isFunction(fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var supportsDescriptors = __webpack_require__("wm0e")();

var defineProperty = function defineProperty(object, name, value, predicate) {
	if (name in object) {
		if (predicate === true) {
			if (object[name] === value) {
				return;
			}
		} else if (!isFunction(predicate) || !predicate()) {
			return;
		}
	}

	if (supportsDescriptors) {
		defineDataProperty(object, name, value, true);
	} else {
		defineDataProperty(object, name, value);
	}
};

var defineProperties = function defineProperties(object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;

/***/ }),

/***/ "WDG1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("ztNz");

/***/ }),

/***/ "WyRA":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("hrFb");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false,"singleton":true,"attrs":{"data-tableonline-build":"10.24.1"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "XU8W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./gOPD')} */

module.exports = Object.getOwnPropertyDescriptor;

/***/ }),

/***/ "YTNT":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("t5DJ");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false,"singleton":true,"attrs":{"data-tableonline-build":"10.24.1"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "YWiL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__("1Hmk");

var supportsDescriptors = __webpack_require__("VxKF").supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;

module.exports = function getPolyfill() {
	if (supportsDescriptors && /a/mig.flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (descriptor && typeof descriptor.get === 'function' && 'dotAll' in RegExp.prototype && 'hasIndices' in RegExp.prototype) {
			/* eslint getter-return: 0 */
			var calls = '';
			var o = {};
			Object.defineProperty(o, 'hasIndices', {
				get: function get() {
					calls += 'd';
				}
			});
			Object.defineProperty(o, 'sticky', {
				get: function get() {
					calls += 'y';
				}
			});

			descriptor.get.call(o);

			if (calls === 'dy') {
				return descriptor.get;
			}
		}
	}
	return implementation;
};

/***/ }),

/***/ "ZE63":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, ".mobileHeader__NBv_z{display:none}@media (max-width:768px){body{margin-top:0}.mobileHeader__NBv_z{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%;height:60px;padding:0 1rem;background-color:transparent;position:absolute;top:0;left:0;right:0;z-index:999;-webkit-transition:background-color .3s ease,-webkit-box-shadow 1s ease;transition:background-color .3s ease,-webkit-box-shadow 1s ease;transition:background-color .3s ease,box-shadow 1s ease;transition:background-color .3s ease,box-shadow 1s ease,-webkit-box-shadow 1s ease}.mobileHeader__NBv_z:hover{-webkit-box-shadow:0 3.5rem 100px 0 rgba(0,0,0,.06);box-shadow:0 3.5rem 100px 0 rgba(0,0,0,.06)}.mobileHeader__NBv_z.dark__1K3xl{color:#fff}.mobileHeader__NBv_z.light__3NZN0{color:#000f0f}.mobileHeader__NBv_z.dark__1K3xl{border-bottom:1px solid hsla(0,0%,100%,.1)}.mobileHeader__NBv_z.light__3NZN0{border-bottom:1px solid rgba(0,0,0,.1)}.mobileHeader__NBv_z.dark__1K3xl .hamburgerButton__1Vzxx span{background-color:#fff}.mobileHeader__NBv_z.light__3NZN0 .hamburgerButton__1Vzxx span{background-color:#000f0f}.hamburgerWrapper__3Opbe{-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.hamburgerButton__1Vzxx,.hamburgerWrapper__3Opbe{display:-webkit-box;display:-ms-flexbox;display:flex}.hamburgerButton__1Vzxx{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:24px;height:18px;background:transparent;border:none;padding:0;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none}.hamburgerButton__1Vzxx span{display:block;width:100%;height:2px;background-color:#fff;border-radius:2px;-webkit-transition:all .3s ease;transition:all .3s ease}.hamburgerButton__1Vzxx.open__29j6c span:first-child{-webkit-transform:translateY(8px) rotate(45deg);-ms-transform:translateY(8px) rotate(45deg);transform:translateY(8px) rotate(45deg)}.hamburgerButton__1Vzxx.open__29j6c span:nth-child(2){opacity:0}.hamburgerButton__1Vzxx.open__29j6c span:nth-child(3){-webkit-transform:translateY(-8px) rotate(-45deg);-ms-transform:translateY(-8px) rotate(-45deg);transform:translateY(-8px) rotate(-45deg)}.logoWrapper__2yJyA{-webkit-box-flex:2;-ms-flex:2;flex:2}.logo__3UBlk,.logoWrapper__2yJyA{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.logo__3UBlk{text-decoration:none;color:#fff}.tableOnlineLogo__2dmI4{height:20px;width:auto}.actionsWrapper__31UR1{-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;gap:.5rem}.actionButton__3Gi8Y,.actionsWrapper__31UR1{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.actionButton__3Gi8Y{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:transparent;border:none;padding:.5rem;cursor:pointer;-webkit-transition:opacity .2s ease;transition:opacity .2s ease}.mobileHeader__NBv_z.dark__1K3xl .actionButton__3Gi8Y{color:#fff}.mobileHeader__NBv_z.light__3NZN0 .actionButton__3Gi8Y{color:#000f0f}.actionButton__3Gi8Y:hover{opacity:.8}.divider__2JiIT{width:1px;height:20px;margin:0 .25rem}.mobileHeader__NBv_z.dark__1K3xl .divider__2JiIT{background-color:hsla(0,0%,100%,.3)}.mobileHeader__NBv_z.light__3NZN0 .divider__2JiIT{background-color:rgba(0,0,0,.3)}}", ""]);

// exports
exports.locals = {
	"mobileHeader": "mobileHeader__NBv_z",
	"dark": "dark__1K3xl",
	"light": "light__3NZN0",
	"hamburgerButton": "hamburgerButton__1Vzxx",
	"hamburgerWrapper": "hamburgerWrapper__3Opbe",
	"open": "open__29j6c",
	"logoWrapper": "logoWrapper__2yJyA",
	"logo": "logo__3UBlk",
	"tableOnlineLogo": "tableOnlineLogo__2dmI4",
	"actionsWrapper": "actionsWrapper__31UR1",
	"actionButton": "actionButton__3Gi8Y",
	"divider": "divider__2JiIT"
};

/***/ }),

/***/ "ZMjw":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("VGEP");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false,"singleton":true,"attrs":{"data-tableonline-build":"10.24.1"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "acgq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__("2V1b");
var gOPD = __webpack_require__("34Ju");

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */[].__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */'__proto__');

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function' ? callBind([desc.get]) : typeof $getPrototypeOf === 'function' ? /** @type {import('./get')} */function getDunder(value) {
	// eslint-disable-next-line eqeqeq
	return $getPrototypeOf(value == null ? value : $Object(value));
} : false;

/***/ }),

/***/ "bwdo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */

module.exports = Object;

/***/ }),

/***/ "bx7G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./Reflect.getPrototypeOf')} */

module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

/***/ }),

/***/ "dNQG":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, ".popover__OpAzz{position:absolute;width:100%;max-width:19rem;-webkit-box-shadow:0 0 1rem rgba(0,0,0,.1);box-shadow:0 0 1rem rgba(0,0,0,.1);border-radius:5px;overflow:hidden;-webkit-transform-origin:50% 50%;-ms-transform-origin:50% 50%;transform-origin:50% 50%;-webkit-animation:dialogAnimation__1AH0z .45s cubic-bezier(.78,-1.22,.17,1.89);animation:dialogAnimation__1AH0z .45s cubic-bezier(.78,-1.22,.17,1.89);-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;z-index:3}.backsplash__V3KvS{z-index:3;position:fixed;top:0;left:0;height:100%;width:100%;background:rgba(0,0,0,.1);-webkit-animation:backgroundIn__1zYx5 .35s ease;animation:backgroundIn__1zYx5 .35s ease}.hidden__2lZlT{display:none}@-webkit-keyframes dialogAnimation__1AH0z{0%{-webkit-transform:translate3d(-50%,-50%,0) scale3d(.8,.8,1);transform:translate3d(-50%,-50%,0) scale3d(.8,.8,1);opacity:0}to{-webkit-transform:translate3d(-50%,-50%,0) scaleX(1);transform:translate3d(-50%,-50%,0) scaleX(1);opacity:1}}@keyframes dialogAnimation__1AH0z{0%{-webkit-transform:translate3d(-50%,-50%,0) scale3d(.8,.8,1);transform:translate3d(-50%,-50%,0) scale3d(.8,.8,1);opacity:0}to{-webkit-transform:translate3d(-50%,-50%,0) scaleX(1);transform:translate3d(-50%,-50%,0) scaleX(1);opacity:1}}@-webkit-keyframes backgroundIn__1zYx5{0%{opacity:0}to{opacity:1}}@keyframes backgroundIn__1zYx5{0%{opacity:0}to{opacity:1}}", ""]);

// exports
exports.locals = {
	"popover": "popover__OpAzz",
	"dialogAnimation": "dialogAnimation__1AH0z",
	"backsplash": "backsplash__V3KvS",
	"backgroundIn": "backgroundIn__1zYx5",
	"hidden": "hidden__2lZlT"
};

/***/ }),

/***/ "dgPI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) {/**/}

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || typeof target !== 'object' && typeof target !== 'function') {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

						// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};

/***/ }),

/***/ "etZl":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("GBKF");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false,"singleton":true,"attrs":{"data-tableonline-build":"10.24.1"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "exxx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_portal__ = __webpack_require__("q6qL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_portal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact_portal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__("x4jQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_root__ = __webpack_require__("VjJS");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var overflowStyles = 'max-height: 90vh;overflow:scroll;';

var Popover = function (_Component) {
  _inherits(Popover, _Component);

  function Popover() {
    var _temp, _this, _ret;

    _classCallCheck(this, Popover);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      hidden: true
    }, _this._calculateFitOnAxis = function (center, elementDimension) {
      var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var stop = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1280;

      // Check if element goes over
      if (center + elementDimension * 0.5 > stop) {
        return stop - elementDimension * 0.5;
      } else if (center - elementDimension * 0.5 < start) {
        return start + elementDimension * 0.5;
      } else {
        return center;
      }
    }, _this.propagateClose = function () {
      if (typeof _this.props.onClose === 'function') {
        _this.props.onClose();
      }
    }, _this.setPosition = function (element) {
      if (!element) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3__components_root__["a" /* default */].setTimeout(function () {
        var e = _this.state.e;
        _this.element = element;

        var windowXStart = document && window ? document.scrollLeft || window.pageXOffset : 0,
            windowXEnd = document && window ? windowXStart + window.innerWidth : 1280,
            windowYStart = document && window ? document.scrollTop || window.pageYOffset : 0,
            windowYEnd = document && window ? windowYStart + window.innerHeight : 1280,
            centerX = windowXStart + e.x,
            centerY = windowYStart + e.y;

        var baseElementRects = void 0;
        if (!e.x) {
          baseElementRects = baseElementRects || _this.base.getBoundingClientRect();
          centerX = windowXStart + baseElementRects.left + baseElementRects.width / 2;
        }

        if (!e.y) {
          baseElementRects = baseElementRects || _this.base.getBoundingClientRect();
          centerY = windowYStart + baseElementRects.top + baseElementRects.height / 2;
        }

        var offsetX = element.offsetWidth,
            offsetY = element.offsetHeight;

        var realX = _this._calculateFitOnAxis(centerX, offsetX, windowXStart, windowXEnd),
            realY = _this._calculateFitOnAxis(centerY, offsetY, windowYStart, windowYEnd);

        _this.setState({
          hidden: false,
          style: (offsetY > windowYEnd - windowYStart ? overflowStyles : '') + 'top:' + realY + 'px;left:' + realX + 'px;-webkit-transform: translate3d(-50%,-50%,0);transform: translate3d(-50%,-50%,0);'
        });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Popover.prototype.getChildContext = function getChildContext() {
    var _this2 = this;

    return {
      closePopOver: function closePopOver() {
        return _this2.setState({ hidden: true }, _this2.propagateClose);
      }
    };
  };

  Popover.prototype.componentWillUnmount = function componentWillUnmount() {
    if (document && this.element && this.element.parentNode) Object(__WEBPACK_IMPORTED_MODULE_0_preact__["render"])(null, document.body, this.element);
  };

  Popover.prototype.render = function render(props, state) {
    var _this3 = this;

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      _extends({}, props, {
        onClick: function onClick(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (_this3.state.hidden === false) {
            return;
          }
          _this3.setState({ hidden: false, e: e });
        },
        onFocusIn: function onFocusIn(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.target.blur();
          window.setTimeout(function () {
            if (_this3.state.hidden === false) {
              return;
            }
            _this3.setState({ hidden: false, e: e });
          }, 64);
        }
      }),
      props.toggle,
      !state.hidden ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_1_preact_portal___default.a,
        { into: 'body' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', {
          'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.backsplash,
          onClick: function onClick() {
            _this3.setState({ hidden: true }, _this3.propagateClose);
          }
        })
      ) : null,
      !state.hidden ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_1_preact_portal___default.a,
        { into: 'body' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          {
            'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.popover,
            ref: this.setPosition,
            style: state.style ? state.style : 'opacity:0'
          },
          props.children[0]
        )
      ) : null
    );
  };

  return Popover;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Popover);

/***/ }),

/***/ "fF25":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("s8Zg");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false,"singleton":true,"attrs":{"data-tableonline-build":"10.24.1"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "fGnf":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, ".hero__31Obu{position:relative;padding:0;padding-top:3.75rem;color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:rgba(0,0,0,.5);background-blend-mode:darken}.hero__31Obu:before{background:-webkit-gradient(linear,left top,left bottom,from(#124142),to(#009688));background:linear-gradient(#124142,#009688);background:-webkit-gradient(linear,left top,right top,from(#004d17),to(#124142));background:linear-gradient(90deg,#004d17,#124142);background:-webkit-gradient(linear,left top,left bottom,from(#001414),to(#073535));background:linear-gradient(180deg,#001414,#073535);position:absolute;top:0;left:0;right:0;bottom:0;content:\"\";opacity:.9}.hero__31Obu h1,.hero__31Obu h2{text-shadow:0 0 10px rgba(0,0,0,.3)}.hero__31Obu h2{opacity:.8}.heroTitle__2aii6{padding:0;padding-top:1rem;padding-bottom:2rem}.heroTitleContent__6MluP{-webkit-animation:fadeIn__3cKqo .3s ease;animation:fadeIn__3cKqo .3s ease;display:-webkit-box;display:-ms-flexbox;display:flex;text-align:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.hero__31Obu h1[placeholder],.hero__31Obu h2[placeholder]{display:block;position:relative;background:hsla(0,0%,100%,.15);border-radius:4px;overflow:hidden;-webkit-animation:fadeIn__3cKqo .3s ease;animation:fadeIn__3cKqo .3s ease}.hero__31Obu h1[placeholder]{width:40%}.hero__31Obu h2[placeholder]{width:25%}.hero__31Obu h1[placeholder]:before,.hero__31Obu h2[placeholder]:before{content:\"\\A0\\A0\"}.hero__31Obu h1[placeholder]:after,.hero__31Obu h2[placeholder]:after{content:\"\";width:100%;opacity:.1;background:-webkit-gradient(linear,right top,left top,from(transparent),color-stop(#fff),to(transparent));background:linear-gradient(270deg,transparent,#fff,transparent);position:absolute;top:0;left:0;bottom:0;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:placeholderAnimate__x-hhM;animation-name:placeholderAnimate__x-hhM;-webkit-animation-timing-function:ease;animation-timing-function:ease}@-webkit-keyframes fadeIn__3cKqo{0%{opacity:0}to{opacity:1}}@keyframes fadeIn__3cKqo{0%{opacity:0}to{opacity:1}}@-webkit-keyframes placeholderAnimate__x-hhM{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);opacity:.3}to{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);opacity:.15}}@keyframes placeholderAnimate__x-hhM{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);opacity:.3}to{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);opacity:.15}}", ""]);

// exports
exports.locals = {
	"hero": "hero__31Obu",
	"heroTitle": "heroTitle__2aii6",
	"heroTitleContent": "heroTitleContent__6MluP",
	"fadeIn": "fadeIn__3cKqo",
	"placeholderAnimate": "placeholderAnimate__x-hhM"
};

/***/ }),

/***/ "fPNz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./abs')} */

module.exports = Math.abs;

/***/ }),

/***/ "fnmv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./routes/book/style.css
var style = __webpack_require__("/g0k");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./components/image/index.js
var components_image = __webpack_require__("tJjN");

// EXTERNAL MODULE: ./components/button/index.js
var components_button = __webpack_require__("rAoZ");

// EXTERNAL MODULE: ./components/popover/index.js
var popover = __webpack_require__("exxx");

// EXTERNAL MODULE: ./routes/book/countryCodes.js
var countryCodes = __webpack_require__("hKt2");

// EXTERNAL MODULE: ./components/input/index.js
var input = __webpack_require__("q40z");

// EXTERNAL MODULE: ./components/translate/index.js
var translate = __webpack_require__("Mcf2");

// EXTERNAL MODULE: ./i18n/index.js
var i18n = __webpack_require__("ktCQ");

// CONCATENATED MODULE: ./routes/book/CountryCodeSelectorDisplay.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var CountryCodeSelectorDisplay_CountryCodeSelectorDisplay = function (_Component) {
  _inherits(CountryCodeSelectorDisplay, _Component);

  function CountryCodeSelectorDisplay() {
    _classCallCheck(this, CountryCodeSelectorDisplay);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  CountryCodeSelectorDisplay.prototype.render = function render(_ref, _ref2, context) {
    var onChange = _ref.onChange,
        contact_info = _ref.contact_info,
        autocomplete = _ref.autocomplete,
        onAutoComplete = _ref.onAutoComplete;

    var _this2 = this;

    var showAll = _ref2.showAll;

    return Object(preact_min["h"])(
      'div',
      { 'class': style_default.a.countryCodeSelectorDisplay },
      Object(preact_min["h"])(
        'div',
        { 'class': style_default.a.smallPadding },
        Object(preact_min["h"])(input["c" /* default */], {
          size: 'full',
          placeholder: i18n["a" /* default */].t('Search'),
          value: autocomplete,
          onInput: onAutoComplete
        })
      ),
      Object(preact_min["h"])(
        'div',
        { 'class': style_default.a.countryCodeSelectorWrapper },
        Object(preact_min["h"])(
          'ul',
          { 'class': style_default.a.countryCodeList },
          Object.keys(countryCodes["a" /* countryCodes */]).filter(function (country_code) {
            return !autocomplete && country_code === 'fi' || !autocomplete && country_code === 'ee' || !autocomplete && showAll || autocomplete.split(' ').join('') && ('' + country_code.split(' ').join('') + countryCodes["a" /* countryCodes */][country_code]).indexOf(autocomplete.split(' ').join('').toLowerCase()) !== -1;
          }).map(function (country_code) {
            return Object(preact_min["h"])(
              'li',
              { 'class': style_default.a.countryCodeListItem },
              Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.countryCodeFlag },
                Object(preact_min["h"])(
                  components_button["c" /* default */],
                  {
                    'class': style_default.a.countryCodeName,
                    onClick: function onClick() {
                      onChange(_extends({}, contact_info, {
                        country_code: country_code.toUpperCase()
                      }));
                      context.closePopOver();
                    }
                  },
                  Object(preact_min["h"])(
                    'span',
                    { 'class': style_default.a.countryCodeFlagWrapper },
                    Object(preact_min["h"])(components_image["a" /* default */], {
                      src: 'https://cdn.rawgit.com/hjnilsson/country-flags/master/svg/' + country_code + '.svg',
                      alt: countryCodes["a" /* countryCodes */][country_code],
                      'class': style_default.a.countryCodeFlagImage
                    })
                  )
                )
              ),
              Object(preact_min["h"])(
                components_button["c" /* default */],
                {
                  'class': style_default.a.countryCodeName,
                  onClick: function onClick() {
                    onChange(_extends({}, contact_info, {
                      country_code: country_code.toUpperCase()
                    }));
                    context.closePopOver();
                  }
                },
                Object(preact_min["h"])(
                  'span',
                  null,
                  countryCodes["a" /* countryCodes */][country_code],
                  ' (',
                  country_code.toUpperCase(),
                  ')'
                )
              )
            );
          }),
          !showAll ? Object(preact_min["h"])(
            'li',
            { 'class': style_default.a.countryCodeListItem },
            Object(preact_min["h"])(
              'div',
              { 'class': style_default.a.showAll },
              Object(preact_min["h"])(
                components_button["c" /* default */],
                {
                  'class': style_default.a.countryCodeName,
                  onClick: function onClick() {
                    return _this2.setState({ showAll: true });
                  }
                },
                Object(preact_min["h"])(
                  translate["a" /* default */],
                  null,
                  i18n["a" /* default */].t("Show all")
                )
              )
            )
          ) : null
        )
      )
    );
  };

  return CountryCodeSelectorDisplay;
}(preact_min["Component"]);
// CONCATENATED MODULE: ./routes/book/CountryCodeSelector.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CountryCodeSelector_CountryCodeSelector; });


function CountryCodeSelector__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CountryCodeSelector__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function CountryCodeSelector__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var CountryCodeSelector_CountryCodeSelector = function (_Component) {
  CountryCodeSelector__inherits(CountryCodeSelector, _Component);

  function CountryCodeSelector() {
    CountryCodeSelector__classCallCheck(this, CountryCodeSelector);

    return CountryCodeSelector__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  CountryCodeSelector.prototype.render = function render(_ref, _ref2, _ref3) {
    var onChange = _ref.onChange,
        contact_info = _ref.contact_info;

    var _this2 = this;

    var _ref2$autocomplete = _ref2.autocomplete,
        autocomplete = _ref2$autocomplete === undefined ? '' : _ref2$autocomplete;
    var lang = _ref3.lang;

    var code = (contact_info.country_code ? contact_info.country_code : lang === 'en' ? 'fi' : lang).toLowerCase();
    return Object(preact_min["h"])(
      popover["a" /* default */],
      {
        toggle: Object(preact_min["h"])(
          components_button["c" /* default */],
          { 'class': style_default.a.countryCodeSelectorFlag },
          Object(preact_min["h"])(components_image["a" /* default */], {
            src: 'https://cdn.rawgit.com/hjnilsson/country-flags/master/svg/' + code + '.svg',
            alt: code,
            'class': style_default.a.countryCodeFlagImage
          }),
          Object(preact_min["h"])(
            'span',
            { 'class': style_default.a.countryCodeToggleText },
            countryCodes["a" /* countryCodes */][code]
          )
        ),
        'class': style_default.a.countryCodeSelectorDisplayWrapper
      },
      Object(preact_min["h"])(CountryCodeSelectorDisplay_CountryCodeSelectorDisplay, {
        onChange: onChange,
        contact_info: contact_info,
        autocomplete: autocomplete,
        onAutoComplete: function onAutoComplete(e) {
          return _this2.setState({ autocomplete: e.target.value });
        }
      })
    );
  };

  return CountryCodeSelector;
}(preact_min["Component"]);

/***/ }),

/***/ "gepC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ComponentInterpolator = __webpack_require__("hpm6");

var extend = function extend(I18n) {
  I18n.ComponentInterpolator = ComponentInterpolator;
  return I18n;
};

module.exports = extend;

/***/ }),

/***/ "h6ac":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "hGbk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./pow')} */

module.exports = Math.pow;

/***/ }),

/***/ "hKt2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countryCodes; });
var countryCodes = {
  il: '+972',
  af: '+93',
  al: '+355',
  dz: '+213',
  as: '+1 684',
  ad: '+376',
  ao: '+244',
  ai: '+1 264',
  ag: '+1268',
  ar: '+54',
  am: '+374',
  aw: '+297',
  cc: '+61',
  at: '+43',
  az: '+994',
  bs: '+1 242',
  bh: '+973',
  bd: '+880',
  bb: '+1 246',
  by: '+375',
  be: '+32',
  bz: '+501',
  bj: '+229',
  bm: '+1 441',
  bt: '+975',
  ba: '+387',
  bw: '+267',
  br: '+55',
  io: '+246',
  bg: '+359',
  bf: '+226',
  bi: '+257',
  kh: '+855',
  cm: '+237',
  us: '+1',
  cv: '+238',
  ky: '+ 345',
  cf: '+236',
  td: '+235',
  cl: '+56',
  cn: '+86',
  co: '+57',
  km: '+269',
  cg: '+242',
  ck: '+682',
  cr: '+506',
  hr: '+385',
  cu: '+53',
  cy: '+537',
  cz: '+420',
  dk: '+45',
  dj: '+253',
  dm: '+1 767',
  do: '+1 849',
  ec: '+593',
  eg: '+20',
  sv: '+503',
  gq: '+240',
  er: '+291',
  ee: '+372',
  et: '+251',
  fo: '+298',
  fj: '+679',
  fi: '+358',
  fr: '+33',
  gf: '+594',
  pf: '+689',
  ga: '+241',
  gm: '+220',
  ge: '+995',
  de: '+49',
  gh: '+233',
  gi: '+350',
  gr: '+30',
  gl: '+299',
  gd: '+1 473',
  mf: '+590',
  gu: '+1 671',
  gt: '+502',
  gn: '+224',
  gw: '+245',
  py: '+595',
  ht: '+509',
  hn: '+504',
  hu: '+36',
  is: '+354',
  in: '+91',
  id: '+62',
  iq: '+964',
  ie: '+353',
  it: '+39',
  jm: '+1 876',
  jp: '+81',
  jo: '+962',
  kz: '+7 7',
  ke: '+254',
  ki: '+686',
  kw: '+965',
  kg: '+996',
  lv: '+371',
  lb: '+961',
  ls: '+266',
  lr: '+231',
  li: '+423',
  lt: '+370',
  lu: '+352',
  mg: '+261',
  mw: '+265',
  my: '+60',
  mv: '+960',
  ml: '+223',
  mt: '+356',
  mh: '+692',
  mq: '+596',
  mr: '+222',
  mu: '+230',
  re: '+262',
  mx: '+52',
  mc: '+377',
  mn: '+976',
  me: '+382',
  ms: '+1664',
  ma: '+212',
  mm: '+95',
  na: '+264',
  nr: '+674',
  np: '+977',
  nl: '+31',
  an: '+599',
  nc: '+687',
  nz: '+64',
  ni: '+505',
  ne: '+227',
  ng: '+234',
  nu: '+683',
  nf: '+672',
  mp: '+1 670',
  sj: '+47',
  om: '+968',
  pk: '+92',
  pw: '+680',
  pa: '+507',
  pg: '+675',
  pe: '+51',
  ph: '+63',
  pl: '+48',
  pt: '+351',
  pr: '+1 939',
  qa: '+974',
  ro: '+40',
  rw: '+250',
  ws: '+685',
  sm: '+378',
  sa: '+966',
  sn: '+221',
  rs: '+381',
  sc: '+248',
  sl: '+232',
  sg: '+65',
  sk: '+421',
  si: '+386',
  sb: '+677',
  za: '+27',
  fk: '+500',
  es: '+34',
  lk: '+94',
  sd: '+249',
  sr: '+597',
  sz: '+268',
  se: '+46',
  ch: '+41',
  tj: '+992',
  th: '+66',
  tg: '+228',
  tk: '+690',
  to: '+676',
  tt: '+1 868',
  tn: '+216',
  tr: '+90',
  tm: '+993',
  tc: '+1 649',
  tv: '+688',
  ug: '+256',
  ua: '+380',
  ae: '+971',
  je: '+44',
  uy: '+598',
  uz: '+998',
  vu: '+678',
  wf: '+681',
  ye: '+967',
  zm: '+260',
  zw: '+263',
  ax: '',
  aq: 'null',
  bo: '+591',
  bn: '+673',
  cd: '+243',
  ci: '+225',
  va: '+379',
  hk: '+852',
  ir: '+98',
  kp: '+850',
  kr: '+82',
  la: '+856',
  ly: '+218',
  mo: '+853',
  mk: '+389',
  fm: '+691',
  md: '+373',
  mz: '+258',
  ps: '+970',
  pn: '+872',
  ru: '+7',
  sh: '+290',
  kn: '+1 869',
  lc: '+1 758',
  pm: '+508',
  vc: '+1 784',
  st: '+239',
  so: '+252',
  sy: '+963',
  tw: '+886',
  tz: '+255',
  tl: '+670',
  ve: '+58',
  vn: '+84',
  vg: '+1 284',
  vi: '+1 340'
};

/***/ }),

/***/ "hpm6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var invariant = __webpack_require__("2gTp");
var Component = __webpack_require__("KM04").Component;
var h = __webpack_require__("KM04").h;
var clone = __webpack_require__("dgPI").bind(true);
var WRAPPER_PATTERN = /(\*+)/;
var PLACEHOLDER_PATTERN = /(%\{.*?\})/;

// Replace a "$1" text descendant in this tree with the newDescendants
var injectNewDescendants = function injectNewDescendants(element, newDescendants, props, ensureInjected) {
  newDescendants.injectedCount = newDescendants.injectedCount || 0;
  props = props || {};

  var children = element.children;
  for (var i = 0; i < children.length; i++) {
    var child = children[i];
    children[i] = child.nodeName ? injectNewDescendants(child, newDescendants) : child;
  }

  var injectIndex = getInjectIndex(children);
  if (injectIndex >= 0) {
    children.splice.apply(children, [injectIndex, 1].concat(newDescendants));
    newDescendants.injectedCount++;
  }

  props.children = children.length ? children : [];
  if (ensureInjected) {
    invariant(newDescendants.injectedCount === 1, 'wrappers must have a single "$1" text descendant');
  }
  return clone(element, props);
};

var getInjectIndex = function getInjectIndex(children, containerName) {
  var child,
      index = -1;
  for (var i = 0; i < children.length; i++) {
    child = children[i];
    if (typeof child !== "string") continue;
    invariant(child === "$1", containerName + ' may not have any non-"$1" text children"');
    invariant(index === -1, containerName + ' may not have multiple "$1" text children"');
    index = i;
  }
  return index;
};

var ComponentInterpolator = function (_Component) {
  _inherits(ComponentInterpolator, _Component);

  function ComponentInterpolator() {
    _classCallCheck(this, ComponentInterpolator);

    return _possibleConstructorReturn(this, (ComponentInterpolator.__proto__ || Object.getPrototypeOf(ComponentInterpolator)).apply(this, arguments));
  }

  _createClass(ComponentInterpolator, [{
    key: 'inferChildren',
    value: function inferChildren() {
      var tokens = (this.props.string || '').split(WRAPPER_PATTERN);
      this.keyCounter = 0;
      var inferredChildren = this.interpolateAllComponents(tokens);

      var currentChildren = this.props.children;

      var index = getInjectIndex(currentChildren, '<ComponentInterpolator>');
      invariant(index >= 0, '<ComponentInterpolator> must have a "$1" text child"');
      currentChildren.splice.apply(currentChildren, [index, 1].concat(inferredChildren));
      return currentChildren;
    }
  }, {
    key: 'interpolateAllComponents',
    value: function interpolateAllComponents(tokens, eof) {
      var token, child;
      var children = [];
      var wrappers = this.props.wrappers || {};
      while (tokens.length) {
        token = tokens.shift();
        if (token === eof) break;
        if (token.match(WRAPPER_PATTERN)) {
          invariant(child = wrappers[token], "<ComponentInterpolator> expected '" + token + "' wrapper, none found");
          child = injectNewDescendants(child, this.interpolateAllComponents(tokens, token), { key: this.keyCounter++ }, true);
          children.push(child);
        } else {
          children.push.apply(children, this.interpolatePlaceholders(token));
        }
      }
      return children;
    }
  }, {
    key: 'interpolatePlaceholders',
    value: function interpolatePlaceholders(string) {
      var token, child;
      var tokens = string.split(PLACEHOLDER_PATTERN);
      var children = [];
      while (tokens.length) {
        token = tokens.shift();
        if (token.match(PLACEHOLDER_PATTERN)) {
          token = token.slice(2, -1);
          invariant(this.props.hasOwnProperty(token), "<ComponentInterpolator> expected '" + token + "' placeholder value, none found");
          child = this.props[token];
          child = child && child.nodeName ? clone(child, { key: this.keyCounter++ }) : child;
          children.push(child);
        } else {
          children.push(token);
        }
      }
      return children;
    }
  }, {
    key: 'render',
    value: function render() {
      return h('span', {}, this.inferChildren());
    }
  }]);

  return ComponentInterpolator;
}(Component);

module.exports = ComponentInterpolator;

/***/ }),

/***/ "hrFb":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, ".dropDownWrapper__18EFV{position:absolute;left:0;right:0;top:2rem;z-index:2;-webkit-animation:animateIn__1iE7n .3s ease;animation:animateIn__1iE7n .3s ease}.dropDownCard__OQWfr{background:#fff;width:100%;max-width:100%;max-height:100%;position:relative;border-radius:5px;background-color:#fff;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:0 0 100px -20px rgba(0,0,0,.25),0 30px 60px -30px rgba(0,0,0,.3);box-shadow:0 0 100px -20px rgba(0,0,0,.25),0 30px 60px -30px rgba(0,0,0,.3)}.dropDownArrow__2atvQ{position:absolute;top:2px;left:50%;width:12px;height:12px;background:#fff;border-radius:2px;-webkit-transform:translate3d(-50%,-6px,0) rotate(-45deg);transform:translate3d(-50%,-6px,0) rotate(-45deg)}.dropDownSpacer__HSf-r{padding-top:6px}.closeButton__hOjF-{position:absolute;top:-6px;right:-6px;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:transparent;border:0;opacity:1;padding:.75rem;cursor:pointer;line-height:12px;height:24px;width:24px;border-radius:24px;text-align:center;z-index:3;outline:0;background:#fff;-webkit-box-shadow:0 0 10px 0 rgba(0,0,0,.25);box-shadow:0 0 10px 0 rgba(0,0,0,.25);padding:0}.closeButton__hOjF- svg{opacity:.46}.closeButton__hOjF-:focus svg,.closeButton__hOjF-:hover svg{opacity:1}@-webkit-keyframes animateIn__1iE7n{0%{opacity:0}to{opacity:1}}@keyframes animateIn__1iE7n{0%{opacity:0}to{opacity:1}}", ""]);

// exports
exports.locals = {
	"dropDownWrapper": "dropDownWrapper__18EFV",
	"animateIn": "animateIn__1iE7n",
	"dropDownCard": "dropDownCard__OQWfr",
	"dropDownArrow": "dropDownArrow__2atvQ",
	"dropDownSpacer": "dropDownSpacer__HSf-r",
	"closeButton": "closeButton__hOjF-"
};

/***/ }),

/***/ "iY+1":
/***/ (function(module, exports, __webpack_require__) {

var log = __webpack_require__("CTmE")('i18nline:i18n');

var I18n = __webpack_require__("6JNq");
var extend = __webpack_require__("SkL2");

module.exports = extend(I18n);

log.debug('Initialized ' + log.name);

/***/ }),

/***/ "iyol":
/***/ (function(module, exports) {


// ulog - microscopically small universal logging library
// © 2017 by Stijn de Witt, some rights reserved
// License: CC-BY-4.0

function log(name) {
	return name ? mods[name] ? mods[name] : mods[name] = enhance({ name: name }, log) : log.debug ? log : enhance(log);
}

log.ulog = { version: '1.1.0' };

log.enable = function (str) {
	var i,
	    split = (str || '').split(/[\s,]+/);
	for (i = 0; i < split.length; i++) {
		if (split[i]) {
			str = split[i].replace(/\*/g, '.*?');
			if (str[0] === '-') skipMods.push(new RegExp('^' + str.substr(1) + '$'));else dbgMods.push(new RegExp('^' + str + '$'));
		}
	}
	for (i in mods) {
		patch(mods[i]);
	}
};

log.enabled = function (name) {
	var i;
	for (i = 0; i < skipMods.length; i++) {
		if (skipMods[i].test(name)) return;
	}for (i = 0; i < dbgMods.length; i++) {
		if (dbgMods[i].test(name)) {
			return true;
		}
	}
};

log.disable = log.enable.bind(log, '');

var LVL = { ERROR: 1, WARN: 2, INFO: 3, LOG: 4, DEBUG: 5, TRACE: 6 },
    names = Object.keys(LVL).map(function (x) {
	return x.toLowerCase();
}),
    mods = {},
    dbgMods = [],
    skipMods = [];

function enhance(o, parent, level) {
	o.NONE = 0;
	for (var key in LVL) {
		o[key] = LVL[key];
	}
	Object.defineProperty(o, 'level', {
		get: function get() {
			return level !== undefined ? level : parent && parent.level;
		},
		set: function set(n) {
			if (n === undefined && parent) {
				level = undefined;
			} else {
				var lvl = n && (Number(n) !== Number(n) ? o[n.toUpperCase()] : Number(n));
				if (lvl >= 0 && lvl <= 6) {
					level = lvl;
				}
			}
			patch(o);
			if (!parent) {
				for (mod in mods) {
					patch(mods[mod]);
				}
			}
		}
	});
	patch(o, parent);
	o.dir = bnd('dir') || nop;
	o.table = bnd('table') || nop;
	o.time = bnd('time') || nop;
	o.timeEnd = bnd('timeEnd') || nop;
	// makes Node behave like browsers 
	o.assert = typeof window == 'object' && bnd('assert') || function () {
		var a = [].concat.apply([], arguments),
		    ok = a.shift();
		if (!ok) {
			o.error.apply(o, a);
		}
	};
	return o;
}

function patch(o) {
	var lvl = Math.max(o.name && log.enabled(o.name) && o.DEBUG || o.level, o.level);
	for (var i = 0, name; name = names[i]; i++) {
		o[name] = lvl <= i ? nop : bnd(name) || typeof print == 'function' && print || nop;
	}
}

function bnd(n, c) {
	return (c = log.con()) && (c[n] || c.log).bind(c);
}
function nop() {}

module.exports = log;

/***/ }),

/***/ "jPvt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__("3JcB");

var $SyntaxError = __webpack_require__("srJF");
var $TypeError = __webpack_require__("uVNY");

var gopd = __webpack_require__("34Ju");

/** @type {import('.')} */
module.exports = function defineDataProperty(obj, property, value) {
	if (!obj || typeof obj !== 'object' && typeof obj !== 'function') {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};

/***/ }),

/***/ "jYt2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */

module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
		return false;
	}
	if (typeof Symbol.iterator === 'symbol') {
		return true;
	}

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') {
		return false;
	}

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
		return false;
	}
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
		return false;
	}

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) {
		return false;
	} // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
		return false;
	}

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
		return false;
	}

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) {
		return false;
	}

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
		return false;
	}

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) {
			return false;
		}
	}

	return true;
};

/***/ }),

/***/ "ki89":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Tabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("1PyO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_root__ = __webpack_require__("VjJS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__("UiAd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dlv__ = __webpack_require__("CYb7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_dlv__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var interactionObserverSupported = 'IntersectionObserver' in __WEBPACK_IMPORTED_MODULE_2__components_root__["a" /* default */];

var Tab = function Tab(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    {
      'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.tab,
      'aria-labelledby': Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["t" /* slugify */])(props.tab) + 'Anchor',
      'aria-hidden': !props.selected,
      id: '' + Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["t" /* slugify */])(props.tab)
    },
    props.selected ? props.children : null
  );
};

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '12',
    viewBox: '0 0 24 24'
  },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M24 6h-24v-4h24v4zm0 4h-24v4h24v-4zm0 8h-24v4h24v-4z' })
);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '12',
    viewBox: '0 0 24 24'
  },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z' })
);

var Tabs = function (_Component) {
  _inherits(Tabs, _Component);

  function Tabs() {
    var _temp, _this, _ret;

    _classCallCheck(this, Tabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      selected: _this.props.selected || 0,
      external: _this.props.external
    }, _this.runningScrolls = 0, _this.getHash = function () {
      return window.location.hash ? window.location.hash.substring(1) : null;
    }, _this.interactionHandler = function (entries) {
      if (!entries[0].isIntersecting) {
        _this.props.onToggleSticky(true);
      } else {
        _this.props.onToggleSticky(false);
      }
    }, _this.initObserver = function () {
      if (interactionObserverSupported && _this.props.onToggleSticky && _this.base.firstChild) {
        if (_this.observer) _this.observer.disconnect();
        _this.observer = new __WEBPACK_IMPORTED_MODULE_2__components_root__["a" /* default */].IntersectionObserver(_this.interactionHandler);
        _this.observer.observe(_this.base.firstChild);
      }
    }, _this.initialScroll = function (props) {
      var hash = _this.getHash();
      if (hash) {
        props.children.filter(function (item) {
          return item;
        }).forEach(function (item, index) {
          if (Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["t" /* slugify */])(__WEBPACK_IMPORTED_MODULE_4_dlv___default()(item || {}, 'attributes.tab', '')) === hash || item.attributes.external && new URL(__WEBPACK_IMPORTED_MODULE_4_dlv___default()(item || {}, 'attributes.external', '')).host === hash) {
            _this.setState({ external: item.attributes.external });
            _this.runningScrolls = _this.runningScrolls + 1;
            window.setTimeout(function () {
              if (_this.runningScrolls === 1) _this.selectIndex(index, item.attributes.external);
              _this.runningScrolls = _this.runningScrolls - 1;
            }, 32);
          }
        });
      }
    }, _this.inView = function (rect) {
      return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
    }, _this.selectIndex = function (index, external) {
      return _this.setState({ selected: index }, function () {
        var rect = _this.base.children[external ? 0 : index + 2].getBoundingClientRect();
        if (!_this.inView(rect) || external) {
          __WEBPACK_IMPORTED_MODULE_2__components_root__["a" /* default */].scrollBy({
            top: rect.top - _this.base.firstChild.clientHeight,
            behavior: 'smooth'
          });
          window.history.pushState({}, '', window.location.pathname + '#' + _this.base.children[external ? 2 : index + 2].id);
        }

        if (typeof _this.props.children.filter(function (item) {
          return item;
        })[index].attributes.onSelect === 'function') {
          typeof _this.props.children.filter(function (item) {
            return item;
          })[index].attributes.onSelect(typeof _this.props.children.filter(function (item) {
            return item;
          })[index].attributes.tab);
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Tabs.prototype.componentDidMount = function componentDidMount() {
    this.initObserver();
    this.initialScroll(this.props);
  };

  Tabs.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!this.observer) {
      this.initObserver();
    }
    if (nextProps.children.filter(function (item) {
      return item;
    }).length !== this.props.children.filter(function (item) {
      return item;
    }).length) {
      this.initialScroll(nextProps);
    }
  };

  Tabs.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.observer) this.observer.disconnect();
  };

  Tabs.prototype.render = function render(props, _ref) {
    var _this2 = this;

    var selected = _ref.selected;

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.tabs },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.watchTarget }),
      props.hideTabs === true ? null : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        {
          'class': ('' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.tablist + (props.transparent ? ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.transparent : '') + (props.inverse ? ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.inverse : '') + ' ' + (props.unsticky ? ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.unsticky : '')).trim(),
          style: props.style,
          role: 'tablist',
          'aria-label': props.label
        },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { 'class': 'contain ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.tabLabelWrapper },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.regularTabs },
            props.children.filter(function (item) {
              return item;
            }).map(function (tab, index) {
              return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'button',
                {
                  role: 'tab',
                  'aria-selected': selected === index ? 'true' : 'false',
                  'aria-controls': '' + Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["t" /* slugify */])(tab.attributes.tab),
                  id: Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["t" /* slugify */])(tab.attributes.tab) + 'Anchor',
                  onClick: function onClick() {
                    _this2.setState({ external: tab.attributes.external });
                    _this2.selectIndex(index, tab.attributes.external);
                  }
                },
                tab.attributes.tab
              );
            })
          ),
          props.extraTabs ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.mobileMenu },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'select',
              {
                onChange: function onChange(e) {
                  return _this2.selectIndex(e.target.selectedIndex);
                }
              },
              props.children.filter(function (item) {
                return item;
              }).map(function (tab) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'option',
                  { value: Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["t" /* slugify */])(tab.attributes.tab) },
                  tab.attributes.tab
                );
              })
            ),
            _ref2
          ) : null,
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.mobileTabs },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'select',
              {
                onChange: function onChange(e) {
                  return _this2.selectIndex(e.target.selectedIndex);
                }
              },
              props.children.filter(function (item) {
                return item;
              }).map(function (tab) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'option',
                  { value: Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["t" /* slugify */])(tab.attributes.tab) },
                  tab.attributes.tab
                );
              })
            ),
            _ref3
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.extraTabs },
            props.extraTabs
          )
        )
      ),
      this.state.external ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('iframe', {
        id: new URL(this.state.external).host,
        src: this.state.external,
        'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.externalTab
      }) : props.children.filter(function (item) {
        return item;
      }).map(function (item, index) {
        item.attributes.selected = props.showAll || index === selected;
        return item;
      })
    );
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = ({ Tabs: Tabs, Tab: Tab });

/***/ }),

/***/ "koiw":
/***/ (function(module, exports, __webpack_require__) {

var objectKeys = __webpack_require__("ywQn");
var isArguments = __webpack_require__("6ord");
var is = __webpack_require__("2pTr");
var isRegex = __webpack_require__("DhUb");
var flags = __webpack_require__("DbQ/");
var isDate = __webpack_require__("NyUK");

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || typeof actual !== 'object' && typeof expected !== 'object') {
    return opts.strict ? is(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) {
    return false;
  }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) {
    return false;
  }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) {
    return false;
  }

  if (isArguments(a) !== isArguments(b)) {
    return false;
  }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) {
    return false;
  }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && flags(a) === flags(b);
  }

  if (isDate(a) && isDate(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) {
    return false;
  }
  if (aIsBuffer || bIsBuffer) {
    // && would work too, because both are true or both false here
    if (a.length !== b.length) {
      return false;
    }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) {
        return false;
      }
    }
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) {
    // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) {
    return false;
  }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) {
      return false;
    }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) {
      return false;
    }
  }

  return true;
}

module.exports = deepEqual;

/***/ }),

/***/ "ktCQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_i18nline_i18n__ = __webpack_require__("m805");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_i18nline_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact_i18nline_i18n__);
// Generated by i18nline and preact-i18nline.


__WEBPACK_IMPORTED_MODULE_0_preact_i18nline_i18n___default.a.supportedLocales = ['ee', 'en', 'fi'];
__WEBPACK_IMPORTED_MODULE_0_preact_i18nline_i18n___default.a.defaultLocale = 'en';

__WEBPACK_IMPORTED_MODULE_0_preact_i18nline_i18n___default.a.import = function (locale) {
	// we use a switch here so the import statements are statically
	// analyzable. the use of import() will make build tools generate
	// separate bundles which are downloaded on-demand.
	switch (locale) {
		case 'ee':
			return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "u+gn"));
		case 'en':
			return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "0Yqh"));
		case 'fi':
			return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "wkLl"));
		default:
			return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "y+1Q"));
	}
};

if (false) {
	module.hot.accept('./ee.json', I18n.reload('ee'));
	module.hot.accept('./en.json', I18n.reload('en'));
	module.hot.accept('./fi.json', I18n.reload('fi'));
	module.hot.accept('./default.json', I18n.reload('default'));
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_preact_i18nline_i18n___default.a);

/***/ }),

/***/ "lJDY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $Object = __webpack_require__("bwdo");

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;

/***/ }),

/***/ "lcwS":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),

/***/ "lg1n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./round')} */

module.exports = Math.round;

/***/ }),

/***/ "m2kL":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, ".tabLabelWrapper__QfeGT{display:-webkit-box;display:-ms-flexbox;display:flex}.watchTarget__2JK2u{width:100%;display:block;margin-top:-1px;height:1px}.tablist__1oZ-n{border-bottom:1px solid rgba(0,0,0,.1);position:sticky;top:0;z-index:2;background-color:#f9f9f6}.transparent__1VLMJ,.transparent__1VLMJ button,.transparent__1VLMJ select{background:transparent}.inverse__1oJjF{color:#fff;border-bottom:1px solid hsla(0,0%,100%,.1)}.inverse__1oJjF button,.inverse__1oJjF select{color:#fff}.inverse__1oJjF svg{fill:#fff}.tablist__1oZ-n>div{padding:0 1rem}.tablist__1oZ-n button,.tablist__1oZ-n select{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;background:transparent;padding:1rem 0;margin:0 1rem 1px 0;text-decoration:none;cursor:pointer;text-align:center;opacity:.56;-webkit-transition:opacity .5s ease;transition:opacity .5s ease;font-weight:500;outline:0}.tablist__1oZ-n button:active,.tablist__1oZ-n button:focus,.tablist__1oZ-n button[aria-selected=true],.tablist__1oZ-n select{-webkit-box-shadow:0 2px 0 0 #124142;box-shadow:0 2px 0 0 #124142}.tablist__1oZ-n button:active,.tablist__1oZ-n button:focus,.tablist__1oZ-n button:hover,.tablist__1oZ-n button[aria-selected=true],.tablist__1oZ-n select{opacity:1}.tablist__1oZ-n select{border-radius:0;padding-right:24px}.mobileMenu__3snWc select{width:0;-webkit-box-shadow:none;box-shadow:none}.mobileMenu__3snWc svg,.mobileTabs__1oVPN svg{margin-left:-36px;pointer-events:none}.tabs__14bZx [aria-hidden=true]{display:none;visibility:hidden}.tab__3B960:focus{outline:0}.regularTabs__1QxIk{display:block}.mobileMenu__3snWc,.mobileTabs__1oVPN{display:none;position:relative}.extraTabs__lKKIZ{-webkit-box-flex:1;-ms-flex:1;flex:1;display:block}.unsticky__1_JOj{position:relative}.externalTab__3RN1u{width:100%;height:100vh;border:0}@media (max-width:64rem){.tablist__1oZ-n>div{padding:0 .5rem}.regularTabs__1QxIk{display:none}.mobileTabs__1oVPN{display:block}}@media (max-width:32rem){.mobileMenu__3snWc+.mobileTabs__1oVPN{display:none}.mobileMenu__3snWc{display:block}}", ""]);

// exports
exports.locals = {
	"tabs": "tabs__14bZx",
	"tabLabelWrapper": "tabLabelWrapper__QfeGT",
	"watchTarget": "watchTarget__2JK2u",
	"tablist": "tablist__1oZ-n",
	"transparent": "transparent__1VLMJ",
	"inverse": "inverse__1oJjF",
	"mobileMenu": "mobileMenu__3snWc",
	"mobileTabs": "mobileTabs__1oVPN",
	"tab": "tab__3B960",
	"regularTabs": "regularTabs__1QxIk",
	"extraTabs": "extraTabs__lKKIZ",
	"unsticky": "unsticky__1_JOj",
	"externalTab": "externalTab__3RN1u"
};

/***/ }),

/***/ "m805":
/***/ (function(module, exports, __webpack_require__) {

var I18n = __webpack_require__("iY+1");
var extend = __webpack_require__("gepC");

module.exports = extend(I18n);

/***/ }),

/***/ "mEl1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("+SFM");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false,"singleton":true,"attrs":{"data-tableonline-build":"10.24.1"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "oG9A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./functionCall')} */

module.exports = Function.prototype.call;

/***/ }),

/***/ "orz+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__("uTT0"); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'];
	var equalsConstructorPrototype = function equalsConstructorPrototype(o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = function () {
		/* global window */
		if (typeof window === 'undefined') {
			return false;
		}
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}();
	var equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;

/***/ }),

/***/ "pijy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__("58Ti");

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (false) {
	navigator.serviceWorker.register(__webpack_public_path__ + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "q40z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Select; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Input; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("SDfs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n__ = __webpack_require__("ktCQ");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var autocomplete = {
  password: 'current-password',
  tel: 'tel',
  email: 'email',
  CVC: 'cc-csc'
};

var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z' });

var Select = function (_Component) {
  _inherits(Select, _Component);

  function Select() {
    _classCallCheck(this, Select);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Select.prototype.render = function render(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'label',
      {
        'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.inputLabel + ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.label + ' ' + (__WEBPACK_IMPORTED_MODULE_1__style___default.a[props.size] || __WEBPACK_IMPORTED_MODULE_1__style___default.a.medium) + ' ' + (props.error ? __WEBPACK_IMPORTED_MODULE_1__style___default.a.error : '')
      },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.labelGuide + ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.labelFilled },
        props.placeholder
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('select', _extends({}, props, { placeholder: null, 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.input })),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.labelHelp },
        props.title
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'svg',
        {
          'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.selectIcon,
          xmlns: 'http://www.w3.org/2000/svg',
          width: '14',
          viewBox: '0 0 24 24'
        },
        _ref
      )
    );
  };

  return Select;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Input = function (_Component2) {
  _inherits(Input, _Component2);

  function Input() {
    _classCallCheck(this, Input);

    return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
  }

  Input.prototype.componentDidMount = function componentDidMount() {
    var props = this.props;
    if (props.value && props.textarea) {
      var textarea = this.base.querySelector('textarea');
      textarea.setAttribute('style', 'height:' + textarea.scrollHeight + 'px');
    }
  };

  Input.prototype.render = function render(props, state) {
    var _this3 = this;

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'label',
      {
        'class': (__WEBPACK_IMPORTED_MODULE_1__style___default.a.label + ' ' + (__WEBPACK_IMPORTED_MODULE_1__style___default.a[props.size] || __WEBPACK_IMPORTED_MODULE_1__style___default.a.medium) + ' ' + (props.error ? __WEBPACK_IMPORTED_MODULE_1__style___default.a.error : '') + ' ' + (state.dirty ? __WEBPACK_IMPORTED_MODULE_1__style___default.a.dirty : '') + ' ' + (props.strict ? __WEBPACK_IMPORTED_MODULE_1__style___default.a.strict : '')).trim()
      },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        {
          'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.labelGuide + ' ' + (props.value || state.focused ? __WEBPACK_IMPORTED_MODULE_1__style___default.a.labelFilled : __WEBPACK_IMPORTED_MODULE_1__style___default.a.labelEmpty)
        },
        props.placeholder
      ),
      props.textarea ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'textarea',
        _extends({}, props, {
          placeholder: null,
          'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.input,
          autocomplete: props.autocomplete || autocomplete[props.type] || autocomplete[props.placeholder],
          onFocus: function onFocus(e) {
            return _this3.setState({ focused: true }, function () {
              if (props.onFocus) {
                props.onFocus(e);
              }
            });
          },
          onBlur: function onBlur(e) {
            return _this3.setState({ focused: false, dirty: true }, function () {
              if (props.onBlur) {
                props.onBlur(e);
              }
            });
          }
        }),
        props.value
      ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', _extends({}, props, {
        placeholder: null,
        'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.input,
        autocomplete: props.autocomplete || autocomplete[props.type] || autocomplete[props.placeholder],
        onFocus: function onFocus(e) {
          return _this3.setState({ focused: true }, function () {
            if (props.onFocus) {
              props.onFocus(e);
            }
          });
        },
        onBlur: function onBlur(e) {
          return _this3.setState({ focused: false, dirty: true }, function () {
            if (props.onBlur) {
              props.onBlur(e);
            }
          });
        }
      })),
      props.value || state.focused ? null : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.labelHelp },
        props.title ? props.title : !props.value && props.required ? __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('Required') : ''
      ),
      props.icon ? props.resetIcon ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'button',
        {
          type: 'button',
          'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.resetButton,
          name: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('Reset'),
          onMouseDown: function onMouseDown() {
            props.onInput({ target: { value: '' } });
          }
        },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'svg',
          {
            'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.selectIcon,
            xmlns: 'http://www.w3.org/2000/svg',
            width: '14',
            viewBox: '0 0 24 24'
          },
          props.icon.children
        )
      ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'svg',
        {
          'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.selectIcon,
          xmlns: 'http://www.w3.org/2000/svg',
          width: '14',
          viewBox: '0 0 24 24'
        },
        props.icon.children
      ) : null
    );
  };

  return Input;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);
/* harmony default export */ __webpack_exports__["c"] = (Input);

/***/ }),

/***/ "q6qL":
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? module.exports = factory(__webpack_require__("KM04")) : typeof define === 'function' && define.amd ? define(['preact'], factory) : global.preactPortal = factory(global.preact);
})(this, function (preact) {
  'use strict';

  var asyncGenerator = function () {
    function AwaitValue(value) {
      this.value = value;
    }

    function AsyncGenerator(gen) {
      var front, back;

      function send(key, arg) {
        return new Promise(function (resolve, reject) {
          var request = {
            key: key,
            arg: arg,
            resolve: resolve,
            reject: reject,
            next: null
          };

          if (back) {
            back = back.next = request;
          } else {
            front = back = request;
            resume(key, arg);
          }
        });
      }

      function resume(key, arg) {
        try {
          var result = gen[key](arg);
          var value = result.value;

          if (value instanceof AwaitValue) {
            Promise.resolve(value.value).then(function (arg) {
              resume("next", arg);
            }, function (arg) {
              resume("throw", arg);
            });
          } else {
            settle(result.done ? "return" : "normal", result.value);
          }
        } catch (err) {
          settle("throw", err);
        }
      }

      function settle(type, value) {
        switch (type) {
          case "return":
            front.resolve({
              value: value,
              done: true
            });
            break;

          case "throw":
            front.reject(value);
            break;

          default:
            front.resolve({
              value: value,
              done: false
            });
            break;
        }

        front = front.next;

        if (front) {
          resume(front.key, front.arg);
        } else {
          back = null;
        }
      }

      this._invoke = send;

      if (typeof gen.return !== "function") {
        this.return = undefined;
      }
    }

    if (typeof Symbol === "function" && Symbol.asyncIterator) {
      AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
        return this;
      };
    }

    AsyncGenerator.prototype.next = function (arg) {
      return this._invoke("next", arg);
    };

    AsyncGenerator.prototype.throw = function (arg) {
      return this._invoke("throw", arg);
    };

    AsyncGenerator.prototype.return = function (arg) {
      return this._invoke("return", arg);
    };

    return {
      wrap: function wrap(fn) {
        return function () {
          return new AsyncGenerator(fn.apply(this, arguments));
        };
      },
      await: function _await(value) {
        return new AwaitValue(value);
      }
    };
  }();

  var classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var inherits = function inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  };

  var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  };

  var Portal = function (_Component) {
    inherits(Portal, _Component);

    function Portal() {
      classCallCheck(this, Portal);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Portal.prototype.componentDidUpdate = function componentDidUpdate(props) {
      for (var i in props) {
        if (props[i] !== this.props[i]) {
          return setTimeout(this.renderLayer);
        }
      }
    };

    Portal.prototype.componentDidMount = function componentDidMount() {
      this.isMounted = true;
      this.renderLayer = this.renderLayer.bind(this);
      this.renderLayer();
    };

    Portal.prototype.componentWillUnmount = function componentWillUnmount() {
      this.renderLayer(false);
      this.isMounted = false;
      if (this.remote) this.remote.parentNode.removeChild(this.remote);
    };

    Portal.prototype.findNode = function findNode(node) {
      return typeof node === 'string' ? document.querySelector(node) : node;
    };

    Portal.prototype.renderLayer = function renderLayer() {
      var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!this.isMounted) return;

      if (this.props.into !== this.intoPointer) {
        this.intoPointer = this.props.into;
        if (this.into && this.remote) {
          this.remote = preact.render(preact.h(PortalProxy, null), this.into, this.remote);
        }
        this.into = this.findNode(this.props.into);
      }

      this.remote = preact.render(preact.h(PortalProxy, { context: this.context }, show && this.props.children || null), this.into, this.remote);
    };

    Portal.prototype.render = function render() {
      return null;
    };

    return Portal;
  }(preact.Component);

  var PortalProxy = function (_Component2) {
    inherits(PortalProxy, _Component2);

    function PortalProxy() {
      classCallCheck(this, PortalProxy);
      return possibleConstructorReturn(this, _Component2.apply(this, arguments));
    }

    PortalProxy.prototype.getChildContext = function getChildContext() {
      return this.props.context;
    };

    PortalProxy.prototype.render = function render(_ref) {
      var children = _ref.children;

      return children && children[0] || null;
    };

    return PortalProxy;
  }(preact.Component);

  return Portal;
});
//# sourceMappingURL=preact-portal.js.map

/***/ }),

/***/ "qV3Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initTagManager */
/* harmony export (immutable) */ __webpack_exports__["a"] = analytics;
/* harmony export (immutable) */ __webpack_exports__["c"] = facebookTracking;
/* harmony export (immutable) */ __webpack_exports__["d"] = mapRestaurantForAnalytics;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globals__ = __webpack_require__("zQXs");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function initTagManager(id) {
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', id);
}

function initFacebookTracking() {
  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
}
function analytics(event) {
  if (!window.dataLayer) {
    window.dataLayer = [];
    initTagManager(__WEBPACK_IMPORTED_MODULE_0__globals__["g" /* TAGMANAGER_ID */]);
  }
  var version = "10.24.1" || 'dev';
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push(_extends({}, event, { version: version }));
  return window.dataLayer || [];
}

var initializedFacebookTrackers = [];
function facebookTracking() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0__globals__["c" /* FACEBOOKPIXEL */];
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'PageView';
  var options = arguments[2];

  if (!__WEBPACK_IMPORTED_MODULE_0__globals__["f" /* PRODUCTION */]) {
    return;
  }
  if (!window.fbq) {
    initFacebookTracking();
  }

  if (!initializedFacebookTrackers.includes(id)) {
    initializedFacebookTrackers.push(id);
    window.fbq('init', id);
  }
  var version = "10.24.1" || 'dev';

  window.fbq('version', version);
  window.fbq('trackSingle', id, type, options);
}

function mapRestaurantForAnalytics(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === undefined ? '[Error]' : _ref$name,
      _ref$restaurantId = _ref.restaurantId,
      restaurantId = _ref$restaurantId === undefined ? 309 : _ref$restaurantId,
      _ref$city = _ref.city,
      city = _ref$city === undefined ? '[Unknown]' : _ref$city,
      _ref$features = _ref.features,
      features = _ref$features === undefined ? [] : _ref$features;

  var lang = document.documentElement.lang === 'et' ? 'ee' : document.documentElement.lang;
  return {
    item_name: name,
    item_id: restaurantId,
    price: 1.8,
    currency: 'EUR',
    item_variant: 'Restaurant',
    item_category: city,
    item_category2: (features.filter(function (item) {
      return item.category === 'kitchen';
    })[0] || {})[lang]
  };
}

/* harmony default export */ __webpack_exports__["b"] = (analytics);

/***/ }),

/***/ "qke+":
/***/ (function(module, exports, __webpack_require__) {

var log = __webpack_require__("iyol");
var qs = location.search.substring(1),
    args = qs && qs.split('&'),
    lvl,
    dbg,
    i,
    m;

try {
	lvl = localStorage.getItem('log');
	dbg = localStorage.getItem('debug');
} catch (e) {}

for (i = 0; m = args && args[i] && args[i].split('='); i++) {
	m[0] == 'log' ? lvl = m[1] : 0;
	m[0] == 'debug' ? dbg = m[1] : 0;
}

log.con = function () {
	return window.console && console;
};
dbg && log.enable(dbg);
var ulog = log();
log.level = lvl || log.WARN;

module.exports = ulog;

/***/ }),

/***/ "qubP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./components/cityselector/style.css
var style = __webpack_require__("3YCK");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./globals.js
var globals = __webpack_require__("zQXs");

// EXTERNAL MODULE: ./components/tabs/index.js
var tabs = __webpack_require__("ki89");

// EXTERNAL MODULE: ./components/dropdowncard/style.css
var dropdowncard_style = __webpack_require__("WyRA");
var dropdowncard_style_default = /*#__PURE__*/__webpack_require__.n(dropdowncard_style);

// EXTERNAL MODULE: ../node_modules/preact-portal/dist/preact-portal.js
var preact_portal = __webpack_require__("q6qL");
var preact_portal_default = /*#__PURE__*/__webpack_require__.n(preact_portal);

// EXTERNAL MODULE: ./components/root/index.js
var root = __webpack_require__("VjJS");

// CONCATENATED MODULE: ./components/dropdowncard/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var lastOpenedComponent = void 0;

var dropdowncard__ref2 = Object(preact_min["h"])(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    height: '12',
    viewBox: '0 0 24 24'
  },
  Object(preact_min["h"])('path', { d: 'M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z' })
);

var dropdowncard_DropDownCard = function (_Component) {
  _inherits(DropDownCard, _Component);

  function DropDownCard() {
    var _temp, _this, _ret;

    _classCallCheck(this, DropDownCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getAnchorPosition = function (el) {
      var rect = el.getBoundingClientRect(),
          windowWidth = document ? document.body.clientWidth : 1280;

      return {
        windowWidth: windowWidth,
        left: rect.left + root["a" /* default */].scrollX,
        top: rect.top + root["a" /* default */].scrollY,
        bottom: rect.top + rect.height + root["a" /* default */].scrollY,
        right: rect.left + rect.width + root["a" /* default */].scrollX,
        xMiddle: rect.left - (Math.max(1680, windowWidth) - 1680) / 2 + rect.width / 2
      };
    }, _this.scrollToPosition = function (el) {
      if (!el) {
        return;
      }
      root["a" /* default */].setTimeout(function () {
        var rect = el.getBoundingClientRect();

        var windowBottom = root["a" /* default */].innerHeight + root["a" /* default */].scrollY;
        if (rect.bottom > windowBottom) {
          var top = Math.min(_this.state.coordinates.top, rect.bottom - root["a" /* default */].scrollY - rect.height);
          root["a" /* default */].scrollTo({ top: top, behavior: 'smooth' });
        }
      }, 0);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  DropDownCard.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var anchor = _ref.anchor,
        show = _ref.show;

    if (show === true && this.props.show !== show) {
      if (lastOpenedComponent && lastOpenedComponent.props && lastOpenedComponent.props.show && lastOpenedComponent.props.anchor !== anchor) {
        if (lastOpenedComponent.props.onClose) lastOpenedComponent.props.onClose();
        lastOpenedComponent = this;
      }
      this.setState({ coordinates: this.getAnchorPosition(anchor) });
    }
  };

  DropDownCard.prototype.render = function render(props, state) {
    return props.show ? Object(preact_min["h"])(
      preact_portal_default.a,
      { into: 'body' },
      Object(preact_min["h"])(
        'div',
        {
          'class': dropdowncard_style_default.a.dropDownWrapper,
          style: state.coordinates ? 'top:' + state.coordinates.bottom + 'px' : null,
          onMouseLeave: props.onClose
        },
        Object(preact_min["h"])(
          'div',
          { 'class': dropdowncard_style_default.a.dropDownSpacer + ' contain' },
          Object(preact_min["h"])(
            'div',
            { 'class': dropdowncard_style_default.a.dropDownCard },
            Object(preact_min["h"])('span', {
              'class': dropdowncard_style_default.a.dropDownArrow,
              style: 'left: ' + state.coordinates.xMiddle + 'px'
            }),
            Object(preact_min["h"])(
              'button',
              { 'class': dropdowncard_style_default.a.closeButton, onClick: this.props.onClose },
              dropdowncard__ref2
            ),
            Object(preact_min["h"])(
              'div',
              { ref: this.scrollToPosition },
              props.children
            )
          )
        )
      )
    ) : null;
  };

  return DropDownCard;
}(preact_min["Component"]);

/* harmony default export */ var dropdowncard = (dropdowncard_DropDownCard);
// EXTERNAL MODULE: ./analytics.js
var analytics = __webpack_require__("qV3Q");

// EXTERNAL MODULE: ./i18n/index.js
var i18n = __webpack_require__("ktCQ");

// CONCATENATED MODULE: ./components/cityselector/index.js
/* unused harmony export CityList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cityselector_CityTabs; });
/* unused harmony export CitySelector */


function cityselector__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function cityselector__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function cityselector__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var cityselector_selectCity = function selectCity(item_name, index) {
  Object(analytics["b" /* default */])({
    event: 'select_content',
    content_type: 'Regular link',
    content_id: item_name,
    index: index
  });
};
var cityselector_cities = [];
var cityselector_CityList = function (_Component) {
  cityselector__inherits(CityList, _Component);

  function CityList() {
    var _temp, _this, _ret;

    cityselector__classCallCheck(this, CityList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = cityselector__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { cities: cityselector_cities }, _this.fetchCities = function () {
      _this.context.auth.request(globals["a" /* API */] + '/cities.json').then(function (allCities) {
        cityselector_cities = allCities;
        _this.setState({ cities: cityselector_cities });
      });
    }, _temp), cityselector__possibleConstructorReturn(_this, _ret);
  }

  CityList.prototype.componentDidMount = function componentDidMount() {
    if (!this.state.cities.length) {
      this.fetchCities();
    }
  };

  CityList.prototype.render = function render(props, _ref, _ref2) {
    var _this2 = this;

    var _ref$cities = _ref.cities,
        cities = _ref$cities === undefined ? [] : _ref$cities;
    var lang = _ref2.lang,
        events = _ref2.events;

    return Object(preact_min["h"])(
      'ul',
      { 'class': style_default.a.cityPromoList + ' contain' },
      cities.filter(function (item) {
        return _this2.props.country ? _this2.props.country === item.country_code : true;
      }).map(function (city, index) {
        return Object(preact_min["h"])(
          'li',
          { 'class': style_default.a.singleCity },
          Object(preact_min["h"])(
            'a',
            {
              href: '/' + lang + '/' + city.slug,
              'class': style_default.a.citySelectionLink,
              onClick: function onClick(e) {
                if (props.onlyChangeCity) {
                  e.preventDefault();
                  e.stopImmediatePropagation();
                  events.emit('city', city.title);
                }
                if (props.onClose) props.onClose(city.title);
                cityselector_selectCity(city.title, index);
              }
            },
            Object(preact_min["h"])(
              'h5',
              null,
              city.title
            )
          )
        );
      })
    );
  };

  return CityList;
}(preact_min["Component"]);

var cityselector_CityTabs = function (_Component2) {
  cityselector__inherits(CityTabs, _Component2);

  function CityTabs() {
    cityselector__classCallCheck(this, CityTabs);

    return cityselector__possibleConstructorReturn(this, _Component2.apply(this, arguments));
  }

  CityTabs.prototype.render = function render(props, state, _ref3) {
    var lang = _ref3.lang;

    var cities = [Object(preact_min["h"])(
      tabs["a" /* Tab */],
      { tab: i18n["a" /* default */].t('Finland') },
      Object(preact_min["h"])(cityselector_CityList, {
        country: 'FI',
        onClose: props.onClose,
        onlyChangeCity: props.onlyChangeCity
      })
    ), Object(preact_min["h"])(
      tabs["a" /* Tab */],
      { tab: i18n["a" /* default */].t('Estonia') },
      Object(preact_min["h"])(cityselector_CityList, {
        country: 'EE',
        onClose: props.onClose,
        onlyChangeCity: props.onlyChangeCity
      })
    )];
    return Object(preact_min["h"])(
      'div',
      { 'class': style_default.a.mainCitySelector },
      Object(preact_min["h"])(
        'div',
        { 'class': style_default.a.citySelectorTabs },
        Object(preact_min["h"])(
          tabs["b" /* Tabs */],
          { label: i18n["a" /* default */].t('Choose your city') },
          lang === 'ee' ? cities.reverse() : cities
        )
      )
    );
  };

  return CityTabs;
}(preact_min["Component"]);

var cityselector_CitySelector = function (_Component3) {
  cityselector__inherits(CitySelector, _Component3);

  function CitySelector() {
    cityselector__classCallCheck(this, CitySelector);

    return cityselector__possibleConstructorReturn(this, _Component3.apply(this, arguments));
  }

  CitySelector.prototype.render = function render(props) {
    return Object(preact_min["h"])(
      dropdowncard,
      {
        show: props.show,
        onClose: props.onClose,
        anchor: props.anchor
      },
      Object(preact_min["h"])(cityselector_CityTabs, {
        onlyChangeCity: props.onlyChangeCity,
        onClose: props.onClose
      })
    );
  };

  return CitySelector;
}(preact_min["Component"]);

/* harmony default export */ var cityselector = __webpack_exports__["b"] = (cityselector_CitySelector);

/***/ }),

/***/ "r/Ku":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("y6BB");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false,"singleton":true,"attrs":{"data-tableonline-build":"10.24.1"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "rAoZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GlowButton; });
/* unused harmony export RoundButton */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("+eY/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var GlowButton = function GlowButton(props) {
  var Tag = props.href ? 'a' : 'button';
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    Tag,
    _extends({}, props, {
      'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.bookButton + ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.hoverGlow + ' ' + (props.glow ? __WEBPACK_IMPORTED_MODULE_1__style___default.a.glow : '') + (props.disabled ? ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.disabled : '') + (props.loading ? ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.loading : '') + (props.class ? ' ' + props.class : '')
    }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'span',
      { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.children },
      props.children
    )
  );
};

var RoundButton = function RoundButton(props) {
  var Tag = props.href ? 'a' : 'button';
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    Tag,
    _extends({}, props, {
      'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.bookButton + ' ' + (props.disabled ? ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.disabled : '') + (props.loading ? ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.loading : '') + (props.class ? ' ' + props.class : '')
    }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'span',
      { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.children },
      props.children
    )
  );
};

var Button = function Button(props) {
  var Tag = props.href ? 'a' : 'button';
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    Tag,
    _extends({}, props, {
      'class': '' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.button + (props.disabled ? ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.disabled : '') + (props.loading ? ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.loading : '') + (props.class ? ' ' + props.class : '')
    }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'span',
      { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.children },
      props.children
    )
  );
};

/* harmony default export */ __webpack_exports__["c"] = (Button);

/***/ }),

/***/ "rXTS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("58Ti");

var $apply = __webpack_require__("THdF");
var $call = __webpack_require__("oG9A");
var $reflectApply = __webpack_require__("55Q6");

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);

/***/ }),

/***/ "rq4c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s8Zg":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, ".secondaryActions__2kZ74{margin:0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;font-weight:500;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around}.secondaryActions__2kZ74 button{font-weight:500;opacity:.56}.secondaryActions__2kZ74 button:hover{opacity:1}.checkbox__1qM-U{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.indicator__1hWMM{display:inline-block;position:relative;background-color:transparent;width:25px;height:25px;-webkit-transform-origin:center;-ms-transform-origin:center;transform-origin:center;border:2px solid #aaa;border-radius:50%;vertical-align:-6px;margin-right:10px;-webkit-transition:background-color .15s .2s,-webkit-transform .35s cubic-bezier(.78,-1.22,.17,1.89);transition:background-color .15s .2s,-webkit-transform .35s cubic-bezier(.78,-1.22,.17,1.89);transition:background-color .15s .2s,transform .35s cubic-bezier(.78,-1.22,.17,1.89);transition:background-color .15s .2s,transform .35s cubic-bezier(.78,-1.22,.17,1.89),-webkit-transform .35s cubic-bezier(.78,-1.22,.17,1.89)}.checkbox__1qM-U:hover .indicator__1hWMM{border:2px solid #124142}.indicator__1hWMM:before{-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);top:11px;left:7px;-webkit-transition:width 50ms ease 50ms;transition:width 50ms ease 50ms;-webkit-transform-origin:0 0;-ms-transform-origin:0 0;transform-origin:0 0}.indicator__1hWMM:after,.indicator__1hWMM:before{content:\"\";width:0;height:2px;border-radius:2px;background:#124142;position:absolute}.indicator__1hWMM:after{-webkit-transform:rotate(305deg);-ms-transform:rotate(305deg);transform:rotate(305deg);top:14px;left:8px;-webkit-transition:width 50ms ease;transition:width 50ms ease;-webkit-transform-origin:0 0;-ms-transform-origin:0 0;transform-origin:0 0}.checkbox__1qM-U:hover .indicator__1hWMM:before{width:5px;-webkit-transition:width .1s ease;transition:width .1s ease}.checkbox__1qM-U:hover .indicator__1hWMM:after{width:10px;-webkit-transition:width .15s ease .1s;transition:width .15s ease .1s}.checkbox__1qM-U input[type=checkbox]{display:none}.checkbox__1qM-U input[type=checkbox]:checked~.indicator__1hWMM{background-color:#124142;border:2px solid #124142;-webkit-transform:scale(1.25);-ms-transform:scale(1.25);transform:scale(1.25)}.checkbox__1qM-U input[type=checkbox]:checked~.indicator__1hWMM:after{width:10px;background:#fff;-webkit-transition:width .15s ease .1s;transition:width .15s ease .1s}.checkbox__1qM-U input[type=checkbox]:checked~.indicator__1hWMM:before{width:5px;background:#fff;-webkit-transition:width .15s ease .1s;transition:width .15s ease .1s}.checkbox__1qM-U:hover input[type=checkbox]:checked~.indicator__1hWMM{background-color:#124142;-webkit-transform:scale(1.25);-ms-transform:scale(1.25);transform:scale(1.25)}.checkbox__1qM-U:hover input[type=checkbox]:checked~.indicator__1hWMM:after{width:10px;background:#fff;-webkit-transition:width .15s ease .1s;transition:width .15s ease .1s}.checkbox__1qM-U:hover input[type=checkbox]:checked~.indicator__1hWMM:before{width:5px;background:#fff;-webkit-transition:width .15s ease .1s;transition:width .15s ease .1s}.content__oNqkv{max-width:calc(100% - 35px);opacity:.54;-webkit-transition:opacity .4s ease;transition:opacity .4s ease}.checkbox__1qM-U input[type=checkbox]:checked~.content__oNqkv{opacity:1}.detailForm__3d8gR{max-width:26rem;margin:0 auto}.formIntro__LMG3v{text-align:center;opacity:.56;margin-bottom:2rem}.emailField__1TSNo{margin-bottom:1rem}.emailField__1TSNo,.sideBySide__1X6uM{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%}.leftInput__GbZJh{margin-right:.5rem;margin-bottom:1rem;width:50%}.leftShortInput__1oFA8{margin-right:.5rem;margin-bottom:1rem;width:25%}.leftShortInput__1oFA8>div{height:100%;width:100%}.leftShortInput__1oFA8 button{margin-right:0}.rightInput__TSBF2{margin-left:.5rem;margin-bottom:1rem;width:50%}.rightLongInput__zJDNu{margin-left:.5rem;margin-bottom:1rem;width:75%}.singleForm__25Mnl{display:-webkit-box;display:-ms-flexbox;display:flex;margin:0 auto}.darkButton__1IGuk{margin-left:1rem;background:#111;color:#fff}.acceptTerms__1E4YI{margin:0 0 1rem}.termsText__1KnFk{margin-left:1rem}.rightSideButton__16EDo{width:100%;text-align:center}.hidden__1fiBk{visibility:hidden}.loggedInView__l0t25{max-width:26rem;margin:0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column}.detailsTable__5niy0{margin-top:2rem}.tableColumn__1Jj7_{padding:.5rem}.mutedTitle__2mmnV{opacity:.56}.logoutWrapper__2yy10{margin:2rem 0 0;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.authTrigger__CiD6H,.logoutWrapper__2yy10{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.authTrigger__CiD6H{font-weight:500;-webkit-box-shadow:0 2px 6px rgba(0,0,0,.1);box-shadow:0 2px 6px rgba(0,0,0,.1)}.authModal__2g6v2{max-width:48rem}.error__3ur1c{font-size:16px;margin-bottom:1rem;padding:1rem;border:1px solid rgba(230,33,23,.15);background:rgba(230,33,23,.05);border-radius:3px;-webkit-box-shadow:rgba(0,0,0,.1) 0 2px 6px;box-shadow:0 2px 6px rgba(0,0,0,.1)}.error__3ur1c:empty{display:none}", ""]);

// exports
exports.locals = {
	"secondaryActions": "secondaryActions__2kZ74",
	"checkbox": "checkbox__1qM-U",
	"indicator": "indicator__1hWMM",
	"content": "content__oNqkv",
	"detailForm": "detailForm__3d8gR",
	"formIntro": "formIntro__LMG3v",
	"emailField": "emailField__1TSNo",
	"sideBySide": "sideBySide__1X6uM",
	"leftInput": "leftInput__GbZJh",
	"leftShortInput": "leftShortInput__1oFA8",
	"rightInput": "rightInput__TSBF2",
	"rightLongInput": "rightLongInput__zJDNu",
	"singleForm": "singleForm__25Mnl",
	"darkButton": "darkButton__1IGuk",
	"acceptTerms": "acceptTerms__1E4YI",
	"termsText": "termsText__1KnFk",
	"rightSideButton": "rightSideButton__16EDo",
	"hidden": "hidden__1fiBk",
	"loggedInView": "loggedInView__l0t25",
	"detailsTable": "detailsTable__5niy0",
	"tableColumn": "tableColumn__1Jj7_",
	"mutedTitle": "mutedTitle__2mmnV",
	"logoutWrapper": "logoutWrapper__2yy10",
	"authTrigger": "authTrigger__CiD6H",
	"authModal": "authModal__2g6v2",
	"error": "error__3ur1c"
};

/***/ }),

/***/ "sIAo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./globals.js
var globals = __webpack_require__("zQXs");

// EXTERNAL MODULE: ./components/header/style.css
var style = __webpack_require__("u3et");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// EXTERNAL MODULE: ./components/image/index.js
var components_image = __webpack_require__("tJjN");

// EXTERNAL MODULE: ./components/translate/index.js
var translate = __webpack_require__("Mcf2");

// EXTERNAL MODULE: ./components/searchfield/style.css
var searchfield_style = __webpack_require__("mEl1");
var searchfield_style_default = /*#__PURE__*/__webpack_require__.n(searchfield_style);

// EXTERNAL MODULE: ./components/button/index.js
var components_button = __webpack_require__("rAoZ");

// EXTERNAL MODULE: ./components/pubsub/index.js + 1 modules
var pubsub = __webpack_require__("0/XQ");

// EXTERNAL MODULE: ./components/cityselector/index.js + 1 modules
var cityselector = __webpack_require__("qubP");

// EXTERNAL MODULE: ./i18n/index.js
var i18n = __webpack_require__("ktCQ");

// EXTERNAL MODULE: ./helpers.js
var helpers = __webpack_require__("UiAd");

// CONCATENATED MODULE: ./components/searchfield/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var _ref5 = Object(preact_min["h"])(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    height: '24',
    viewBox: '0 0 24 24'
  },
  Object(preact_min["h"])('path', { d: 'M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z' })
);

var searchfield__ref6 = Object(preact_min["h"])('path', { d: 'M23.809 21.646l-6.205-6.205c1.167-1.605 1.857-3.579 1.857-5.711 0-5.365-4.365-9.73-9.731-9.73-5.365 0-9.73 4.365-9.73 9.73 0 5.366 4.365 9.73 9.73 9.73 2.034 0 3.923-.627 5.487-1.698l6.238 6.238 2.354-2.354zm-20.955-11.916c0-3.792 3.085-6.877 6.877-6.877s6.877 3.085 6.877 6.877-3.085 6.877-6.877 6.877c-3.793 0-6.877-3.085-6.877-6.877z' });

var searchfield_SearchField = function (_Component) {
  _inherits(SearchField, _Component);

  function SearchField() {
    _classCallCheck(this, SearchField);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  SearchField.prototype.render = function render(_ref, _ref2, _ref3) {
    var autofocus = _ref.autofocus,
        onChange = _ref.onChange,
        _ref$showCityFilter = _ref.showCityFilter,
        showCityFilter = _ref$showCityFilter === undefined ? false : _ref$showCityFilter;

    var _this2 = this;

    var _ref2$query = _ref2.query,
        query = _ref2$query === undefined ? '' : _ref2$query,
        _ref2$focus = _ref2.focus,
        focus = _ref2$focus === undefined ? false : _ref2$focus,
        _ref2$showCitySelecto = _ref2.showCitySelector,
        showCitySelector = _ref2$showCitySelecto === undefined ? false : _ref2$showCitySelecto;
    var lang = _ref3.lang;

    return Object(preact_min["h"])(
      pubsub["c" /* Stateful */],
      { events: ['city'] },
      function (_ref4) {
        var _ref4$city = _ref4.city,
            city = _ref4$city === undefined ? Object(helpers["i" /* getCity */])() : _ref4$city;
        return Object(preact_min["h"])(
          'div',
          {
            'class': searchfield_style_default.a.searchField + ' ' + (focus ? searchfield_style_default.a.focus : '') + ' ' + (!showCityFilter ? searchfield_style_default.a.noCityFilter : '')
          },
          showCityFilter && Object(preact_min["h"])(
            'div',
            { 'class': searchfield_style_default.a.cityFilterContainer },
            _ref5,
            Object(preact_min["h"])(
              'a',
              {
                href: '/' + lang + '/' + Object(helpers["t" /* slugify */])(city),
                'class': searchfield_style_default.a.citySelection,
                ref: function ref(el) {
                  return _this2.citySelector = el;
                },
                onMouseEnter: function onMouseEnter() {
                  return _this2.setState({ showCitySelector: true });
                }
              },
              city
            )
          ),
          Object(preact_min["h"])(
            'form',
            {
              'class': searchfield_style_default.a.searchForm,
              method: 'GET',
              action: '/' + lang + '/search'
            },
            Object(preact_min["h"])('input', { type: 'hidden', name: 'city', value: city }),
            Object(preact_min["h"])('input', {
              'class': searchfield_style_default.a.searchInput,
              placeholder: focus ? null : i18n["a" /* default */].t('Search'),
              'aria-label': i18n["a" /* default */].t('Search'),
              name: 'q',
              autocomplete: 'off',
              value: query,
              autofocus: autofocus,
              onInput: function onInput(e) {
                _this2.setState({ query: e.target.value }, function () {
                  if (onChange) {
                    onChange(_this2.state.query);
                  }
                });
              },
              onFocus: function onFocus() {
                _this2.setState({ focus: true });
              },
              onBlur: function onBlur() {
                _this2.setState({ focus: false });
              }
            }),
            Object(preact_min["h"])(
              components_button["c" /* default */],
              { 'class': searchfield_style_default.a.searchButton, name: i18n["a" /* default */].t('Search') },
              Object(preact_min["h"])(
                'svg',
                {
                  xmlns: 'http://www.w3.org/2000/svg',
                  viewBox: '0 0 24 24',
                  'class': searchfield_style_default.a.searchIcon
                },
                searchfield__ref6
              )
            )
          ),
          showCityFilter && Object(preact_min["h"])(cityselector["b" /* default */], {
            show: showCitySelector,
            onClose: function onClose() {
              return _this2.setState({ showCitySelector: false });
            },
            anchor: _this2.citySelector
          }),
          query && window.tableOnlineShowAutocomplete ? Object(preact_min["h"])(
            'div',
            { 'class': searchfield_style_default.a.autocomplete },
            Object(preact_min["h"])(
              'label',
              { 'class': searchfield_style_default.a.autocompleteSuggestion },
              Object(preact_min["h"])(
                'h5',
                { 'class': 'hug' },
                Object(preact_min["h"])(
                  translate["a" /* default */],
                  null,
                  i18n["a" /* default */].t("Search")
                ),
                ' ',
                query
              ),
              Object(preact_min["h"])(
                'h6',
                { 'class': 'hug' },
                Object(preact_min["h"])(
                  translate["a" /* default */],
                  null,
                  i18n["a" /* default */].t("From city")
                ),
                ' ',
                Object(preact_min["h"])(
                  'strong',
                  null,
                  Object(preact_min["h"])(
                    pubsub["c" /* Stateful */],
                    { events: ['city'] },
                    function (_ref7) {
                      var _ref7$city = _ref7.city,
                          city = _ref7$city === undefined ? Object(helpers["i" /* getCity */])() : _ref7$city;
                      return city;
                    }
                  )
                )
              )
            ),
            Object(preact_min["h"])(
              'label',
              { 'class': searchfield_style_default.a.autocompleteSuggestionSmall },
              Object(preact_min["h"])(
                'h5',
                { 'class': 'hug' },
                Object(preact_min["h"])(
                  translate["a" /* default */],
                  null,
                  i18n["a" /* default */].t("Restaurant name")
                ),
                ': ',
                query
              )
            ),
            Object(preact_min["h"])(
              'label',
              { 'class': searchfield_style_default.a.autocompleteSuggestionSmall },
              Object(preact_min["h"])(
                'h5',
                { 'class': 'hug' },
                Object(preact_min["h"])(
                  translate["a" /* default */],
                  null,
                  i18n["a" /* default */].t("Restaurant from city")
                ),
                ': ',
                query
              )
            ),
            Object(preact_min["h"])(
              'label',
              { 'class': searchfield_style_default.a.autocompleteSuggestionSmall },
              Object(preact_min["h"])(
                'h5',
                { 'class': 'hug' },
                Object(preact_min["h"])(
                  translate["a" /* default */],
                  null,
                  i18n["a" /* default */].t("Restaurant with kitchen")
                ),
                ': ',
                query
              )
            )
          ) : null
        );
      }
    );
  };

  return SearchField;
}(preact_min["Component"]);

/* harmony default export */ var searchfield = (searchfield_SearchField);
// EXTERNAL MODULE: ./components/jsonld/index.js
var jsonld = __webpack_require__("D3C6");

// EXTERNAL MODULE: ./components/mobile-nav/style.css
var mobile_nav_style = __webpack_require__("Dv02");
var mobile_nav_style_default = /*#__PURE__*/__webpack_require__.n(mobile_nav_style);

// CONCATENATED MODULE: ./components/mobile-nav/index.js


function mobile_nav__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function mobile_nav__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function mobile_nav__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var mobile_nav__ref4 = Object(preact_min["h"])(
  'svg',
  {
    width: '24',
    height: '24',
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    'stroke-width': '2'
  },
  Object(preact_min["h"])('line', { x1: '18', y1: '6', x2: '6', y2: '18' }),
  Object(preact_min["h"])('line', { x1: '6', y1: '6', x2: '18', y2: '18' })
);

var mobile_nav__ref5 = Object(preact_min["h"])('polyline', { points: '6 9 12 15 18 9' });

var mobile_nav__ref7 = Object(preact_min["h"])(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    height: '16',
    viewBox: '0 0 24 24',
    fill: 'currentColor'
  },
  Object(preact_min["h"])('path', { d: 'M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z' })
);

var _ref8 = Object(preact_min["h"])('polyline', { points: '6 9 12 15 18 9' });

var _ref9 = Object(preact_min["h"])(
  'svg',
  {
    width: '16',
    height: '16',
    viewBox: '0 -2.89 122.88 122.88',
    fill: 'currentColor'
  },
  Object(preact_min["h"])(
    'g',
    null,
    Object(preact_min["h"])('path', {
      'fill-rule': 'evenodd',
      'clip-rule': 'evenodd',
      d: 'M36.82,107.86L35.65,78.4l13.25-0.53c5.66,0.78,11.39,3.61,17.15,6.92l10.29-0.41c4.67,0.1,7.3,4.72,2.89,8 c-3.5,2.79-8.27,2.83-13.17,2.58c-3.37-0.03-3.34,4.5,0.17,4.37c1.22,0.05,2.54-0.29,3.69-0.34c6.09-0.25,11.06-1.61,13.94-6.55 l1.4-3.66l15.01-8.2c7.56-2.83,12.65,4.3,7.23,10.1c-10.77,8.51-21.2,16.27-32.62,22.09c-8.24,5.47-16.7,5.64-25.34,1.01 L36.82,107.86L36.82,107.86z M29.74,62.97h91.9c0.68,0,1.24,0.57,1.24,1.24v5.41c0,0.67-0.56,1.24-1.24,1.24h-91.9 c-0.68,0-1.24-0.56-1.24-1.24v-5.41C28.5,63.53,29.06,62.97,29.74,62.97L29.74,62.97z M79.26,11.23 c25.16,2.01,46.35,23.16,43.22,48.06l-93.57,0C25.82,34.23,47.09,13.05,72.43,11.2V7.14l-4,0c-0.7,0-1.28-0.58-1.28-1.28V1.28 c0-0.7,0.57-1.28,1.28-1.28h14.72c0.7,0,1.28,0.58,1.28,1.28v4.58c0,0.7-0.58,1.28-1.28,1.28h-3.89L79.26,11.23L79.26,11.23 L79.26,11.23z M0,77.39l31.55-1.66l1.4,35.25L1.4,112.63L0,77.39L0,77.39z'
    })
  )
);

var _ref10 = Object(preact_min["h"])(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '16',
    height: '16',
    viewBox: '0 0 24 24',
    fill: 'currentColor'
  },
  Object(preact_min["h"])('path', { d: 'M12 24c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12zm1-6h-2v-8h2v8zm-1-12.25c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25z' })
);

var _ref12 = Object(preact_min["h"])(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '16',
    height: '16',
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    'stroke-width': '2',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round'
  },
  Object(preact_min["h"])('path', { d: 'M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2' }),
  Object(preact_min["h"])('circle', { cx: '12', cy: '7', r: '4' })
);

var mobile_nav_MobileNav = function (_Component) {
  mobile_nav__inherits(MobileNav, _Component);

  function MobileNav(props) {
    mobile_nav__classCallCheck(this, MobileNav);

    var _this = mobile_nav__possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      showLanguageSelector: false,
      showCitySelector: false,
      cities: [],
      showGradient: true,
      scrollPercent: 0
    };

    _this.fetchCities = function () {
      _this.context.auth.request(globals["a" /* API */] + '/cities.json').then(function (allCities) {
        _this.setState({ cities: allCities });
      });
    };

    _this.toggleLanguageSelector = function (e) {
      e.stopPropagation();
      _this.setState({
        showLanguageSelector: !_this.state.showLanguageSelector,
        showCitySelector: false
      });
    };

    _this.toggleCitySelector = function (e) {
      e.stopPropagation();
      _this.setState({
        showCitySelector: !_this.state.showCitySelector,
        showLanguageSelector: false
      });
    };

    _this.selectLanguage = function (lang) {
      // Handle language change
      window.location.pathname = window.location.pathname.split('/').map(function (item, index) {
        return index === 1 ? lang : item;
      }).join('/');

      _this.setState({ showLanguageSelector: false });
    };

    _this.selectCity = function (city) {
      Object(helpers["q" /* setCity */])(city);
      if (_this.context.events) {
        _this.context.events.emit('city', city);
      }
      _this.setState({ showCitySelector: false });
    };

    _this.closeMenu = function () {
      // Call the onClose prop provided by the parent
      if (_this.props.onClose) {
        _this.props.onClose();
      }

      _this.setState({
        showLanguageSelector: false,
        showCitySelector: false
      });
      document.body.style.overflow = 'auto';
    };

    _this.handleDropdownScroll = function () {
      if (!_this.dropdownRef) return;
      var _this$dropdownRef = _this.dropdownRef,
          scrollTop = _this$dropdownRef.scrollTop,
          scrollHeight = _this$dropdownRef.scrollHeight,
          clientHeight = _this$dropdownRef.clientHeight;
      // If scrolled to bottom, hide gradient

      if (scrollTop + clientHeight >= scrollHeight - 1) {
        if (_this.state.showGradient) _this.setState({ showGradient: false });
      } else {
        if (!_this.state.showGradient) _this.setState({ showGradient: true });
      }

      var scrollPercent = scrollTop / (scrollHeight - clientHeight);
      _this.setState({ scrollPercent: scrollPercent });
    };

    _this.dropdownRef = null;
    return _this;
  }

  MobileNav.prototype.componentDidMount = function componentDidMount() {
    if (!this.state.cities.length) {
      this.fetchCities();
    }
  };

  MobileNav.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // Handle body overflow when isOpen changes
    if (prevProps.isOpen !== this.props.isOpen) {
      document.body.style.overflow = this.props.isOpen ? 'hidden' : 'auto';
    }
    // Attach/detach scroll listener for city dropdown
    if (prevState.showCitySelector !== this.state.showCitySelector) {
      if (this.state.showCitySelector && this.dropdownRef) {
        this.dropdownRef.addEventListener('scroll', this.handleDropdownScroll);
        // Initial check in case already at bottom
        this.handleDropdownScroll();
      } else if (this.dropdownRef) {
        this.dropdownRef.removeEventListener('scroll', this.handleDropdownScroll);
        // Reset gradient when closed
        if (!this.state.showGradient) this.setState({ showGradient: true });
      }
    }
  };

  MobileNav.prototype.render = function render(_ref, _ref2, _ref3) {
    var _ref$isOpen = _ref.isOpen,
        isOpen = _ref$isOpen === undefined ? false : _ref$isOpen,
        onClose = _ref.onClose;

    var _this2 = this;

    var showLanguageSelector = _ref2.showLanguageSelector,
        showCitySelector = _ref2.showCitySelector,
        cities = _ref2.cities,
        showGradient = _ref2.showGradient,
        scrollPercent = _ref2.scrollPercent;
    var lang = _ref3.lang,
        events = _ref3.events;

    var languages = [{ code: 'en', name: 'English', flag: 'gb' }, { code: 'fi', name: 'Suomi', flag: 'fi' }, { code: 'ee', name: 'Eesti', flag: 'ee' }];

    // Fallback cities if API request hasn't completed yet
    var defaultCities = ['Helsinki', 'Espoo', 'Tampere', 'Turku', 'Tallinn', 'Oulu'];
    var availableCities = cities.length ? cities : defaultCities;

    var currentLanguage = languages.find(function (l) {
      return l.code === lang;
    }) || languages[0];

    // Get appropriate app store badges based on language
    var getAppStoreImage = function getAppStoreImage() {
      switch (lang) {
        case 'fi':
          return '/assets/download/Download_on_the_App_Store_Badge_FI_RGB_blk_100217.svg';
        case 'ee':
          return '/assets/download/Download_on_the_App_Store_Badge_EE_RGB_blk_100217.svg';
        case 'en':
        default:
          return '/assets/download/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';
      }
    };

    var getGooglePlayImage = function getGooglePlayImage() {
      switch (lang) {
        case 'fi':
          return '/assets/download/GetItOnGooglePlay_Badge_Web_color_Finnish.png';
        case 'ee':
          return '/assets/download/GetItOnGooglePlay_Badge_Web_color_Estonian.png';
        case 'en':
        default:
          return '/assets/download/GetItOnGooglePlay_Badge_Web_color_English.png';
      }
    };

    // Localized store URLs
    var getAppStoreUrl = function getAppStoreUrl() {
      switch (lang) {
        case 'fi':
          return 'https://apps.apple.com/fi/app/tableonline-reservations/id1596078295';
        case 'ee':
          return 'https://apps.apple.com/ee/app/tableonline-reservations/id1596078295';
        case 'en':
        default:
          return 'https://apps.apple.com/app/tableonline-reservations/id1596078295';
      }
    };

    var getGooglePlayUrl = function getGooglePlayUrl() {
      switch (lang) {
        case 'fi':
          return 'https://play.google.com/store/apps/details?id=fi.tableonline.app&hl=fi';
        case 'ee':
          return 'https://play.google.com/store/apps/details?id=fi.tableonline.app&hl=et';
        case 'en':
        default:
          return 'https://play.google.com/store/apps/details?id=fi.tableonline.app&hl=en';
      }
    };

    return Object(preact_min["h"])(
      'div',
      { 'class': mobile_nav_style_default.a.mobileNavContainer },
      isOpen && Object(preact_min["h"])('div', { 'class': mobile_nav_style_default.a.backsplash, onClick: this.closeMenu }),
      Object(preact_min["h"])(
        'div',
        { 'class': mobile_nav_style_default.a.mobileMenu + ' ' + (isOpen ? mobile_nav_style_default.a.open : '') },
        Object(preact_min["h"])(
          'div',
          { 'class': mobile_nav_style_default.a.mobileMenuHeader },
          Object(preact_min["h"])('img', {
            src: '/assets/logo/TableOnline_Logo_Green.svg',
            alt: 'TableOnline Icon',
            'class': mobile_nav_style_default.a.tableOnlineIcon
          }),
          Object(preact_min["h"])(
            'button',
            { 'class': mobile_nav_style_default.a.closeButton, onClick: this.closeMenu },
            mobile_nav__ref4
          )
        ),
        Object(preact_min["h"])(
          'div',
          { 'class': mobile_nav_style_default.a.mobileMenuContent },
          Object(preact_min["h"])(
            'div',
            { 'class': mobile_nav_style_default.a.appDownloadSection },
            Object(preact_min["h"])(
              'div',
              { 'class': mobile_nav_style_default.a.appDownloadLinks },
              Object(preact_min["h"])(
                'a',
                {
                  href: getAppStoreUrl(),
                  target: '_blank',
                  rel: 'noopener noreferrer',
                  'class': mobile_nav_style_default.a.storeLink,
                  onClick: this.closeMenu
                },
                Object(preact_min["h"])('img', {
                  src: getAppStoreImage(),
                  alt: 'Download on the App Store',
                  'class': mobile_nav_style_default.a.storeBadge
                })
              ),
              Object(preact_min["h"])(
                'a',
                {
                  href: getGooglePlayUrl(),
                  target: '_blank',
                  rel: 'noopener noreferrer',
                  'class': mobile_nav_style_default.a.storeLink,
                  onClick: this.closeMenu
                },
                Object(preact_min["h"])('img', {
                  src: getGooglePlayImage(),
                  alt: 'Get it on Google Play',
                  'class': mobile_nav_style_default.a.storeBadge
                })
              )
            )
          ),
          Object(preact_min["h"])(
            'div',
            { 'class': mobile_nav_style_default.a.navSection },
            Object(preact_min["h"])(
              'div',
              { 'class': mobile_nav_style_default.a.navItem, onClick: this.toggleLanguageSelector },
              Object(preact_min["h"])(
                'div',
                { 'class': mobile_nav_style_default.a.navItemContent },
                Object(preact_min["h"])(
                  'div',
                  { 'class': mobile_nav_style_default.a.navIconWrapper },
                  Object(preact_min["h"])(
                    'span',
                    { 'class': mobile_nav_style_default.a.languageSelectorFlag },
                    Object(preact_min["h"])(components_image["a" /* default */], {
                      src: 'https://cdn.rawgit.com/hjnilsson/country-flags/master/svg/' + currentLanguage.flag + '.svg',
                      alt: currentLanguage.name,
                      'class': mobile_nav_style_default.a.languageSelectorFlagImage
                    })
                  )
                ),
                Object(preact_min["h"])(
                  'span',
                  null,
                  currentLanguage.name
                )
              ),
              Object(preact_min["h"])(
                'svg',
                {
                  xmlns: 'http://www.w3.org/2000/svg',
                  width: '16',
                  height: '16',
                  viewBox: '0 0 24 24',
                  fill: 'none',
                  stroke: 'currentColor',
                  'stroke-width': '2',
                  'stroke-linecap': 'round',
                  'stroke-linejoin': 'round',
                  'class': mobile_nav_style_default.a.chevron + ' ' + (showLanguageSelector ? mobile_nav_style_default.a.up : '')
                },
                mobile_nav__ref5
              )
            ),
            showLanguageSelector && Object(preact_min["h"])(
              'div',
              { 'class': mobile_nav_style_default.a.dropdownContent },
              languages.map(function (language) {
                return Object(preact_min["h"])(
                  'div',
                  {
                    key: language.code,
                    'class': mobile_nav_style_default.a.dropdownItem,
                    onClick: function onClick() {
                      return _this2.selectLanguage(language.code);
                    }
                  },
                  Object(preact_min["h"])(
                    'span',
                    { 'class': mobile_nav_style_default.a.languageSelectorFlag },
                    Object(preact_min["h"])(components_image["a" /* default */], {
                      src: 'https://cdn.rawgit.com/hjnilsson/country-flags/master/svg/' + language.flag + '.svg',
                      alt: language.name,
                      'class': mobile_nav_style_default.a.languageSelectorFlagImage
                    })
                  ),
                  Object(preact_min["h"])(
                    'span',
                    null,
                    language.name
                  )
                );
              })
            ),
            Object(preact_min["h"])(
              pubsub["c" /* Stateful */],
              { events: ['city'] },
              function (_ref6) {
                var _ref6$city = _ref6.city,
                    city = _ref6$city === undefined ? Object(helpers["i" /* getCity */])() : _ref6$city;
                return Object(preact_min["h"])(
                  'div',
                  {
                    'class': mobile_nav_style_default.a.citySelectorWrapper,
                    showGradient: showCitySelector && showGradient
                  },
                  Object(preact_min["h"])(
                    'div',
                    {
                      'class': mobile_nav_style_default.a.navItem,
                      onClick: _this2.toggleCitySelector
                    },
                    Object(preact_min["h"])(
                      'div',
                      { 'class': mobile_nav_style_default.a.navItemContent },
                      Object(preact_min["h"])(
                        'div',
                        { 'class': mobile_nav_style_default.a.navIconWrapper },
                        mobile_nav__ref7
                      ),
                      Object(preact_min["h"])(
                        'span',
                        null,
                        city
                      )
                    ),
                    Object(preact_min["h"])(
                      'svg',
                      {
                        xmlns: 'http://www.w3.org/2000/svg',
                        width: '16',
                        height: '16',
                        viewBox: '0 0 24 24',
                        fill: 'none',
                        stroke: 'currentColor',
                        'stroke-width': '2',
                        'stroke-linecap': 'round',
                        'stroke-linejoin': 'round',
                        'class': mobile_nav_style_default.a.chevron + ' ' + (showCitySelector ? mobile_nav_style_default.a.up : '')
                      },
                      _ref8
                    )
                  ),
                  showCitySelector && Object(preact_min["h"])(
                    'div',
                    {
                      'class': mobile_nav_style_default.a.dropdownContent,
                      ref: function ref(el) {
                        return _this2.dropdownRef = el;
                      },
                      style: { maxHeight: '250px', overflowY: 'auto' }
                    },
                    availableCities.map(function (city) {
                      return Object(preact_min["h"])(
                        'a',
                        {
                          href: '/' + lang + '/' + city.slug,
                          key: city.title,
                          'class': mobile_nav_style_default.a.dropdownItem,
                          onClick: _this2.closeMenu
                        },
                        city.title
                      );
                    })
                  ),
                  showCitySelector && Object(preact_min["h"])('div', {
                    'class': mobile_nav_style_default.a.scrollIndicator,
                    style: { top: (250 - 24) * scrollPercent + 56 + 'px' }
                  })
                );
              }
            ),
            Object(preact_min["h"])(
              'a',
              {
                href: lang === 'fi' ? '/fi/liity-tableonlineen' : lang === 'en' ? '/en/join' : lang === 'ee' ? '/ee/vota-meiega-uhendust' : null,
                'class': mobile_nav_style_default.a.navItem,
                onClick: this.closeMenu
              },
              Object(preact_min["h"])(
                'div',
                { 'class': mobile_nav_style_default.a.navItemContent },
                Object(preact_min["h"])(
                  'div',
                  { 'class': mobile_nav_style_default.a.navIconWrapper },
                  _ref9
                ),
                Object(preact_min["h"])(
                  'span',
                  null,
                  Object(preact_min["h"])(
                    translate["a" /* default */],
                    null,
                    i18n["a" /* default */].t("For restaurants")
                  )
                )
              )
            ),
            Object(preact_min["h"])(
              match["Link"],
              {
                href: lang === 'fi' ? '/fi/ota-yhteytta' : lang === 'en' ? '/en/contact-us' : lang === 'ee' ? '/ee/vota-meiega-uhendust' : null,
                'class': mobile_nav_style_default.a.navItem,
                onClick: function onClick() {
                  _this2.closeMenu();
                  trackContentClick('Mobile nav link', 'Contact us');
                }
              },
              Object(preact_min["h"])(
                'div',
                { 'class': mobile_nav_style_default.a.navItemContent },
                Object(preact_min["h"])(
                  'div',
                  { 'class': mobile_nav_style_default.a.navIconWrapper },
                  _ref10
                ),
                Object(preact_min["h"])(
                  'span',
                  null,
                  Object(preact_min["h"])(
                    translate["a" /* default */],
                    null,
                    i18n["a" /* default */].t("Contact us")
                  )
                )
              )
            ),
            Object(preact_min["h"])(
              pubsub["c" /* Stateful */],
              { events: ['auth'] },
              function (_ref11) {
                var auth = _ref11.auth;
                return auth ? Object(preact_min["h"])(
                  match["Link"],
                  {
                    href: '/' + lang + '/profile',
                    'class': mobile_nav_style_default.a.navItem,
                    onClick: _this2.closeMenu
                  },
                  Object(preact_min["h"])(
                    'div',
                    { 'class': mobile_nav_style_default.a.navItemContent },
                    Object(preact_min["h"])(
                      'div',
                      { 'class': mobile_nav_style_default.a.navIconWrapper },
                      _ref12
                    ),
                    Object(preact_min["h"])(
                      'span',
                      null,
                      auth.firstname,
                      ' ',
                      auth.lastname
                    )
                  )
                ) : Object(preact_min["h"])(
                  'div',
                  { 'class': mobile_nav_style_default.a.profileSection },
                  Object(preact_min["h"])(
                    'div',
                    { 'class': mobile_nav_style_default.a.authButtons },
                    Object(preact_min["h"])(
                      components_button["a" /* Button */],
                      {
                        href: '/' + lang + '/profile',
                        'class': mobile_nav_style_default.a.loginButton,
                        onClick: _this2.closeMenu
                      },
                      i18n["a" /* default */].t('Login')
                    ),
                    Object(preact_min["h"])(
                      components_button["a" /* Button */],
                      {
                        href: '/' + lang + '/profile?view=create',
                        'class': 'defaultButton',
                        onClick: _this2.closeMenu
                      },
                      i18n["a" /* default */].t('Create account')
                    )
                  )
                );
              }
            )
          )
        )
      )
    );
  };

  return MobileNav;
}(preact_min["Component"]);

/* harmony default export */ var mobile_nav = (mobile_nav_MobileNav);
// EXTERNAL MODULE: ../node_modules/preact-portal/dist/preact-portal.js
var preact_portal = __webpack_require__("q6qL");
var preact_portal_default = /*#__PURE__*/__webpack_require__.n(preact_portal);

// EXTERNAL MODULE: ./components/mobile-header/style.css
var mobile_header_style = __webpack_require__("2S6C");
var mobile_header_style_default = /*#__PURE__*/__webpack_require__.n(mobile_header_style);

// CONCATENATED MODULE: ./components/mobile-header/index.js


function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function mobile_header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function mobile_header__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function mobile_header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var mobile_header__ref3 = Object(preact_min["h"])('span', null);

var mobile_header__ref4 = Object(preact_min["h"])('span', null);

var mobile_header__ref5 = Object(preact_min["h"])('span', null);

var mobile_header__ref6 = Object(preact_min["h"])(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '20',
    height: '20',
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    'stroke-width': '2',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round'
  },
  Object(preact_min["h"])('circle', { cx: '11', cy: '11', r: '8' }),
  Object(preact_min["h"])('line', { x1: '21', y1: '21', x2: '16.65', y2: '16.65' })
);

var mobile_header__ref8 = Object(preact_min["h"])(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '20',
    height: '20',
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    'stroke-width': '2',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round'
  },
  Object(preact_min["h"])('path', { d: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2' }),
  Object(preact_min["h"])('circle', { cx: '12', cy: '7', r: '4' })
);

var mobile_header_MobileHeader = function (_Component) {
  mobile_header__inherits(MobileHeader, _Component);

  function MobileHeader() {
    var _temp, _this, _ret;

    mobile_header__classCallCheck(this, MobileHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = mobile_header__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      navOpen: false
    }, _this.toggleNav = function () {
      _this.setState({ navOpen: !_this.state.navOpen });
    }, _temp), mobile_header__possibleConstructorReturn(_this, _ret);
  }

  MobileHeader.prototype.render = function render(_ref, state, _ref2) {
    var _this2 = this;

    var lang = _ref2.lang;

    var _ref$dark = _ref.dark,
        dark = _ref$dark === undefined ? true : _ref$dark,
        props = _objectWithoutProperties(_ref, ['dark']);

    return Object(preact_min["h"])(
      'div',
      { 'class': mobile_header_style_default.a.mobileHeader + ' ' + (dark ? mobile_header_style_default.a.dark : mobile_header_style_default.a.light) },
      Object(preact_min["h"])(
        'div',
        { 'class': mobile_header_style_default.a.hamburgerWrapper },
        Object(preact_min["h"])(
          'button',
          {
            'class': mobile_header_style_default.a.hamburgerButton + ' ' + (state.navOpen ? mobile_header_style_default.a.open : ''),
            onClick: this.toggleNav,
            'aria-label': 'Menu'
          },
          mobile_header__ref3,
          mobile_header__ref4,
          mobile_header__ref5
        )
      ),
      Object(preact_min["h"])(
        'div',
        { 'class': mobile_header_style_default.a.logoWrapper },
        Object(preact_min["h"])(
          'a',
          { href: '/' + lang, 'class': mobile_header_style_default.a.logo },
          Object(preact_min["h"])('img', {
            height: '20',
            'class': mobile_header_style_default.a.tableOnlineLogo,
            src: dark ? '/assets/images/logo-text-white.png' : '/assets/images/logo-text-black.png',
            alt: 'TableOnline Logo'
          })
        )
      ),
      Object(preact_min["h"])(
        'div',
        { 'class': mobile_header_style_default.a.actionsWrapper },
        Object(preact_min["h"])(
          match["Link"],
          {
            href: '/' + lang + '/search',
            'class': mobile_header_style_default.a.actionButton,
            'aria-label': 'Search'
          },
          mobile_header__ref6
        ),
        Object(preact_min["h"])('div', { 'class': mobile_header_style_default.a.divider }),
        Object(preact_min["h"])(
          pubsub["c" /* Stateful */],
          { events: ['auth'] },
          function (_ref7) {
            var auth = _ref7.auth;
            return Object(preact_min["h"])(
              match["Link"],
              {
                href: '/' + lang + '/profile',
                'class': mobile_header_style_default.a.actionButton,
                'aria-label': auth ? auth.firstname : 'Profile'
              },
              mobile_header__ref8
            );
          }
        )
      ),
      Object(preact_min["h"])(
        preact_portal_default.a,
        { into: 'body' },
        Object(preact_min["h"])(mobile_nav, {
          isOpen: state.navOpen,
          onClose: function onClose() {
            return _this2.setState({ navOpen: false });
          }
        })
      )
    );
  };

  return MobileHeader;
}(preact_min["Component"]);

/* harmony default export */ var mobile_header = (mobile_header_MobileHeader);
// CONCATENATED MODULE: ./components/header/index.js


function header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function header__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var header__ref3 = Object(preact_min["h"])(searchfield, { showCityFilter: false });

var header__ref5 = Object(preact_min["h"])(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '20',
    height: '20',
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    'stroke-width': '2',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    style: 'margin-right: 0.5rem;'
  },
  Object(preact_min["h"])('path', { d: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2' }),
  Object(preact_min["h"])('circle', { cx: '12', cy: '7', r: '4' })
);

var header_Header = function (_Component) {
  header__inherits(Header, _Component);

  function Header() {
    var _temp, _this, _ret;

    header__classCallCheck(this, Header);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = header__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      show: false
    }, _this.toggleCitySelector = function () {
      _this.setState({ show: !_this.state.show });
    }, _temp), header__possibleConstructorReturn(_this, _ret);
  }

  Header.prototype.render = function render(_ref, state, _ref2) {
    var _ref$breadcrumbs = _ref.breadcrumbs,
        breadcrumbs = _ref$breadcrumbs === undefined ? [] : _ref$breadcrumbs,
        dark = _ref.dark;
    var lang = _ref2.lang;

    return Object(preact_min["h"])(
      'navigation',
      { 'class': style_default.a.navigation },
      Object(preact_min["h"])(mobile_header, { dark: dark }),
      Object(preact_min["h"])(
        'main',
        { 'class': style_default.a.header + ' ' + (dark ? style_default.a.dark : style_default.a.light) },
        Object(preact_min["h"])(
          'div',
          { 'class': style_default.a.logoContainer + ' contain' },
          Object(preact_min["h"])(
            'div',
            { 'class': style_default.a.logoWrapper },
            Object(preact_min["h"])(
              'a',
              { href: '/' + lang, 'class': style_default.a.logo },
              Object(preact_min["h"])('img', {
                height: '20',
                'class': style_default.a.tableOnlineLogo,
                src: '/assets/logo/TableOnline_Logo_White_Eggshell.svg',
                alt: 'TableOnline Logo'
              })
            )
          ),
          Object(preact_min["h"])(
            'div',
            { 'class': style_default.a.searchContainer },
            header__ref3
          ),
          Object(preact_min["h"])(
            'nav',
            null,
            Object(preact_min["h"])(
              'div',
              { 'class': style_default.a.authContainer },
              Object(preact_min["h"])(
                pubsub["c" /* Stateful */],
                { events: ['auth'] },
                function (_ref4) {
                  var auth = _ref4.auth;
                  return auth ? Object(preact_min["h"])(
                    components_button["a" /* Button */],
                    {
                      href: '/' + lang + '/profile',
                      'class': style_default.a.authButton
                    },
                    header__ref5,
                    auth.firstname
                  ) : Object(preact_min["h"])(
                    'div',
                    { 'class': style_default.a.authButtons },
                    Object(preact_min["h"])(
                      components_button["a" /* Button */],
                      {
                        href: '/' + lang + '/profile',
                        'class': style_default.a.authButton
                      },
                      i18n["a" /* default */].t('Login')
                    ),
                    Object(preact_min["h"])(
                      components_button["a" /* Button */],
                      {
                        href: '/' + lang + '/profile?view=create',
                        'class': style_default.a.authButton + ' ' + style_default.a.signupButton
                      },
                      i18n["a" /* default */].t('Create account')
                    )
                  );
                }
              )
            ),
            window.tableOnlineShowProfile ? Object(preact_min["h"])(
              'ul',
              { 'class': style_default.a.navigationIcons },
              Object(preact_min["h"])(
                'li',
                null,
                Object(preact_min["h"])(
                  match["Link"],
                  {
                    activeClassName: style_default.a.active,
                    'class': style_default.a.link,
                    href: '/' + lang + '/about'
                  },
                  Object(preact_min["h"])(
                    'svg',
                    {
                      xmlns: 'http://www.w3.org/2000/svg',
                      width: '24',
                      height: '24',
                      viewBox: '0 0 24 24'
                    },
                    Object(preact_min["h"])('path', {
                      d: 'M12 24c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12zm1-6h-2v-8h2v8zm-1-12.25c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25z',
                      fill: dark ? '#eee' : '#aaa'
                    })
                  ),
                  Object(preact_min["h"])(
                    translate["a" /* default */],
                    { span: true, 'class': style_default.a.hideOnMobile },
                    i18n["a" /* default */].t("About us")
                  )
                )
              )
            ) : null
          )
        )
      ),
      breadcrumbs.length ? Object(preact_min["h"])(
        jsonld["a" /* default */],
        null,
        {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: breadcrumbs.map(function (item, index) {
            return {
              '@type': 'ListItem',
              position: index + 1,
              name: item.title,
              item: '' + globals["b" /* DOMAIN */] + item.link
            };
          })
        }
      ) : null
    );
  };

  return Header;
}(preact_min["Component"]);

/* harmony default export */ var header = __webpack_exports__["a"] = (header_Header);

/***/ }),

/***/ "sV6m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./min')} */

module.exports = Math.min;

/***/ }),

/***/ "srJF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./syntax')} */

module.exports = SyntaxError;

/***/ }),

/***/ "sw5u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Link = exports.Match = undefined;

var _extends = Object.assign || function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key];
			}
		}
	}return target;
};

var _preact = __webpack_require__("KM04");

var _preactRouter = __webpack_require__("/QC5");

function _objectWithoutProperties(obj, keys) {
	var target = {};for (var i in obj) {
		if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	}return target;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Match = exports.Match = function (_Component) {
	_inherits(Match, _Component);

	function Match() {
		var _temp, _this, _ret;

		_classCallCheck(this, Match);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.update = function (url) {
			_this.nextUrl = url;
			_this.setState({});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Match.prototype.componentDidMount = function componentDidMount() {
		_preactRouter.subscribers.push(this.update);
	};

	Match.prototype.componentWillUnmount = function componentWillUnmount() {
		_preactRouter.subscribers.splice(_preactRouter.subscribers.indexOf(this.update) >>> 0, 1);
	};

	Match.prototype.render = function render(props) {
		var url = this.nextUrl || (0, _preactRouter.getCurrentUrl)(),
		    path = url.replace(/\?.+$/, '');
		this.nextUrl = null;
		return props.children[0] && props.children[0]({
			url: url,
			path: path,
			matches: path === props.path
		});
	};

	return Match;
}(_preact.Component);

var Link = function Link(_ref) {
	var activeClassName = _ref.activeClassName,
	    path = _ref.path,
	    props = _objectWithoutProperties(_ref, ['activeClassName', 'path']);

	return (0, _preact.h)(Match, { path: path || props.href }, function (_ref2) {
		var matches = _ref2.matches;
		return (0, _preact.h)(_preactRouter.Link, _extends({}, props, { 'class': [props.class || props.className, matches && activeClassName].filter(Boolean).join(' ') }));
	});
};

exports.Link = Link;
exports.default = Match;

Match.Link = Link;

/***/ }),

/***/ "t5DJ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, ".topBar__PLNow{background-color:#14151a;color:#fff;padding:.5rem 0;font-size:.875rem;width:100%;z-index:100}.topBarContainer__1tRSd{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:0 1rem;max-width:105rem;margin:0 auto}.topBarContainer__1tRSd,.topBarLeft__1ZMLt,.topBarRight__3_2lf{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.topBarRight__3_2lf{gap:1rem}.topBarItem__1J0Oy{margin-right:1.5rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.topBarItem__1J0Oy:last-child{margin-right:0}.topBarLink__1n6g0{color:#fff;text-decoration:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:none;border:none;cursor:pointer;padding:0;font-size:.875rem}.topBarLink__1n6g0:hover{text-decoration:underline}.topBarIcon__2cXqM{margin-right:.5rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.languageSelectorContainer___9Yq1{position:relative}.languageToggle__1Vtu6{background:none;border:none;color:#fff;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0;font-size:.875rem}.languagePopover__1UFJp{position:absolute;top:100%;left:0;margin-top:.5rem;z-index:1000;-webkit-box-shadow:0 2px 8px rgba(0,0,0,.15);box-shadow:0 2px 8px rgba(0,0,0,.15);border-radius:4px;background-color:#fff}.languageSelectorFlag__xxQ9f{width:16px;height:16px;margin-right:.5rem;overflow:hidden;border-radius:2px}.languageSelectorFlagImage__2lbbK{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.languageSelectorWrapper__3D39u{background-color:#fff;border-radius:4px;-webkit-box-shadow:0 2px 8px rgba(0,0,0,.15);box-shadow:0 2px 8px rgba(0,0,0,.15);overflow:hidden;min-width:150px}.languageSelectorWrapper__3D39u ul{list-style:none;margin:0;padding:0}.languageSelectorWrapper__3D39u li{margin:0;padding:0}.languageSelectorButton__1oQRV{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:8px 12px;width:100%;text-align:left;border:none;background:none;cursor:pointer;color:#333}.languageSelectorButton__1oQRV:hover{background-color:#f5f5f5}.languageSelectorDisplayname__3MmSH{margin-left:8px}.divider__3XEmU{height:16px;width:1px;background-color:hsla(0,0%,100%,.3);margin:0 1rem}.authLinks__3UUis{display:-webkit-box;display:-ms-flexbox;display:flex}.authLinks__3UUis,.authLinks__3UUis a{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.authLinks__3UUis a{color:#fff;text-decoration:none;font-size:.875rem;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.authLinks__3UUis a:hover{text-decoration:underline}@media (max-width:768px){.topBarContainer__1tRSd{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:.5rem 1rem}.topBarLeft__1ZMLt,.topBarRight__3_2lf{width:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.topBarRight__3_2lf{margin-top:.5rem;display:none}.divider__3XEmU{display:none}}", ""]);

// exports
exports.locals = {
	"topBar": "topBar__PLNow",
	"topBarContainer": "topBarContainer__1tRSd",
	"topBarLeft": "topBarLeft__1ZMLt",
	"topBarRight": "topBarRight__3_2lf",
	"topBarItem": "topBarItem__1J0Oy",
	"topBarLink": "topBarLink__1n6g0",
	"topBarIcon": "topBarIcon__2cXqM",
	"languageSelectorContainer": "languageSelectorContainer___9Yq1",
	"languageToggle": "languageToggle__1Vtu6",
	"languagePopover": "languagePopover__1UFJp",
	"languageSelectorFlag": "languageSelectorFlag__xxQ9f",
	"languageSelectorFlagImage": "languageSelectorFlagImage__2lbbK",
	"languageSelectorWrapper": "languageSelectorWrapper__3D39u",
	"languageSelectorButton": "languageSelectorButton__1oQRV",
	"languageSelectorDisplayname": "languageSelectorDisplayname__3MmSH",
	"divider": "divider__3XEmU",
	"authLinks": "authLinks__3UUis"
};

/***/ }),

/***/ "tJjN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clampImageWidth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dlv__ = __webpack_require__("CYb7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dlv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__("BMvp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_root__ = __webpack_require__("VjJS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__("UiAd");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var interactionObserverSupported = 'IntersectionObserver' in __WEBPACK_IMPORTED_MODULE_3__components_root__["a" /* default */];
var cache = {};
var SNAP_TO = 64;

var queue = [];
var running = false;

function clampImageWidth(w) {
  // Snap image width to 64px increments

  if (!w) return w;
  var width = w;

  var remainder = width % SNAP_TO;

  if (remainder) {
    return width + (SNAP_TO - remainder);
  }
  return width;
}

function flushQueue() {
  running = true;
  var self = queue[0];
  window.requestAnimationFrame(function () {
    if (self && self.base) {
      var params = {
        dpr: window.devicePixelRatio || 1,
        q: 90,
        format: 'auto'
      };
      if (self.props.width || self.props.height) {
        if (self.props.height) {
          params.h = parseInt(self.props.height);
        }
        if (self.props.width) {
          params.w = parseInt(self.props.width);
        }
      } else {
        var dimensions = self.base.parentElement.getBoundingClientRect();
        var w = parseInt(dimensions.width) > 10 ? parseInt(dimensions.width) : void 0;
        var _h = parseInt(dimensions.height) > 10 ? parseInt(dimensions.height) : void 0;
        if (w > _h) {
          params.w = w;
          params.h = w;
        } else if (_h > w) {
          params.w = _h;
          params.h = _h;
        } else {
          params.w = w;
          params.h = _h;
        }
      }

      if (params.w) {
        params.w = clampImageWidth(params.w);
      }
      if (params.h) {
        params.h = clampImageWidth(params.h);
      }

      self.setState({
        dimensions: '?' + Object.keys(params).filter(function (key) {
          return params[key];
        }).map(function (key) {
          return key + '=' + params[key];
        }).join('&')
      });
      if (__WEBPACK_IMPORTED_MODULE_1_dlv___default()(self, 'props.src')) cache[__WEBPACK_IMPORTED_MODULE_1_dlv___default()(self, 'props.src')] = (cache[__WEBPACK_IMPORTED_MODULE_1_dlv___default()(self, 'props.src')] || 0) + 1;
    }

    queue = queue.filter(function (item, index) {
      return index;
    });

    if (queue[0]) {
      flushQueue();
    } else {
      running = false;
    }
  });
  return;
}
function revealImage(self) {
  queue.push(self);
  if (!running) {
    flushQueue();
  }
}

var Image = function (_Component) {
  _inherits(Image, _Component);

  function Image() {
    _classCallCheck(this, Image);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    if (cache[__WEBPACK_IMPORTED_MODULE_1_dlv___default()(_this, 'props.src')]) {
      revealImage(_this);
    }
    return _this;
  }

  Image.prototype.loadImage = function loadImage(src) {
    var _this2 = this;

    fetch(src + '?w=2&h=2&q=0&auto=format&dpr=1', { mode: 'no-cors' }).then(function () {
      _this2.setState({ ready: true }, function () {
        if (_this2.intersecting) {
          revealImage(_this2);
        }
      });
    }).catch(function () {
      _this2.setState({ ready: true }, function () {
        if (_this2.intersecting) {
          revealImage(_this2);
        }
      });
    });
  };

  Image.prototype.getImage = function getImage() {
    var _this3 = this;

    var self = this;
    if (interactionObserverSupported && self.base && self.base.nodeType === 1) {
      self.lazyImageObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          _this3.boundingClientRect = entry.boundingClientRect;
          if (entry.isIntersecting && self.lazyImageObserver) {
            revealImage(self);
            _this3.intersecting = true;
            // if(self.base) {
            // 	self.lazyImageObserver.unobserve(self.base);
            // 	self.lazyImageObserver = null;
            // } else {
            // 	self.lazyImageObserver.disconnect();
            // 	self.lazyImageObserver = null;
            // }
          } else {
            _this3.intersecting = false;
          }
        });
      });
      self.lazyImageObserver.observe(self.base);
    } else {
      revealImage(self);
    }
  };

  Image.prototype.componentDidMount = function componentDidMount() {
    if (cache[__WEBPACK_IMPORTED_MODULE_1_dlv___default()(this, 'props.src')]) {
      revealImage(this);
    }
    this.getImage(this.props.src);
  };

  Image.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.lazyImageObserver) {
      if (this.base) {
        this.lazyImageObserver.unobserve(this.base);
        this.lazyImageObserver.disconnect();
      } else {
        this.lazyImageObserver.disconnect();
      }
      this.lazyImageObserver = null;
    }
  };

  Image.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var src = _ref.src;

    if (this.props.src !== src && src) {
      if (cache[src]) {
        revealImage(this);
      } else {
        this.getImage(src);
      }
    }
  };

  Image.prototype.render = function render(props, state) {
    var url = props.src.startsWith('data:image') ? props.src : Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["o" /* parseImageUrl */])(props.src);
    return state.err ? null : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', {
      height: props.height,
      width: props.width,
      alt: props.alt,
      cached: cache[props.src] > 1 ? true : null,
      'class': '' + __WEBPACK_IMPORTED_MODULE_2__style___default.a.image + (props.class ? ' ' + props.class : ''),
      src: !state.dimensions ? null : ('' + url + (!props.src.startsWith('data:image') ? state.dimensions.replace('?', props.src.includes('?') ? '&' : '?') : '')).replace('format=auto', 'auto=format'),
      style: '' + props.style
    });
  };

  return Image;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),

/***/ "u3et":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("MM91");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false,"singleton":true,"attrs":{"data-tableonline-build":"10.24.1"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "u6G0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./uri')} */

module.exports = URIError;

/***/ }),

/***/ "uTT0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

/***/ }),

/***/ "uVNY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./type')} */

module.exports = TypeError;

/***/ }),

/***/ "ujtv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./max')} */

module.exports = Math.max;

/***/ }),

/***/ "v2Hg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reflectGetProto = __webpack_require__("bx7G");
var originalGetProto = __webpack_require__("lJDY");

var getDunderProto = __webpack_require__("acgq");

/** @type {import('.')} */
module.exports = reflectGetProto ? function getProto(O) {
	// @ts-expect-error TS can't narrow inside a closure, for some reason
	return reflectGetProto(O);
} : originalGetProto ? function getProto(O) {
	if (!O || typeof O !== 'object' && typeof O !== 'function') {
		throw new TypeError('getProto: not an object');
	}
	// @ts-expect-error TS can't narrow inside a closure, for some reason
	return originalGetProto(O);
} : getDunderProto ? function getProto(O) {
	// @ts-expect-error TS can't narrow inside a closure, for some reason
	return getDunderProto(O);
} : null;

/***/ }),

/***/ "vnt6":
/***/ (function(module, exports) {

(function () {
	'use strict';

	var table = [],
	    poly = 0xEDB88320; // reverse polynomial

	// build the table
	function makeTable() {
		var c, n, k;

		for (n = 0; n < 256; n += 1) {
			c = n;
			for (k = 0; k < 8; k += 1) {
				if (c & 1) {
					c = poly ^ c >>> 1;
				} else {
					c = c >>> 1;
				}
			}
			table[n] = c >>> 0;
		}
	}

	function strToArr(str) {
		// sweet hack to turn string into a 'byte' array
		return Array.prototype.map.call(str, function (c) {
			return c.charCodeAt(0);
		});
	}

	/*
  * Compute CRC of array directly.
  *
  * This is slower for repeated calls, so append mode is not supported.
  */
	function crcDirect(arr) {
		var crc = -1,
		    // initial contents of LFBSR
		i,
		    j,
		    l,
		    temp;

		for (i = 0, l = arr.length; i < l; i += 1) {
			temp = (crc ^ arr[i]) & 0xff;

			// read 8 bits one at a time
			for (j = 0; j < 8; j += 1) {
				if ((temp & 1) === 1) {
					temp = temp >>> 1 ^ poly;
				} else {
					temp = temp >>> 1;
				}
			}
			crc = crc >>> 8 ^ temp;
		}

		// flip bits
		return crc ^ -1;
	}

	/*
  * Compute CRC with the help of a pre-calculated table.
  *
  * This supports append mode, if the second parameter is set.
  */
	function crcTable(arr, append) {
		var crc, i, l;

		// if we're in append mode, don't reset crc
		// if arr is null or undefined, reset table and return
		if (typeof crcTable.crc === 'undefined' || !append || !arr) {
			crcTable.crc = 0 ^ -1;

			if (!arr) {
				return;
			}
		}

		// store in temp variable for minor speed gain
		crc = crcTable.crc;

		for (i = 0, l = arr.length; i < l; i += 1) {
			crc = crc >>> 8 ^ table[(crc ^ arr[i]) & 0xff];
		}

		crcTable.crc = crc;

		return crc ^ -1;
	}

	// build the table
	// this isn't that costly, and most uses will be for table assisted mode
	makeTable();

	module.exports = function (val, direct) {
		var val = typeof val === 'string' ? strToArr(val) : val,
		    ret = direct ? crcDirect(val) : crcTable(val);

		// convert to 2's complement hex
		return (ret >>> 0).toString(16);
	};
	module.exports.direct = crcDirect;
	module.exports.table = crcTable;
})();

/***/ }),

/***/ "wDN6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__("LiLl");
var define = __webpack_require__("jPvt");
var hasDescriptors = __webpack_require__("wm0e")();
var gOPD = __webpack_require__("34Ju");

var $TypeError = __webpack_require__("uVNY");
var $floor = GetIntrinsic('%Math.floor%');

/** @type {import('.')} */
module.exports = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
		throw new $TypeError('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD) {
		var desc = gOPD(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			define( /** @type {Parameters<define>[0]} */fn, 'length', length, true, true);
		} else {
			define( /** @type {Parameters<define>[0]} */fn, 'length', length);
		}
	}
	return fn;
};

/***/ }),

/***/ "wm0e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__("3JcB");

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	return !!$defineProperty;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!$defineProperty) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;

/***/ }),

/***/ "x4jQ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("dNQG");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"sourceMap":false,"singleton":true,"attrs":{"data-tableonline-build":"10.24.1"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "xCEH":
/***/ (function(module, exports, __webpack_require__) {

var log = __webpack_require__("CTmE")('i18nline:pluralize');

// ported pluralizations from active_support/inflections.rb
// (except for cow -> kine, because nobody does that)
var skip = ['equipment', 'information', 'rice', 'money', 'species', 'series', 'fish', 'sheep', 'jeans'];
var patterns = [[/person$/i, 'people'], [/man$/i, 'men'], [/child$/i, 'children'], [/sex$/i, 'sexes'], [/move$/i, 'moves'], [/(quiz)$/i, '$1zes'], [/^(ox)$/i, '$1en'], [/([m|l])ouse$/i, '$1ice'], [/(matr|vert|ind)(?:ix|ex)$/i, '$1ices'], [/(x|ch|ss|sh)$/i, '$1es'], [/([^aeiouy]|qu)y$/i, '$1ies'], [/(hive)$/i, '$1s'], [/(?:([^f])fe|([lr])f)$/i, '$1$2ves'], [/sis$/i, 'ses'], [/([ti])um$/i, '$1a'], [/(buffal|tomat)o$/i, '$1oes'], [/(bu)s$/i, '$1ses'], [/(alias|status)$/i, '$1es'], [/(octop|vir)us$/i, '$1i'], [/(ax|test)is$/i, '$1es'], [/s$/i, 's']];

var pluralize = function pluralize(string) {
  string = string || '';
  if (skip.indexOf(string) >= 0) {
    return string;
  }
  for (var i = 0, len = patterns.length; i < len; i++) {
    var pair = patterns[i];
    if (string.match(pair[0])) {
      return string.replace(pair[0], pair[1]);
    }
  }
  return string + "s";
};

pluralize.withCount = function (count, string) {
  return "" + count + " " + (count === 1 ? string : pluralize(string));
};

module.exports = pluralize;

log.debug('Initialized ' + log.name);

/***/ }),

/***/ "xToX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /** @jsx h */

module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        // preact-compat normally does this
        var children = nextProps.children,
            props = _objectWithoutProperties(nextProps, ['children']);

        if (children && children.length) props.children = children;
        return shallowDiffers(props, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return (0, _preact.h)(WrappedComponent, this.props);
      };

      return SideEffect;
    }(_preact.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

    return SideEffect;
  };

  // Pulled from react-compat
  function shallowDiffers(a, b) {
    for (var i in a) {
      if (!(i in b)) return true;
    }for (var _i in b) {
      if (a[_i] !== b[_i]) return true;
    }return false;
  }
};

/***/ }),

/***/ "xcHB":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, ".label__3nws3{padding:0;vertical-align:baseline;border:0;display:block;position:relative;font-weight:400;color:#373737;background-color:transparent;border:2px solid rgba(0,0,0,.08);border-radius:4px;-webkit-box-shadow:0 1px 1px 0 rgba(0,0,0,.08);box-shadow:0 1px 1px 0 rgba(0,0,0,.08);background:#fff;max-width:100%;-ms-flex-item-align:baseline;align-self:baseline}.inputLabel__1EWXL{cursor:text}.label__3nws3:hover{border:2px solid rgba(0,0,0,.16)}.label__3nws3.mini__3HfmP{-webkit-box-flex:1;-ms-flex:1 1 8rem;flex:1 1 8rem}.label__3nws3.small__3oHAU{-webkit-box-flex:1;-ms-flex:1 1 16rem;flex:1 1 16rem}.label__3nws3.medium__nbANJ{-webkit-box-flex:1;-ms-flex:1 1 24rem;flex:1 1 24rem}.label__3nws3.large__2mRla{-webkit-box-flex:1;-ms-flex:1 1 48rem;flex:1 1 48rem}.label__3nws3.full__1vgwb{width:100%}.label__3nws3.error__1yo1J{border:2px solid rgba(230,33,23,.15);background:rgba(230,33,23,.05)}fieldset .label__3nws3,fieldset .label__3nws3.full__1vgwb,fieldset .label__3nws3.large__2mRla,fieldset .label__3nws3.medium__nbANJ,fieldset .label__3nws3.small__3oHAU{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;-webkit-box-shadow:none;box-shadow:none}.input__oJ4i6{padding:0;margin:0;vertical-align:baseline;border:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;display:block;padding:1rem .5rem 0;width:100%;height:2.75rem;min-height:2.75rem;line-height:1.75rem;background:rgba(0,0,0,.02);border-radius:4px;overflow:hidden;font-size:16px;resize:vertical}textarea.input__oJ4i6{overflow:auto}.input__oJ4i6:hover{background:#fff}.input__oJ4i6:focus{background:#fff;outline:0 solid #124142;-webkit-box-shadow:0 0 0 2px #124142;box-shadow:0 0 0 2px #124142}.labelGuide__3Nplt{position:absolute;font-weight:500;padding:0 .5rem;height:2.75rem;line-height:2.75rem;top:0;left:0;-webkit-transform:translateZ(0);transform:translateZ(0);z-index:1;pointer-events:none}.labelEmpty__38pE1{opacity:.6;cursor:text;-webkit-animation:inputBlur__4qypk .6s ease;animation:inputBlur__4qypk .6s ease}.labelFilled__ni07E{cursor:pointer;font-size:14px;-webkit-animation:inputFocus__1Ps3o .3s ease;animation:inputFocus__1Ps3o .3s ease;-webkit-transform:translate3d(0,-.65rem,0);transform:translate3d(0,-.65rem,0)}.labelHelp__2Lw8V{position:absolute;font-weight:500;padding:0;height:2.75rem;line-height:2.75rem;top:0;right:.5rem;font-size:12px;opacity:.6;pointer-events:none}.label__3nws3[error]{border:2px solid #d12c1a;background:rgba(231,76,60,.06)}.label__3nws3[error] .labelGuide__3Nplt{color:#d12c1a;opacity:1}.label__3nws3[error] .input__oJ4i6:focus{background:#fff;outline:0 solid #d12c1a;-webkit-box-shadow:0 0 0 2px #d12c1a;box-shadow:0 0 0 2px #d12c1a}.label__3nws3[success]{border:2px solid #124142;background:rgba(18,65,66,.02)}.label__3nws3[success] .input__oJ4i6:focus{background:#fff;outline:0 solid #124142;-webkit-box-shadow:0 0 0 2px #124142;box-shadow:0 0 0 2px #124142}.dirty__3TJ4u .input__oJ4i6:invalid,.strict__2OU6P .input__oJ4i6:invalid{background:rgba(231,76,60,.06);-webkit-box-shadow:0 0 0 2px #d12c1a;box-shadow:0 0 0 2px #d12c1a}.selectIcon__1V7nX{position:absolute;top:50%;right:1em;margin-top:-6px;pointer-events:none}.resetButton__1Oupy{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:0;background:transparent;margin:0;padding:0;outline:0;opacity:.56;pointer-events:all;cursor:pointer;position:absolute;top:50%;right:0;margin-top:-16px;z-index:1;width:32px;height:32px}.resetButton__1Oupy:hover{opacity:1}@media only screen and (max-width:50rem){.labelEmpty__38pE1,.labelFilled__ni07E{-webkit-animation:none;animation:none;font-size:12px}}@media only screen and (max-width:30rem){.labelHelp__2Lw8V{line-height:1;height:auto;right:auto;top:auto;bottom:.5rem;left:.5rem}.labelEmpty__38pE1{opacity:1;cursor:text;-webkit-transform:translate3d(0,-.65rem,0);transform:translate3d(0,-.65rem,0)}.labelEmpty__38pE1,.labelFilled__ni07E{-webkit-animation:none;animation:none;font-size:10px}}@-webkit-keyframes inputBlur__4qypk{0%{opacity:0}to{opacity:.6}}@keyframes inputBlur__4qypk{0%{opacity:0}to{opacity:.6}}@-webkit-keyframes inputFocus__1Ps3o{0%{opacity:0;font-size:14px;-webkit-transform:translateZ(0);transform:translateZ(0)}to{opacity:.8;font-size:14px;-webkit-transform:translate3d(0,-.65rem,0);transform:translate3d(0,-.65rem,0)}}@keyframes inputFocus__1Ps3o{0%{opacity:0;font-size:14px;-webkit-transform:translateZ(0);transform:translateZ(0)}to{opacity:.8;font-size:14px;-webkit-transform:translate3d(0,-.65rem,0);transform:translate3d(0,-.65rem,0)}}", ""]);

// exports
exports.locals = {
	"label": "label__3nws3",
	"inputLabel": "inputLabel__1EWXL",
	"mini": "mini__3HfmP",
	"small": "small__3oHAU",
	"medium": "medium__nbANJ",
	"large": "large__2mRla",
	"full": "full__1vgwb",
	"error": "error__1yo1J",
	"input": "input__oJ4i6",
	"labelGuide": "labelGuide__3Nplt",
	"labelEmpty": "labelEmpty__38pE1",
	"inputBlur": "inputBlur__4qypk",
	"labelFilled": "labelFilled__ni07E",
	"inputFocus": "inputFocus__1Ps3o",
	"labelHelp": "labelHelp__2Lw8V",
	"dirty": "dirty__3TJ4u",
	"strict": "strict__2OU6P",
	"selectIcon": "selectIcon__1V7nX",
	"resetButton": "resetButton__1Oupy"
};

/***/ }),

/***/ "y6BB":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, ".breadcrumbWrapper__bGLCl{width:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.breadcrumbs__3Fmo2,.breadcrumbWrapper__bGLCl{padding:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.breadcrumbs__3Fmo2{list-style:none;margin:0;color:#fff}.breadcrumbs__3Fmo2 li{padding:0;margin:0 .25rem 0 0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:16px;-webkit-animation:breadcrumbsIn__NJ-0e .6s cubic-bezier(.25,.46,.45,.94);animation:breadcrumbsIn__NJ-0e .6s cubic-bezier(.25,.46,.45,.94);-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;opacity:0;-webkit-transform:translate3d(0,1rem,0);transform:translate3d(0,1rem,0)}.breadcrumbs__3Fmo2 li:nth-child(2){-webkit-animation-delay:.3s;animation-delay:.3s}.breadcrumbs__3Fmo2 li:nth-child(3){-webkit-animation-delay:.6s;animation-delay:.6s}.breadcrumbs__3Fmo2 li:nth-child(4){-webkit-animation-delay:.9s;animation-delay:.9s}.breadcrumbs__3Fmo2 li:after{content:\"\\BB\";padding:.25rem}.breadcrumbs__3Fmo2 li:last-child:after{content:none}.breadcrumbs__3Fmo2 a{font-weight:500;color:#fff;text-decoration:none}.breadcrumbs__3Fmo2 a:hover{text-decoration:underline}.breadcrumbs__3Fmo2 a.active__34C8P{opacity:1}@-webkit-keyframes breadcrumbsIn__NJ-0e{0%{opacity:0;-webkit-transform:translate3d(0,1rem,0);transform:translate3d(0,1rem,0)}to{opacity:.65;-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes breadcrumbsIn__NJ-0e{0%{opacity:0;-webkit-transform:translate3d(0,1rem,0);transform:translate3d(0,1rem,0)}to{opacity:.65;-webkit-transform:translateZ(0);transform:translateZ(0)}}@media (max-width:768px){.breadcrumbWrapper__bGLCl{padding:0}.breadcrumbs__3Fmo2,.breadcrumbs__3Fmo2 li{font-size:14px}}", ""]);

// exports
exports.locals = {
	"breadcrumbWrapper": "breadcrumbWrapper__bGLCl",
	"breadcrumbs": "breadcrumbs__3Fmo2",
	"breadcrumbsIn": "breadcrumbsIn__NJ-0e",
	"active": "active__34C8P"
};

/***/ }),

/***/ "y9YS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var setFunctionLength = __webpack_require__("wDN6");

var $defineProperty = __webpack_require__("3JcB");

var callBindBasic = __webpack_require__("2V1b");
var applyBind = __webpack_require__("Il1g");

module.exports = function callBind(originalFunction) {
	var func = callBindBasic(arguments);
	var adjustedLength = 1 + originalFunction.length - (arguments.length - 1);
	return setFunctionLength(func, adjustedLength > 0 ? adjustedLength : 0, true);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}

/***/ }),

/***/ "ywQn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__("uTT0");

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) {
	return origKeys(o);
} : __webpack_require__("orz+");

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2);
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) {
				// eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;

/***/ }),

/***/ "zPSE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__("jPvt");
var hasDescriptors = __webpack_require__("wm0e")();
var functionsHaveConfigurableNames = __webpack_require__("VCQ6").functionsHaveConfigurableNames();

var $TypeError = __webpack_require__("uVNY");

/** @type {import('.')} */
module.exports = function setFunctionName(fn, name) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	var loose = arguments.length > 2 && !!arguments[2];
	if (!loose || functionsHaveConfigurableNames) {
		if (hasDescriptors) {
			define( /** @type {Parameters<define>[0]} */fn, 'name', name, true, true);
		} else {
			define( /** @type {Parameters<define>[0]} */fn, 'name', name);
		}
	}
	return fn;
};

/***/ }),

/***/ "zQXs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DOMAIN; });
/* unused harmony export LOCALES */
/* unused harmony export ROOT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LAMBDA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API; });
/* unused harmony export AVAILABILITYAPI */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FACEBOOKPIXEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GIFTCARD_AMOUNTS; });
/* unused harmony export GIFTCARD_DEFAULT_MAX_QUANTITY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TAGMANAGER_ID; });
/* unused harmony export ANALYTICS_ID */
var DOMAIN = 'https://www.tableonline.fi',
    LOCALES = ['ee', 'en', 'fi'],
    ROOT = typeof self === 'object' && self.self === self && self || typeof global === 'object' && global.global === global && global || this,
    PRODUCTION = ROOT.location && ROOT.location.origin === DOMAIN ? true : false,
    LAMBDA = !PRODUCTION ? 'https://preprod-service.tableonline.fi' : 'https://service.tableonline.fi',
    API = 'https://s3-eu-west-1.amazonaws.com/tox-json',
    AVAILABILITYAPI = 'https://mjiqkf3oq4.execute-api.eu-west-1.amazonaws.com/prod/bookable',
    FACEBOOKPIXEL = '172561719940552',
    GIFTCARD_AMOUNTS = [20, 50, 100, 150, 200, 250],
    GIFTCARD_DEFAULT_MAX_QUANTITY = 10,
    TAGMANAGER_ID = PRODUCTION ? 'GTM-WTBWJ3' : 'GTM-NMCV6RP',
    ANALYTICS_ID = PRODUCTION ? 'UA-19728430-6' : 'UA-67407950-3';
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("h6ac")))

/***/ }),

/***/ "ztNz":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root) {
    'use strict';

    /**
     * charMap
     * @type {Object}
     */

    var charMap = {

        // latin
        'À': 'A',
        'Á': 'A',
        'Â': 'A',
        'Ã': 'A',
        'Ä': 'Ae',
        'Å': 'A',
        'Æ': 'AE',
        'Ç': 'C',
        'È': 'E',
        'É': 'E',
        'Ê': 'E',
        'Ë': 'E',
        'Ì': 'I',
        'Í': 'I',
        'Î': 'I',
        'Ï': 'I',
        'Ð': 'D',
        'Ñ': 'N',
        'Ò': 'O',
        'Ó': 'O',
        'Ô': 'O',
        'Õ': 'O',
        'Ö': 'Oe',
        'Ő': 'O',
        'Ø': 'O',
        'Ù': 'U',
        'Ú': 'U',
        'Û': 'U',
        'Ü': 'Ue',
        'Ű': 'U',
        'Ý': 'Y',
        'Þ': 'TH',
        'ß': 'ss',
        'à': 'a',
        'á': 'a',
        'â': 'a',
        'ã': 'a',
        'ä': 'ae',
        'å': 'a',
        'æ': 'ae',
        'ç': 'c',
        'è': 'e',
        'é': 'e',
        'ê': 'e',
        'ë': 'e',
        'ì': 'i',
        'í': 'i',
        'î': 'i',
        'ï': 'i',
        'ð': 'd',
        'ñ': 'n',
        'ò': 'o',
        'ó': 'o',
        'ô': 'o',
        'õ': 'o',
        'ö': 'oe',
        'ő': 'o',
        'ø': 'o',
        'ù': 'u',
        'ú': 'u',
        'û': 'u',
        'ü': 'ue',
        'ű': 'u',
        'ý': 'y',
        'þ': 'th',
        'ÿ': 'y',
        'ẞ': 'SS',

        // language specific

        // Arabic
        'ا': 'a',
        'أ': 'a',
        'إ': 'i',
        'آ': 'aa',
        'ؤ': 'u',
        'ئ': 'e',
        'ء': 'a',
        'ب': 'b',
        'ت': 't',
        'ث': 'th',
        'ج': 'j',
        'ح': 'h',
        'خ': 'kh',
        'د': 'd',
        'ذ': 'th',
        'ر': 'r',
        'ز': 'z',
        'س': 's',
        'ش': 'sh',
        'ص': 's',
        'ض': 'dh',
        'ط': 't',
        'ظ': 'z',
        'ع': 'a',
        'غ': 'gh',
        'ف': 'f',
        'ق': 'q',
        'ك': 'k',
        'ل': 'l',
        'م': 'm',
        'ن': 'n',
        'ه': 'h',
        'و': 'w',
        'ي': 'y',
        'ى': 'a',
        'ة': 'h',
        'ﻻ': 'la',
        'ﻷ': 'laa',
        'ﻹ': 'lai',
        'ﻵ': 'laa',

        // Persian additional characters than Arabic
        'گ': 'g',
        'چ': 'ch',
        'پ': 'p',
        'ژ': 'zh',
        'ک': 'k',
        'ی': 'y',

        // Arabic diactrics
        'َ': 'a',
        'ً': 'an',
        'ِ': 'e',
        'ٍ': 'en',
        'ُ': 'u',
        'ٌ': 'on',
        'ْ': '',

        // Arabic numbers
        '٠': '0',
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',

        // Persian numbers
        '۰': '0',
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',

        // Burmese consonants
        'က': 'k',
        'ခ': 'kh',
        'ဂ': 'g',
        'ဃ': 'ga',
        'င': 'ng',
        'စ': 's',
        'ဆ': 'sa',
        'ဇ': 'z',
        'စျ': 'za',
        'ည': 'ny',
        'ဋ': 't',
        'ဌ': 'ta',
        'ဍ': 'd',
        'ဎ': 'da',
        'ဏ': 'na',
        'တ': 't',
        'ထ': 'ta',
        'ဒ': 'd',
        'ဓ': 'da',
        'န': 'n',
        'ပ': 'p',
        'ဖ': 'pa',
        'ဗ': 'b',
        'ဘ': 'ba',
        'မ': 'm',
        'ယ': 'y',
        'ရ': 'ya',
        'လ': 'l',
        'ဝ': 'w',
        'သ': 'th',
        'ဟ': 'h',
        'ဠ': 'la',
        'အ': 'a',
        // consonant character combos
        'ြ': 'y',
        'ျ': 'ya',
        'ွ': 'w',
        'ြွ': 'yw',
        'ျွ': 'ywa',
        'ှ': 'h',
        // independent vowels
        'ဧ': 'e',
        '၏': '-e',
        'ဣ': 'i',
        'ဤ': '-i',
        'ဉ': 'u',
        'ဦ': '-u',
        'ဩ': 'aw',
        'သြော': 'aw',
        'ဪ': 'aw',
        // numbers
        '၀': '0',
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        // virama and tone marks which are silent in transliteration
        '္': '',
        '့': '',
        'း': '',

        // Czech
        'č': 'c',
        'ď': 'd',
        'ě': 'e',
        'ň': 'n',
        'ř': 'r',
        'š': 's',
        'ť': 't',
        'ů': 'u',
        'ž': 'z',
        'Č': 'C',
        'Ď': 'D',
        'Ě': 'E',
        'Ň': 'N',
        'Ř': 'R',
        'Š': 'S',
        'Ť': 'T',
        'Ů': 'U',
        'Ž': 'Z',

        // Dhivehi
        'ހ': 'h',
        'ށ': 'sh',
        'ނ': 'n',
        'ރ': 'r',
        'ބ': 'b',
        'ޅ': 'lh',
        'ކ': 'k',
        'އ': 'a',
        'ވ': 'v',
        'މ': 'm',
        'ފ': 'f',
        'ދ': 'dh',
        'ތ': 'th',
        'ލ': 'l',
        'ގ': 'g',
        'ޏ': 'gn',
        'ސ': 's',
        'ޑ': 'd',
        'ޒ': 'z',
        'ޓ': 't',
        'ޔ': 'y',
        'ޕ': 'p',
        'ޖ': 'j',
        'ޗ': 'ch',
        'ޘ': 'tt',
        'ޙ': 'hh',
        'ޚ': 'kh',
        'ޛ': 'th',
        'ޜ': 'z',
        'ޝ': 'sh',
        'ޞ': 's',
        'ޟ': 'd',
        'ޠ': 't',
        'ޡ': 'z',
        'ޢ': 'a',
        'ޣ': 'gh',
        'ޤ': 'q',
        'ޥ': 'w',
        'ަ': 'a',
        'ާ': 'aa',
        'ި': 'i',
        'ީ': 'ee',
        'ު': 'u',
        'ޫ': 'oo',
        'ެ': 'e',
        'ޭ': 'ey',
        'ޮ': 'o',
        'ޯ': 'oa',
        'ް': '',

        // Georgian https://en.wikipedia.org/wiki/Romanization_of_Georgian
        // National system (2002)
        'ა': 'a',
        'ბ': 'b',
        'გ': 'g',
        'დ': 'd',
        'ე': 'e',
        'ვ': 'v',
        'ზ': 'z',
        'თ': 't',
        'ი': 'i',
        'კ': 'k',
        'ლ': 'l',
        'მ': 'm',
        'ნ': 'n',
        'ო': 'o',
        'პ': 'p',
        'ჟ': 'zh',
        'რ': 'r',
        'ს': 's',
        'ტ': 't',
        'უ': 'u',
        'ფ': 'p',
        'ქ': 'k',
        'ღ': 'gh',
        'ყ': 'q',
        'შ': 'sh',
        'ჩ': 'ch',
        'ც': 'ts',
        'ძ': 'dz',
        'წ': 'ts',
        'ჭ': 'ch',
        'ხ': 'kh',
        'ჯ': 'j',
        'ჰ': 'h',

        // Greek
        'α': 'a',
        'β': 'v',
        'γ': 'g',
        'δ': 'd',
        'ε': 'e',
        'ζ': 'z',
        'η': 'i',
        'θ': 'th',
        'ι': 'i',
        'κ': 'k',
        'λ': 'l',
        'μ': 'm',
        'ν': 'n',
        'ξ': 'ks',
        'ο': 'o',
        'π': 'p',
        'ρ': 'r',
        'σ': 's',
        'τ': 't',
        'υ': 'y',
        'φ': 'f',
        'χ': 'x',
        'ψ': 'ps',
        'ω': 'o',
        'ά': 'a',
        'έ': 'e',
        'ί': 'i',
        'ό': 'o',
        'ύ': 'y',
        'ή': 'i',
        'ώ': 'o',
        'ς': 's',
        'ϊ': 'i',
        'ΰ': 'y',
        'ϋ': 'y',
        'ΐ': 'i',
        'Α': 'A',
        'Β': 'B',
        'Γ': 'G',
        'Δ': 'D',
        'Ε': 'E',
        'Ζ': 'Z',
        'Η': 'I',
        'Θ': 'TH',
        'Ι': 'I',
        'Κ': 'K',
        'Λ': 'L',
        'Μ': 'M',
        'Ν': 'N',
        'Ξ': 'KS',
        'Ο': 'O',
        'Π': 'P',
        'Ρ': 'R',
        'Σ': 'S',
        'Τ': 'T',
        'Υ': 'Y',
        'Φ': 'F',
        'Χ': 'X',
        'Ψ': 'PS',
        'Ω': 'O',
        'Ά': 'A',
        'Έ': 'E',
        'Ί': 'I',
        'Ό': 'O',
        'Ύ': 'Y',
        'Ή': 'I',
        'Ώ': 'O',
        'Ϊ': 'I',
        'Ϋ': 'Y',

        // Latvian
        'ā': 'a',
        // 'č': 'c', // duplicate
        'ē': 'e',
        'ģ': 'g',
        'ī': 'i',
        'ķ': 'k',
        'ļ': 'l',
        'ņ': 'n',
        // 'š': 's', // duplicate
        'ū': 'u',
        // 'ž': 'z', // duplicate
        'Ā': 'A',
        // 'Č': 'C', // duplicate
        'Ē': 'E',
        'Ģ': 'G',
        'Ī': 'I',
        'Ķ': 'k',
        'Ļ': 'L',
        'Ņ': 'N',
        // 'Š': 'S', // duplicate
        'Ū': 'U',
        // 'Ž': 'Z', // duplicate

        // Macedonian
        'Ќ': 'Kj',
        'ќ': 'kj',
        'Љ': 'Lj',
        'љ': 'lj',
        'Њ': 'Nj',
        'њ': 'nj',
        'Тс': 'Ts',
        'тс': 'ts',

        // Polish
        'ą': 'a',
        'ć': 'c',
        'ę': 'e',
        'ł': 'l',
        'ń': 'n',
        // 'ó': 'o', // duplicate
        'ś': 's',
        'ź': 'z',
        'ż': 'z',
        'Ą': 'A',
        'Ć': 'C',
        'Ę': 'E',
        'Ł': 'L',
        'Ń': 'N',
        'Ś': 'S',
        'Ź': 'Z',
        'Ż': 'Z',

        // Ukranian
        'Є': 'Ye',
        'І': 'I',
        'Ї': 'Yi',
        'Ґ': 'G',
        'є': 'ye',
        'і': 'i',
        'ї': 'yi',
        'ґ': 'g',

        // Romanian
        'ă': 'a',
        'Ă': 'A',
        'ș': 's',
        'Ș': 'S',
        // 'ş': 's', // duplicate
        // 'Ş': 'S', // duplicate
        'ț': 't',
        'Ț': 'T',
        'ţ': 't',
        'Ţ': 'T',

        // Russian https://en.wikipedia.org/wiki/Romanization_of_Russian
        // ICAO

        'а': 'a',
        'б': 'b',
        'в': 'v',
        'г': 'g',
        'д': 'd',
        'е': 'e',
        'ё': 'yo',
        'ж': 'zh',
        'з': 'z',
        'и': 'i',
        'й': 'i',
        'к': 'k',
        'л': 'l',
        'м': 'm',
        'н': 'n',
        'о': 'o',
        'п': 'p',
        'р': 'r',
        'с': 's',
        'т': 't',
        'у': 'u',
        'ф': 'f',
        'х': 'kh',
        'ц': 'c',
        'ч': 'ch',
        'ш': 'sh',
        'щ': 'sh',
        'ъ': '',
        'ы': 'y',
        'ь': '',
        'э': 'e',
        'ю': 'yu',
        'я': 'ya',
        'А': 'A',
        'Б': 'B',
        'В': 'V',
        'Г': 'G',
        'Д': 'D',
        'Е': 'E',
        'Ё': 'Yo',
        'Ж': 'Zh',
        'З': 'Z',
        'И': 'I',
        'Й': 'I',
        'К': 'K',
        'Л': 'L',
        'М': 'M',
        'Н': 'N',
        'О': 'O',
        'П': 'P',
        'Р': 'R',
        'С': 'S',
        'Т': 'T',
        'У': 'U',
        'Ф': 'F',
        'Х': 'Kh',
        'Ц': 'C',
        'Ч': 'Ch',
        'Ш': 'Sh',
        'Щ': 'Sh',
        'Ъ': '',
        'Ы': 'Y',
        'Ь': '',
        'Э': 'E',
        'Ю': 'Yu',
        'Я': 'Ya',

        // Serbian
        'ђ': 'dj',
        'ј': 'j',
        // 'љ': 'lj',  // duplicate
        // 'њ': 'nj', // duplicate
        'ћ': 'c',
        'џ': 'dz',
        'Ђ': 'Dj',
        'Ј': 'j',
        // 'Љ': 'Lj', // duplicate
        // 'Њ': 'Nj', // duplicate
        'Ћ': 'C',
        'Џ': 'Dz',

        // Slovak
        'ľ': 'l',
        'ĺ': 'l',
        'ŕ': 'r',
        'Ľ': 'L',
        'Ĺ': 'L',
        'Ŕ': 'R',

        // Turkish
        'ş': 's',
        'Ş': 'S',
        'ı': 'i',
        'İ': 'I',
        // 'ç': 'c', // duplicate
        // 'Ç': 'C', // duplicate
        // 'ü': 'u', // duplicate, see langCharMap
        // 'Ü': 'U', // duplicate, see langCharMap
        // 'ö': 'o', // duplicate, see langCharMap
        // 'Ö': 'O', // duplicate, see langCharMap
        'ğ': 'g',
        'Ğ': 'G',

        // Vietnamese
        'ả': 'a',
        'Ả': 'A',
        'ẳ': 'a',
        'Ẳ': 'A',
        'ẩ': 'a',
        'Ẩ': 'A',
        'đ': 'd',
        'Đ': 'D',
        'ẹ': 'e',
        'Ẹ': 'E',
        'ẽ': 'e',
        'Ẽ': 'E',
        'ẻ': 'e',
        'Ẻ': 'E',
        'ế': 'e',
        'Ế': 'E',
        'ề': 'e',
        'Ề': 'E',
        'ệ': 'e',
        'Ệ': 'E',
        'ễ': 'e',
        'Ễ': 'E',
        'ể': 'e',
        'Ể': 'E',
        'ỏ': 'o',
        'ọ': 'o',
        'Ọ': 'o',
        'ố': 'o',
        'Ố': 'O',
        'ồ': 'o',
        'Ồ': 'O',
        'ổ': 'o',
        'Ổ': 'O',
        'ộ': 'o',
        'Ộ': 'O',
        'ỗ': 'o',
        'Ỗ': 'O',
        'ơ': 'o',
        'Ơ': 'O',
        'ớ': 'o',
        'Ớ': 'O',
        'ờ': 'o',
        'Ờ': 'O',
        'ợ': 'o',
        'Ợ': 'O',
        'ỡ': 'o',
        'Ỡ': 'O',
        'Ở': 'o',
        'ở': 'o',
        'ị': 'i',
        'Ị': 'I',
        'ĩ': 'i',
        'Ĩ': 'I',
        'ỉ': 'i',
        'Ỉ': 'i',
        'ủ': 'u',
        'Ủ': 'U',
        'ụ': 'u',
        'Ụ': 'U',
        'ũ': 'u',
        'Ũ': 'U',
        'ư': 'u',
        'Ư': 'U',
        'ứ': 'u',
        'Ứ': 'U',
        'ừ': 'u',
        'Ừ': 'U',
        'ự': 'u',
        'Ự': 'U',
        'ữ': 'u',
        'Ữ': 'U',
        'ử': 'u',
        'Ử': 'ư',
        'ỷ': 'y',
        'Ỷ': 'y',
        'ỳ': 'y',
        'Ỳ': 'Y',
        'ỵ': 'y',
        'Ỵ': 'Y',
        'ỹ': 'y',
        'Ỹ': 'Y',
        'ạ': 'a',
        'Ạ': 'A',
        'ấ': 'a',
        'Ấ': 'A',
        'ầ': 'a',
        'Ầ': 'A',
        'ậ': 'a',
        'Ậ': 'A',
        'ẫ': 'a',
        'Ẫ': 'A',
        // 'ă': 'a', // duplicate
        // 'Ă': 'A', // duplicate
        'ắ': 'a',
        'Ắ': 'A',
        'ằ': 'a',
        'Ằ': 'A',
        'ặ': 'a',
        'Ặ': 'A',
        'ẵ': 'a',
        'Ẵ': 'A',
        "⓪": "0",
        "①": "1",
        "②": "2",
        "③": "3",
        "④": "4",
        "⑤": "5",
        "⑥": "6",
        "⑦": "7",
        "⑧": "8",
        "⑨": "9",
        "⑩": "10",
        "⑪": "11",
        "⑫": "12",
        "⑬": "13",
        "⑭": "14",
        "⑮": "15",
        "⑯": "16",
        "⑰": "17",
        "⑱": "18",
        "⑲": "18",
        "⑳": "18",

        "⓵": "1",
        "⓶": "2",
        "⓷": "3",
        "⓸": "4",
        "⓹": "5",
        "⓺": "6",
        "⓻": "7",
        "⓼": "8",
        "⓽": "9",
        "⓾": "10",

        "⓿": "0",
        "⓫": "11",
        "⓬": "12",
        "⓭": "13",
        "⓮": "14",
        "⓯": "15",
        "⓰": "16",
        "⓱": "17",
        "⓲": "18",
        "⓳": "19",
        "⓴": "20",

        "Ⓐ": "A",
        "Ⓑ": "B",
        "Ⓒ": "C",
        "Ⓓ": "D",
        "Ⓔ": "E",
        "Ⓕ": "F",
        "Ⓖ": "G",
        "Ⓗ": "H",
        "Ⓘ": "I",
        "Ⓙ": "J",
        "Ⓚ": "K",
        "Ⓛ": "L",
        "Ⓜ": "M",
        "Ⓝ": "N",
        "Ⓞ": "O",
        "Ⓟ": "P",
        "Ⓠ": "Q",
        "Ⓡ": "R",
        "Ⓢ": "S",
        "Ⓣ": "T",
        "Ⓤ": "U",
        "Ⓥ": "V",
        "Ⓦ": "W",
        "Ⓧ": "X",
        "Ⓨ": "Y",
        "Ⓩ": "Z",

        "ⓐ": "a",
        "ⓑ": "b",
        "ⓒ": "c",
        "ⓓ": "d",
        "ⓔ": "e",
        "ⓕ": "f",
        "ⓖ": "g",
        "ⓗ": "h",
        "ⓘ": "i",
        "ⓙ": "j",
        "ⓚ": "k",
        "ⓛ": "l",
        "ⓜ": "m",
        "ⓝ": "n",
        "ⓞ": "o",
        "ⓟ": "p",
        "ⓠ": "q",
        "ⓡ": "r",
        "ⓢ": "s",
        "ⓣ": "t",
        "ⓤ": "u",
        "ⓦ": "v",
        "ⓥ": "w",
        "ⓧ": "x",
        "ⓨ": "y",
        "ⓩ": "z",

        // symbols
        '“': '"',
        '”': '"',
        '‘': "'",
        '’': "'",
        '∂': 'd',
        'ƒ': 'f',
        '™': '(TM)',
        '©': '(C)',
        'œ': 'oe',
        'Œ': 'OE',
        '®': '(R)',
        '†': '+',
        '℠': '(SM)',
        '…': '...',
        '˚': 'o',
        'º': 'o',
        'ª': 'a',
        '•': '*',
        '၊': ',',
        '။': '.',

        // currency
        '$': 'USD',
        '€': 'EUR',
        '₢': 'BRN',
        '₣': 'FRF',
        '£': 'GBP',
        '₤': 'ITL',
        '₦': 'NGN',
        '₧': 'ESP',
        '₩': 'KRW',
        '₪': 'ILS',
        '₫': 'VND',
        '₭': 'LAK',
        '₮': 'MNT',
        '₯': 'GRD',
        '₱': 'ARS',
        '₲': 'PYG',
        '₳': 'ARA',
        '₴': 'UAH',
        '₵': 'GHS',
        '¢': 'cent',
        '¥': 'CNY',
        '元': 'CNY',
        '円': 'YEN',
        '﷼': 'IRR',
        '₠': 'EWE',
        '฿': 'THB',
        '₨': 'INR',
        '₹': 'INR',
        '₰': 'PF',
        '₺': 'TRY',
        '؋': 'AFN',
        '₼': 'AZN',
        'лв': 'BGN',
        '៛': 'KHR',
        '₡': 'CRC',
        '₸': 'KZT',
        'ден': 'MKD',
        'zł': 'PLN',
        '₽': 'RUB',
        '₾': 'GEL'

    };

    /**
     * special look ahead character array
     * These characters form with consonants to become 'single'/consonant combo
     * @type [Array]
     */
    var lookAheadCharArray = [
    // burmese
    '်',

    // Dhivehi
    'ް'];

    /**
     * diatricMap for languages where transliteration changes entirely as more diatrics are added
     * @type {Object}
     */
    var diatricMap = {
        // Burmese
        // dependent vowels
        'ာ': 'a',
        'ါ': 'a',
        'ေ': 'e',
        'ဲ': 'e',
        'ိ': 'i',
        'ီ': 'i',
        'ို': 'o',
        'ု': 'u',
        'ူ': 'u',
        'ေါင်': 'aung',
        'ော': 'aw',
        'ော်': 'aw',
        'ေါ': 'aw',
        'ေါ်': 'aw',
        '်': '်', // this is special case but the character will be converted to latin in the code
        'က်': 'et',
        'ိုက်': 'aik',
        'ောက်': 'auk',
        'င်': 'in',
        'ိုင်': 'aing',
        'ောင်': 'aung',
        'စ်': 'it',
        'ည်': 'i',
        'တ်': 'at',
        'ိတ်': 'eik',
        'ုတ်': 'ok',
        'ွတ်': 'ut',
        'ေတ်': 'it',
        'ဒ်': 'd',
        'ိုဒ်': 'ok',
        'ုဒ်': 'ait',
        'န်': 'an',
        'ာန်': 'an',
        'ိန်': 'ein',
        'ုန်': 'on',
        'ွန်': 'un',
        'ပ်': 'at',
        'ိပ်': 'eik',
        'ုပ်': 'ok',
        'ွပ်': 'ut',
        'န်ုပ်': 'nub',
        'မ်': 'an',
        'ိမ်': 'ein',
        'ုမ်': 'on',
        'ွမ်': 'un',
        'ယ်': 'e',
        'ိုလ်': 'ol',
        'ဉ်': 'in',
        'ံ': 'an',
        'ိံ': 'ein',
        'ုံ': 'on',

        // Dhivehi
        'ައް': 'ah',
        'ަށް': 'ah'
    };

    /**
     * langCharMap language specific characters translations
     * @type   {Object}
     */
    var langCharMap = {
        'en': {}, // default language

        'az': { // Azerbaijani
            'ç': 'c',
            'ə': 'e',
            'ğ': 'g',
            'ı': 'i',
            'ö': 'o',
            'ş': 's',
            'ü': 'u',
            'Ç': 'C',
            'Ə': 'E',
            'Ğ': 'G',
            'İ': 'I',
            'Ö': 'O',
            'Ş': 'S',
            'Ü': 'U'
        },

        'cs': { // Czech
            'č': 'c',
            'ď': 'd',
            'ě': 'e',
            'ň': 'n',
            'ř': 'r',
            'š': 's',
            'ť': 't',
            'ů': 'u',
            'ž': 'z',
            'Č': 'C',
            'Ď': 'D',
            'Ě': 'E',
            'Ň': 'N',
            'Ř': 'R',
            'Š': 'S',
            'Ť': 'T',
            'Ů': 'U',
            'Ž': 'Z'
        },

        'fi': { // Finnish
            // 'å': 'a', duplicate see charMap/latin
            // 'Å': 'A', duplicate see charMap/latin
            'ä': 'a', // ok
            'Ä': 'A', // ok
            'ö': 'o', // ok
            'Ö': 'O' // ok
        },

        'hu': { // Hungarian
            'ä': 'a', // ok
            'Ä': 'A', // ok
            // 'á': 'a', duplicate see charMap/latin
            // 'Á': 'A', duplicate see charMap/latin
            'ö': 'o', // ok
            'Ö': 'O', // ok
            // 'ő': 'o', duplicate see charMap/latin
            // 'Ő': 'O', duplicate see charMap/latin
            'ü': 'u',
            'Ü': 'U',
            'ű': 'u',
            'Ű': 'U'
        },

        'lt': { // Lithuanian
            'ą': 'a',
            'č': 'c',
            'ę': 'e',
            'ė': 'e',
            'į': 'i',
            'š': 's',
            'ų': 'u',
            'ū': 'u',
            'ž': 'z',
            'Ą': 'A',
            'Č': 'C',
            'Ę': 'E',
            'Ė': 'E',
            'Į': 'I',
            'Š': 'S',
            'Ų': 'U',
            'Ū': 'U'
        },

        'lv': { // Latvian
            'ā': 'a',
            'č': 'c',
            'ē': 'e',
            'ģ': 'g',
            'ī': 'i',
            'ķ': 'k',
            'ļ': 'l',
            'ņ': 'n',
            'š': 's',
            'ū': 'u',
            'ž': 'z',
            'Ā': 'A',
            'Č': 'C',
            'Ē': 'E',
            'Ģ': 'G',
            'Ī': 'i',
            'Ķ': 'k',
            'Ļ': 'L',
            'Ņ': 'N',
            'Š': 'S',
            'Ū': 'u',
            'Ž': 'Z'
        },

        'pl': { // Polish
            'ą': 'a',
            'ć': 'c',
            'ę': 'e',
            'ł': 'l',
            'ń': 'n',
            'ó': 'o',
            'ś': 's',
            'ź': 'z',
            'ż': 'z',
            'Ą': 'A',
            'Ć': 'C',
            'Ę': 'e',
            'Ł': 'L',
            'Ń': 'N',
            'Ó': 'O',
            'Ś': 'S',
            'Ź': 'Z',
            'Ż': 'Z'
        },

        'sv': { // Swedish
            // 'å': 'a', duplicate see charMap/latin
            // 'Å': 'A', duplicate see charMap/latin
            'ä': 'a', // ok
            'Ä': 'A', // ok
            'ö': 'o', // ok
            'Ö': 'O' // ok
        },

        'sk': { // Slovak
            'ä': 'a',
            'Ä': 'A'
        },

        'sr': { // Serbian
            'љ': 'lj',
            'њ': 'nj',
            'Љ': 'Lj',
            'Њ': 'Nj',
            'đ': 'dj',
            'Đ': 'Dj'
        },

        'tr': { // Turkish
            'Ü': 'U',
            'Ö': 'O',
            'ü': 'u',
            'ö': 'o'
        }
    };

    /**
     * symbolMap language specific symbol translations
     * translations must be transliterated already
     * @type   {Object}
     */
    var symbolMap = {
        'ar': {
            '∆': 'delta',
            '∞': 'la-nihaya',
            '♥': 'hob',
            '&': 'wa',
            '|': 'aw',
            '<': 'aqal-men',
            '>': 'akbar-men',
            '∑': 'majmou',
            '¤': 'omla'
        },

        'az': {},

        'ca': {
            '∆': 'delta',
            '∞': 'infinit',
            '♥': 'amor',
            '&': 'i',
            '|': 'o',
            '<': 'menys que',
            '>': 'mes que',
            '∑': 'suma dels',
            '¤': 'moneda'
        },

        'cs': {
            '∆': 'delta',
            '∞': 'nekonecno',
            '♥': 'laska',
            '&': 'a',
            '|': 'nebo',
            '<': 'mensi nez',
            '>': 'vetsi nez',
            '∑': 'soucet',
            '¤': 'mena'
        },

        'de': {
            '∆': 'delta',
            '∞': 'unendlich',
            '♥': 'Liebe',
            '&': 'und',
            '|': 'oder',
            '<': 'kleiner als',
            '>': 'groesser als',
            '∑': 'Summe von',
            '¤': 'Waehrung'
        },

        'dv': {
            '∆': 'delta',
            '∞': 'kolunulaa',
            '♥': 'loabi',
            '&': 'aai',
            '|': 'noonee',
            '<': 'ah vure kuda',
            '>': 'ah vure bodu',
            '∑': 'jumula',
            '¤': 'faisaa'
        },

        'en': {
            '∆': 'delta',
            '∞': 'infinity',
            '♥': 'love',
            '&': 'and',
            '|': 'or',
            '<': 'less than',
            '>': 'greater than',
            '∑': 'sum',
            '¤': 'currency'
        },

        'es': {
            '∆': 'delta',
            '∞': 'infinito',
            '♥': 'amor',
            '&': 'y',
            '|': 'u',
            '<': 'menos que',
            '>': 'mas que',
            '∑': 'suma de los',
            '¤': 'moneda'
        },

        'fa': {
            '∆': 'delta',
            '∞': 'bi-nahayat',
            '♥': 'eshgh',
            '&': 'va',
            '|': 'ya',
            '<': 'kamtar-az',
            '>': 'bishtar-az',
            '∑': 'majmooe',
            '¤': 'vahed'
        },

        'fi': {
            '∆': 'delta',
            '∞': 'aarettomyys',
            '♥': 'rakkaus',
            '&': 'ja',
            '|': 'tai',
            '<': 'pienempi kuin',
            '>': 'suurempi kuin',
            '∑': 'summa',
            '¤': 'valuutta'
        },

        'fr': {
            '∆': 'delta',
            '∞': 'infiniment',
            '♥': 'Amour',
            '&': 'et',
            '|': 'ou',
            '<': 'moins que',
            '>': 'superieure a',
            '∑': 'somme des',
            '¤': 'monnaie'
        },

        'ge': {
            '∆': 'delta',
            '∞': 'usasruloba',
            '♥': 'siqvaruli',
            '&': 'da',
            '|': 'an',
            '<': 'naklebi',
            '>': 'meti',
            '∑': 'jami',
            '¤': 'valuta'
        },

        'gr': {},

        'hu': {
            '∆': 'delta',
            '∞': 'vegtelen',
            '♥': 'szerelem',
            '&': 'es',
            '|': 'vagy',
            '<': 'kisebb mint',
            '>': 'nagyobb mint',
            '∑': 'szumma',
            '¤': 'penznem'
        },

        'it': {
            '∆': 'delta',
            '∞': 'infinito',
            '♥': 'amore',
            '&': 'e',
            '|': 'o',
            '<': 'minore di',
            '>': 'maggiore di',
            '∑': 'somma',
            '¤': 'moneta'
        },

        'lt': {
            '∆': 'delta',
            '∞': 'begalybe',
            '♥': 'meile',
            '&': 'ir',
            '|': 'ar',
            '<': 'maziau nei',
            '>': 'daugiau nei',
            '∑': 'suma',
            '¤': 'valiuta'
        },

        'lv': {
            '∆': 'delta',
            '∞': 'bezgaliba',
            '♥': 'milestiba',
            '&': 'un',
            '|': 'vai',
            '<': 'mazak neka',
            '>': 'lielaks neka',
            '∑': 'summa',
            '¤': 'valuta'
        },

        'my': {
            '∆': 'kwahkhyaet',
            '∞': 'asaonasme',
            '♥': 'akhyait',
            '&': 'nhin',
            '|': 'tho',
            '<': 'ngethaw',
            '>': 'kyithaw',
            '∑': 'paungld',
            '¤': 'ngwekye'
        },

        'mk': {},

        'nl': {
            '∆': 'delta',
            '∞': 'oneindig',
            '♥': 'liefde',
            '&': 'en',
            '|': 'of',
            '<': 'kleiner dan',
            '>': 'groter dan',
            '∑': 'som',
            '¤': 'valuta'
        },

        'pl': {
            '∆': 'delta',
            '∞': 'nieskonczonosc',
            '♥': 'milosc',
            '&': 'i',
            '|': 'lub',
            '<': 'mniejsze niz',
            '>': 'wieksze niz',
            '∑': 'suma',
            '¤': 'waluta'
        },

        'pt': {
            '∆': 'delta',
            '∞': 'infinito',
            '♥': 'amor',
            '&': 'e',
            '|': 'ou',
            '<': 'menor que',
            '>': 'maior que',
            '∑': 'soma',
            '¤': 'moeda'
        },

        'ro': {
            '∆': 'delta',
            '∞': 'infinit',
            '♥': 'dragoste',
            '&': 'si',
            '|': 'sau',
            '<': 'mai mic ca',
            '>': 'mai mare ca',
            '∑': 'suma',
            '¤': 'valuta'
        },

        'ru': {
            '∆': 'delta',
            '∞': 'beskonechno',
            '♥': 'lubov',
            '&': 'i',
            '|': 'ili',
            '<': 'menshe',
            '>': 'bolshe',
            '∑': 'summa',
            '¤': 'valjuta'
        },

        'sk': {
            '∆': 'delta',
            '∞': 'nekonecno',
            '♥': 'laska',
            '&': 'a',
            '|': 'alebo',
            '<': 'menej ako',
            '>': 'viac ako',
            '∑': 'sucet',
            '¤': 'mena'
        },

        'sr': {},

        'tr': {
            '∆': 'delta',
            '∞': 'sonsuzluk',
            '♥': 'ask',
            '&': 've',
            '|': 'veya',
            '<': 'kucuktur',
            '>': 'buyuktur',
            '∑': 'toplam',
            '¤': 'para birimi'
        },

        'uk': {
            '∆': 'delta',
            '∞': 'bezkinechnist',
            '♥': 'lubov',
            '&': 'i',
            '|': 'abo',
            '<': 'menshe',
            '>': 'bilshe',
            '∑': 'suma',
            '¤': 'valjuta'
        },

        'vn': {
            '∆': 'delta',
            '∞': 'vo cuc',
            '♥': 'yeu',
            '&': 'va',
            '|': 'hoac',
            '<': 'nho hon',
            '>': 'lon hon',
            '∑': 'tong',
            '¤': 'tien te'
        }
    };

    var uricChars = [';', '?', ':', '@', '&', '=', '+', '$', ',', '/'].join('');

    var uricNoSlashChars = [';', '?', ':', '@', '&', '=', '+', '$', ','].join('');

    var markChars = ['.', '!', '~', '*', "'", '(', ')'].join('');

    /**
     * getSlug
     * @param  {string} input input string
     * @param  {object|string} opts config object or separator string/char
     * @api    public
     * @return {string}  sluggified string
     */
    var getSlug = function getSlug(input, opts) {
        var separator = '-';
        var result = '';
        var diatricString = '';
        var convertSymbols = true;
        var customReplacements = {};
        var maintainCase;
        var titleCase;
        var truncate;
        var uricFlag;
        var uricNoSlashFlag;
        var markFlag;
        var symbol;
        var langChar;
        var lucky;
        var i;
        var ch;
        var l;
        var lastCharWasSymbol;
        var lastCharWasDiatric;
        var allowedChars = '';

        if (typeof input !== 'string') {
            return '';
        }

        if (typeof opts === 'string') {
            separator = opts;
        }

        symbol = symbolMap.en;
        langChar = langCharMap.en;

        if (typeof opts === 'object') {
            maintainCase = opts.maintainCase || false;
            customReplacements = opts.custom && typeof opts.custom === 'object' ? opts.custom : customReplacements;
            truncate = +opts.truncate > 1 && opts.truncate || false;
            uricFlag = opts.uric || false;
            uricNoSlashFlag = opts.uricNoSlash || false;
            markFlag = opts.mark || false;
            convertSymbols = opts.symbols === false || opts.lang === false ? false : true;
            separator = opts.separator || separator;

            if (uricFlag) {
                allowedChars += uricChars;
            }

            if (uricNoSlashFlag) {
                allowedChars += uricNoSlashChars;
            }

            if (markFlag) {
                allowedChars += markChars;
            }

            symbol = opts.lang && symbolMap[opts.lang] && convertSymbols ? symbolMap[opts.lang] : convertSymbols ? symbolMap.en : {};

            langChar = opts.lang && langCharMap[opts.lang] ? langCharMap[opts.lang] : opts.lang === false || opts.lang === true ? {} : langCharMap.en;

            // if titleCase config is an Array, rewrite to object format
            if (opts.titleCase && typeof opts.titleCase.length === 'number' && Array.prototype.toString.call(opts.titleCase)) {
                opts.titleCase.forEach(function (v) {
                    customReplacements[v + ''] = v + '';
                });

                titleCase = true;
            } else {
                titleCase = !!opts.titleCase;
            }

            // if custom config is an Array, rewrite to object format
            if (opts.custom && typeof opts.custom.length === 'number' && Array.prototype.toString.call(opts.custom)) {
                opts.custom.forEach(function (v) {
                    customReplacements[v + ''] = v + '';
                });
            }

            // custom replacements
            Object.keys(customReplacements).forEach(function (v) {
                var r;

                if (v.length > 1) {
                    r = new RegExp('\\b' + escapeChars(v) + '\\b', 'gi');
                } else {
                    r = new RegExp(escapeChars(v), 'gi');
                }

                input = input.replace(r, customReplacements[v]);
            });

            // add all custom replacement to allowed charlist
            for (ch in customReplacements) {
                allowedChars += ch;
            }
        }

        allowedChars += separator;

        // escape all necessary chars
        allowedChars = escapeChars(allowedChars);

        // trim whitespaces
        input = input.replace(/(^\s+|\s+$)/g, '');

        lastCharWasSymbol = false;
        lastCharWasDiatric = false;

        for (i = 0, l = input.length; i < l; i++) {
            ch = input[i];

            if (isReplacedCustomChar(ch, customReplacements)) {
                // don't convert a already converted char
                lastCharWasSymbol = false;
            } else if (langChar[ch]) {
                // process language specific diactrics chars conversion
                ch = lastCharWasSymbol && langChar[ch].match(/[A-Za-z0-9]/) ? ' ' + langChar[ch] : langChar[ch];

                lastCharWasSymbol = false;
            } else if (ch in charMap) {
                // the transliteration changes entirely when some special characters are added
                if (i + 1 < l && lookAheadCharArray.indexOf(input[i + 1]) >= 0) {
                    diatricString += ch;
                    ch = '';
                } else if (lastCharWasDiatric === true) {
                    ch = diatricMap[diatricString] + charMap[ch];
                    diatricString = '';
                } else {
                    // process diactrics chars
                    ch = lastCharWasSymbol && charMap[ch].match(/[A-Za-z0-9]/) ? ' ' + charMap[ch] : charMap[ch];
                }

                lastCharWasSymbol = false;
                lastCharWasDiatric = false;
            } else if (ch in diatricMap) {
                diatricString += ch;
                ch = '';
                // end of string, put the whole meaningful word
                if (i === l - 1) {
                    ch = diatricMap[diatricString];
                }
                lastCharWasDiatric = true;
            } else if (
            // process symbol chars
            symbol[ch] && !(uricFlag && uricChars.indexOf(ch) !== -1) && !(uricNoSlashFlag && uricNoSlashChars
            // .indexOf(ch) !== -1) && !(markFlag && markChars
            .indexOf(ch) !== -1)) {
                ch = lastCharWasSymbol || result.substr(-1).match(/[A-Za-z0-9]/) ? separator + symbol[ch] : symbol[ch];
                ch += input[i + 1] !== void 0 && input[i + 1].match(/[A-Za-z0-9]/) ? separator : '';

                lastCharWasSymbol = true;
            } else {
                if (lastCharWasDiatric === true) {
                    ch = diatricMap[diatricString] + ch;
                    diatricString = '';
                    lastCharWasDiatric = false;
                } else if (lastCharWasSymbol && (/[A-Za-z0-9]/.test(ch) || result.substr(-1).match(/A-Za-z0-9]/))) {
                    // process latin chars
                    ch = ' ' + ch;
                }
                lastCharWasSymbol = false;
            }

            // add allowed chars
            result += ch.replace(new RegExp('[^\\w\\s' + allowedChars + '_-]', 'g'), separator);
        }

        if (titleCase) {
            result = result.replace(/(\w)(\S*)/g, function (_, i, r) {
                var j = i.toUpperCase() + (r !== null ? r : '');
                return Object.keys(customReplacements).indexOf(j.toLowerCase()) < 0 ? j : j.toLowerCase();
            });
        }

        // eliminate duplicate separators
        // add separator
        // trim separators from start and end
        result = result.replace(/\s+/g, separator).replace(new RegExp('\\' + separator + '+', 'g'), separator).replace(new RegExp('(^\\' + separator + '+|\\' + separator + '+$)', 'g'), '');

        if (truncate && result.length > truncate) {
            lucky = result.charAt(truncate) === separator;
            result = result.slice(0, truncate);

            if (!lucky) {
                result = result.slice(0, result.lastIndexOf(separator));
            }
        }

        if (!maintainCase && !titleCase) {
            result = result.toLowerCase();
        }

        return result;
    };

    /**
     * createSlug curried(opts)(input)
     * @param   {object|string} opts config object or input string
     * @return  {Function} function getSlugWithConfig()
     **/
    var createSlug = function createSlug(opts) {

        /**
         * getSlugWithConfig
         * @param   {string} input string
         * @return  {string} slug string
         */
        return function getSlugWithConfig(input) {
            return getSlug(input, opts);
        };
    };

    /**
     * escape Chars
     * @param   {string} input string
     */
    var escapeChars = function escapeChars(input) {
        return input.replace(/[-\\^$*+?.()|[\]{}\/]/g, '\\$&');
    };

    /**
     * check if the char is an already converted char from custom list
     * @param   {char} ch character to check
     * @param   {object} customReplacements custom translation map
     */
    var isReplacedCustomChar = function isReplacedCustomChar(ch, customReplacements) {
        for (var c in customReplacements) {
            if (customReplacements[c] === ch) {
                return true;
            }
        }
    };

    if (typeof module !== 'undefined' && module.exports) {

        // export functions for use in Node
        module.exports = getSlug;
        module.exports.createSlug = createSlug;
    } else if (true) {

        // export function for use in AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
            return getSlug;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {

        // don't overwrite global if exists
        try {
            if (root.getSlug || root.createSlug) {
                throw 'speakingurl: globals exists /(getSlug|createSlug)/';
            } else {
                root.getSlug = getSlug;
                root.createSlug = createSlug;
            }
        } catch (e) {}
    }
})(this);

/***/ })

/******/ });


// WEBPACK FOOTER //
// static/10.24.1/tableonline.bundle.js